// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/delivery.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { AwardDeliverableRoll, AwardPricedDuty, OrderCeiling, ReviewItem, ReviewSource, StatedObligation } from "../../common/v1/types_pb";
import { NotificationKindPreference, NotificationPreferenceChange, NotificationPreferenceSubject } from "./notification_preferences_pb";
/**
 * OnTimeWindow names a trailing window that pangaea resolves to concrete
 * [from, to) bounds server-side, in UTC, in exactly one place. Clients never
 * compute the boundaries themselves; they name the window and read the
 * applied bounds back off the response. Value names are retained for wire
 * compatibility even though they now name trailing, not calendar, windows.
 *
 * @generated from enum mono.datagateway.v1.OnTimeWindow
 */ export var OnTimeWindow = /*#__PURE__*/ function(OnTimeWindow) {
    /**
   * Cumulative: no window predicate at all. Default, so every existing caller
   * keeps its current cumulative behaviour unchanged.
   *
   * @generated from enum value: ON_TIME_WINDOW_UNSPECIFIED = 0;
   */ OnTimeWindow[OnTimeWindow["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * The trailing 7 calendar days ending at the request instant: half-open
   * [now - 7d, now) in UTC.
   *
   * @generated from enum value: ON_TIME_WINDOW_PREVIOUS_WEEK = 1;
   */ OnTimeWindow[OnTimeWindow["PREVIOUS_WEEK"] = 1] = "PREVIOUS_WEEK";
    /**
   * The trailing 30 calendar days ending at the request instant: half-open
   * [now - 30d, now) in UTC.
   *
   * @generated from enum value: ON_TIME_WINDOW_PREVIOUS_MONTH = 2;
   */ OnTimeWindow[OnTimeWindow["PREVIOUS_MONTH"] = 2] = "PREVIOUS_MONTH";
    return OnTimeWindow;
}({});
// Retrieve enum metadata with: proto3.getEnumType(OnTimeWindow)
proto3.util.setEnumType(OnTimeWindow, "mono.datagateway.v1.OnTimeWindow", [
    {
        no: 0,
        name: "ON_TIME_WINDOW_UNSPECIFIED"
    },
    {
        no: 1,
        name: "ON_TIME_WINDOW_PREVIOUS_WEEK"
    },
    {
        no: 2,
        name: "ON_TIME_WINDOW_PREVIOUS_MONTH"
    }
]);
/**
 * AssignedActionKind enumerates the four assignee-carrying record types this
 * feed unions. Deliberately excludes delivery.deviations (an approver is not
 * an assignee), delivery.audits (already represented by the existing audit
 * signal), and delivery.growth_opportunities (Growth is out of scope).
 *
 * @generated from enum mono.datagateway.v1.AssignedActionKind
 */ export var AssignedActionKind = /*#__PURE__*/ function(AssignedActionKind) {
    /**
   * @generated from enum value: ASSIGNED_ACTION_KIND_UNSPECIFIED = 0;
   */ AssignedActionKind[AssignedActionKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: ASSIGNED_ACTION_KIND_PROGRAM_TASK = 1;
   */ AssignedActionKind[AssignedActionKind["PROGRAM_TASK"] = 1] = "PROGRAM_TASK";
    /**
   * @generated from enum value: ASSIGNED_ACTION_KIND_ISSUE = 2;
   */ AssignedActionKind[AssignedActionKind["ISSUE"] = 2] = "ISSUE";
    /**
   * @generated from enum value: ASSIGNED_ACTION_KIND_CORRECTIVE_ACTION = 3;
   */ AssignedActionKind[AssignedActionKind["CORRECTIVE_ACTION"] = 3] = "CORRECTIVE_ACTION";
    /**
   * @generated from enum value: ASSIGNED_ACTION_KIND_RISK = 4;
   */ AssignedActionKind[AssignedActionKind["RISK"] = 4] = "RISK";
    /**
   * @generated from enum value: ASSIGNED_ACTION_KIND_PROPOSAL_WRITER = 5;
   */ AssignedActionKind[AssignedActionKind["PROPOSAL_WRITER"] = 5] = "PROPOSAL_WRITER";
    /**
   * @generated from enum value: ASSIGNED_ACTION_KIND_PROPOSAL_REVIEWER = 6;
   */ AssignedActionKind[AssignedActionKind["PROPOSAL_REVIEWER"] = 6] = "PROPOSAL_REVIEWER";
    return AssignedActionKind;
}({});
// Retrieve enum metadata with: proto3.getEnumType(AssignedActionKind)
proto3.util.setEnumType(AssignedActionKind, "mono.datagateway.v1.AssignedActionKind", [
    {
        no: 0,
        name: "ASSIGNED_ACTION_KIND_UNSPECIFIED"
    },
    {
        no: 1,
        name: "ASSIGNED_ACTION_KIND_PROGRAM_TASK"
    },
    {
        no: 2,
        name: "ASSIGNED_ACTION_KIND_ISSUE"
    },
    {
        no: 3,
        name: "ASSIGNED_ACTION_KIND_CORRECTIVE_ACTION"
    },
    {
        no: 4,
        name: "ASSIGNED_ACTION_KIND_RISK"
    },
    {
        no: 5,
        name: "ASSIGNED_ACTION_KIND_PROPOSAL_WRITER"
    },
    {
        no: 6,
        name: "ASSIGNED_ACTION_KIND_PROPOSAL_REVIEWER"
    }
]);
/**
 * @generated from message mono.datagateway.v1.Sector
 */ export class Sector extends Message {
    static fromBinary(bytes, options) {
        return new Sector().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Sector().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Sector().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Sector, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 6;
   */ _define_property(this, "deletedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(Sector, "runtime", proto3);
_define_property(Sector, "typeName", "mono.datagateway.v1.Sector");
_define_property(Sector, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BusinessUnit
 */ export class BusinessUnit extends Message {
    static fromBinary(bytes, options) {
        return new BusinessUnit().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BusinessUnit().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BusinessUnit().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BusinessUnit, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string sector_id = 3;
   */ _define_property(this, "sectorId", ""), /**
   * @generated from field: string name = 4;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string manager_name = 5;
   */ _define_property(this, "managerName", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 8;
   */ _define_property(this, "deletedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BusinessUnit, "runtime", proto3);
_define_property(BusinessUnit, "typeName", "mono.datagateway.v1.BusinessUnit");
_define_property(BusinessUnit, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sector_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "manager_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.Portfolio
 */ export class Portfolio extends Message {
    static fromBinary(bytes, options) {
        return new Portfolio().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Portfolio().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Portfolio().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Portfolio, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string business_unit_id = 3;
   */ _define_property(this, "businessUnitId", ""), /**
   * @generated from field: string name = 4;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string director_name = 5;
   */ _define_property(this, "directorName", ""), /**
   * @generated from field: string director_role = 6;
   */ _define_property(this, "directorRole", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 9;
   */ _define_property(this, "deletedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(Portfolio, "runtime", proto3);
_define_property(Portfolio, "typeName", "mono.datagateway.v1.Portfolio");
_define_property(Portfolio, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "director_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "director_role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * One name that resolves to one profile. alias_type is closed
 * (previous | trading_as | dba | former — the shanks corporate-family
 * vocabulary), and the spelling is unique per tenant: a name that resolves to
 * two profiles is an ambiguity, not an alias.
 *
 * @generated from message mono.datagateway.v1.CompanyAlias
 */ export class CompanyAlias extends Message {
    static fromBinary(bytes, options) {
        return new CompanyAlias().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompanyAlias().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompanyAlias().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompanyAlias, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string company_profile_id = 3;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string alias_name = 4;
   */ _define_property(this, "aliasName", ""), /**
   * @generated from field: string alias_type = 5;
   */ _define_property(this, "aliasType", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 6;
   */ _define_property(this, "effectiveDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_date = 7;
   */ _define_property(this, "endDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompanyAlias, "runtime", proto3);
_define_property(CompanyAlias, "typeName", "mono.datagateway.v1.CompanyAlias");
_define_property(CompanyAlias, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "alias_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "alias_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCompanyAliasRequest
 */ export class UpsertCompanyAliasRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCompanyAliasRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCompanyAliasRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCompanyAliasRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCompanyAliasRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CompanyAlias alias = 1;
   */ _define_property(this, "alias", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCompanyAliasRequest, "runtime", proto3);
_define_property(UpsertCompanyAliasRequest, "typeName", "mono.datagateway.v1.UpsertCompanyAliasRequest");
_define_property(UpsertCompanyAliasRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "alias",
            kind: "message",
            T: CompanyAlias
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCompanyAliasResponse
 */ export class UpsertCompanyAliasResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCompanyAliasResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCompanyAliasResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCompanyAliasResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCompanyAliasResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CompanyAlias alias = 1;
   */ _define_property(this, "alias", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCompanyAliasResponse, "runtime", proto3);
_define_property(UpsertCompanyAliasResponse, "typeName", "mono.datagateway.v1.UpsertCompanyAliasResponse");
_define_property(UpsertCompanyAliasResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "alias",
            kind: "message",
            T: CompanyAlias
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCompanyAliasesRequest
 */ export class ListCompanyAliasesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCompanyAliasesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCompanyAliasesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCompanyAliasesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCompanyAliasesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * Optional: empty lists the tenant's whole alias table (the match points
   * want all of it in one read).
   *
   * @generated from field: string company_profile_id = 2;
   */ _define_property(this, "companyProfileId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCompanyAliasesRequest, "runtime", proto3);
_define_property(ListCompanyAliasesRequest, "typeName", "mono.datagateway.v1.ListCompanyAliasesRequest");
_define_property(ListCompanyAliasesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCompanyAliasesResponse
 */ export class ListCompanyAliasesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCompanyAliasesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCompanyAliasesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCompanyAliasesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCompanyAliasesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CompanyAlias aliases = 1;
   */ _define_property(this, "aliases", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCompanyAliasesResponse, "runtime", proto3);
_define_property(ListCompanyAliasesResponse, "typeName", "mono.datagateway.v1.ListCompanyAliasesResponse");
_define_property(ListCompanyAliasesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "aliases",
            kind: "message",
            T: CompanyAlias,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCompanyAliasRequest
 */ export class DeleteCompanyAliasRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCompanyAliasRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCompanyAliasRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCompanyAliasRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCompanyAliasRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string alias_id = 2;
   */ _define_property(this, "aliasId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCompanyAliasRequest, "runtime", proto3);
_define_property(DeleteCompanyAliasRequest, "typeName", "mono.datagateway.v1.DeleteCompanyAliasRequest");
_define_property(DeleteCompanyAliasRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "alias_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCompanyAliasResponse
 */ export class DeleteCompanyAliasResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCompanyAliasResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCompanyAliasResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCompanyAliasResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCompanyAliasResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCompanyAliasResponse, "runtime", proto3);
_define_property(DeleteCompanyAliasResponse, "typeName", "mono.datagateway.v1.DeleteCompanyAliasResponse");
_define_property(DeleteCompanyAliasResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * A dated M&A/rename/spinoff edge between two profiles. relationship_type is
 * closed (subsidiary | acquisition | merger | joint_venture | rename |
 * spinoff). Both eras keep their own profiles and their own rates; the edge is
 * the fact that connects them.
 *
 * @generated from message mono.datagateway.v1.CompanyRelationship
 */ export class CompanyRelationship extends Message {
    static fromBinary(bytes, options) {
        return new CompanyRelationship().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompanyRelationship().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompanyRelationship().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompanyRelationship, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string from_company_id = 3;
   */ _define_property(this, "fromCompanyId", ""), /**
   * @generated from field: string to_company_id = 4;
   */ _define_property(this, "toCompanyId", ""), /**
   * @generated from field: string relationship_type = 5;
   */ _define_property(this, "relationshipType", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_start = 6;
   */ _define_property(this, "effectiveStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp effective_end = 7;
   */ _define_property(this, "effectiveEnd", void 0), /**
   * @generated from field: string notes = 8;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * DAT-25: provenance. source manual | sba_mp_xlsx (projector-only, not
   * user-editable); source_record_id = SBA agreement key; end_basis
   * not_in_source when the agreement dropped off SBA's list.
   *
   * @generated from field: string source = 10;
   */ _define_property(this, "source", ""), /**
   * @generated from field: google.protobuf.Timestamp observed_as_of = 11;
   */ _define_property(this, "observedAsOf", void 0), /**
   * @generated from field: string end_basis = 12;
   */ _define_property(this, "endBasis", ""), /**
   * @generated from field: string source_record_id = 13;
   */ _define_property(this, "sourceRecordId", ""), /**
   * REG-31: people who moved over in an acquisition or merger (company-level
   * headcount, no people). Only for relationship_type acquisition | merger.
   *
   * @generated from field: optional int32 transferred_headcount = 14;
   */ _define_property(this, "transferredHeadcount", void 0), /**
   * @generated from field: string transferred_headcount_source = 15;
   */ _define_property(this, "transferredHeadcountSource", ""), /**
   * REG-62: the document the event was recorded from (artifact id; soft
   * reference, artifacts live in zou). Empty when none was cited.
   *
   * @generated from field: string source_artifact_id = 16;
   */ _define_property(this, "sourceArtifactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompanyRelationship, "runtime", proto3);
_define_property(CompanyRelationship, "typeName", "mono.datagateway.v1.CompanyRelationship");
_define_property(CompanyRelationship, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "from_company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "to_company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "relationship_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "effective_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "effective_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "observed_as_of",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "end_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "source_record_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "transferred_headcount",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ ,
            opt: true
        },
        {
            no: 15,
            name: "transferred_headcount_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "source_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateCompanyRelationshipRequest
 */ export class CreateCompanyRelationshipRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateCompanyRelationshipRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCompanyRelationshipRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCompanyRelationshipRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCompanyRelationshipRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CompanyRelationship relationship = 1;
   */ _define_property(this, "relationship", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCompanyRelationshipRequest, "runtime", proto3);
_define_property(CreateCompanyRelationshipRequest, "typeName", "mono.datagateway.v1.CreateCompanyRelationshipRequest");
_define_property(CreateCompanyRelationshipRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "relationship",
            kind: "message",
            T: CompanyRelationship
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateCompanyRelationshipResponse
 */ export class CreateCompanyRelationshipResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateCompanyRelationshipResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCompanyRelationshipResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCompanyRelationshipResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCompanyRelationshipResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CompanyRelationship relationship = 1;
   */ _define_property(this, "relationship", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCompanyRelationshipResponse, "runtime", proto3);
_define_property(CreateCompanyRelationshipResponse, "typeName", "mono.datagateway.v1.CreateCompanyRelationshipResponse");
_define_property(CreateCompanyRelationshipResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "relationship",
            kind: "message",
            T: CompanyRelationship
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCompanyRelationshipsRequest
 */ export class ListCompanyRelationshipsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCompanyRelationshipsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCompanyRelationshipsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCompanyRelationshipsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCompanyRelationshipsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * Optional: empty lists every edge in the tenant.
   *
   * @generated from field: string company_profile_id = 2;
   */ _define_property(this, "companyProfileId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCompanyRelationshipsRequest, "runtime", proto3);
_define_property(ListCompanyRelationshipsRequest, "typeName", "mono.datagateway.v1.ListCompanyRelationshipsRequest");
_define_property(ListCompanyRelationshipsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCompanyRelationshipsResponse
 */ export class ListCompanyRelationshipsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCompanyRelationshipsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCompanyRelationshipsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCompanyRelationshipsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCompanyRelationshipsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CompanyRelationship relationships = 1;
   */ _define_property(this, "relationships", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCompanyRelationshipsResponse, "runtime", proto3);
_define_property(ListCompanyRelationshipsResponse, "typeName", "mono.datagateway.v1.ListCompanyRelationshipsResponse");
_define_property(ListCompanyRelationshipsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "relationships",
            kind: "message",
            T: CompanyRelationship,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCompanyRelationshipRequest
 */ export class DeleteCompanyRelationshipRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCompanyRelationshipRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCompanyRelationshipRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCompanyRelationshipRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCompanyRelationshipRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string relationship_id = 2;
   */ _define_property(this, "relationshipId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCompanyRelationshipRequest, "runtime", proto3);
_define_property(DeleteCompanyRelationshipRequest, "typeName", "mono.datagateway.v1.DeleteCompanyRelationshipRequest");
_define_property(DeleteCompanyRelationshipRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "relationship_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCompanyRelationshipResponse
 */ export class DeleteCompanyRelationshipResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCompanyRelationshipResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCompanyRelationshipResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCompanyRelationshipResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCompanyRelationshipResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCompanyRelationshipResponse, "runtime", proto3);
_define_property(DeleteCompanyRelationshipResponse, "typeName", "mono.datagateway.v1.DeleteCompanyRelationshipResponse");
_define_property(DeleteCompanyRelationshipResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * REG-62: relationship.id and relationship.tenant_id pick the row; every other
 * field replaces the stored value (type, both ends, dates, notes, headcount,
 * source document). Set effective_end to end an edge and keep it as history.
 *
 * @generated from message mono.datagateway.v1.UpdateCompanyRelationshipRequest
 */ export class UpdateCompanyRelationshipRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCompanyRelationshipRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCompanyRelationshipRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCompanyRelationshipRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCompanyRelationshipRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CompanyRelationship relationship = 1;
   */ _define_property(this, "relationship", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCompanyRelationshipRequest, "runtime", proto3);
_define_property(UpdateCompanyRelationshipRequest, "typeName", "mono.datagateway.v1.UpdateCompanyRelationshipRequest");
_define_property(UpdateCompanyRelationshipRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "relationship",
            kind: "message",
            T: CompanyRelationship
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateCompanyRelationshipResponse
 */ export class UpdateCompanyRelationshipResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCompanyRelationshipResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCompanyRelationshipResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCompanyRelationshipResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCompanyRelationshipResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CompanyRelationship relationship = 1;
   */ _define_property(this, "relationship", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCompanyRelationshipResponse, "runtime", proto3);
_define_property(UpdateCompanyRelationshipResponse, "typeName", "mono.datagateway.v1.UpdateCompanyRelationshipResponse");
_define_property(UpdateCompanyRelationshipResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "relationship",
            kind: "message",
            T: CompanyRelationship
        }
    ]));
/**
 * A company's seat on a contract vehicle (delivery.vehicle_company_access,
 * dead since migration 000014 until SAD-432). access_type is closed
 * (direct_holder | jv_participant | team_member | other, migration 000258).
 * READ-ONLY here: writing/maintaining these records is C1.4/SAD-435's job.
 * vehicle_name and vehicle_contract_number are joined from
 * delivery.contract_vehicles so a Company detail page needs no second
 * round-trip to show what it's listing.
 *
 * @generated from message mono.datagateway.v1.VehicleCompanyAccess
 */ export class VehicleCompanyAccess extends Message {
    static fromBinary(bytes, options) {
        return new VehicleCompanyAccess().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VehicleCompanyAccess().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VehicleCompanyAccess().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VehicleCompanyAccess, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string vehicle_id = 3;
   */ _define_property(this, "vehicleId", ""), /**
   * @generated from field: string company_profile_id = 4;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string access_type = 5;
   */ _define_property(this, "accessType", ""), /**
   * @generated from field: string contract_holder_number = 6;
   */ _define_property(this, "contractHolderNumber", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 7;
   */ _define_property(this, "effectiveDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp expiration_date = 8;
   */ _define_property(this, "expirationDate", void 0), /**
   * @generated from field: string notes = 9;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: string vehicle_name = 12;
   */ _define_property(this, "vehicleName", ""), /**
   * @generated from field: string vehicle_contract_number = 13;
   */ _define_property(this, "vehicleContractNumber", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(VehicleCompanyAccess, "runtime", proto3);
_define_property(VehicleCompanyAccess, "typeName", "mono.datagateway.v1.VehicleCompanyAccess");
_define_property(VehicleCompanyAccess, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "access_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "contract_holder_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "expiration_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "vehicle_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "vehicle_contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCompanyVehicleHoldingsRequest
 */ export class ListCompanyVehicleHoldingsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCompanyVehicleHoldingsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCompanyVehicleHoldingsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCompanyVehicleHoldingsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCompanyVehicleHoldingsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string company_profile_id = 2;
   */ _define_property(this, "companyProfileId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCompanyVehicleHoldingsRequest, "runtime", proto3);
_define_property(ListCompanyVehicleHoldingsRequest, "typeName", "mono.datagateway.v1.ListCompanyVehicleHoldingsRequest");
_define_property(ListCompanyVehicleHoldingsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCompanyVehicleHoldingsResponse
 */ export class ListCompanyVehicleHoldingsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCompanyVehicleHoldingsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCompanyVehicleHoldingsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCompanyVehicleHoldingsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCompanyVehicleHoldingsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.VehicleCompanyAccess holdings = 1;
   */ _define_property(this, "holdings", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCompanyVehicleHoldingsResponse, "runtime", proto3);
_define_property(ListCompanyVehicleHoldingsResponse, "typeName", "mono.datagateway.v1.ListCompanyVehicleHoldingsResponse");
_define_property(ListCompanyVehicleHoldingsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "holdings",
            kind: "message",
            T: VehicleCompanyAccess,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CompanyProfile
 */ export class CompanyProfile extends Message {
    static fromBinary(bytes, options) {
        return new CompanyProfile().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompanyProfile().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompanyProfile().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompanyProfile, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string cage_code = 4;
   */ _define_property(this, "cageCode", ""), /**
   * @generated from field: string duns_number = 5;
   */ _define_property(this, "dunsNumber", ""), /**
   * @generated from field: string uei = 6;
   */ _define_property(this, "uei", ""), /**
   * @generated from field: string socioeconomic_status = 7;
   */ _define_property(this, "socioeconomicStatus", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 10;
   */ _define_property(this, "deletedAt", void 0), /**
   * @generated from field: string legal_name = 11;
   */ _define_property(this, "legalName", ""), /**
   * @generated from field: string entity_type = 12;
   */ _define_property(this, "entityType", ""), /**
   * @generated from field: string parent_company_id = 13;
   */ _define_property(this, "parentCompanyId", ""), /**
   * @generated from field: string status = 14;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string website = 15;
   */ _define_property(this, "website", ""), /**
   * @generated from field: string primary_naics = 16;
   */ _define_property(this, "primaryNaics", ""), /**
   * @generated from field: string ein = 17;
   */ _define_property(this, "ein", ""), /**
   * The tenant's own organization. At most one live profile per tenant may
   * carry this (partial unique index); stamped by GetOwnCompanyProfile's
   * resolution, never set from browser-facing upserts.
   *
   * @generated from field: bool is_own_company = 18;
   */ _define_property(this, "isOwnCompany", false), /**
   * REG-55: survivor id when this row was merged into another (Get by a loser
   * id returns the loser with this set so the FE can redirect); lists hide losers.
   *
   * @generated from field: string merged_into_id = 19;
   */ _define_property(this, "mergedIntoId", ""), /**
   * REG-04: analyst/manual size tier. Closed set MID_SIZE|SMALL|LARGE|OTHER_THAN_SMALL|UNKNOWN (empty = UNKNOWN).
   *
   * @generated from field: string business_size = 20;
   */ _define_property(this, "businessSize", ""), /**
   * ''|MANUAL|SAM_ENTITY|USASPENDING
   *
   * @generated from field: string business_size_source = 21;
   */ _define_property(this, "businessSizeSource", ""), /**
   * REG-04: SAM size facts. OUTPUT ONLY — never written from a form; DAT-18 is the only writer.
   *
   * @generated from field: string sam_business_size = 22;
   */ _define_property(this, "samBusinessSize", ""), /**
   * @generated from field: string sam_business_size_naics = 23;
   */ _define_property(this, "samBusinessSizeNaics", ""), /**
   * @generated from field: google.protobuf.Timestamp sam_business_size_retrieved_at = 24;
   */ _define_property(this, "samBusinessSizeRetrievedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompanyProfile, "runtime", proto3);
_define_property(CompanyProfile, "typeName", "mono.datagateway.v1.CompanyProfile");
_define_property(CompanyProfile, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "cage_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "duns_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "uei",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "socioeconomic_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "legal_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "entity_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "parent_company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "website",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "primary_naics",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "ein",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "is_own_company",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 19,
            name: "merged_into_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "business_size",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "business_size_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "sam_business_size",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "sam_business_size_naics",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "sam_business_size_retrieved_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.Contact
 */ export class Contact extends Message {
    static fromBinary(bytes, options) {
        return new Contact().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Contact().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Contact().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Contact, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string first_name = 3;
   */ _define_property(this, "firstName", ""), /**
   * @generated from field: string last_name = 4;
   */ _define_property(this, "lastName", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string email = 6;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string phone = 7;
   */ _define_property(this, "phone", ""), /**
   * @generated from field: string location = 8;
   */ _define_property(this, "location", ""), /**
   * @generated from field: string organization = 9;
   */ _define_property(this, "organization", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 12;
   */ _define_property(this, "deletedAt", void 0), /**
   * @generated from field: string contact_type = 13;
   */ _define_property(this, "contactType", ""), /**
   * @generated from field: string company_profile_id = 14;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string government_organization_id = 15;
   */ _define_property(this, "governmentOrganizationId", ""), /**
   * @generated from field: string platform_user_id = 16;
   */ _define_property(this, "platformUserId", ""), /**
   * @generated from field: bool is_active = 17;
   */ _define_property(this, "isActive", false), /**
   * Registry-assigned role (tenant role_type enum id). For INTERNAL contacts:
   * program role assignments inherit this and treat it as static.
   *
   * @generated from field: string role_type_id = 18;
   */ _define_property(this, "roleTypeId", ""), /**
   * Labeled addresses. `email` (field 6) is a server-derived primary
   * recomputed from these two plus contact_type on every write — see
   * models.DeriveContactPrimaryEmail — so every existing reader of `email`
   * needs no change.
   *
   * @generated from field: string corporate_email = 19;
   */ _define_property(this, "corporateEmail", ""), /**
   * @generated from field: string government_email = 20;
   */ _define_property(this, "governmentEmail", ""), /**
   * People Graph (migration 000100): merged_into_id is the person-row
   * superseded_by_id — set means this row merged into another and reads
   * resolve through the pointer. is_placeholder marks a seat-shaped contact
   * minted from a vacant staffing line.
   *
   * @generated from field: string merged_into_id = 21;
   */ _define_property(this, "mergedIntoId", ""), /**
   * @generated from field: bool is_placeholder = 22;
   */ _define_property(this, "isPlaceholder", false), /**
   * Business-unit scope (SAD-75, migration 000150). Empty means "not scoped
   * to a business unit — visible everywhere", mirroring
   * tenant_enum_values.business_unit_id (see TenantEnumValue below): most
   * contacts are company-wide, and an equality-only filter would hide every
   * one of them from a BU-scoped picker.
   *
   * @generated from field: string business_unit_id = 23;
   */ _define_property(this, "businessUnitId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(Contact, "runtime", proto3);
_define_property(Contact, "typeName", "mono.datagateway.v1.Contact");
_define_property(Contact, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "first_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "last_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "phone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "location",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "organization",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "contact_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "government_organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "platform_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "is_active",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 18,
            name: "role_type_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "corporate_email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "government_email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "merged_into_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "is_placeholder",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 23,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ContactEmployment is one temporal employer fact on a person (Phase 3 slice
 * 2): employer is EXACTLY ONE of company_profile_id / government_organization_id,
 * dates are optional (recorded when known), source is MANUAL | DERIVED | IMPORT.
 *
 * @generated from message mono.datagateway.v1.ContactEmployment
 */ export class ContactEmployment extends Message {
    static fromBinary(bytes, options) {
        return new ContactEmployment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContactEmployment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContactEmployment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContactEmployment, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string contact_id = 3;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string company_profile_id = 4;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string government_organization_id = 5;
   */ _define_property(this, "governmentOrganizationId", ""), /**
   * @generated from field: string title = 6;
   */ _define_property(this, "title", ""), /**
   * EMPLOYEE | CONTRACTOR | ADVISOR | GOV_CIVILIAN | MILITARY | UNKNOWN
   *
   * @generated from field: string employment_type = 7;
   */ _define_property(this, "employmentType", ""), /**
   * @generated from field: google.protobuf.Timestamp start_date = 8;
   */ _define_property(this, "startDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_date = 9;
   */ _define_property(this, "endDate", void 0), /**
   * @generated from field: string source = 10;
   */ _define_property(this, "source", ""), /**
   * Optional so an explicit 0.0 is distinguishable from unset (Phase 5 feeds).
   *
   * @generated from field: optional double confidence = 11;
   */ _define_property(this, "confidence", void 0), /**
   * @generated from field: string evidence_json = 12;
   */ _define_property(this, "evidenceJson", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */ _define_property(this, "createdAt", void 0), /**
   * REG-31: the seat this job holds at the employer (same employer; "" = none).
   *
   * @generated from field: string seat_id = 14;
   */ _define_property(this, "seatId", ""), /**
   * MOVED | RETIRED | LAID_OFF | ACQUISITION | DECEASED | UNKNOWN ("" = not recorded).
   *
   * @generated from field: string end_reason = 15;
   */ _define_property(this, "endReason", ""), /**
   * Where they went when that is not a registry row (<= 200 chars).
   *
   * @generated from field: string departure_destination_text = 16;
   */ _define_property(this, "departureDestinationText", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContactEmployment, "runtime", proto3);
_define_property(ContactEmployment, "typeName", "mono.datagateway.v1.ContactEmployment");
_define_property(ContactEmployment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "government_organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "employment_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 12,
            name: "evidence_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "seat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "end_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "departure_destination_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateContactEmploymentRequest
 */ export class CreateContactEmploymentRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateContactEmploymentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateContactEmploymentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateContactEmploymentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateContactEmploymentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContactEmployment contact_employment = 1;
   */ _define_property(this, "contactEmployment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateContactEmploymentRequest, "runtime", proto3);
_define_property(CreateContactEmploymentRequest, "typeName", "mono.datagateway.v1.CreateContactEmploymentRequest");
_define_property(CreateContactEmploymentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact_employment",
            kind: "message",
            T: ContactEmployment
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateContactEmploymentResponse
 */ export class CreateContactEmploymentResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateContactEmploymentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateContactEmploymentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateContactEmploymentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateContactEmploymentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContactEmployment contact_employment = 1;
   */ _define_property(this, "contactEmployment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateContactEmploymentResponse, "runtime", proto3);
_define_property(CreateContactEmploymentResponse, "typeName", "mono.datagateway.v1.CreateContactEmploymentResponse");
_define_property(CreateContactEmploymentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact_employment",
            kind: "message",
            T: ContactEmployment
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.EndContactEmploymentRequest
 */ export class EndContactEmploymentRequest extends Message {
    static fromBinary(bytes, options) {
        return new EndContactEmploymentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EndContactEmploymentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EndContactEmploymentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EndContactEmploymentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: google.protobuf.Timestamp end_date = 3;
   */ _define_property(this, "endDate", void 0), /**
   * REG-31; closed set, "" = not recorded
   *
   * @generated from field: string end_reason = 4;
   */ _define_property(this, "endReason", ""), /**
   * REG-31; <= 200 chars
   *
   * @generated from field: string departure_destination_text = 5;
   */ _define_property(this, "departureDestinationText", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EndContactEmploymentRequest, "runtime", proto3);
_define_property(EndContactEmploymentRequest, "typeName", "mono.datagateway.v1.EndContactEmploymentRequest");
_define_property(EndContactEmploymentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "end_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "departure_destination_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.EndContactEmploymentResponse
 */ export class EndContactEmploymentResponse extends Message {
    static fromBinary(bytes, options) {
        return new EndContactEmploymentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EndContactEmploymentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EndContactEmploymentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EndContactEmploymentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContactEmployment contact_employment = 1;
   */ _define_property(this, "contactEmployment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EndContactEmploymentResponse, "runtime", proto3);
_define_property(EndContactEmploymentResponse, "typeName", "mono.datagateway.v1.EndContactEmploymentResponse");
_define_property(EndContactEmploymentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact_employment",
            kind: "message",
            T: ContactEmployment
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListContactEmploymentsRequest
 */ export class ListContactEmploymentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListContactEmploymentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContactEmploymentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContactEmploymentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContactEmploymentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string contact_id = 2;
   */ _define_property(this, "contactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContactEmploymentsRequest, "runtime", proto3);
_define_property(ListContactEmploymentsRequest, "typeName", "mono.datagateway.v1.ListContactEmploymentsRequest");
_define_property(ListContactEmploymentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListContactEmploymentsResponse
 */ export class ListContactEmploymentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListContactEmploymentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContactEmploymentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContactEmploymentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContactEmploymentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ContactEmployment contact_employments = 1;
   */ _define_property(this, "contactEmployments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContactEmploymentsResponse, "runtime", proto3);
_define_property(ListContactEmploymentsResponse, "typeName", "mono.datagateway.v1.ListContactEmploymentsResponse");
_define_property(ListContactEmploymentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact_employments",
            kind: "message",
            T: ContactEmployment,
            repeated: true
        }
    ]));
/**
 * Merge folds loser into survivor (resolve-at-read; audited; reversible).
 * Typed failures surface as FAILED_PRECONDITION: two platform accounts never
 * merge (B5); self-merge, merged/deleted parties refused.
 *
 * @generated from message mono.datagateway.v1.MergeContactsRequest
 */ export class MergeContactsRequest extends Message {
    static fromBinary(bytes, options) {
        return new MergeContactsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MergeContactsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MergeContactsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MergeContactsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string loser_contact_id = 2;
   */ _define_property(this, "loserContactId", ""), /**
   * @generated from field: string survivor_contact_id = 3;
   */ _define_property(this, "survivorContactId", ""), /**
   * @generated from field: string decided_by = 4;
   */ _define_property(this, "decidedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MergeContactsRequest, "runtime", proto3);
_define_property(MergeContactsRequest, "typeName", "mono.datagateway.v1.MergeContactsRequest");
_define_property(MergeContactsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "loser_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "survivor_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "decided_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MergeContactsResponse
 */ export class MergeContactsResponse extends Message {
    static fromBinary(bytes, options) {
        return new MergeContactsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MergeContactsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MergeContactsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MergeContactsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string event_id = 1;
   */ _define_property(this, "eventId", ""), /**
   * @generated from field: mono.datagateway.v1.Contact survivor = 2;
   */ _define_property(this, "survivor", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MergeContactsResponse, "runtime", proto3);
_define_property(MergeContactsResponse, "typeName", "mono.datagateway.v1.MergeContactsResponse");
_define_property(MergeContactsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "survivor",
            kind: "message",
            T: Contact
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UnmergeContactsRequest
 */ export class UnmergeContactsRequest extends Message {
    static fromBinary(bytes, options) {
        return new UnmergeContactsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnmergeContactsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnmergeContactsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnmergeContactsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string contact_id = 2;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string decided_by = 3;
   */ _define_property(this, "decidedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnmergeContactsRequest, "runtime", proto3);
_define_property(UnmergeContactsRequest, "typeName", "mono.datagateway.v1.UnmergeContactsRequest");
_define_property(UnmergeContactsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "decided_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UnmergeContactsResponse
 */ export class UnmergeContactsResponse extends Message {
    static fromBinary(bytes, options) {
        return new UnmergeContactsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnmergeContactsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnmergeContactsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnmergeContactsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Contact contact = 1;
   */ _define_property(this, "contact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnmergeContactsResponse, "runtime", proto3);
_define_property(UnmergeContactsResponse, "typeName", "mono.datagateway.v1.UnmergeContactsResponse");
_define_property(UnmergeContactsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact",
            kind: "message",
            T: Contact
        }
    ]));
/**
 * One audited merge (and its optional reversal) — the survivor drawer's
 * merge history reads these.
 *
 * @generated from message mono.datagateway.v1.ContactMergeEvent
 */ export class ContactMergeEvent extends Message {
    static fromBinary(bytes, options) {
        return new ContactMergeEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContactMergeEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContactMergeEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContactMergeEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string loser_contact_id = 3;
   */ _define_property(this, "loserContactId", ""), /**
   * @generated from field: string survivor_contact_id = 4;
   */ _define_property(this, "survivorContactId", ""), /**
   * @generated from field: string decided_by = 5;
   */ _define_property(this, "decidedBy", ""), /**
   * @generated from field: string loser_snapshot_json = 6;
   */ _define_property(this, "loserSnapshotJson", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp reversed_at = 8;
   */ _define_property(this, "reversedAt", void 0), /**
   * @generated from field: string reversed_by = 9;
   */ _define_property(this, "reversedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContactMergeEvent, "runtime", proto3);
_define_property(ContactMergeEvent, "typeName", "mono.datagateway.v1.ContactMergeEvent");
_define_property(ContactMergeEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "loser_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "survivor_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "decided_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "loser_snapshot_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "reversed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "reversed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListContactMergeEventsRequest
 */ export class ListContactMergeEventsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListContactMergeEventsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContactMergeEventsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContactMergeEventsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContactMergeEventsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string contact_id = 2;
   */ _define_property(this, "contactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContactMergeEventsRequest, "runtime", proto3);
_define_property(ListContactMergeEventsRequest, "typeName", "mono.datagateway.v1.ListContactMergeEventsRequest");
_define_property(ListContactMergeEventsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListContactMergeEventsResponse
 */ export class ListContactMergeEventsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListContactMergeEventsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContactMergeEventsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContactMergeEventsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContactMergeEventsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ContactMergeEvent events = 1;
   */ _define_property(this, "events", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContactMergeEventsResponse, "runtime", proto3);
_define_property(ListContactMergeEventsResponse, "typeName", "mono.datagateway.v1.ListContactMergeEventsResponse");
_define_property(ListContactMergeEventsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "events",
            kind: "message",
            T: ContactMergeEvent,
            repeated: true
        }
    ]));
/**
 * RateObservation is one typed money fact (Phase 4 slice 1): amount + unit +
 * burden basis for a company x LCAT entry VERSION x vehicle, in a rate period.
 * Types are never blurred; rows are append-only (a correction is a NEW row
 * carrying corrects_id); period_label is immutable source text beside a
 * derived coercion layer. PAY and contact-scoped rows are vault-gated (W4-B)
 * and refused with FAILED_PRECONDITION until then.
 *
 * @generated from message mono.datagateway.v1.RateObservation
 */ export class RateObservation extends Message {
    static fromBinary(bytes, options) {
        return new RateObservation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RateObservation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RateObservation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RateObservation, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string lcat_entry_id = 3;
   */ _define_property(this, "lcatEntryId", ""), /**
   * @generated from field: string company_profile_id = 4;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string contract_vehicle_id = 5;
   */ _define_property(this, "contractVehicleId", ""), /**
   * @generated from field: string program_id = 6;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string contract_clin_id = 7;
   */ _define_property(this, "contractClinId", ""), /**
   * @generated from field: string contact_id = 8;
   */ _define_property(this, "contactId", ""), /**
   * CEILING | PROPOSED | SUBK_AGREED | BILLED | PAY | INFERRED
   *
   * @generated from field: string observation_type = 9;
   */ _define_property(this, "observationType", ""), /**
   * @generated from field: double amount = 10;
   */ _define_property(this, "amount", 0), /**
   * @generated from field: string currency = 11;
   */ _define_property(this, "currency", ""), /**
   * HOURLY | DAILY | MONTHLY | ANNUAL | FIXED
   *
   * @generated from field: string rate_unit = 12;
   */ _define_property(this, "rateUnit", ""), /**
   * FULLY_BURDENED | BURDENED_NO_FEE | UNBURDENED | UNKNOWN
   *
   * @generated from field: string burden_basis = 13;
   */ _define_property(this, "burdenBasis", ""), /**
   * Immutable source text, exactly as the sheet published it.
   *
   * @generated from field: string period_label = 14;
   */ _define_property(this, "periodLabel", ""), /**
   * @generated from field: string period_raw_text = 15;
   */ _define_property(this, "periodRawText", ""), /**
   * Derived comparison layer — never overwrites the label.
   *
   * @generated from field: google.protobuf.Timestamp period_start = 16;
   */ _define_property(this, "periodStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp period_end = 17;
   */ _define_property(this, "periodEnd", void 0), /**
   * DATE_RANGE | FY_OR_SLASH_YEAR | ORDINAL_YEAR | UNKNOWN
   *
   * @generated from field: string period_kind = 18;
   */ _define_property(this, "periodKind", ""), /**
   * @generated from field: string normalized_period_key = 19;
   */ _define_property(this, "normalizedPeriodKey", ""), /**
   * @generated from field: optional double period_confidence = 20;
   */ _define_property(this, "periodConfidence", void 0), /**
   * @generated from field: string period_rule = 21;
   */ _define_property(this, "periodRule", ""), /**
   * @generated from field: string worksite = 22;
   */ _define_property(this, "worksite", ""), /**
   * @generated from field: string locality = 23;
   */ _define_property(this, "locality", ""), /**
   * MANUAL | SHEET | EXTRACTION | DERIVED | IMPORT
   *
   * @generated from field: string source = 24;
   */ _define_property(this, "source", ""), /**
   * @generated from field: optional double confidence = 25;
   */ _define_property(this, "confidence", void 0), /**
   * @generated from field: string source_document_id = 26;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string evidence_json = 27;
   */ _define_property(this, "evidenceJson", ""), /**
   * @generated from field: string recorded_by = 28;
   */ _define_property(this, "recordedBy", ""), /**
   * @generated from field: string corrects_id = 29;
   */ _define_property(this, "correctsId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 30;
   */ _define_property(this, "createdAt", void 0), /**
   * The GSA Special Item Number the rate was priced under, as the document wrote
   * it. A rate DIMENSION one level below the vehicle — the same shape as
   * pricing_sheet_generations.vehicle_pool — not part of a labor category's
   * identity: one published title priced under two schedules is one job at two
   * prices, and forking the entry would fork its Rosetta edges.
   *
   * Verbatim, so a non-code line like "Ancillary" stays "Ancillary" rather than
   * having a SIN invented for it. Nullable: only MAS-family vehicles have SINs.
   *
   * Without it, five of fifty-five identities on one real MAS pricelist collapse
   * into pairs holding two different current ceilings with nothing to choose
   * between them.
   *
   * @generated from field: string sin = 31;
   */ _define_property(this, "sin", ""), /**
   * Audit metadata; source evidence and the original observation stay immutable.
   *
   * @generated from field: string correction_reason = 32;
   */ _define_property(this, "correctionReason", ""), /**
   * @generated from field: string corrected_by_id = 33;
   */ _define_property(this, "correctedById", ""), /**
   * @generated from field: string invalidation_reason = 34;
   */ _define_property(this, "invalidationReason", ""), /**
   * @generated from field: string invalidated_by = 35;
   */ _define_property(this, "invalidatedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp invalidated_at = 36;
   */ _define_property(this, "invalidatedAt", void 0), /**
   * @generated from field: string replacement_id = 37;
   */ _define_property(this, "replacementId", ""), /**
   * @generated from field: string replaces_id = 38;
   */ _define_property(this, "replacesId", ""), /**
   * SAD-450: exact source of a pricing-sheet rate — the sheet generation and the
   * reviewed block (change item, in its change set) that minted it. The sheet and
   * cell locator is in evidence_json. Empty for manual rows.
   *
   * @generated from field: string source_generation_id = 39;
   */ _define_property(this, "sourceGenerationId", ""), /**
   * @generated from field: string source_change_item_id = 40;
   */ _define_property(this, "sourceChangeItemId", ""), /**
   * @generated from field: string source_change_set_id = 41;
   */ _define_property(this, "sourceChangeSetId", ""), /**
   * @generated from field: string source_label = 42;
   */ _define_property(this, "sourceLabel", ""), /**
   * @generated from field: string mapped_anchor_id = 43;
   */ _define_property(this, "mappedAnchorId", ""), /**
   * @generated from field: string mapped_anchor_title = 44;
   */ _define_property(this, "mappedAnchorTitle", ""), /**
   * @generated from field: string mapped_relation = 45;
   */ _define_property(this, "mappedRelation", ""), /**
   * @generated from field: string mapped_status = 46;
   */ _define_property(this, "mappedStatus", ""), /**
   * @generated from field: string effective_vehicle_id = 48;
   */ _define_property(this, "effectiveVehicleId", ""), /**
   * @generated from field: string effective_vehicle_name = 49;
   */ _define_property(this, "effectiveVehicleName", ""), /**
   * REG-26: the period key after a person's decision (YYYY-MM-DD/YYYY-MM-DD);
   * equals normalized_period_key while undecided. period_label stays verbatim.
   *
   * @generated from field: string resolved_normalized_period_key = 47;
   */ _define_property(this, "resolvedNormalizedPeriodKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RateObservation, "runtime", proto3);
_define_property(RateObservation, "typeName", "mono.datagateway.v1.RateObservation");
_define_property(RateObservation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "lcat_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "contract_clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "observation_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 11,
            name: "currency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "rate_unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "burden_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "period_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "period_raw_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "period_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "period_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 18,
            name: "period_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "normalized_period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "period_confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 21,
            name: "period_rule",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "worksite",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "locality",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 25,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 26,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 27,
            name: "evidence_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 28,
            name: "recorded_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 29,
            name: "corrects_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 30,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 31,
            name: "sin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 32,
            name: "correction_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 33,
            name: "corrected_by_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 34,
            name: "invalidation_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 35,
            name: "invalidated_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 36,
            name: "invalidated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 37,
            name: "replacement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 38,
            name: "replaces_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 39,
            name: "source_generation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 40,
            name: "source_change_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 41,
            name: "source_change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 42,
            name: "source_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 43,
            name: "mapped_anchor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 44,
            name: "mapped_anchor_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 45,
            name: "mapped_relation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 46,
            name: "mapped_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 48,
            name: "effective_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 49,
            name: "effective_vehicle_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 47,
            name: "resolved_normalized_period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RateObservationFilter
 */ export class RateObservationFilter extends Message {
    static fromBinary(bytes, options) {
        return new RateObservationFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RateObservationFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RateObservationFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RateObservationFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string lcat_entry_id = 2;
   */ _define_property(this, "lcatEntryId", ""), /**
   * @generated from field: string company_profile_id = 3;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string contract_vehicle_id = 4;
   */ _define_property(this, "contractVehicleId", ""), /**
   * @generated from field: string observation_type = 5;
   */ _define_property(this, "observationType", ""), /**
   * @generated from field: string normalized_period_key = 6;
   */ _define_property(this, "normalizedPeriodKey", ""), /**
   * Full history: includes superseded and explicitly invalidated observations.
   *
   * @generated from field: bool include_corrected = 7;
   */ _define_property(this, "includeCorrected", false), /**
   * Filter by schedule line — "every rate code on SIN 54151S".
   *
   * @generated from field: string sin = 8;
   */ _define_property(this, "sin", ""), /**
   * @generated from field: string rate_unit = 9;
   */ _define_property(this, "rateUnit", ""), /**
   * @generated from field: string burden_basis = 10;
   */ _define_property(this, "burdenBasis", ""), /**
   * @generated from field: string anchor_id = 11;
   */ _define_property(this, "anchorId", ""), /**
   * @generated from field: repeated string relation_in = 12;
   */ _define_property(this, "relationIn", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RateObservationFilter, "runtime", proto3);
_define_property(RateObservationFilter, "typeName", "mono.datagateway.v1.RateObservationFilter");
_define_property(RateObservationFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "lcat_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "observation_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "normalized_period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "include_corrected",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "sin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "rate_unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "burden_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "anchor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "relation_in",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateRateObservationRequest
 */ export class CreateRateObservationRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateRateObservationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRateObservationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRateObservationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRateObservationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RateObservation rate_observation = 1;
   */ _define_property(this, "rateObservation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRateObservationRequest, "runtime", proto3);
_define_property(CreateRateObservationRequest, "typeName", "mono.datagateway.v1.CreateRateObservationRequest");
_define_property(CreateRateObservationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rate_observation",
            kind: "message",
            T: RateObservation
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateRateObservationResponse
 */ export class CreateRateObservationResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateRateObservationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRateObservationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRateObservationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRateObservationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RateObservation rate_observation = 1;
   */ _define_property(this, "rateObservation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRateObservationResponse, "runtime", proto3);
_define_property(CreateRateObservationResponse, "typeName", "mono.datagateway.v1.CreateRateObservationResponse");
_define_property(CreateRateObservationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rate_observation",
            kind: "message",
            T: RateObservation
        }
    ]));
/**
 * Correct supersedes an existing observation with a new row. The original is
 * never rewritten; the correction inherits identity axes it does not restate,
 * and may NOT change observation_type.
 *
 * @generated from message mono.datagateway.v1.CorrectRateObservationRequest
 */ export class CorrectRateObservationRequest extends Message {
    static fromBinary(bytes, options) {
        return new CorrectRateObservationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CorrectRateObservationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CorrectRateObservationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CorrectRateObservationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string corrects_id = 2;
   */ _define_property(this, "correctsId", ""), /**
   * @generated from field: mono.datagateway.v1.RateObservation rate_observation = 3;
   */ _define_property(this, "rateObservation", void 0), /**
   * Required; stored separately from source evidence.
   *
   * @generated from field: string reason = 4;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CorrectRateObservationRequest, "runtime", proto3);
_define_property(CorrectRateObservationRequest, "typeName", "mono.datagateway.v1.CorrectRateObservationRequest");
_define_property(CorrectRateObservationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "corrects_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "rate_observation",
            kind: "message",
            T: RateObservation
        },
        {
            no: 4,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CorrectRateObservationResponse
 */ export class CorrectRateObservationResponse extends Message {
    static fromBinary(bytes, options) {
        return new CorrectRateObservationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CorrectRateObservationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CorrectRateObservationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CorrectRateObservationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RateObservation rate_observation = 1;
   */ _define_property(this, "rateObservation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CorrectRateObservationResponse, "runtime", proto3);
_define_property(CorrectRateObservationResponse, "typeName", "mono.datagateway.v1.CorrectRateObservationResponse");
_define_property(CorrectRateObservationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rate_observation",
            kind: "message",
            T: RateObservation
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRateObservationsRequest
 */ export class ListRateObservationsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRateObservationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRateObservationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRateObservationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRateObservationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RateObservationFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRateObservationsRequest, "runtime", proto3);
_define_property(ListRateObservationsRequest, "typeName", "mono.datagateway.v1.ListRateObservationsRequest");
_define_property(ListRateObservationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: RateObservationFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRateObservationsResponse
 */ export class ListRateObservationsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRateObservationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRateObservationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRateObservationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRateObservationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.RateObservation rate_observations = 1;
   */ _define_property(this, "rateObservations", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRateObservationsResponse, "runtime", proto3);
_define_property(ListRateObservationsResponse, "typeName", "mono.datagateway.v1.ListRateObservationsResponse");
_define_property(ListRateObservationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rate_observations",
            kind: "message",
            T: RateObservation,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * "Every rate for this LABOR CATEGORY" — spans the entry's version chain,
 * because a rate pins the version that was current when it was observed.
 *
 * @generated from message mono.datagateway.v1.ListRateObservationsForEntryChainRequest
 */ export class ListRateObservationsForEntryChainRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRateObservationsForEntryChainRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRateObservationsForEntryChainRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRateObservationsForEntryChainRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRateObservationsForEntryChainRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string lcat_entry_id = 2;
   */ _define_property(this, "lcatEntryId", ""), /**
   * @generated from field: string observation_type = 3;
   */ _define_property(this, "observationType", ""), /**
   * @generated from field: bool include_corrected = 4;
   */ _define_property(this, "includeCorrected", false), /**
   * @generated from field: string anchor_id = 5;
   */ _define_property(this, "anchorId", ""), /**
   * @generated from field: repeated string relation_in = 6;
   */ _define_property(this, "relationIn", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRateObservationsForEntryChainRequest, "runtime", proto3);
_define_property(ListRateObservationsForEntryChainRequest, "typeName", "mono.datagateway.v1.ListRateObservationsForEntryChainRequest");
_define_property(ListRateObservationsForEntryChainRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "lcat_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "observation_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "include_corrected",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "anchor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "relation_in",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRateObservationsForEntryChainResponse
 */ export class ListRateObservationsForEntryChainResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRateObservationsForEntryChainResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRateObservationsForEntryChainResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRateObservationsForEntryChainResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRateObservationsForEntryChainResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.RateObservation rate_observations = 1;
   */ _define_property(this, "rateObservations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRateObservationsForEntryChainResponse, "runtime", proto3);
_define_property(ListRateObservationsForEntryChainResponse, "typeName", "mono.datagateway.v1.ListRateObservationsForEntryChainResponse");
_define_property(ListRateObservationsForEntryChainResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rate_observations",
            kind: "message",
            T: RateObservation,
            repeated: true
        }
    ]));
/**
 * Compatibility RPC: explicitly INVALIDATES; never deletes or restores a predecessor.
 *
 * @generated from message mono.datagateway.v1.DeleteRateObservationRequest
 */ export class DeleteRateObservationRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteRateObservationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteRateObservationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteRateObservationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteRateObservationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * Required. Actor/time come from the server.
   *
   * @generated from field: string reason = 3;
   */ _define_property(this, "reason", ""), /**
   * Optional correctly attributed, independently typed new observation.
   *
   * @generated from field: mono.datagateway.v1.RateObservation replacement = 4;
   */ _define_property(this, "replacement", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteRateObservationRequest, "runtime", proto3);
_define_property(DeleteRateObservationRequest, "typeName", "mono.datagateway.v1.DeleteRateObservationRequest");
_define_property(DeleteRateObservationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "replacement",
            kind: "message",
            T: RateObservation
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteRateObservationResponse
 */ export class DeleteRateObservationResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteRateObservationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteRateObservationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteRateObservationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteRateObservationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RateObservation replacement = 1;
   */ _define_property(this, "replacement", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteRateObservationResponse, "runtime", proto3);
_define_property(DeleteRateObservationResponse, "typeName", "mono.datagateway.v1.DeleteRateObservationResponse");
_define_property(DeleteRateObservationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "replacement",
            kind: "message",
            T: RateObservation
        }
    ]));
/**
 * Capability is a tenant-wide catalog entry a program's capabilities pick from
 * (registry pattern, same shape as Contact).
 *
 * @generated from message mono.datagateway.v1.Capability
 */ export class Capability extends Message {
    static fromBinary(bytes, options) {
        return new Capability().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Capability().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Capability().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Capability, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string description = 4;
   */ _define_property(this, "description", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 7;
   */ _define_property(this, "deletedAt", void 0), /**
   * @generated from field: bool is_system = 8;
   */ _define_property(this, "isSystem", false), /**
   * Set when the requesting tenant has retired this capability (per-tenant
   * state, so a retired _system starter is retired for that tenant only).
   *
   * @generated from field: google.protobuf.Timestamp retired_at = 9;
   */ _define_property(this, "retiredAt", void 0), /**
   * @generated from field: string category = 10;
   */ _define_property(this, "category", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(Capability, "runtime", proto3);
_define_property(Capability, "typeName", "mono.datagateway.v1.Capability");
_define_property(Capability, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "is_system",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "retired_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractVehicle
 */ export class ContractVehicle extends Message {
    static fromBinary(bytes, options) {
        return new ContractVehicle().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractVehicle().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractVehicle().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractVehicle, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string vehicle_type = 4;
   */ _define_property(this, "vehicleType", ""), /**
   * @generated from field: string contract_number = 5;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 8;
   */ _define_property(this, "deletedAt", void 0), /**
   * @generated from field: string description = 9;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string awarding_agency_org_id = 10;
   */ _define_property(this, "awardingAgencyOrgId", ""), /**
   * @generated from field: string agency_acronym = 11;
   */ _define_property(this, "agencyAcronym", ""), /**
   * @generated from field: string naics_code = 12;
   */ _define_property(this, "naicsCode", ""), /**
   * @generated from field: google.protobuf.Timestamp ordering_period_start = 13;
   */ _define_property(this, "orderingPeriodStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp ordering_period_end = 14;
   */ _define_property(this, "orderingPeriodEnd", void 0), /**
   * @generated from field: double max_ceiling_value = 15;
   */ _define_property(this, "maxCeilingValue", 0), /**
   * @generated from field: string vehicle_scope = 16;
   */ _define_property(this, "vehicleScope", ""), /**
   * @generated from field: string status = 17;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string notes = 18;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: string seed_key = 19;
   */ _define_property(this, "seedKey", ""), /**
   * @generated from field: bool is_system_seed = 20;
   */ _define_property(this, "isSystemSeed", false), /**
   * @generated from field: string verification_status = 21;
   */ _define_property(this, "verificationStatus", ""), /**
   * no canonical organization; source text is not identity
   *
   * @generated from field: bool agency_unresolved = 22;
   */ _define_property(this, "agencyUnresolved", false), /**
   * @generated from field: string legacy_source_agency = 23;
   */ _define_property(this, "legacySourceAgency", ""), /**
   * @generated from field: int64 revision = 24;
   */ _define_property(this, "revision", protoInt64.zero), /**
   * REG-55: survivor id when this row was merged into another; lists hide losers.
   *
   * @generated from field: string merged_into_id = 25;
   */ _define_property(this, "mergedIntoId", ""), /**
   * @generated from field: string full_name = 26;
   */ _define_property(this, "fullName", ""), /**
   * GOVERNMENT_WIDE|AGENCY_SPECIFIC|UNKNOWN (empty = UNKNOWN)
   *
   * @generated from field: string ordering_eligibility = 27;
   */ _define_property(this, "orderingEligibility", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractVehicle, "runtime", proto3);
_define_property(ContractVehicle, "typeName", "mono.datagateway.v1.ContractVehicle");
_define_property(ContractVehicle, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "vehicle_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "awarding_agency_org_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "agency_acronym",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "naics_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "ordering_period_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "ordering_period_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "max_ceiling_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 16,
            name: "vehicle_scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "seed_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "is_system_seed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 21,
            name: "verification_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "agency_unresolved",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 23,
            name: "legacy_source_agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 25,
            name: "merged_into_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 26,
            name: "full_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 27,
            name: "ordering_eligibility",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.Program
 */ export class Program extends Message {
    static fromBinary(bytes, options) {
        return new Program().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Program().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Program().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Program, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_name_full = 3;
   */ _define_property(this, "programNameFull", ""), /**
   * @generated from field: string program_name_short = 4;
   */ _define_property(this, "programNameShort", ""), /**
   * @generated from field: string deltek_project_number = 5;
   */ _define_property(this, "deltekProjectNumber", ""), /**
   * @generated from field: string contract_number = 6;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string task_number = 7;
   */ _define_property(this, "taskNumber", ""), /**
   * @generated from field: string contract_vehicle_id = 8;
   */ _define_property(this, "contractVehicleId", ""), /**
   * @generated from field: string naics_code = 9;
   */ _define_property(this, "naicsCode", ""), /**
   * @generated from field: string contract_title = 12;
   */ _define_property(this, "contractTitle", ""), /**
   * @generated from field: google.protobuf.Timestamp award_date = 13;
   */ _define_property(this, "awardDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 14;
   */ _define_property(this, "effectiveDate", void 0), /**
   * @generated from field: double tcv_on_award = 15;
   */ _define_property(this, "tcvOnAward", 0), /**
   * @generated from field: bool deliverable_based_invoicing = 16;
   */ _define_property(this, "deliverableBasedInvoicing", false), /**
   * @generated from field: string sector_id = 17;
   */ _define_property(this, "sectorId", ""), /**
   * @generated from field: string business_unit_id = 18;
   */ _define_property(this, "businessUnitId", ""), /**
   * @generated from field: string portfolio_id = 19;
   */ _define_property(this, "portfolioId", ""), /**
   * @generated from field: google.protobuf.Timestamp contract_start_date = 23;
   */ _define_property(this, "contractStartDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp contract_end_date = 24;
   */ _define_property(this, "contractEndDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp company_start_date = 25;
   */ _define_property(this, "companyStartDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp company_end_date = 26;
   */ _define_property(this, "companyEndDate", void 0), /**
   * @generated from field: string description = 31;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string work_unique = 32;
   */ _define_property(this, "workUnique", ""), /**
   * JSON []string
   *
   * @generated from field: string work_types = 33;
   */ _define_property(this, "workTypes", ""), /**
   * JSON []string
   *
   * @generated from field: string technologies = 34;
   */ _define_property(this, "technologies", ""), /**
   * JSON []string
   *
   * @generated from field: string tools = 35;
   */ _define_property(this, "tools", ""), /**
   * @generated from field: string zou_project_id = 36;
   */ _define_property(this, "zouProjectId", ""), /**
   * @generated from field: string idiq_program_id = 37;
   */ _define_property(this, "idiqProgramId", ""), /**
   * @generated from field: google.protobuf.Timestamp last_synced_from_zou_at = 38;
   */ _define_property(this, "lastSyncedFromZouAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 39;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 40;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 41;
   */ _define_property(this, "deletedAt", void 0), /**
   * ---- Phase 0a SDS extensions (workspace + contract identity + lifecycle) ----
   * Workspace metadata absorbed from zou.Project when the project's type=CONTRACT.
   *
   * @generated from field: string name = 42;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string status = 43;
   */ _define_property(this, "status", ""), /**
   * @generated from field: google.protobuf.Timestamp last_activity_at = 44;
   */ _define_property(this, "lastActivityAt", void 0), /**
   * @generated from field: string created_by = 45;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp archived_at = 46;
   */ _define_property(this, "archivedAt", void 0), /**
   * @generated from field: string archived_by = 47;
   */ _define_property(this, "archivedBy", ""), /**
   * Contract identity absorbed from zou.ProjectContractInfo.
   *
   * @generated from field: string solicitation_number = 48;
   */ _define_property(this, "solicitationNumber", ""), /**
   * @generated from field: string stage = 49;
   */ _define_property(this, "stage", ""), /**
   * @generated from field: string contract_analysis_id = 50;
   */ _define_property(this, "contractAnalysisId", ""), /**
   * @generated from field: string source_proposal_project_id = 51;
   */ _define_property(this, "sourceProposalProjectId", ""), /**
   * @generated from field: string agency_acronym = 52;
   */ _define_property(this, "agencyAcronym", ""), /**
   * @generated from field: string sub_agency = 53;
   */ _define_property(this, "subAgency", ""), /**
   * @generated from field: string sub_agency_acronym = 54;
   */ _define_property(this, "subAgencyAcronym", ""), /**
   * @generated from field: google.protobuf.Timestamp pop_start_date = 55;
   */ _define_property(this, "popStartDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp pop_end_date = 56;
   */ _define_property(this, "popEndDate", void 0), /**
   * @generated from field: int32 pop_duration_months = 57;
   */ _define_property(this, "popDurationMonths", 0), /**
   * @generated from field: double base_value = 58;
   */ _define_property(this, "baseValue", 0), /**
   * @generated from field: double total_ceiling = 59;
   */ _define_property(this, "totalCeiling", 0), /**
   * @generated from field: string currency = 60;
   */ _define_property(this, "currency", ""), /**
   * @generated from field: string contract_type = 61;
   */ _define_property(this, "contractType", ""), /**
   * @generated from field: string prime_contractor_name = 62;
   */ _define_property(this, "primeContractorName", ""), /**
   * @generated from field: string prime_contractor_duns = 63;
   */ _define_property(this, "primeContractorDuns", ""), /**
   * @generated from field: string prime_contractor_uei = 64;
   */ _define_property(this, "primeContractorUei", ""), /**
   * @generated from field: string prime_contractor_cage_code = 65;
   */ _define_property(this, "primeContractorCageCode", ""), /**
   * Extraction processing snapshot.
   *
   * @generated from field: string processing_job_id = 66;
   */ _define_property(this, "processingJobId", ""), /**
   * @generated from field: string processing_status = 67;
   */ _define_property(this, "processingStatus", ""), /**
   * @generated from field: int32 processing_progress = 68;
   */ _define_property(this, "processingProgress", 0), /**
   * @generated from field: string processing_current_step = 69;
   */ _define_property(this, "processingCurrentStep", ""), /**
   * @generated from field: google.protobuf.Timestamp processing_completed_at = 70;
   */ _define_property(this, "processingCompletedAt", void 0), /**
   * @generated from field: string processing_error = 71;
   */ _define_property(this, "processingError", ""), /**
   * @generated from field: int32 data_version = 72;
   */ _define_property(this, "dataVersion", 0), /**
   * @generated from field: double extraction_confidence_table_detection = 73;
   */ _define_property(this, "extractionConfidenceTableDetection", 0), /**
   * @generated from field: double extraction_confidence_enrichment = 74;
   */ _define_property(this, "extractionConfidenceEnrichment", 0), /**
   * @generated from field: double extraction_confidence_overall = 75;
   */ _define_property(this, "extractionConfidenceOverall", 0), /**
   * JSON []string
   *
   * @generated from field: string extraction_notes_json = 76;
   */ _define_property(this, "extractionNotesJson", ""), /**
   * @generated from field: string extraction_version = 77;
   */ _define_property(this, "extractionVersion", ""), /**
   * SDS-aligned financial baseline. tcv_on_award (field 15) is the originally
   * awarded amount; current_tcv tracks running TCV after modifications.
   *
   * @generated from field: double funded_amount = 78;
   */ _define_property(this, "fundedAmount", 0), /**
   * @generated from field: double funded_percent = 79;
   */ _define_property(this, "fundedPercent", 0), /**
   * @generated from field: double current_tcv = 80;
   */ _define_property(this, "currentTcv", 0), /**
   * ---- Foundation (000010): normalized program fields ----
   *
   * @generated from field: string pricing_type = 82;
   */ _define_property(this, "pricingType", ""), /**
   * @generated from field: string company_role_type = 83;
   */ _define_property(this, "companyRoleType", ""), /**
   * contracting office
   *
   * @generated from field: string government_organization_id = 84;
   */ _define_property(this, "governmentOrganizationId", ""), /**
   * customer / mission office
   *
   * @generated from field: string customer_org_id = 85;
   */ _define_property(this, "customerOrgId", ""), /**
   * @generated from field: string prime_contractor_company_id = 86;
   */ _define_property(this, "primeContractorCompanyId", ""), /**
   * @generated from field: string legal_entity_company_id = 87;
   */ _define_property(this, "legalEntityCompanyId", ""), /**
   * @generated from field: string record_status_id = 88;
   */ _define_property(this, "recordStatusId", ""), /**
   * @generated from field: string contract_lifecycle_state_id = 89;
   */ _define_property(this, "contractLifecycleStateId", ""), /**
   * @generated from field: string operational_state_id = 90;
   */ _define_property(this, "operationalStateId", ""), /**
   * @generated from field: string delivery_model_type_id = 91;
   */ _define_property(this, "deliveryModelTypeId", ""), /**
   * Read helpers (JOIN at handler; not stored)
   *
   * @generated from field: string government_organization_name = 92;
   */ _define_property(this, "governmentOrganizationName", ""), /**
   * @generated from field: string customer_org_name = 93;
   */ _define_property(this, "customerOrgName", ""), /**
   * @generated from field: string cabinet_name = 94;
   */ _define_property(this, "cabinetName", ""), /**
   * @generated from field: string agency_name = 95;
   */ _define_property(this, "agencyName", ""), /**
   * @generated from field: string prime_contractor_company_name = 96;
   */ _define_property(this, "primeContractorCompanyName", ""), /**
   * @generated from field: string legal_entity_company_name = 97;
   */ _define_property(this, "legalEntityCompanyName", ""), /**
   * @generated from field: string operational_state_label = 98;
   */ _define_property(this, "operationalStateLabel", ""), /**
   * @generated from field: string contract_lifecycle_state_label = 99;
   */ _define_property(this, "contractLifecycleStateLabel", ""), /**
   * @generated from field: string record_status_label = 100;
   */ _define_property(this, "recordStatusLabel", ""), /**
   * @generated from field: string delivery_model_type_label = 101;
   */ _define_property(this, "deliveryModelTypeLabel", ""), /**
   * True when no active program_role_assignment on this program carries a role
   * type whose role_bundle_key is delivery_pm — i.e. nobody holds the lead seat
   * yet, which is the state a freshly awarded contract sits in until the
   * Delivery VP names one. DERIVED from the assignment rows on every read and
   * never stored: there is no lead-less status column to drift out of sync with
   * who is actually staffed.
   * False for EVERY program when the tenant has no role_type mapped to
   * delivery_pm — the lead role is then unidentifiable, and flagging the whole
   * tenant off one missing configuration row would cry wolf.
   *
   * @generated from field: bool needs_program_lead = 102;
   */ _define_property(this, "needsProgramLead", false), /**
   * SAD-186 project closeout lifecycle transition (migration 000103). Set by
   * DeliveryGatewayService.CloseProgram once the program's closeout
   * checklist is Completed.
   *
   * @generated from field: google.protobuf.Timestamp closed_at = 103;
   */ _define_property(this, "closedAt", void 0), /**
   * @generated from field: string closed_by = 104;
   */ _define_property(this, "closedBy", ""), /**
   * SAD-166/SAD-176 (migration 000143): the burn/AR indicator's alert
   * threshold as a percent of funded amount. Explicit presence (`optional`)
   * so an update that omits this field leaves the stored value alone rather
   * than zeroing it — see UpdateProgram's handling in delivery.go and
   * major-push/august-roadmap/_decisions.md decision D7 caveat C4. Absent
   * means "use the system default of 75" (FAR 52.232-22 limitation-of-funds
   * notification threshold).
   *
   * @generated from field: optional int32 funding_alert_threshold_pct = 105;
   */ _define_property(this, "fundingAlertThresholdPct", void 0), /**
   * @generated from field: optional string funding_basis = 106;
   */ _define_property(this, "fundingBasis", void 0), /**
   * @generated from field: optional double unallocated_funding = 107;
   */ _define_property(this, "unallocatedFunding", void 0), /**
   * Read-only canonical presence: absent legacy, false unknown, true stated.
   *
   * @generated from field: optional bool tcv_on_award_known = 108;
   */ _define_property(this, "tcvOnAwardKnown", void 0), /**
   * @generated from field: optional bool current_tcv_known = 109;
   */ _define_property(this, "currentTcvKnown", void 0), /**
   * SAD-1342: the day (YYYY-MM-DD, UTC) the current ON_HOLD stretch began.
   * Absent when the program is not on hold. On write: set when the state
   * changes into ON_HOLD (request value, else today), kept while it stays on
   * hold unless the request supplies a new one, cleared for any other state.
   *
   * @generated from field: optional string on_hold_since = 110;
   */ _define_property(this, "onHoldSince", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(Program, "runtime", proto3);
_define_property(Program, "typeName", "mono.datagateway.v1.Program");
_define_property(Program, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_name_full",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "program_name_short",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "deltek_project_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "task_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "naics_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "contract_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "award_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "tcv_on_award",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 16,
            name: "deliverable_based_invoicing",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 17,
            name: "sector_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "portfolio_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "contract_start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 24,
            name: "contract_end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 25,
            name: "company_start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 26,
            name: "company_end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 31,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 32,
            name: "work_unique",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 33,
            name: "work_types",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 34,
            name: "technologies",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 35,
            name: "tools",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 36,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 37,
            name: "idiq_program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 38,
            name: "last_synced_from_zou_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 39,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 40,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 41,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 42,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 43,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 44,
            name: "last_activity_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 45,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 46,
            name: "archived_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 47,
            name: "archived_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 48,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 49,
            name: "stage",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 50,
            name: "contract_analysis_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 51,
            name: "source_proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 52,
            name: "agency_acronym",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 53,
            name: "sub_agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 54,
            name: "sub_agency_acronym",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 55,
            name: "pop_start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 56,
            name: "pop_end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 57,
            name: "pop_duration_months",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 58,
            name: "base_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 59,
            name: "total_ceiling",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 60,
            name: "currency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 61,
            name: "contract_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 62,
            name: "prime_contractor_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 63,
            name: "prime_contractor_duns",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 64,
            name: "prime_contractor_uei",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 65,
            name: "prime_contractor_cage_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 66,
            name: "processing_job_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 67,
            name: "processing_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 68,
            name: "processing_progress",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 69,
            name: "processing_current_step",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 70,
            name: "processing_completed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 71,
            name: "processing_error",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 72,
            name: "data_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 73,
            name: "extraction_confidence_table_detection",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 74,
            name: "extraction_confidence_enrichment",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 75,
            name: "extraction_confidence_overall",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 76,
            name: "extraction_notes_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 77,
            name: "extraction_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 78,
            name: "funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 79,
            name: "funded_percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 80,
            name: "current_tcv",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 82,
            name: "pricing_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 83,
            name: "company_role_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 84,
            name: "government_organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 85,
            name: "customer_org_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 86,
            name: "prime_contractor_company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 87,
            name: "legal_entity_company_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 88,
            name: "record_status_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 89,
            name: "contract_lifecycle_state_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 90,
            name: "operational_state_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 91,
            name: "delivery_model_type_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 92,
            name: "government_organization_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 93,
            name: "customer_org_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 94,
            name: "cabinet_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 95,
            name: "agency_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 96,
            name: "prime_contractor_company_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 97,
            name: "legal_entity_company_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 98,
            name: "operational_state_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 99,
            name: "contract_lifecycle_state_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 100,
            name: "record_status_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 101,
            name: "delivery_model_type_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 102,
            name: "needs_program_lead",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 103,
            name: "closed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 104,
            name: "closed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 105,
            name: "funding_alert_threshold_pct",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ ,
            opt: true
        },
        {
            no: 106,
            name: "funding_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 107,
            name: "unallocated_funding",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 108,
            name: "tcv_on_award_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 109,
            name: "current_tcv_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 110,
            name: "on_hold_since",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProgramRole
 */ export class ProgramRole extends Message {
    static fromBinary(bytes, options) {
        return new ProgramRole().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramRole().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramRole().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramRole, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string role = 4;
   */ _define_property(this, "role", ""), /**
   * @generated from field: string name = 5;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string email = 6;
   */ _define_property(this, "email", ""), /**
   * @generated from field: bool is_primary = 7;
   */ _define_property(this, "isPrimary", false), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 10;
   */ _define_property(this, "deletedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramRole, "runtime", proto3);
_define_property(ProgramRole, "typeName", "mono.datagateway.v1.ProgramRole");
_define_property(ProgramRole, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "is_primary",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProgramCapability
 */ export class ProgramCapability extends Message {
    static fromBinary(bytes, options) {
        return new ProgramCapability().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramCapability().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramCapability().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramCapability, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string category = 4;
   */ _define_property(this, "category", ""), /**
   * @generated from field: double percentage = 5;
   */ _define_property(this, "percentage", 0), /**
   * @generated from field: string description = 6;
   */ _define_property(this, "description", ""), /**
   * Phase 0a SDS extensions absorbed from zou.CompanyCapability (the past-
   * performance evidence lens).
   *
   * @generated from field: string title = 7;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string capability_type = 8;
   */ _define_property(this, "capabilityType", ""), /**
   * JSON []CapabilitySourceDocument
   *
   * @generated from field: string source_documents_json = 9;
   */ _define_property(this, "sourceDocumentsJson", ""), /**
   * JSON []string
   *
   * @generated from field: string skills_json = 10;
   */ _define_property(this, "skillsJson", ""), /**
   * JSON []string
   *
   * @generated from field: string certifications_json = 11;
   */ _define_property(this, "certificationsJson", ""), /**
   * JSON []string
   *
   * @generated from field: string naics_codes_json = 12;
   */ _define_property(this, "naicsCodesJson", ""), /**
   * JSON []string
   *
   * @generated from field: string contract_types_json = 13;
   */ _define_property(this, "contractTypesJson", ""), /**
   * JSON []string
   *
   * @generated from field: string agencies_json = 14;
   */ _define_property(this, "agenciesJson", ""), /**
   * JSON []CapabilityPastPerformanceProof
   *
   * @generated from field: string past_performance_proofs_json = 15;
   */ _define_property(this, "pastPerformanceProofsJson", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 16;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 17;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 18;
   */ _define_property(this, "deletedAt", void 0), /**
   * The vocabulary row this was picked from; empty for a local free-text label.
   *
   * @generated from field: string capability_id = 19;
   */ _define_property(this, "capabilityId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramCapability, "runtime", proto3);
_define_property(ProgramCapability, "typeName", "mono.datagateway.v1.ProgramCapability");
_define_property(ProgramCapability, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "percentage",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "capability_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "source_documents_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "skills_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "certifications_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "naics_codes_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "contract_types_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "agencies_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "past_performance_proofs_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 18,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 19,
            name: "capability_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProgramCompanyAssignment
 */ export class ProgramCompanyAssignment extends Message {
    static fromBinary(bytes, options) {
        return new ProgramCompanyAssignment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramCompanyAssignment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramCompanyAssignment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramCompanyAssignment, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string company_profile_id = 4;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: bool active = 5;
   */ _define_property(this, "active", false), /**
   * @generated from field: string type = 6;
   */ _define_property(this, "type", ""), /**
   * @generated from field: double fte_count = 7;
   */ _define_property(this, "fteCount", 0), /**
   * @generated from field: int32 vacancies = 8;
   */ _define_property(this, "vacancies", 0), /**
   * @generated from field: google.protobuf.Timestamp termination_date = 9;
   */ _define_property(this, "terminationDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 12;
   */ _define_property(this, "deletedAt", void 0), /**
   * Phase 0a SDS extensions absorbed from zou.ContractParty: workshare +
   * per-program address (address is contract-specific in zou's model, not a
   * CompanyProfile-level attribute).
   *
   * @generated from field: double workshare_percentage = 13;
   */ _define_property(this, "worksharePercentage", 0), /**
   * @generated from field: string address_street1 = 14;
   */ _define_property(this, "addressStreet1", ""), /**
   * @generated from field: string address_street2 = 15;
   */ _define_property(this, "addressStreet2", ""), /**
   * @generated from field: string address_city = 16;
   */ _define_property(this, "addressCity", ""), /**
   * @generated from field: string address_state = 17;
   */ _define_property(this, "addressState", ""), /**
   * @generated from field: string address_zip_code = 18;
   */ _define_property(this, "addressZipCode", ""), /**
   * @generated from field: string address_country = 19;
   */ _define_property(this, "addressCountry", ""), /**
   * @generated from field: bool workshare_override = 20;
   */ _define_property(this, "workshareOverride", false), /**
   * @generated from field: double imported_workshare_percentage = 21;
   */ _define_property(this, "importedWorksharePercentage", 0), /**
   * @generated from field: string workshare_calculation_method = 22;
   */ _define_property(this, "workshareCalculationMethod", ""), /**
   * Migration 000090 — decision 1(c) hybrid FTE derivation. fte_count /
   * vacancies above are SERVED and server-owned: pangaea recomputes them
   * from staffing lines when any exist, or from these two manual columns
   * when none do. An incoming fte_count / vacancies on update is never used
   * to overwrite the served value — write fte_count_manual /
   * vacancies_manual instead.
   *
   * @generated from field: double fte_count_manual = 23;
   */ _define_property(this, "fteCountManual", 0), /**
   * @generated from field: int32 vacancies_manual = 24;
   */ _define_property(this, "vacanciesManual", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramCompanyAssignment, "runtime", proto3);
_define_property(ProgramCompanyAssignment, "typeName", "mono.datagateway.v1.ProgramCompanyAssignment");
_define_property(ProgramCompanyAssignment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "active",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "fte_count",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "vacancies",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "termination_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "workshare_percentage",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 14,
            name: "address_street1",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "address_street2",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "address_city",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "address_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "address_zip_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "address_country",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "workshare_override",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 21,
            name: "imported_workshare_percentage",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 22,
            name: "workshare_calculation_method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "fte_count_manual",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 24,
            name: "vacancies_manual",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * ProgramCompanyStaffingLine is one position under a company assignment —
 * not one person, not one timecard. A line with no contact_id is a vacancy.
 * lcat_id is the tenant registry LCAT entry id (Phase 2a of
 * major-push/lcat-intelligence/) — NOT a zou project LaborCategory id/code.
 * Empty until a registry entry is picked; lcat_title carries the display
 * snapshot and free-text fallback either way.
 * fte_count / vacancies on the parent ProgramCompanyAssignment are recomputed
 * from these rows on every write — see decision 1(c) above.
 *
 * @generated from message mono.datagateway.v1.ProgramCompanyStaffingLine
 */ export class ProgramCompanyStaffingLine extends Message {
    static fromBinary(bytes, options) {
        return new ProgramCompanyStaffingLine().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramCompanyStaffingLine().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramCompanyStaffingLine().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramCompanyStaffingLine, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string company_assignment_id = 4;
   */ _define_property(this, "companyAssignmentId", ""), /**
   * @generated from field: string lcat_id = 5;
   */ _define_property(this, "lcatId", ""), /**
   * @generated from field: string lcat_title = 6;
   */ _define_property(this, "lcatTitle", ""), /**
   * @generated from field: string position_title = 7;
   */ _define_property(this, "positionTitle", ""), /**
   * @generated from field: double fte = 8;
   */ _define_property(this, "fte", 0), /**
   * @generated from field: string contact_id = 9;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: google.protobuf.Timestamp start_date = 10;
   */ _define_property(this, "startDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_date = 11;
   */ _define_property(this, "endDate", void 0), /**
   * @generated from field: string notes = 12;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 14;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 15;
   */ _define_property(this, "deletedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramCompanyStaffingLine, "runtime", proto3);
_define_property(ProgramCompanyStaffingLine, "typeName", "mono.datagateway.v1.ProgramCompanyStaffingLine");
_define_property(ProgramCompanyStaffingLine, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_assignment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "lcat_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "lcat_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "position_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "fte",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProgramContact
 */ export class ProgramContact extends Message {
    static fromBinary(bytes, options) {
        return new ProgramContact().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramContact().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramContact().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramContact, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string contact_id = 4;
   */ _define_property(this, "contactId", ""), /**
   * legacy; use customer_poc_role_id
   *
   * @generated from field: string role = 5;
   */ _define_property(this, "role", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 8;
   */ _define_property(this, "deletedAt", void 0), /**
   * @generated from field: string customer_poc_role_id = 9;
   */ _define_property(this, "customerPocRoleId", ""), /**
   * @generated from field: string customer_poc_role_label = 10;
   */ _define_property(this, "customerPocRoleLabel", ""), /**
   * @generated from field: string contact_name = 11;
   */ _define_property(this, "contactName", ""), /**
   * @generated from field: string contact_email = 12;
   */ _define_property(this, "contactEmail", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramContact, "runtime", proto3);
_define_property(ProgramContact, "typeName", "mono.datagateway.v1.ProgramContact");
_define_property(ProgramContact, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "customer_poc_role_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "customer_poc_role_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "contact_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "contact_email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.PeriodOfPerformance
 */ export class PeriodOfPerformance extends Message {
    static fromBinary(bytes, options) {
        return new PeriodOfPerformance().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PeriodOfPerformance().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PeriodOfPerformance().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PeriodOfPerformance, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string period_name = 4;
   */ _define_property(this, "periodName", ""), /**
   * @generated from field: string period_type = 5;
   */ _define_property(this, "periodType", ""), /**
   * @generated from field: int32 option_number = 6;
   */ _define_property(this, "optionNumber", 0), /**
   * @generated from field: bool exercised = 7;
   */ _define_property(this, "exercised", false), /**
   * @generated from field: google.protobuf.Timestamp start_date = 8;
   */ _define_property(this, "startDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_date = 9;
   */ _define_property(this, "endDate", void 0), /**
   * @generated from field: double funded_amount = 10;
   */ _define_property(this, "fundedAmount", 0), /**
   * @generated from field: double total_amount = 11;
   */ _define_property(this, "totalAmount", 0), /**
   * @generated from field: int32 sort_order = 12;
   */ _define_property(this, "sortOrder", 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 14;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 15;
   */ _define_property(this, "deletedAt", void 0), /**
   * Phase 0a SDS extension absorbed from zou.ContractPeriod.
   *
   * @generated from field: int32 duration_months = 16;
   */ _define_property(this, "durationMonths", 0), /**
   * Read-only source presence: absent is legacy; false is unknown; true includes zero.
   *
   * @generated from field: optional bool funded_amount_known = 17;
   */ _define_property(this, "fundedAmountKnown", void 0), /**
   * @generated from field: optional bool total_amount_known = 18;
   */ _define_property(this, "totalAmountKnown", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PeriodOfPerformance, "runtime", proto3);
_define_property(PeriodOfPerformance, "typeName", "mono.datagateway.v1.PeriodOfPerformance");
_define_property(PeriodOfPerformance, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "period_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "period_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "option_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "exercised",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 11,
            name: "total_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 12,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 13,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "duration_months",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 17,
            name: "funded_amount_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 18,
            name: "total_amount_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.OptionalTask
 */ export class OptionalTask extends Message {
    static fromBinary(bytes, options) {
        return new OptionalTask().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OptionalTask().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OptionalTask().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OptionalTask, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string name = 4;
   */ _define_property(this, "name", ""), /**
   * @generated from field: int32 task_number = 5;
   */ _define_property(this, "taskNumber", 0), /**
   * @generated from field: bool exercised = 6;
   */ _define_property(this, "exercised", false), /**
   * @generated from field: string description = 7;
   */ _define_property(this, "description", ""), /**
   * @generated from field: double funded_amount = 8;
   */ _define_property(this, "fundedAmount", 0), /**
   * @generated from field: double total_amount = 9;
   */ _define_property(this, "totalAmount", 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 12;
   */ _define_property(this, "deletedAt", void 0), /**
   * JSON []string, same convention as ProgramTask.pws_sections.
   *
   * @generated from field: string pws_sections = 13;
   */ _define_property(this, "pwsSections", ""), /**
   * @generated from field: string clin_number = 14;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string pricing_type = 15;
   */ _define_property(this, "pricingType", ""), /**
   * Complete extracted requirement/source text this task was derived from --
   * preserved verbatim so the concise `name` never destroys provenance.
   *
   * @generated from field: string requirement_text = 16;
   */ _define_property(this, "requirementText", ""), /**
   * not_exercised / exercised / completed. Additive to `exercised`, which
   * stays the denormalized "count(live exercises) > 0" projection; completed
   * is a further, manually-asserted state that never implies the exercise
   * ledger is deleted or hidden.
   *
   * @generated from field: string status = 17;
   */ _define_property(this, "status", ""), /**
   * Read-only source presence: absent is legacy; false is unknown; true includes zero.
   *
   * @generated from field: optional bool funded_amount_known = 18;
   */ _define_property(this, "fundedAmountKnown", void 0), /**
   * @generated from field: optional bool total_amount_known = 19;
   */ _define_property(this, "totalAmountKnown", void 0), /**
   * K9c-1c (D103): the stated "may be exercised up to N times" cap, with
   * lineage; never the family CLIN's quantity. Read-only: absent is legacy,
   * false is not stated, true is stated (0 included).
   *
   * @generated from field: int32 max_exercises = 20;
   */ _define_property(this, "maxExercises", 0), /**
   * @generated from field: optional bool max_exercises_known = 21;
   */ _define_property(this, "maxExercisesKnown", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OptionalTask, "runtime", proto3);
_define_property(OptionalTask, "typeName", "mono.datagateway.v1.OptionalTask");
_define_property(OptionalTask, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "task_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "exercised",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "total_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "pws_sections",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "pricing_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "requirement_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "funded_amount_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 19,
            name: "total_amount_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 20,
            name: "max_exercises",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 21,
            name: "max_exercises_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        }
    ]));
/**
 * One exercise event on an optional task — how much was exercised, at what
 * cost, when, and (when a modification drove it) which change set. The
 * parent's `exercised` bool is a denormalization of count(live exercises) > 0,
 * maintained by the repository on create/delete.
 *
 * @generated from message mono.datagateway.v1.OptionalTaskExercise
 */ export class OptionalTaskExercise extends Message {
    static fromBinary(bytes, options) {
        return new OptionalTaskExercise().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OptionalTaskExercise().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OptionalTaskExercise().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OptionalTaskExercise, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string optional_task_id = 4;
   */ _define_property(this, "optionalTaskId", ""), /**
   * @generated from field: double amount_exercised = 5;
   */ _define_property(this, "amountExercised", 0), /**
   * @generated from field: double cost = 6;
   */ _define_property(this, "cost", 0), /**
   * @generated from field: string description = 7;
   */ _define_property(this, "description", ""), /**
   * @generated from field: google.protobuf.Timestamp exercised_at = 8;
   */ _define_property(this, "exercisedAt", void 0), /**
   * @generated from field: string change_set_id = 9;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string created_by = 10;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */ _define_property(this, "updatedAt", void 0), /**
   * Terms at exercise time, copied from the exercising SLIN.
   *
   * @generated from field: string clin_number = 13;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string pricing_type = 14;
   */ _define_property(this, "pricingType", ""), /**
   * @generated from field: double quantity = 15;
   */ _define_property(this, "quantity", 0), /**
   * @generated from field: double unit_price = 16;
   */ _define_property(this, "unitPrice", 0), /**
   * Period of performance for this exercised instance, copied from the
   * exercising SLIN. Unset when the SLIN carried no parseable date.
   *
   * @generated from field: google.protobuf.Timestamp pop_start_date = 17;
   */ _define_property(this, "popStartDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp pop_end_date = 18;
   */ _define_property(this, "popEndDate", void 0), /**
   * SAD-151: the SLINs that contributed to this (possibly collapsed) exercise
   * row -- a single exercise can fan out across many funding SLINs (SAD-349),
   * and this itemises each one's own clin_number, funded amount, and terms so
   * a collapsed row never has to lie about being one SLIN.
   *
   * @generated from field: repeated mono.datagateway.v1.OptionalTaskExerciseSlin contributing_slins = 19;
   */ _define_property(this, "contributingSlins", []), /**
   * Read-only canonical storage presence: true means NULL, false means a
   * stored value (including zero). Absent means presence is unknown from a
   * legacy server. These markers do not affect writes or certify money roles.
   *
   * @generated from field: optional bool amount_exercised_is_null = 20;
   */ _define_property(this, "amountExercisedIsNull", void 0), /**
   * @generated from field: optional bool cost_is_null = 21;
   */ _define_property(this, "costIsNull", void 0), /**
   * @generated from field: optional bool quantity_is_null = 22;
   */ _define_property(this, "quantityIsNull", void 0), /**
   * @generated from field: optional bool unit_price_is_null = 23;
   */ _define_property(this, "unitPriceIsNull", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OptionalTaskExercise, "runtime", proto3);
_define_property(OptionalTaskExercise, "typeName", "mono.datagateway.v1.OptionalTaskExercise");
_define_property(OptionalTaskExercise, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "optional_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "amount_exercised",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "cost",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "exercised_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "pricing_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "quantity",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 16,
            name: "unit_price",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 17,
            name: "pop_start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 18,
            name: "pop_end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 19,
            name: "contributing_slins",
            kind: "message",
            T: OptionalTaskExerciseSlin,
            repeated: true
        },
        {
            no: 20,
            name: "amount_exercised_is_null",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 21,
            name: "cost_is_null",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 22,
            name: "quantity_is_null",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 23,
            name: "unit_price_is_null",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        }
    ]));
/**
 * One SLIN that contributed to an OptionalTaskExercise's (possibly collapsed)
 * row -- its own clin_number, its own funded amount (never a share of the
 * parent's accumulated cost), and its own terms at exercise time.
 *
 * @generated from message mono.datagateway.v1.OptionalTaskExerciseSlin
 */ export class OptionalTaskExerciseSlin extends Message {
    static fromBinary(bytes, options) {
        return new OptionalTaskExerciseSlin().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OptionalTaskExerciseSlin().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OptionalTaskExerciseSlin().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OptionalTaskExerciseSlin, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string exercise_id = 4;
   */ _define_property(this, "exerciseId", ""), /**
   * @generated from field: string clin_number = 5;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string description = 6;
   */ _define_property(this, "description", ""), /**
   * @generated from field: double funded_amount = 7;
   */ _define_property(this, "fundedAmount", 0), /**
   * @generated from field: double quantity = 8;
   */ _define_property(this, "quantity", 0), /**
   * @generated from field: double unit_price = 9;
   */ _define_property(this, "unitPrice", 0), /**
   * @generated from field: string pricing_type = 10;
   */ _define_property(this, "pricingType", ""), /**
   * @generated from field: google.protobuf.Timestamp pop_start_date = 11;
   */ _define_property(this, "popStartDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp pop_end_date = 12;
   */ _define_property(this, "popEndDate", void 0), /**
   * Read-only canonical storage presence; absent means unknown from a legacy
   * server. A present false marker distinguishes stored zero from NULL.
   *
   * @generated from field: optional bool funded_amount_is_null = 13;
   */ _define_property(this, "fundedAmountIsNull", void 0), /**
   * @generated from field: optional bool quantity_is_null = 14;
   */ _define_property(this, "quantityIsNull", void 0), /**
   * @generated from field: optional bool unit_price_is_null = 15;
   */ _define_property(this, "unitPriceIsNull", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OptionalTaskExerciseSlin, "runtime", proto3);
_define_property(OptionalTaskExerciseSlin, "typeName", "mono.datagateway.v1.OptionalTaskExerciseSlin");
_define_property(OptionalTaskExerciseSlin, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "exercise_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "quantity",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "unit_price",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 10,
            name: "pricing_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "pop_start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "pop_end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "funded_amount_is_null",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 14,
            name: "quantity_is_null",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 15,
            name: "unit_price_is_null",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProgramTask
 */ export class ProgramTask extends Message {
    static fromBinary(bytes, options) {
        return new ProgramTask().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramTask().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramTask().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramTask, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string deliverable_number = 4;
   */ _define_property(this, "deliverableNumber", ""), /**
   * @generated from field: string short_description = 5;
   */ _define_property(this, "shortDescription", ""), /**
   * @generated from field: google.protobuf.Timestamp due_date = 6;
   */ _define_property(this, "dueDate", void 0), /**
   * @generated from field: string due_date_notes = 7;
   */ _define_property(this, "dueDateNotes", ""), /**
   * @generated from field: string frequency = 8;
   */ _define_property(this, "frequency", ""), /**
   * @generated from field: string state = 9;
   */ _define_property(this, "state", ""), /**
   * @generated from field: google.protobuf.Timestamp closed_at = 10;
   */ _define_property(this, "closedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp submitted_at = 11;
   */ _define_property(this, "submittedAt", void 0), /**
   * @generated from field: string responsible_person = 12;
   */ _define_property(this, "responsiblePerson", ""), /**
   * @generated from field: string rejection_reason = 13;
   */ _define_property(this, "rejectionReason", ""), /**
   * @generated from field: int32 rework_count = 14;
   */ _define_property(this, "reworkCount", 0), /**
   * @generated from field: string zou_deliverable_id = 15;
   */ _define_property(this, "zouDeliverableId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 16;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 17;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 18;
   */ _define_property(this, "deletedAt", void 0), /**
   * Phase 0a — absorbed from zou.Deliverable. ProgramTask is canonical for
   * SDS "deliverables"; we keep the table name for compat with existing
   * pangaea/ryugu callers.
   *
   * @generated from field: string clin_id = 19;
   */ _define_property(this, "clinId", ""), /**
   * @generated from field: string clin_number = 20;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string contract_id = 21;
   */ _define_property(this, "contractId", ""), /**
   * @generated from field: string title = 22;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 23;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string type = 24;
   */ _define_property(this, "type", ""), /**
   * @generated from field: int32 days_after_award = 25;
   */ _define_property(this, "daysAfterAward", 0), /**
   * @generated from field: string trigger_event = 26;
   */ _define_property(this, "triggerEvent", ""), /**
   * @generated from field: string format = 27;
   */ _define_property(this, "format", ""), /**
   * @generated from field: string submission_method = 28;
   */ _define_property(this, "submissionMethod", ""), /**
   * @generated from field: string pws_sections = 29;
   */ _define_property(this, "pwsSections", ""), /**
   * @generated from field: google.protobuf.Timestamp current_due_date = 30;
   */ _define_property(this, "currentDueDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp next_due_date = 31;
   */ _define_property(this, "nextDueDate", void 0), /**
   * @generated from field: string notes = 32;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: int32 total_submissions = 33;
   */ _define_property(this, "totalSubmissions", 0), /**
   * @generated from field: int32 accepted_submissions = 34;
   */ _define_property(this, "acceptedSubmissions", 0), /**
   * @generated from field: int32 rejected_submissions = 35;
   */ _define_property(this, "rejectedSubmissions", 0), /**
   * @generated from field: string recurring_detail = 36;
   */ _define_property(this, "recurringDetail", ""), /**
   * @generated from field: string acceptance_criteria = 37;
   */ _define_property(this, "acceptanceCriteria", ""), /**
   * @generated from field: bool is_cdrl = 38;
   */ _define_property(this, "isCdrl", false), /**
   * @generated from field: string slin_number = 39;
   */ _define_property(this, "slinNumber", ""), /**
   * @generated from field: int32 sort_order = 40;
   */ _define_property(this, "sortOrder", 0), /**
   * SDS evidence/POD semantics. evidence_status: missing|partial|complete|
   * exception_approved|not_required. proof_of_delivery_status: missing|
   * attached|external_reference_captured|customer_receipt_captured|
   * exception_approved.
   *
   * @generated from field: string evidence_status = 41;
   */ _define_property(this, "evidenceStatus", ""), /**
   * @generated from field: string proof_of_delivery_status = 42;
   */ _define_property(this, "proofOfDeliveryStatus", ""), /**
   * @generated from field: bool on_time_flag = 43;
   */ _define_property(this, "onTimeFlag", false), /**
   * @generated from field: bool waived_or_tailored_flag = 44;
   */ _define_property(this, "waivedOrTailoredFlag", false), /**
   * FK to ExternalArtifactReference in delivery_sds.proto
   *
   * @generated from field: string external_reference_id = 45;
   */ _define_property(this, "externalReferenceId", ""), /**
   * Optional per-task bound for the form-managed deliverable series; unset
   * falls back to the program PoP end.
   *
   * @generated from field: google.protobuf.Timestamp series_end_date = 46;
   */ _define_property(this, "seriesEndDate", void 0), /**
   * Explicit period-of-performance assignment. Empty means "no explicit
   * period — fall back to CLIN-derived classification"; pangaea does NOT
   * enforce that the id belongs to this task's program/tenant itself (see
   * the file header comment) — ryugu validates before it ever reaches here.
   *
   * @generated from field: string period_of_performance_id = 47;
   */ _define_property(this, "periodOfPerformanceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramTask, "runtime", proto3);
_define_property(ProgramTask, "typeName", "mono.datagateway.v1.ProgramTask");
_define_property(ProgramTask, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "deliverable_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "short_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "due_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "due_date_notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "frequency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "closed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "submitted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "responsible_person",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "rejection_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "rework_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 15,
            name: "zou_deliverable_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 18,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 19,
            name: "clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 25,
            name: "days_after_award",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 26,
            name: "trigger_event",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 27,
            name: "format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 28,
            name: "submission_method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 29,
            name: "pws_sections",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 30,
            name: "current_due_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 31,
            name: "next_due_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 32,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 33,
            name: "total_submissions",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 34,
            name: "accepted_submissions",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 35,
            name: "rejected_submissions",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 36,
            name: "recurring_detail",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 37,
            name: "acceptance_criteria",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 38,
            name: "is_cdrl",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 39,
            name: "slin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 40,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 41,
            name: "evidence_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 42,
            name: "proof_of_delivery_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 43,
            name: "on_time_flag",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 44,
            name: "waived_or_tailored_flag",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 45,
            name: "external_reference_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 46,
            name: "series_end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 47,
            name: "period_of_performance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.TaskAttachment
 */ export class TaskAttachment extends Message {
    static fromBinary(bytes, options) {
        return new TaskAttachment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TaskAttachment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TaskAttachment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TaskAttachment, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string task_id = 3;
   */ _define_property(this, "taskId", ""), /**
   * FK to artifacts.artifacts.id
   *
   * @generated from field: string artifact_id = 4;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string type = 5;
   */ _define_property(this, "type", ""), /**
   * @generated from field: google.protobuf.Timestamp uploaded_at = 6;
   */ _define_property(this, "uploadedAt", void 0), /**
   * @generated from field: string uploaded_by = 7;
   */ _define_property(this, "uploadedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TaskAttachment, "runtime", proto3);
_define_property(TaskAttachment, "typeName", "mono.datagateway.v1.TaskAttachment");
_define_property(TaskAttachment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "uploaded_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "uploaded_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.Audit
 */ export class Audit extends Message {
    static fromBinary(bytes, options) {
        return new Audit().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Audit().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Audit().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Audit, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: google.protobuf.Timestamp audit_date = 4;
   */ _define_property(this, "auditDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp period_start = 5;
   */ _define_property(this, "periodStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp period_end = 6;
   */ _define_property(this, "periodEnd", void 0), /**
   * @generated from field: string area = 7;
   */ _define_property(this, "area", ""), /**
   * @generated from field: string state = 8;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string assigned_to = 9;
   */ _define_property(this, "assignedTo", ""), /**
   * @generated from field: string notes = 10;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: string reviewed_by = 11;
   */ _define_property(this, "reviewedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp reviewed_at = 12;
   */ _define_property(this, "reviewedAt", void 0), /**
   * @generated from field: string reviewer_notes = 13;
   */ _define_property(this, "reviewerNotes", ""), /**
   * @generated from field: google.protobuf.Timestamp published_at = 14;
   */ _define_property(this, "publishedAt", void 0), /**
   * @generated from field: string published_by = 15;
   */ _define_property(this, "publishedBy", ""), /**
   * @generated from field: int32 frozen_pass_count = 16;
   */ _define_property(this, "frozenPassCount", 0), /**
   * @generated from field: int32 frozen_total_count = 17;
   */ _define_property(this, "frozenTotalCount", 0), /**
   * @generated from field: string frozen_score = 18;
   */ _define_property(this, "frozenScore", ""), /**
   * @generated from field: bool is_final = 19;
   */ _define_property(this, "isFinal", false), /**
   * @generated from field: google.protobuf.Timestamp created_at = 20;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 21;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 22;
   */ _define_property(this, "deletedAt", void 0), /**
   * Planned monthly workflow (000067).
   *
   * @generated from field: string period_month = 23;
   */ _define_property(this, "periodMonth", ""), /**
   * @generated from field: google.protobuf.Timestamp scheduled_date = 24;
   */ _define_property(this, "scheduledDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp started_at = 25;
   */ _define_property(this, "startedAt", void 0), /**
   * @generated from field: string started_by = 26;
   */ _define_property(this, "startedBy", ""), /**
   * @generated from field: string started_by_contact_id = 27;
   */ _define_property(this, "startedByContactId", ""), /**
   * @generated from field: google.protobuf.Timestamp completed_at = 28;
   */ _define_property(this, "completedAt", void 0), /**
   * @generated from field: string completed_by = 29;
   */ _define_property(this, "completedBy", ""), /**
   * @generated from field: string completed_by_contact_id = 30;
   */ _define_property(this, "completedByContactId", ""), /**
   * @generated from field: string audit_summary = 31;
   */ _define_property(this, "auditSummary", ""), /**
   * The auditor this audit is assigned to (contact FK). Mapped through so a
   * Select("*") update doesn't rewrite it as NULL on every complete/sync.
   *
   * @generated from field: string assigned_contact_id = 32;
   */ _define_property(this, "assignedContactId", ""), /**
   * Items that passed on first review, i.e. WITHOUT needing a verified corrective
   * action — the pre-remediation quality signal KPI 4 scores on. NULL/absent on
   * legacy audits, which fall back to frozen_pass_count.
   *
   * @generated from field: int32 frozen_first_pass_count = 33;
   */ _define_property(this, "frozenFirstPassCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(Audit, "runtime", proto3);
_define_property(Audit, "typeName", "mono.datagateway.v1.Audit");
_define_property(Audit, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "audit_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "period_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "period_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "area",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "assigned_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "reviewed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "reviewed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "reviewer_notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "published_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "published_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "frozen_pass_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 17,
            name: "frozen_total_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 18,
            name: "frozen_score",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "is_final",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 20,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 21,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 22,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 23,
            name: "period_month",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "scheduled_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 25,
            name: "started_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 26,
            name: "started_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 27,
            name: "started_by_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 28,
            name: "completed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 29,
            name: "completed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 30,
            name: "completed_by_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 31,
            name: "audit_summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 32,
            name: "assigned_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 33,
            name: "frozen_first_pass_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AuditQuestion
 */ export class AuditQuestion extends Message {
    static fromBinary(bytes, options) {
        return new AuditQuestion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuditQuestion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuditQuestion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuditQuestion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string audit_id = 3;
   */ _define_property(this, "auditId", ""), /**
   * @generated from field: string question = 4;
   */ _define_property(this, "question", ""), /**
   * @generated from field: string result = 5;
   */ _define_property(this, "result", ""), /**
   * @generated from field: string notes = 6;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: bool corrective_action_required = 7;
   */ _define_property(this, "correctiveActionRequired", false), /**
   * @generated from field: bool resolved_during_audit = 8;
   */ _define_property(this, "resolvedDuringAudit", false), /**
   * @generated from field: int32 sort_order = 9;
   */ _define_property(this, "sortOrder", 0), /**
   * Standard-checklist provenance + owner routing (000067).
   *
   * @generated from field: int32 item_number = 10;
   */ _define_property(this, "itemNumber", 0), /**
   * @generated from field: string checklist_item_key = 11;
   */ _define_property(this, "checklistItemKey", ""), /**
   * @generated from field: string review_area = 12;
   */ _define_property(this, "reviewArea", ""), /**
   * @generated from field: string responsibility_key = 13;
   */ _define_property(this, "responsibilityKey", ""), /**
   * "What the auditor confirms" — cloned from the template so the checklist row
   * can show the guidance, not just the item title.
   *
   * @generated from field: string description = 14;
   */ _define_property(this, "description", ""), /**
   * Lifecycle phase and evidence owner (display text), cloned from the template.
   *
   * @generated from field: string project_phase = 15;
   */ _define_property(this, "projectPhase", ""), /**
   * @generated from field: string evidence_owner = 16;
   */ _define_property(this, "evidenceOwner", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AuditQuestion, "runtime", proto3);
_define_property(AuditQuestion, "typeName", "mono.datagateway.v1.AuditQuestion");
_define_property(AuditQuestion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "audit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "question",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "result",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "corrective_action_required",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "resolved_during_audit",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "item_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 11,
            name: "checklist_item_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "review_area",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "responsibility_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "project_phase",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "evidence_owner",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CorrectiveAction
 */ export class CorrectiveAction extends Message {
    static fromBinary(bytes, options) {
        return new CorrectiveAction().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CorrectiveAction().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CorrectiveAction().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CorrectiveAction, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string audit_id = 3;
   */ _define_property(this, "auditId", ""), /**
   * @generated from field: string question_id = 4;
   */ _define_property(this, "questionId", ""), /**
   * @generated from field: string description = 5;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string assigned_to = 6;
   */ _define_property(this, "assignedTo", ""), /**
   * @generated from field: string state = 7;
   */ _define_property(this, "state", ""), /**
   * @generated from field: google.protobuf.Timestamp due_date = 8;
   */ _define_property(this, "dueDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp resolved_at = 9;
   */ _define_property(this, "resolvedAt", void 0), /**
   * @generated from field: bool extension_requested = 10;
   */ _define_property(this, "extensionRequested", false), /**
   * @generated from field: google.protobuf.Timestamp extension_expected_date = 11;
   */ _define_property(this, "extensionExpectedDate", void 0), /**
   * @generated from field: string extension_reason = 12;
   */ _define_property(this, "extensionReason", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 14;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 15;
   */ _define_property(this, "deletedAt", void 0), /**
   * @generated from field: string assigned_contact_id = 16;
   */ _define_property(this, "assignedContactId", ""), /**
   * Auditor verify step + resolution capture (000067).
   *
   * @generated from field: string verified_by_contact_id = 17;
   */ _define_property(this, "verifiedByContactId", ""), /**
   * @generated from field: google.protobuf.Timestamp verified_at = 18;
   */ _define_property(this, "verifiedAt", void 0), /**
   * @generated from field: string resolution_note = 19;
   */ _define_property(this, "resolutionNote", ""), /**
   * @generated from field: string resolved_by_contact_id = 20;
   */ _define_property(this, "resolvedByContactId", ""), /**
   * @generated from field: string responsibility_key = 21;
   */ _define_property(this, "responsibilityKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CorrectiveAction, "runtime", proto3);
_define_property(CorrectiveAction, "typeName", "mono.datagateway.v1.CorrectiveAction");
_define_property(CorrectiveAction, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "audit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "question_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "assigned_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "due_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "resolved_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "extension_requested",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "extension_expected_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "extension_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "assigned_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "verified_by_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "verified_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 19,
            name: "resolution_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "resolved_by_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "responsibility_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.Deviation
 */ export class Deviation extends Message {
    static fromBinary(bytes, options) {
        return new Deviation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Deviation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Deviation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Deviation, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string type = 4;
   */ _define_property(this, "type", ""), /**
   * @generated from field: string category = 5;
   */ _define_property(this, "category", ""), /**
   * @generated from field: string comment = 6;
   */ _define_property(this, "comment", ""), /**
   * @generated from field: string state = 7;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string approval_source = 8;
   */ _define_property(this, "approvalSource", ""), /**
   * @generated from field: string linked_task_id = 9;
   */ _define_property(this, "linkedTaskId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 12;
   */ _define_property(this, "deletedAt", void 0), /**
   * @generated from field: string approved_by_contact_id = 13;
   */ _define_property(this, "approvedByContactId", ""), /**
   * @generated from field: string linked_clin_id = 14;
   */ _define_property(this, "linkedClinId", ""), /**
   * @generated from field: string approved_by_contact_name = 15;
   */ _define_property(this, "approvedByContactName", ""), /**
   * New due date approved by a WAIVER, substituting for the linked task's own
   * due date (SAD-165). Unset means this waiver approves no new date. Only
   * effective when type = "WAIVER" and state = "Approved" -- Tailoring never
   * modulates timeliness, and a Requested/Denied waiver's date is stored but
   * inert. See taskWaivers.ts for the sibling type/state rule this extends.
   *
   * @generated from field: google.protobuf.Timestamp approved_replacement_due_date = 16;
   */ _define_property(this, "approvedReplacementDueDate", void 0), /**
   * When the approval answer (Approved/Denied) came back (SAD-172). Unset
   * means no answer date is recorded yet. Independent of
   * approved_replacement_due_date: this never modulates task timeliness, it
   * only timestamps the answer itself.
   *
   * @generated from field: google.protobuf.Timestamp answered_at = 17;
   */ _define_property(this, "answeredAt", void 0), /**
   * Which occurrence of a recurring deliverable this waiver targets
   * (delivery.deliverable_instances.id), a SAD-165 follow-up to
   * approved_replacement_due_date above. Unset/"" means this waiver targets
   * the whole linked task -- the pre-existing behaviour. Only meaningful
   * together with linked_task_id: a waiver cannot name an occurrence without
   * naming the task it belongs to.
   *
   * @generated from field: string linked_deliverable_instance_id = 18;
   */ _define_property(this, "linkedDeliverableInstanceId", ""), /**
   * Recurrence this WAIVER approves for its linked deliverable going forward
   * (SAD-165) -- Weekly|Biweekly|Monthly|Quarterly|Annually. "" means the
   * waiver approves no cadence change. Gated exactly as
   * approved_replacement_due_date above: only effective when type = "WAIVER"
   * and state = "Approved". The re-projection is FORWARD ONLY -- an
   * already-delivered occurrence is never deleted and none is ever created
   * inside delivered history.
   *
   * @generated from field: string approved_cadence = 19;
   */ _define_property(this, "approvedCadence", ""), /**
   * Server-owned, monotonic per-deviation counter (SAD-285): advances only
   * when a committed transaction actually changes state, never read from a
   * client request. 0 means "not reported" by a server that predates
   * SAD-285, not "never changed."
   *
   * @generated from field: int64 state_revision = 20;
   */ _define_property(this, "stateRevision", protoInt64.zero), /**
   * Contract model v2 (D113, migration 000217): the duty
   * (delivery.duties.id) and/or occurrence (delivery.occurrences.id) this row
   * is about. "" = none. Both must be this row's tenant and program
   * (composite FK: FailedPrecondition otherwise); when both are set the
   * occurrence must be one of that duty's (InvalidArgument otherwise). Full-row
   * write like every other field here: "" on Update clears the link.
   *
   * @generated from field: string linked_duty_id = 21;
   */ _define_property(this, "linkedDutyId", ""), /**
   * @generated from field: string linked_occurrence_id = 22;
   */ _define_property(this, "linkedOccurrenceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(Deviation, "runtime", proto3);
_define_property(Deviation, "typeName", "mono.datagateway.v1.Deviation");
_define_property(Deviation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "approval_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "linked_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "approved_by_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "linked_clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "approved_by_contact_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "approved_replacement_due_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "answered_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 18,
            name: "linked_deliverable_instance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "approved_cadence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "state_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 21,
            name: "linked_duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "linked_occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DSOEntry
 */ export class DSOEntry extends Message {
    static fromBinary(bytes, options) {
        return new DSOEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DSOEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DSOEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DSOEntry, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: google.protobuf.Timestamp period_end_date = 4;
   */ _define_property(this, "periodEndDate", void 0), /**
   * @generated from field: int32 dso = 5;
   */ _define_property(this, "dso", 0), /**
   * @generated from field: string comment = 6;
   */ _define_property(this, "comment", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0), /**
   * artifact id of the uploaded invoice (optional)
   *
   * @generated from field: string invoice_file_id = 8;
   */ _define_property(this, "invoiceFileId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DSOEntry, "runtime", proto3);
_define_property(DSOEntry, "typeName", "mono.datagateway.v1.DSOEntry");
_define_property(DSOEntry, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "period_end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "dso",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "invoice_file_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.EACEntry
 */ export class EACEntry extends Message {
    static fromBinary(bytes, options) {
        return new EACEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EACEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EACEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EACEntry, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: google.protobuf.Timestamp start_date = 4;
   */ _define_property(this, "startDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_date = 5;
   */ _define_property(this, "endDate", void 0), /**
   * @generated from field: double revenue = 6;
   */ _define_property(this, "revenue", 0), /**
   * @generated from field: double direct_costs = 7;
   */ _define_property(this, "directCosts", 0), /**
   * @generated from field: double subcontractor_costs = 8;
   */ _define_property(this, "subcontractorCosts", 0), /**
   * @generated from field: double odcs = 9;
   */ _define_property(this, "odcs", 0), /**
   * @generated from field: double management_reserve = 10;
   */ _define_property(this, "managementReserve", 0), /**
   * @generated from field: double dpaf = 11;
   */ _define_property(this, "dpaf", 0), /**
   * @generated from field: double forecasted_dpaf_margin = 12;
   */ _define_property(this, "forecastedDpafMargin", 0), /**
   * @generated from field: double dpaf_margin_percent = 13;
   */ _define_property(this, "dpafMarginPercent", 0), /**
   * @generated from field: double target_dpaf_margin = 14;
   */ _define_property(this, "targetDpafMargin", 0), /**
   * @generated from field: double inception_to_date_actuals = 15;
   */ _define_property(this, "inceptionToDateActuals", 0), /**
   * @generated from field: double estimate_to_complete = 16;
   */ _define_property(this, "estimateToComplete", 0), /**
   * @generated from field: string comment = 17;
   */ _define_property(this, "comment", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 18;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EACEntry, "runtime", proto3);
_define_property(EACEntry, "typeName", "mono.datagateway.v1.EACEntry");
_define_property(EACEntry, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "revenue",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "direct_costs",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "subcontractor_costs",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "odcs",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 10,
            name: "management_reserve",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 11,
            name: "dpaf",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 12,
            name: "forecasted_dpaf_margin",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 13,
            name: "dpaf_margin_percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 14,
            name: "target_dpaf_margin",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 15,
            name: "inception_to_date_actuals",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 16,
            name: "estimate_to_complete",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 17,
            name: "comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * ProgramFinancialMonth (SAD-166/SAD-176): one row per (tenant, program,
 * calendar month). period_month is a plain "YYYY-MM" string, never a
 * timestamp — a calendar month has no timezone or locale to parse.
 * burn_rate_cents/ar_balance_cents are integer cents; money here is never
 * floating point.
 *
 * @generated from message mono.datagateway.v1.ProgramFinancialMonth
 */ export class ProgramFinancialMonth extends Message {
    static fromBinary(bytes, options) {
        return new ProgramFinancialMonth().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramFinancialMonth().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramFinancialMonth().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramFinancialMonth, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string period_month = 4;
   */ _define_property(this, "periodMonth", ""), /**
   * @generated from field: int64 burn_rate_cents = 5;
   */ _define_property(this, "burnRateCents", protoInt64.zero), /**
   * @generated from field: int64 ar_balance_cents = 6;
   */ _define_property(this, "arBalanceCents", protoInt64.zero), /**
   * @generated from field: string comment = 7;
   */ _define_property(this, "comment", ""), /**
   * @generated from field: string recorded_by = 8;
   */ _define_property(this, "recordedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramFinancialMonth, "runtime", proto3);
_define_property(ProgramFinancialMonth, "typeName", "mono.datagateway.v1.ProgramFinancialMonth");
_define_property(ProgramFinancialMonth, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "period_month",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "burn_rate_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 6,
            name: "ar_balance_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 7,
            name: "comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "recorded_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CPARSScore
 */ export class CPARSScore extends Message {
    static fromBinary(bytes, options) {
        return new CPARSScore().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CPARSScore().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CPARSScore().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CPARSScore, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: int32 entry_number = 4;
   */ _define_property(this, "entryNumber", 0), /**
   * @generated from field: optional double overall_score = 5;
   */ _define_property(this, "overallScore", void 0), /**
   * @generated from field: google.protobuf.Timestamp eval_period_start = 6;
   */ _define_property(this, "evalPeriodStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp eval_period_end = 7;
   */ _define_property(this, "evalPeriodEnd", void 0), /**
   * @generated from field: string overall_comment = 8;
   */ _define_property(this, "overallComment", ""), /**
   * @generated from field: optional double quality_score = 9;
   */ _define_property(this, "qualityScore", void 0), /**
   * @generated from field: optional double schedule_score = 10;
   */ _define_property(this, "scheduleScore", void 0), /**
   * @generated from field: optional double cost_control_score = 11;
   */ _define_property(this, "costControlScore", void 0), /**
   * @generated from field: optional double management_score = 12;
   */ _define_property(this, "managementScore", void 0), /**
   * @generated from field: optional double small_business_score = 13;
   */ _define_property(this, "smallBusinessScore", void 0), /**
   * @generated from field: optional double regulatory_compliance_score = 14;
   */ _define_property(this, "regulatoryComplianceScore", void 0), /**
   * @generated from field: string quality_narrative = 15;
   */ _define_property(this, "qualityNarrative", ""), /**
   * @generated from field: string schedule_narrative = 16;
   */ _define_property(this, "scheduleNarrative", ""), /**
   * @generated from field: string cost_control_narrative = 17;
   */ _define_property(this, "costControlNarrative", ""), /**
   * @generated from field: string management_narrative = 18;
   */ _define_property(this, "managementNarrative", ""), /**
   * @generated from field: string small_business_narrative = 19;
   */ _define_property(this, "smallBusinessNarrative", ""), /**
   * @generated from field: string regulatory_compliance_narr = 20;
   */ _define_property(this, "regulatoryComplianceNarr", ""), /**
   * @generated from field: string get_well_plan = 21;
   */ _define_property(this, "getWellPlan", ""), /**
   * @generated from field: string artifact_id = 22;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string concurrence_status = 23;
   */ _define_property(this, "concurrenceStatus", ""), /**
   * @generated from field: string concurrence_comment = 24;
   */ _define_property(this, "concurrenceComment", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 25;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CPARSScore, "runtime", proto3);
_define_property(CPARSScore, "typeName", "mono.datagateway.v1.CPARSScore");
_define_property(CPARSScore, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "entry_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "overall_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 6,
            name: "eval_period_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "eval_period_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "overall_comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "quality_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 10,
            name: "schedule_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 11,
            name: "cost_control_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 12,
            name: "management_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 13,
            name: "small_business_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 14,
            name: "regulatory_compliance_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 15,
            name: "quality_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "schedule_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "cost_control_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "management_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "small_business_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "regulatory_compliance_narr",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "get_well_plan",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "concurrence_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "concurrence_comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 25,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.QASPScore
 */ export class QASPScore extends Message {
    static fromBinary(bytes, options) {
        return new QASPScore().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QASPScore().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QASPScore().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QASPScore, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string quarter = 4;
   */ _define_property(this, "quarter", ""), /**
   * @generated from field: optional double overall_score = 5;
   */ _define_property(this, "overallScore", void 0), /**
   * @generated from field: optional double technical_score = 6;
   */ _define_property(this, "technicalScore", void 0), /**
   * @generated from field: optional double schedule_score = 7;
   */ _define_property(this, "scheduleScore", void 0), /**
   * @generated from field: optional double cost_staffing_score = 8;
   */ _define_property(this, "costStaffingScore", void 0), /**
   * @generated from field: optional double management_score = 9;
   */ _define_property(this, "managementScore", void 0), /**
   * @generated from field: string technical_narrative = 10;
   */ _define_property(this, "technicalNarrative", ""), /**
   * @generated from field: string schedule_narrative = 11;
   */ _define_property(this, "scheduleNarrative", ""), /**
   * @generated from field: string cost_staffing_narrative = 12;
   */ _define_property(this, "costStaffingNarrative", ""), /**
   * @generated from field: string management_narrative = 13;
   */ _define_property(this, "managementNarrative", ""), /**
   * @generated from field: google.protobuf.Timestamp report_period_start = 14;
   */ _define_property(this, "reportPeriodStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp report_period_end = 15;
   */ _define_property(this, "reportPeriodEnd", void 0), /**
   * @generated from field: string get_well_plan = 16;
   */ _define_property(this, "getWellPlan", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 17;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string artifact_id = 18;
   */ _define_property(this, "artifactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(QASPScore, "runtime", proto3);
_define_property(QASPScore, "typeName", "mono.datagateway.v1.QASPScore");
_define_property(QASPScore, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "quarter",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "overall_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 6,
            name: "technical_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 7,
            name: "schedule_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 8,
            name: "cost_staffing_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 9,
            name: "management_score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 10,
            name: "technical_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "schedule_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "cost_staffing_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "management_narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "report_period_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "report_period_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "get_well_plan",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 18,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.Risk
 */ export class Risk extends Message {
    static fromBinary(bytes, options) {
        return new Risk().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Risk().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Risk().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Risk, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string category = 4;
   */ _define_property(this, "category", ""), /**
   * @generated from field: string audience = 5;
   */ _define_property(this, "audience", ""), /**
   * @generated from field: string status = 6;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string strategy = 7;
   */ _define_property(this, "strategy", ""), /**
   * @generated from field: string probability = 8;
   */ _define_property(this, "probability", ""), /**
   * @generated from field: string impact = 9;
   */ _define_property(this, "impact", ""), /**
   * @generated from field: string short_description = 10;
   */ _define_property(this, "shortDescription", ""), /**
   * @generated from field: string strategy_plan = 11;
   */ _define_property(this, "strategyPlan", ""), /**
   * @generated from field: string owner = 12;
   */ _define_property(this, "owner", ""), /**
   * @generated from field: google.protobuf.Timestamp target_resolution_date = 13;
   */ _define_property(this, "targetResolutionDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp actual_resolution_date = 14;
   */ _define_property(this, "actualResolutionDate", void 0), /**
   * @generated from field: string escalation_path = 15;
   */ _define_property(this, "escalationPath", ""), /**
   * @generated from field: string comments = 16;
   */ _define_property(this, "comments", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 17;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 18;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 19;
   */ _define_property(this, "deletedAt", void 0), /**
   * @generated from field: string owner_contact_id = 20;
   */ _define_property(this, "ownerContactId", ""), /**
   * @generated from field: string audience_contact_id = 21;
   */ _define_property(this, "audienceContactId", ""), /**
   * @generated from field: string linked_clin_id = 22;
   */ _define_property(this, "linkedClinId", ""), /**
   * @generated from field: string linked_deliverable_id = 23;
   */ _define_property(this, "linkedDeliverableId", ""), /**
   * NOT-S8 leadership escalation snapshot — see migration
   * 000113_risk_leadership_escalation. Unset leadership_escalated_at means
   * never escalated (or re-armed by a probability/impact edit since the last
   * escalation); the probability/impact pair is the bands AS THEY STOOD at
   * escalation time, not the risk's current bands.
   *
   * @generated from field: google.protobuf.Timestamp leadership_escalated_at = 24;
   */ _define_property(this, "leadershipEscalatedAt", void 0), /**
   * @generated from field: string leadership_escalated_probability = 25;
   */ _define_property(this, "leadershipEscalatedProbability", ""), /**
   * @generated from field: string leadership_escalated_impact = 26;
   */ _define_property(this, "leadershipEscalatedImpact", ""), /**
   * Contract model v2 (D113, migration 000217): the duty
   * (delivery.duties.id) and/or occurrence (delivery.occurrences.id) this row
   * is about. "" = none. Both must be this row's tenant and program
   * (composite FK: FailedPrecondition otherwise); when both are set the
   * occurrence must be one of that duty's (InvalidArgument otherwise). Full-row
   * write like every other field here: "" on Update clears the link.
   *
   * @generated from field: string linked_duty_id = 27;
   */ _define_property(this, "linkedDutyId", ""), /**
   * @generated from field: string linked_occurrence_id = 28;
   */ _define_property(this, "linkedOccurrenceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(Risk, "runtime", proto3);
_define_property(Risk, "typeName", "mono.datagateway.v1.Risk");
_define_property(Risk, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "audience",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "strategy",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "probability",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "impact",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "short_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "strategy_plan",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "owner",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "target_resolution_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "actual_resolution_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "escalation_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "comments",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 18,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 19,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 20,
            name: "owner_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "audience_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "linked_clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "linked_deliverable_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "leadership_escalated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 25,
            name: "leadership_escalated_probability",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 26,
            name: "leadership_escalated_impact",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 27,
            name: "linked_duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 28,
            name: "linked_occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.Issue
 */ export class Issue extends Message {
    static fromBinary(bytes, options) {
        return new Issue().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Issue().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Issue().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Issue, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string priority = 4;
   */ _define_property(this, "priority", ""), /**
   * @generated from field: string impact = 5;
   */ _define_property(this, "impact", ""), /**
   * @generated from field: string description = 6;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string state = 7;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string assigned_to = 8;
   */ _define_property(this, "assignedTo", ""), /**
   * @generated from field: string root_cause = 9;
   */ _define_property(this, "rootCause", ""), /**
   * Deprecated as of SAD-129: superseded by IssueComment (append-only comment
   * history). Retained only because buf.yaml uses the FILE breaking category
   * (which includes FIELD_NO_DELETE), so the field cannot be removed.
   *
   * @generated from field: string corrective_action = 10 [deprecated = true];
   * @deprecated
   */ _define_property(this, "correctiveAction", ""), /**
   * @generated from field: google.protobuf.Timestamp target_resolution_date = 11;
   */ _define_property(this, "targetResolutionDate", void 0), /**
   * @generated from field: bool high_risk_flag = 12;
   */ _define_property(this, "highRiskFlag", false), /**
   * @generated from field: string auto_generated_type = 13;
   */ _define_property(this, "autoGeneratedType", ""), /**
   * @generated from field: string linked_record_id = 14;
   */ _define_property(this, "linkedRecordId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 15;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 16;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp resolved_at = 17;
   */ _define_property(this, "resolvedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 18;
   */ _define_property(this, "deletedAt", void 0), /**
   * @generated from field: string assignee_contact_id = 19;
   */ _define_property(this, "assigneeContactId", ""), /**
   * @generated from field: string linked_clin_id = 20;
   */ _define_property(this, "linkedClinId", ""), /**
   * @generated from field: string linked_deliverable_id = 21;
   */ _define_property(this, "linkedDeliverableId", ""), /**
   * Contract model v2 (D113, migration 000217): the duty
   * (delivery.duties.id) and/or occurrence (delivery.occurrences.id) this row
   * is about. "" = none. Both must be this row's tenant and program
   * (composite FK: FailedPrecondition otherwise); when both are set the
   * occurrence must be one of that duty's (InvalidArgument otherwise). Full-row
   * write like every other field here: "" on Update clears the link.
   *
   * @generated from field: string linked_duty_id = 22;
   */ _define_property(this, "linkedDutyId", ""), /**
   * @generated from field: string linked_occurrence_id = 23;
   */ _define_property(this, "linkedOccurrenceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(Issue, "runtime", proto3);
_define_property(Issue, "typeName", "mono.datagateway.v1.Issue");
_define_property(Issue, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "priority",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "impact",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "assigned_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "root_cause",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "corrective_action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "target_resolution_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "high_risk_flag",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "auto_generated_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "linked_record_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "resolved_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 18,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 19,
            name: "assignee_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "linked_clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "linked_deliverable_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "linked_duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "linked_occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CustomerTouchpoint
 */ export class CustomerTouchpoint extends Message {
    static fromBinary(bytes, options) {
        return new CustomerTouchpoint().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CustomerTouchpoint().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CustomerTouchpoint().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CustomerTouchpoint, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string method = 4;
   */ _define_property(this, "method", ""), /**
   * @generated from field: string briefing_level = 5;
   */ _define_property(this, "briefingLevel", ""), /**
   * @generated from field: google.protobuf.Timestamp date_of_briefing = 6;
   */ _define_property(this, "dateOfBriefing", void 0), /**
   * @generated from field: string provided_by = 7;
   */ _define_property(this, "providedBy", ""), /**
   * @generated from field: string provided_to_contact_id = 8;
   */ _define_property(this, "providedToContactId", ""), /**
   * @generated from field: string provided_to_secondary_id = 9;
   */ _define_property(this, "providedToSecondaryId", ""), /**
   * @generated from field: string provided_to_primary = 10;
   */ _define_property(this, "providedToPrimary", ""), /**
   * @generated from field: string provided_to_secondary = 11;
   */ _define_property(this, "providedToSecondary", ""), /**
   * @generated from field: string comments = 12;
   */ _define_property(this, "comments", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string provided_by_contact_id = 14;
   */ _define_property(this, "providedByContactId", ""), /**
   * @generated from field: string brief_description = 15;
   */ _define_property(this, "briefDescription", ""), /**
   * @generated from field: string summary_and_action_items = 16;
   */ _define_property(this, "summaryAndActionItems", ""), /**
   * Ordered, user-entered plain-text attendee list (SAD-163) -- no
   * contact/user relationship, just names attached to the record. See
   * models.CustomerTouchpoint.Attendees.
   *
   * @generated from field: repeated string attendees = 17;
   */ _define_property(this, "attendees", []), /**
   * Affiliation each linked contact held when the touchpoint was recorded
   * (SAD-433). Server-stamped on create and whenever the contact id changes;
   * never taken from a request, and untouched by later employer changes.
   * Empty means unknown at the time, not current.
   *
   * @generated from field: string provided_to_company_profile_id = 18;
   */ _define_property(this, "providedToCompanyProfileId", ""), /**
   * @generated from field: string provided_to_government_organization_id = 19;
   */ _define_property(this, "providedToGovernmentOrganizationId", ""), /**
   * @generated from field: string provided_to_employment_id = 20;
   */ _define_property(this, "providedToEmploymentId", ""), /**
   * @generated from field: string provided_by_company_profile_id = 21;
   */ _define_property(this, "providedByCompanyProfileId", ""), /**
   * @generated from field: string provided_by_government_organization_id = 22;
   */ _define_property(this, "providedByGovernmentOrganizationId", ""), /**
   * @generated from field: string provided_by_employment_id = 23;
   */ _define_property(this, "providedByEmploymentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CustomerTouchpoint, "runtime", proto3);
_define_property(CustomerTouchpoint, "typeName", "mono.datagateway.v1.CustomerTouchpoint");
_define_property(CustomerTouchpoint, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "briefing_level",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "date_of_briefing",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "provided_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "provided_to_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "provided_to_secondary_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "provided_to_primary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "provided_to_secondary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "comments",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "provided_by_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "brief_description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "summary_and_action_items",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "attendees",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 18,
            name: "provided_to_company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "provided_to_government_organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "provided_to_employment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "provided_by_company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "provided_by_government_organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "provided_by_employment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GrowthOpportunity
 */ export class GrowthOpportunity extends Message {
    static fromBinary(bytes, options) {
        return new GrowthOpportunity().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GrowthOpportunity().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GrowthOpportunity().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GrowthOpportunity, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string description = 4;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string status = 5;
   */ _define_property(this, "status", ""), /**
   * @generated from field: double estimated_value = 6;
   */ _define_property(this, "estimatedValue", 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 9;
   */ _define_property(this, "deletedAt", void 0), /**
   * @generated from field: string comment = 10;
   */ _define_property(this, "comment", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GrowthOpportunity, "runtime", proto3);
_define_property(GrowthOpportunity, "typeName", "mono.datagateway.v1.GrowthOpportunity");
_define_property(GrowthOpportunity, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "estimated_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "comment",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SubcontractorReview
 */ export class SubcontractorReview extends Message {
    static fromBinary(bytes, options) {
        return new SubcontractorReview().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubcontractorReview().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubcontractorReview().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubcontractorReview, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string company_assignment_id = 4;
   */ _define_property(this, "companyAssignmentId", ""), /**
   * @generated from field: google.protobuf.Timestamp review_date = 5;
   */ _define_property(this, "reviewDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp due_date = 6;
   */ _define_property(this, "dueDate", void 0), /**
   * @generated from field: double score = 7;
   */ _define_property(this, "score", 0), /**
   * @generated from field: string feedback = 8;
   */ _define_property(this, "feedback", ""), /**
   * @generated from field: string state = 9;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string reviewed_by = 10;
   */ _define_property(this, "reviewedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 13;
   */ _define_property(this, "deletedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SubcontractorReview, "runtime", proto3);
_define_property(SubcontractorReview, "typeName", "mono.datagateway.v1.SubcontractorReview");
_define_property(SubcontractorReview, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_assignment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "review_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "due_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "score",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "feedback",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "reviewed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProgramDocument
 */ export class ProgramDocument extends Message {
    static fromBinary(bytes, options) {
        return new ProgramDocument().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramDocument().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramDocument().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramDocument, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 5;
   */ _define_property(this, "description", ""), /**
   * @generated from field: google.protobuf.Timestamp doc_date = 6;
   */ _define_property(this, "docDate", void 0), /**
   * @generated from field: string artifact_id = 7;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string category = 8;
   */ _define_property(this, "category", ""), /**
   * @generated from field: google.protobuf.Timestamp uploaded_at = 9;
   */ _define_property(this, "uploadedAt", void 0), /**
   * @generated from field: string uploaded_by = 10;
   */ _define_property(this, "uploadedBy", ""), /**
   * @generated from field: string company_assignment_id = 11;
   */ _define_property(this, "companyAssignmentId", ""), /**
   * read-only, server-populated; ignored on Create/Update
   *
   * @generated from field: string file_name = 12;
   */ _define_property(this, "fileName", ""), /**
   * Optional: scopes the document to one program contact (a person's docs —
   * e.g. a resume on their team seat), mirroring company_assignment_id.
   *
   * @generated from field: string contact_id = 13;
   */ _define_property(this, "contactId", ""), /**
   * Optional: scopes the document to one issue (an attachment on an Issue),
   * mirroring contact_id.
   *
   * @generated from field: string issue_id = 14;
   */ _define_property(this, "issueId", ""), /**
   * Free-text labels; normalised (trim/dedupe/limits) by ryugu before write.
   *
   * @generated from field: repeated string tags = 15;
   */ _define_property(this, "tags", []), /**
   * Processing outcome, read-only (written by SetProgramDocumentProcessing):
   * "processing", "ready", "failed", or empty when none was recorded.
   *
   * @generated from field: string processing_status = 16;
   */ _define_property(this, "processingStatus", ""), /**
   * plain reason, set only when failed
   *
   * @generated from field: string processing_reason = 17;
   */ _define_property(this, "processingReason", ""), /**
   * @generated from field: google.protobuf.Timestamp processing_attempted_at = 18;
   */ _define_property(this, "processingAttemptedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramDocument, "runtime", proto3);
_define_property(ProgramDocument, "typeName", "mono.datagateway.v1.ProgramDocument");
_define_property(ProgramDocument, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "doc_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "uploaded_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "uploaded_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "company_assignment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "file_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "issue_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "tags",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 16,
            name: "processing_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "processing_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "processing_attempted_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.IssueComment
 */ export class IssueComment extends Message {
    static fromBinary(bytes, options) {
        return new IssueComment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IssueComment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IssueComment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IssueComment, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string issue_id = 3;
   */ _define_property(this, "issueId", ""), /**
   * @generated from field: string author_user_id = 4;
   */ _define_property(this, "authorUserId", ""), /**
   * @generated from field: string body = 5;
   */ _define_property(this, "body", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IssueComment, "runtime", proto3);
_define_property(IssueComment, "typeName", "mono.datagateway.v1.IssueComment");
_define_property(IssueComment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "issue_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "author_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProgramModification
 */ export class ProgramModification extends Message {
    static fromBinary(bytes, options) {
        return new ProgramModification().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramModification().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramModification().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramModification, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string modification_number = 4;
   */ _define_property(this, "modificationNumber", ""), /**
   * @generated from field: string modification_type = 5;
   */ _define_property(this, "modificationType", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 6;
   */ _define_property(this, "effectiveDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp signed_date = 7;
   */ _define_property(this, "signedDate", void 0), /**
   * @generated from field: string purpose = 8;
   */ _define_property(this, "purpose", ""), /**
   * @generated from field: string change_categories = 9;
   */ _define_property(this, "changeCategories", ""), /**
   * @generated from field: bool no_cost_modification = 10;
   */ _define_property(this, "noCostModification", false), /**
   * @generated from field: double total_funding_impact = 11;
   */ _define_property(this, "totalFundingImpact", 0), /**
   * @generated from field: double cumulative_contract_value = 12;
   */ _define_property(this, "cumulativeContractValue", 0), /**
   * @generated from field: string period_changes_json = 13;
   */ _define_property(this, "periodChangesJson", ""), /**
   * @generated from field: string funding_changes_json = 14;
   */ _define_property(this, "fundingChangesJson", ""), /**
   * @generated from field: string scope_changes_json = 15;
   */ _define_property(this, "scopeChangesJson", ""), /**
   * @generated from field: string document_artifact_id = 16;
   */ _define_property(this, "documentArtifactId", ""), /**
   * @generated from field: string zou_modification_id = 17;
   */ _define_property(this, "zouModificationId", ""), /**
   * @generated from field: string status = 18;
   */ _define_property(this, "status", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 19;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 20;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 21;
   */ _define_property(this, "deletedAt", void 0), /**
   * Phase 0a SDS extensions absorbed from zou.ContractModification.
   *
   * @generated from field: double extraction_confidence = 22;
   */ _define_property(this, "extractionConfidence", 0), /**
   * denormalized for query convenience
   *
   * @generated from field: string contract_number = 23;
   */ _define_property(this, "contractNumber", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramModification, "runtime", proto3);
_define_property(ProgramModification, "typeName", "mono.datagateway.v1.ProgramModification");
_define_property(ProgramModification, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "modification_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "modification_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "signed_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "purpose",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "change_categories",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "no_cost_modification",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "total_funding_impact",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 12,
            name: "cumulative_contract_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 13,
            name: "period_changes_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "funding_changes_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "scope_changes_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "document_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "zou_modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 20,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 21,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 22,
            name: "extraction_confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 23,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AuditTemplate
 */ export class AuditTemplate extends Message {
    static fromBinary(bytes, options) {
        return new AuditTemplate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuditTemplate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuditTemplate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuditTemplate, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string name = 4;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string area = 5;
   */ _define_property(this, "area", ""), /**
   * @generated from field: bool is_default = 6;
   */ _define_property(this, "isDefault", false), /**
   * @generated from field: bool is_system = 7;
   */ _define_property(this, "isSystem", false), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 10;
   */ _define_property(this, "deletedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AuditTemplate, "runtime", proto3);
_define_property(AuditTemplate, "typeName", "mono.datagateway.v1.AuditTemplate");
_define_property(AuditTemplate, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "area",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "is_default",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "is_system",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AuditTemplateQuestion
 */ export class AuditTemplateQuestion extends Message {
    static fromBinary(bytes, options) {
        return new AuditTemplateQuestion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuditTemplateQuestion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuditTemplateQuestion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuditTemplateQuestion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string template_id = 3;
   */ _define_property(this, "templateId", ""), /**
   * @generated from field: string question = 4;
   */ _define_property(this, "question", ""), /**
   * @generated from field: int32 sort_order = 5;
   */ _define_property(this, "sortOrder", 0), /**
   * Standard-checklist annotations (000067).
   *
   * @generated from field: int32 item_number = 6;
   */ _define_property(this, "itemNumber", 0), /**
   * @generated from field: string checklist_item_key = 7;
   */ _define_property(this, "checklistItemKey", ""), /**
   * @generated from field: string review_area = 8;
   */ _define_property(this, "reviewArea", ""), /**
   * @generated from field: string description = 9;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string responsibility_key = 10;
   */ _define_property(this, "responsibilityKey", ""), /**
   * @generated from field: string project_phase = 11;
   */ _define_property(this, "projectPhase", ""), /**
   * @generated from field: string evidence_owner = 12;
   */ _define_property(this, "evidenceOwner", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AuditTemplateQuestion, "runtime", proto3);
_define_property(AuditTemplateQuestion, "typeName", "mono.datagateway.v1.AuditTemplateQuestion");
_define_property(AuditTemplateQuestion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "question",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "item_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "checklist_item_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "review_area",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "responsibility_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "project_phase",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "evidence_owner",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * AuditSectionOwner — per-program audit responsibility → owner mapping (000067).
 *
 * @generated from message mono.datagateway.v1.AuditSectionOwner
 */ export class AuditSectionOwner extends Message {
    static fromBinary(bytes, options) {
        return new AuditSectionOwner().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuditSectionOwner().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuditSectionOwner().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuditSectionOwner, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string responsibility_key = 4;
   */ _define_property(this, "responsibilityKey", ""), /**
   * @generated from field: string contact_id = 5;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string contact_name = 6;
   */ _define_property(this, "contactName", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 9;
   */ _define_property(this, "deletedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AuditSectionOwner, "runtime", proto3);
_define_property(AuditSectionOwner, "typeName", "mono.datagateway.v1.AuditSectionOwner");
_define_property(AuditSectionOwner, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "responsibility_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "contact_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AuditSectionOwnerFilter
 */ export class AuditSectionOwnerFilter extends Message {
    static fromBinary(bytes, options) {
        return new AuditSectionOwnerFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuditSectionOwnerFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuditSectionOwnerFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuditSectionOwnerFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AuditSectionOwnerFilter, "runtime", proto3);
_define_property(AuditSectionOwnerFilter, "typeName", "mono.datagateway.v1.AuditSectionOwnerFilter");
_define_property(AuditSectionOwnerFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateAuditSectionOwnerRequest
 */ export class CreateAuditSectionOwnerRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateAuditSectionOwnerRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateAuditSectionOwnerRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateAuditSectionOwnerRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateAuditSectionOwnerRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AuditSectionOwner owner = 1;
   */ _define_property(this, "owner", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateAuditSectionOwnerRequest, "runtime", proto3);
_define_property(CreateAuditSectionOwnerRequest, "typeName", "mono.datagateway.v1.CreateAuditSectionOwnerRequest");
_define_property(CreateAuditSectionOwnerRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "owner",
            kind: "message",
            T: AuditSectionOwner
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateAuditSectionOwnerResponse
 */ export class CreateAuditSectionOwnerResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateAuditSectionOwnerResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateAuditSectionOwnerResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateAuditSectionOwnerResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateAuditSectionOwnerResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AuditSectionOwner owner = 1;
   */ _define_property(this, "owner", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateAuditSectionOwnerResponse, "runtime", proto3);
_define_property(CreateAuditSectionOwnerResponse, "typeName", "mono.datagateway.v1.CreateAuditSectionOwnerResponse");
_define_property(CreateAuditSectionOwnerResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "owner",
            kind: "message",
            T: AuditSectionOwner
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateAuditSectionOwnerRequest
 */ export class UpdateAuditSectionOwnerRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateAuditSectionOwnerRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateAuditSectionOwnerRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateAuditSectionOwnerRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateAuditSectionOwnerRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AuditSectionOwner owner = 1;
   */ _define_property(this, "owner", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateAuditSectionOwnerRequest, "runtime", proto3);
_define_property(UpdateAuditSectionOwnerRequest, "typeName", "mono.datagateway.v1.UpdateAuditSectionOwnerRequest");
_define_property(UpdateAuditSectionOwnerRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "owner",
            kind: "message",
            T: AuditSectionOwner
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateAuditSectionOwnerResponse
 */ export class UpdateAuditSectionOwnerResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateAuditSectionOwnerResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateAuditSectionOwnerResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateAuditSectionOwnerResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateAuditSectionOwnerResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AuditSectionOwner owner = 1;
   */ _define_property(this, "owner", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateAuditSectionOwnerResponse, "runtime", proto3);
_define_property(UpdateAuditSectionOwnerResponse, "typeName", "mono.datagateway.v1.UpdateAuditSectionOwnerResponse");
_define_property(UpdateAuditSectionOwnerResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "owner",
            kind: "message",
            T: AuditSectionOwner
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListAuditSectionOwnersRequest
 */ export class ListAuditSectionOwnersRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListAuditSectionOwnersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAuditSectionOwnersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAuditSectionOwnersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAuditSectionOwnersRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AuditSectionOwnerFilter filter = 1;
   */ _define_property(this, "filter", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAuditSectionOwnersRequest, "runtime", proto3);
_define_property(ListAuditSectionOwnersRequest, "typeName", "mono.datagateway.v1.ListAuditSectionOwnersRequest");
_define_property(ListAuditSectionOwnersRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: AuditSectionOwnerFilter
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListAuditSectionOwnersResponse
 */ export class ListAuditSectionOwnersResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListAuditSectionOwnersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAuditSectionOwnersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAuditSectionOwnersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAuditSectionOwnersResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.AuditSectionOwner owners = 1;
   */ _define_property(this, "owners", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAuditSectionOwnersResponse, "runtime", proto3);
_define_property(ListAuditSectionOwnersResponse, "typeName", "mono.datagateway.v1.ListAuditSectionOwnersResponse");
_define_property(ListAuditSectionOwnersResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "owners",
            kind: "message",
            T: AuditSectionOwner,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SectorFilter
 */ export class SectorFilter extends Message {
    static fromBinary(bytes, options) {
        return new SectorFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SectorFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SectorFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SectorFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SectorFilter, "runtime", proto3);
_define_property(SectorFilter, "typeName", "mono.datagateway.v1.SectorFilter");
_define_property(SectorFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BusinessUnitFilter
 */ export class BusinessUnitFilter extends Message {
    static fromBinary(bytes, options) {
        return new BusinessUnitFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BusinessUnitFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BusinessUnitFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BusinessUnitFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string sector_id = 2;
   */ _define_property(this, "sectorId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(BusinessUnitFilter, "runtime", proto3);
_define_property(BusinessUnitFilter, "typeName", "mono.datagateway.v1.BusinessUnitFilter");
_define_property(BusinessUnitFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "sector_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.PortfolioFilter
 */ export class PortfolioFilter extends Message {
    static fromBinary(bytes, options) {
        return new PortfolioFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortfolioFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortfolioFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortfolioFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string business_unit_id = 2;
   */ _define_property(this, "businessUnitId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PortfolioFilter, "runtime", proto3);
_define_property(PortfolioFilter, "typeName", "mono.datagateway.v1.PortfolioFilter");
_define_property(PortfolioFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CompanyProfileFilter
 */ export class CompanyProfileFilter extends Message {
    static fromBinary(bytes, options) {
        return new CompanyProfileFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompanyProfileFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompanyProfileFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompanyProfileFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompanyProfileFilter, "runtime", proto3);
_define_property(CompanyProfileFilter, "typeName", "mono.datagateway.v1.CompanyProfileFilter");
_define_property(CompanyProfileFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * business_unit_id: NULL-or-match, same as TenantEnumListFilter's — set,
 * returns rows whose business_unit_id IS NULL **OR** equals this id, never
 * an equality-only narrowing. Empty means no BU filtering at all.
 *
 * @generated from message mono.datagateway.v1.ContactFilter
 */ export class ContactFilter extends Message {
    static fromBinary(bytes, options) {
        return new ContactFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContactFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContactFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContactFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string email = 2;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string platform_user_id = 3;
   */ _define_property(this, "platformUserId", ""), /**
   * @generated from field: string business_unit_id = 4;
   */ _define_property(this, "businessUnitId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContactFilter, "runtime", proto3);
_define_property(ContactFilter, "typeName", "mono.datagateway.v1.ContactFilter");
_define_property(ContactFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "platform_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CapabilityFilter
 */ export class CapabilityFilter extends Message {
    static fromBinary(bytes, options) {
        return new CapabilityFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CapabilityFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CapabilityFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CapabilityFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CapabilityFilter, "runtime", proto3);
_define_property(CapabilityFilter, "typeName", "mono.datagateway.v1.CapabilityFilter");
_define_property(CapabilityFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractVehicleFilter
 */ export class ContractVehicleFilter extends Message {
    static fromBinary(bytes, options) {
        return new ContractVehicleFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractVehicleFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractVehicleFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractVehicleFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractVehicleFilter, "runtime", proto3);
_define_property(ContractVehicleFilter, "typeName", "mono.datagateway.v1.ContractVehicleFilter");
_define_property(ContractVehicleFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProgramFilter
 */ export class ProgramFilter extends Message {
    static fromBinary(bytes, options) {
        return new ProgramFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string sector_id = 3;
   */ _define_property(this, "sectorId", ""), /**
   * @generated from field: string business_unit_id = 4;
   */ _define_property(this, "businessUnitId", ""), /**
   * @generated from field: string portfolio_id = 5;
   */ _define_property(this, "portfolioId", ""), /**
   * @generated from field: string contract_number = 6;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string idiq_program_id = 7;
   */ _define_property(this, "idiqProgramId", ""), /**
   * @generated from field: string operational_state_id = 8;
   */ _define_property(this, "operationalStateId", ""), /**
   * @generated from field: string pricing_type = 9;
   */ _define_property(this, "pricingType", ""), /**
   * @generated from field: string government_organization_id = 10;
   */ _define_property(this, "governmentOrganizationId", ""), /**
   * @generated from field: string customer_org_id = 11;
   */ _define_property(this, "customerOrgId", ""), /**
   * Reverse lookup: the zou contract project backing this program. Used by
   * zou's program-authz bridge to resolve delivery-program permissions for
   * callers who are not project_members of the underlying project.
   *
   * @generated from field: string zou_project_id = 12;
   */ _define_property(this, "zouProjectId", ""), /**
   * Task/call order number. Pairs with contract_number to disambiguate IDIQ/BPA
   * task orders that share a parent PIID (idx_programs_dedup keys on
   * (tenant, contract_number, COALESCE(task_number,''))). Empty is not a
   * wildcard here — it matches the standalone/parent row with no task number.
   *
   * @generated from field: string task_number = 13;
   */ _define_property(this, "taskNumber", ""), /**
   * Closed programs (non-null closed_at) are excluded from List by default;
   * set true to include them. See ProgramListFilter.IncludeClosed.
   *
   * @generated from field: bool include_closed = 14;
   */ _define_property(this, "includeClosed", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramFilter, "runtime", proto3);
_define_property(ProgramFilter, "typeName", "mono.datagateway.v1.ProgramFilter");
_define_property(ProgramFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sector_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "portfolio_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "idiq_program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "operational_state_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "pricing_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "government_organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "customer_org_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "task_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "include_closed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProgramRoleFilter
 */ export class ProgramRoleFilter extends Message {
    static fromBinary(bytes, options) {
        return new ProgramRoleFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramRoleFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramRoleFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramRoleFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string role = 3;
   */ _define_property(this, "role", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramRoleFilter, "runtime", proto3);
_define_property(ProgramRoleFilter, "typeName", "mono.datagateway.v1.ProgramRoleFilter");
_define_property(ProgramRoleFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProgramCapabilityFilter
 */ export class ProgramCapabilityFilter extends Message {
    static fromBinary(bytes, options) {
        return new ProgramCapabilityFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramCapabilityFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramCapabilityFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramCapabilityFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramCapabilityFilter, "runtime", proto3);
_define_property(ProgramCapabilityFilter, "typeName", "mono.datagateway.v1.ProgramCapabilityFilter");
_define_property(ProgramCapabilityFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProgramCompanyAssignmentFilter
 */ export class ProgramCompanyAssignmentFilter extends Message {
    static fromBinary(bytes, options) {
        return new ProgramCompanyAssignmentFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramCompanyAssignmentFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramCompanyAssignmentFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramCompanyAssignmentFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string company_profile_id = 3;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: bool active_only = 4;
   */ _define_property(this, "activeOnly", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramCompanyAssignmentFilter, "runtime", proto3);
_define_property(ProgramCompanyAssignmentFilter, "typeName", "mono.datagateway.v1.ProgramCompanyAssignmentFilter");
_define_property(ProgramCompanyAssignmentFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "active_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProgramCompanyStaffingLineFilter
 */ export class ProgramCompanyStaffingLineFilter extends Message {
    static fromBinary(bytes, options) {
        return new ProgramCompanyStaffingLineFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramCompanyStaffingLineFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramCompanyStaffingLineFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramCompanyStaffingLineFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string company_assignment_id = 3;
   */ _define_property(this, "companyAssignmentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramCompanyStaffingLineFilter, "runtime", proto3);
_define_property(ProgramCompanyStaffingLineFilter, "typeName", "mono.datagateway.v1.ProgramCompanyStaffingLineFilter");
_define_property(ProgramCompanyStaffingLineFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_assignment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProgramContactFilter
 */ export class ProgramContactFilter extends Message {
    static fromBinary(bytes, options) {
        return new ProgramContactFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramContactFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramContactFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramContactFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string contact_id = 3;
   */ _define_property(this, "contactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramContactFilter, "runtime", proto3);
_define_property(ProgramContactFilter, "typeName", "mono.datagateway.v1.ProgramContactFilter");
_define_property(ProgramContactFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.PeriodOfPerformanceFilter
 */ export class PeriodOfPerformanceFilter extends Message {
    static fromBinary(bytes, options) {
        return new PeriodOfPerformanceFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PeriodOfPerformanceFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PeriodOfPerformanceFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PeriodOfPerformanceFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PeriodOfPerformanceFilter, "runtime", proto3);
_define_property(PeriodOfPerformanceFilter, "typeName", "mono.datagateway.v1.PeriodOfPerformanceFilter");
_define_property(PeriodOfPerformanceFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.OptionalTaskFilter
 */ export class OptionalTaskFilter extends Message {
    static fromBinary(bytes, options) {
        return new OptionalTaskFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OptionalTaskFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OptionalTaskFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OptionalTaskFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OptionalTaskFilter, "runtime", proto3);
_define_property(OptionalTaskFilter, "typeName", "mono.datagateway.v1.OptionalTaskFilter");
_define_property(OptionalTaskFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProgramTaskFilter
 */ export class ProgramTaskFilter extends Message {
    static fromBinary(bytes, options) {
        return new ProgramTaskFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramTaskFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramTaskFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramTaskFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string state = 3;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string deliverable_number = 4;
   */ _define_property(this, "deliverableNumber", ""), /**
   * @generated from field: string zou_deliverable_id = 5;
   */ _define_property(this, "zouDeliverableId", ""), /**
   * @generated from field: google.protobuf.Timestamp due_date_before = 6;
   */ _define_property(this, "dueDateBefore", void 0), /**
   * @generated from field: google.protobuf.Timestamp due_date_after = 7;
   */ _define_property(this, "dueDateAfter", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramTaskFilter, "runtime", proto3);
_define_property(ProgramTaskFilter, "typeName", "mono.datagateway.v1.ProgramTaskFilter");
_define_property(ProgramTaskFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "deliverable_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "zou_deliverable_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "due_date_before",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "due_date_after",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.TaskAttachmentFilter
 */ export class TaskAttachmentFilter extends Message {
    static fromBinary(bytes, options) {
        return new TaskAttachmentFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TaskAttachmentFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TaskAttachmentFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TaskAttachmentFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string task_id = 2;
   */ _define_property(this, "taskId", ""), /**
   * @generated from field: string type = 3;
   */ _define_property(this, "type", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TaskAttachmentFilter, "runtime", proto3);
_define_property(TaskAttachmentFilter, "typeName", "mono.datagateway.v1.TaskAttachmentFilter");
_define_property(TaskAttachmentFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AuditFilter
 */ export class AuditFilter extends Message {
    static fromBinary(bytes, options) {
        return new AuditFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuditFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuditFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuditFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string state = 3;
   */ _define_property(this, "state", ""), /**
   * @generated from field: bool is_final = 4;
   */ _define_property(this, "isFinal", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AuditFilter, "runtime", proto3);
_define_property(AuditFilter, "typeName", "mono.datagateway.v1.AuditFilter");
_define_property(AuditFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "is_final",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AuditQuestionFilter
 */ export class AuditQuestionFilter extends Message {
    static fromBinary(bytes, options) {
        return new AuditQuestionFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuditQuestionFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuditQuestionFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuditQuestionFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string audit_id = 2;
   */ _define_property(this, "auditId", ""), /**
   * @generated from field: string result = 3;
   */ _define_property(this, "result", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AuditQuestionFilter, "runtime", proto3);
_define_property(AuditQuestionFilter, "typeName", "mono.datagateway.v1.AuditQuestionFilter");
_define_property(AuditQuestionFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "audit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "result",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CorrectiveActionFilter
 */ export class CorrectiveActionFilter extends Message {
    static fromBinary(bytes, options) {
        return new CorrectiveActionFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CorrectiveActionFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CorrectiveActionFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CorrectiveActionFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string audit_id = 2;
   */ _define_property(this, "auditId", ""), /**
   * @generated from field: string state = 3;
   */ _define_property(this, "state", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CorrectiveActionFilter, "runtime", proto3);
_define_property(CorrectiveActionFilter, "typeName", "mono.datagateway.v1.CorrectiveActionFilter");
_define_property(CorrectiveActionFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "audit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeviationFilter
 */ export class DeviationFilter extends Message {
    static fromBinary(bytes, options) {
        return new DeviationFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeviationFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeviationFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeviationFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string state = 3;
   */ _define_property(this, "state", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeviationFilter, "runtime", proto3);
_define_property(DeviationFilter, "typeName", "mono.datagateway.v1.DeviationFilter");
_define_property(DeviationFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DSOEntryFilter
 */ export class DSOEntryFilter extends Message {
    static fromBinary(bytes, options) {
        return new DSOEntryFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DSOEntryFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DSOEntryFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DSOEntryFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DSOEntryFilter, "runtime", proto3);
_define_property(DSOEntryFilter, "typeName", "mono.datagateway.v1.DSOEntryFilter");
_define_property(DSOEntryFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.EACEntryFilter
 */ export class EACEntryFilter extends Message {
    static fromBinary(bytes, options) {
        return new EACEntryFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EACEntryFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EACEntryFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EACEntryFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EACEntryFilter, "runtime", proto3);
_define_property(EACEntryFilter, "typeName", "mono.datagateway.v1.EACEntryFilter");
_define_property(EACEntryFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProgramFinancialMonthFilter
 */ export class ProgramFinancialMonthFilter extends Message {
    static fromBinary(bytes, options) {
        return new ProgramFinancialMonthFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramFinancialMonthFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramFinancialMonthFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramFinancialMonthFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramFinancialMonthFilter, "runtime", proto3);
_define_property(ProgramFinancialMonthFilter, "typeName", "mono.datagateway.v1.ProgramFinancialMonthFilter");
_define_property(ProgramFinancialMonthFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CPARSScoreFilter
 */ export class CPARSScoreFilter extends Message {
    static fromBinary(bytes, options) {
        return new CPARSScoreFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CPARSScoreFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CPARSScoreFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CPARSScoreFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CPARSScoreFilter, "runtime", proto3);
_define_property(CPARSScoreFilter, "typeName", "mono.datagateway.v1.CPARSScoreFilter");
_define_property(CPARSScoreFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.QASPScoreFilter
 */ export class QASPScoreFilter extends Message {
    static fromBinary(bytes, options) {
        return new QASPScoreFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QASPScoreFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QASPScoreFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QASPScoreFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(QASPScoreFilter, "runtime", proto3);
_define_property(QASPScoreFilter, "typeName", "mono.datagateway.v1.QASPScoreFilter");
_define_property(QASPScoreFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RiskFilter
 */ export class RiskFilter extends Message {
    static fromBinary(bytes, options) {
        return new RiskFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RiskFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RiskFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RiskFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string status = 3;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RiskFilter, "runtime", proto3);
_define_property(RiskFilter, "typeName", "mono.datagateway.v1.RiskFilter");
_define_property(RiskFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.IssueFilter
 */ export class IssueFilter extends Message {
    static fromBinary(bytes, options) {
        return new IssueFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IssueFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IssueFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IssueFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string state = 3;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string auto_generated_type = 4;
   */ _define_property(this, "autoGeneratedType", ""), /**
   * @generated from field: string linked_record_id = 5;
   */ _define_property(this, "linkedRecordId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(IssueFilter, "runtime", proto3);
_define_property(IssueFilter, "typeName", "mono.datagateway.v1.IssueFilter");
_define_property(IssueFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "auto_generated_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "linked_record_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CustomerTouchpointFilter
 */ export class CustomerTouchpointFilter extends Message {
    static fromBinary(bytes, options) {
        return new CustomerTouchpointFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CustomerTouchpointFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CustomerTouchpointFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CustomerTouchpointFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * Touchpoints where this contact is the provided-to or provided-by party.
   *
   * @generated from field: string contact_id = 3;
   */ _define_property(this, "contactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CustomerTouchpointFilter, "runtime", proto3);
_define_property(CustomerTouchpointFilter, "typeName", "mono.datagateway.v1.CustomerTouchpointFilter");
_define_property(CustomerTouchpointFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GrowthOpportunityFilter
 */ export class GrowthOpportunityFilter extends Message {
    static fromBinary(bytes, options) {
        return new GrowthOpportunityFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GrowthOpportunityFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GrowthOpportunityFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GrowthOpportunityFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GrowthOpportunityFilter, "runtime", proto3);
_define_property(GrowthOpportunityFilter, "typeName", "mono.datagateway.v1.GrowthOpportunityFilter");
_define_property(GrowthOpportunityFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SubcontractorReviewFilter
 */ export class SubcontractorReviewFilter extends Message {
    static fromBinary(bytes, options) {
        return new SubcontractorReviewFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubcontractorReviewFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubcontractorReviewFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubcontractorReviewFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string company_assignment_id = 3;
   */ _define_property(this, "companyAssignmentId", ""), /**
   * @generated from field: string state = 4;
   */ _define_property(this, "state", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SubcontractorReviewFilter, "runtime", proto3);
_define_property(SubcontractorReviewFilter, "typeName", "mono.datagateway.v1.SubcontractorReviewFilter");
_define_property(SubcontractorReviewFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_assignment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProgramDocumentFilter
 */ export class ProgramDocumentFilter extends Message {
    static fromBinary(bytes, options) {
        return new ProgramDocumentFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramDocumentFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramDocumentFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramDocumentFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string category = 3;
   */ _define_property(this, "category", ""), /**
   * @generated from field: string company_assignment_id = 4;
   */ _define_property(this, "companyAssignmentId", ""), /**
   * Include tombstoned (user-removed) rows — the pipeline's dedup scope.
   *
   * @generated from field: bool include_removed = 5;
   */ _define_property(this, "includeRemoved", false), /**
   * @generated from field: string contact_id = 6;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string issue_id = 7;
   */ _define_property(this, "issueId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramDocumentFilter, "runtime", proto3);
_define_property(ProgramDocumentFilter, "typeName", "mono.datagateway.v1.ProgramDocumentFilter");
_define_property(ProgramDocumentFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_assignment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "include_removed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "issue_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.IssueCommentFilter
 */ export class IssueCommentFilter extends Message {
    static fromBinary(bytes, options) {
        return new IssueCommentFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IssueCommentFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IssueCommentFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IssueCommentFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string issue_id = 2;
   */ _define_property(this, "issueId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(IssueCommentFilter, "runtime", proto3);
_define_property(IssueCommentFilter, "typeName", "mono.datagateway.v1.IssueCommentFilter");
_define_property(IssueCommentFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "issue_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProgramModificationFilter
 */ export class ProgramModificationFilter extends Message {
    static fromBinary(bytes, options) {
        return new ProgramModificationFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramModificationFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramModificationFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramModificationFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramModificationFilter, "runtime", proto3);
_define_property(ProgramModificationFilter, "typeName", "mono.datagateway.v1.ProgramModificationFilter");
_define_property(ProgramModificationFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AuditTemplateFilter
 */ export class AuditTemplateFilter extends Message {
    static fromBinary(bytes, options) {
        return new AuditTemplateFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuditTemplateFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuditTemplateFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuditTemplateFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: bool include_system = 3;
   */ _define_property(this, "includeSystem", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AuditTemplateFilter, "runtime", proto3);
_define_property(AuditTemplateFilter, "typeName", "mono.datagateway.v1.AuditTemplateFilter");
_define_property(AuditTemplateFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "include_system",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AuditTemplateQuestionFilter
 */ export class AuditTemplateQuestionFilter extends Message {
    static fromBinary(bytes, options) {
        return new AuditTemplateQuestionFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuditTemplateQuestionFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuditTemplateQuestionFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuditTemplateQuestionFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string template_id = 2;
   */ _define_property(this, "templateId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AuditTemplateQuestionFilter, "runtime", proto3);
_define_property(AuditTemplateQuestionFilter, "typeName", "mono.datagateway.v1.AuditTemplateQuestionFilter");
_define_property(AuditTemplateQuestionFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetSectorRequest
 */ export class GetSectorRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetSectorRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSectorRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSectorRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSectorRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSectorRequest, "runtime", proto3);
_define_property(GetSectorRequest, "typeName", "mono.datagateway.v1.GetSectorRequest");
_define_property(GetSectorRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetSectorResponse
 */ export class GetSectorResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetSectorResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSectorResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSectorResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSectorResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Sector sector = 1;
   */ _define_property(this, "sector", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSectorResponse, "runtime", proto3);
_define_property(GetSectorResponse, "typeName", "mono.datagateway.v1.GetSectorResponse");
_define_property(GetSectorResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sector",
            kind: "message",
            T: Sector
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateSectorRequest
 */ export class CreateSectorRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateSectorRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateSectorRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateSectorRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateSectorRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Sector sector = 1;
   */ _define_property(this, "sector", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateSectorRequest, "runtime", proto3);
_define_property(CreateSectorRequest, "typeName", "mono.datagateway.v1.CreateSectorRequest");
_define_property(CreateSectorRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sector",
            kind: "message",
            T: Sector
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateSectorResponse
 */ export class CreateSectorResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateSectorResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateSectorResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateSectorResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateSectorResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Sector sector = 1;
   */ _define_property(this, "sector", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateSectorResponse, "runtime", proto3);
_define_property(CreateSectorResponse, "typeName", "mono.datagateway.v1.CreateSectorResponse");
_define_property(CreateSectorResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sector",
            kind: "message",
            T: Sector
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateSectorRequest
 */ export class UpdateSectorRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateSectorRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateSectorRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateSectorRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateSectorRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Sector sector = 1;
   */ _define_property(this, "sector", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateSectorRequest, "runtime", proto3);
_define_property(UpdateSectorRequest, "typeName", "mono.datagateway.v1.UpdateSectorRequest");
_define_property(UpdateSectorRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sector",
            kind: "message",
            T: Sector
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateSectorResponse
 */ export class UpdateSectorResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateSectorResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateSectorResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateSectorResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateSectorResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Sector sector = 1;
   */ _define_property(this, "sector", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateSectorResponse, "runtime", proto3);
_define_property(UpdateSectorResponse, "typeName", "mono.datagateway.v1.UpdateSectorResponse");
_define_property(UpdateSectorResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sector",
            kind: "message",
            T: Sector
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListSectorsRequest
 */ export class ListSectorsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListSectorsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSectorsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSectorsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSectorsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SectorFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSectorsRequest, "runtime", proto3);
_define_property(ListSectorsRequest, "typeName", "mono.datagateway.v1.ListSectorsRequest");
_define_property(ListSectorsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: SectorFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListSectorsResponse
 */ export class ListSectorsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListSectorsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSectorsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSectorsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSectorsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.Sector sectors = 1;
   */ _define_property(this, "sectors", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSectorsResponse, "runtime", proto3);
_define_property(ListSectorsResponse, "typeName", "mono.datagateway.v1.ListSectorsResponse");
_define_property(ListSectorsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sectors",
            kind: "message",
            T: Sector,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteSectorRequest
 */ export class DeleteSectorRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteSectorRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteSectorRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteSectorRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteSectorRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteSectorRequest, "runtime", proto3);
_define_property(DeleteSectorRequest, "typeName", "mono.datagateway.v1.DeleteSectorRequest");
_define_property(DeleteSectorRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteSectorResponse
 */ export class DeleteSectorResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteSectorResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteSectorResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteSectorResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteSectorResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteSectorResponse, "runtime", proto3);
_define_property(DeleteSectorResponse, "typeName", "mono.datagateway.v1.DeleteSectorResponse");
_define_property(DeleteSectorResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetBusinessUnitRequest
 */ export class GetBusinessUnitRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetBusinessUnitRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetBusinessUnitRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetBusinessUnitRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetBusinessUnitRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetBusinessUnitRequest, "runtime", proto3);
_define_property(GetBusinessUnitRequest, "typeName", "mono.datagateway.v1.GetBusinessUnitRequest");
_define_property(GetBusinessUnitRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetBusinessUnitResponse
 */ export class GetBusinessUnitResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetBusinessUnitResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetBusinessUnitResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetBusinessUnitResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetBusinessUnitResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.BusinessUnit business_unit = 1;
   */ _define_property(this, "businessUnit", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetBusinessUnitResponse, "runtime", proto3);
_define_property(GetBusinessUnitResponse, "typeName", "mono.datagateway.v1.GetBusinessUnitResponse");
_define_property(GetBusinessUnitResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "business_unit",
            kind: "message",
            T: BusinessUnit
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateBusinessUnitRequest
 */ export class CreateBusinessUnitRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateBusinessUnitRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateBusinessUnitRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateBusinessUnitRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateBusinessUnitRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.BusinessUnit business_unit = 1;
   */ _define_property(this, "businessUnit", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateBusinessUnitRequest, "runtime", proto3);
_define_property(CreateBusinessUnitRequest, "typeName", "mono.datagateway.v1.CreateBusinessUnitRequest");
_define_property(CreateBusinessUnitRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "business_unit",
            kind: "message",
            T: BusinessUnit
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateBusinessUnitResponse
 */ export class CreateBusinessUnitResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateBusinessUnitResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateBusinessUnitResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateBusinessUnitResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateBusinessUnitResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.BusinessUnit business_unit = 1;
   */ _define_property(this, "businessUnit", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateBusinessUnitResponse, "runtime", proto3);
_define_property(CreateBusinessUnitResponse, "typeName", "mono.datagateway.v1.CreateBusinessUnitResponse");
_define_property(CreateBusinessUnitResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "business_unit",
            kind: "message",
            T: BusinessUnit
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateBusinessUnitRequest
 */ export class UpdateBusinessUnitRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateBusinessUnitRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateBusinessUnitRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateBusinessUnitRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateBusinessUnitRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.BusinessUnit business_unit = 1;
   */ _define_property(this, "businessUnit", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateBusinessUnitRequest, "runtime", proto3);
_define_property(UpdateBusinessUnitRequest, "typeName", "mono.datagateway.v1.UpdateBusinessUnitRequest");
_define_property(UpdateBusinessUnitRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "business_unit",
            kind: "message",
            T: BusinessUnit
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateBusinessUnitResponse
 */ export class UpdateBusinessUnitResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateBusinessUnitResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateBusinessUnitResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateBusinessUnitResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateBusinessUnitResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.BusinessUnit business_unit = 1;
   */ _define_property(this, "businessUnit", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateBusinessUnitResponse, "runtime", proto3);
_define_property(UpdateBusinessUnitResponse, "typeName", "mono.datagateway.v1.UpdateBusinessUnitResponse");
_define_property(UpdateBusinessUnitResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "business_unit",
            kind: "message",
            T: BusinessUnit
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListBusinessUnitsRequest
 */ export class ListBusinessUnitsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListBusinessUnitsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListBusinessUnitsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListBusinessUnitsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListBusinessUnitsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.BusinessUnitFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListBusinessUnitsRequest, "runtime", proto3);
_define_property(ListBusinessUnitsRequest, "typeName", "mono.datagateway.v1.ListBusinessUnitsRequest");
_define_property(ListBusinessUnitsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: BusinessUnitFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListBusinessUnitsResponse
 */ export class ListBusinessUnitsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListBusinessUnitsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListBusinessUnitsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListBusinessUnitsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListBusinessUnitsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.BusinessUnit business_units = 1;
   */ _define_property(this, "businessUnits", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListBusinessUnitsResponse, "runtime", proto3);
_define_property(ListBusinessUnitsResponse, "typeName", "mono.datagateway.v1.ListBusinessUnitsResponse");
_define_property(ListBusinessUnitsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "business_units",
            kind: "message",
            T: BusinessUnit,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteBusinessUnitRequest
 */ export class DeleteBusinessUnitRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteBusinessUnitRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteBusinessUnitRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteBusinessUnitRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteBusinessUnitRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteBusinessUnitRequest, "runtime", proto3);
_define_property(DeleteBusinessUnitRequest, "typeName", "mono.datagateway.v1.DeleteBusinessUnitRequest");
_define_property(DeleteBusinessUnitRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteBusinessUnitResponse
 */ export class DeleteBusinessUnitResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteBusinessUnitResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteBusinessUnitResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteBusinessUnitResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteBusinessUnitResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteBusinessUnitResponse, "runtime", proto3);
_define_property(DeleteBusinessUnitResponse, "typeName", "mono.datagateway.v1.DeleteBusinessUnitResponse");
_define_property(DeleteBusinessUnitResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetPortfolioRequest
 */ export class GetPortfolioRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPortfolioRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPortfolioRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPortfolioRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPortfolioRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPortfolioRequest, "runtime", proto3);
_define_property(GetPortfolioRequest, "typeName", "mono.datagateway.v1.GetPortfolioRequest");
_define_property(GetPortfolioRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetPortfolioResponse
 */ export class GetPortfolioResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPortfolioResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPortfolioResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPortfolioResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPortfolioResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Portfolio portfolio = 1;
   */ _define_property(this, "portfolio", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPortfolioResponse, "runtime", proto3);
_define_property(GetPortfolioResponse, "typeName", "mono.datagateway.v1.GetPortfolioResponse");
_define_property(GetPortfolioResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "portfolio",
            kind: "message",
            T: Portfolio
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreatePortfolioRequest
 */ export class CreatePortfolioRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreatePortfolioRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreatePortfolioRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreatePortfolioRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreatePortfolioRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Portfolio portfolio = 1;
   */ _define_property(this, "portfolio", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreatePortfolioRequest, "runtime", proto3);
_define_property(CreatePortfolioRequest, "typeName", "mono.datagateway.v1.CreatePortfolioRequest");
_define_property(CreatePortfolioRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "portfolio",
            kind: "message",
            T: Portfolio
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreatePortfolioResponse
 */ export class CreatePortfolioResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreatePortfolioResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreatePortfolioResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreatePortfolioResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreatePortfolioResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Portfolio portfolio = 1;
   */ _define_property(this, "portfolio", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreatePortfolioResponse, "runtime", proto3);
_define_property(CreatePortfolioResponse, "typeName", "mono.datagateway.v1.CreatePortfolioResponse");
_define_property(CreatePortfolioResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "portfolio",
            kind: "message",
            T: Portfolio
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdatePortfolioRequest
 */ export class UpdatePortfolioRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdatePortfolioRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdatePortfolioRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdatePortfolioRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdatePortfolioRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Portfolio portfolio = 1;
   */ _define_property(this, "portfolio", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdatePortfolioRequest, "runtime", proto3);
_define_property(UpdatePortfolioRequest, "typeName", "mono.datagateway.v1.UpdatePortfolioRequest");
_define_property(UpdatePortfolioRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "portfolio",
            kind: "message",
            T: Portfolio
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdatePortfolioResponse
 */ export class UpdatePortfolioResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdatePortfolioResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdatePortfolioResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdatePortfolioResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdatePortfolioResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Portfolio portfolio = 1;
   */ _define_property(this, "portfolio", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdatePortfolioResponse, "runtime", proto3);
_define_property(UpdatePortfolioResponse, "typeName", "mono.datagateway.v1.UpdatePortfolioResponse");
_define_property(UpdatePortfolioResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "portfolio",
            kind: "message",
            T: Portfolio
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPortfoliosRequest
 */ export class ListPortfoliosRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPortfoliosRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPortfoliosRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPortfoliosRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPortfoliosRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PortfolioFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPortfoliosRequest, "runtime", proto3);
_define_property(ListPortfoliosRequest, "typeName", "mono.datagateway.v1.ListPortfoliosRequest");
_define_property(ListPortfoliosRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: PortfolioFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPortfoliosResponse
 */ export class ListPortfoliosResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPortfoliosResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPortfoliosResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPortfoliosResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPortfoliosResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.Portfolio portfolios = 1;
   */ _define_property(this, "portfolios", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPortfoliosResponse, "runtime", proto3);
_define_property(ListPortfoliosResponse, "typeName", "mono.datagateway.v1.ListPortfoliosResponse");
_define_property(ListPortfoliosResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "portfolios",
            kind: "message",
            T: Portfolio,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeletePortfolioRequest
 */ export class DeletePortfolioRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeletePortfolioRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeletePortfolioRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeletePortfolioRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeletePortfolioRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeletePortfolioRequest, "runtime", proto3);
_define_property(DeletePortfolioRequest, "typeName", "mono.datagateway.v1.DeletePortfolioRequest");
_define_property(DeletePortfolioRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeletePortfolioResponse
 */ export class DeletePortfolioResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeletePortfolioResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeletePortfolioResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeletePortfolioResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeletePortfolioResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeletePortfolioResponse, "runtime", proto3);
_define_property(DeletePortfolioResponse, "typeName", "mono.datagateway.v1.DeletePortfolioResponse");
_define_property(DeletePortfolioResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetCompanyProfileRequest
 */ export class GetCompanyProfileRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCompanyProfileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCompanyProfileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCompanyProfileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCompanyProfileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCompanyProfileRequest, "runtime", proto3);
_define_property(GetCompanyProfileRequest, "typeName", "mono.datagateway.v1.GetCompanyProfileRequest");
_define_property(GetCompanyProfileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCompanyProfileResponse
 */ export class GetCompanyProfileResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCompanyProfileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCompanyProfileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCompanyProfileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCompanyProfileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CompanyProfile company_profile = 1;
   */ _define_property(this, "companyProfile", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCompanyProfileResponse, "runtime", proto3);
_define_property(GetCompanyProfileResponse, "typeName", "mono.datagateway.v1.GetCompanyProfileResponse");
_define_property(GetCompanyProfileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_profile",
            kind: "message",
            T: CompanyProfile
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateCompanyProfileRequest
 */ export class CreateCompanyProfileRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateCompanyProfileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCompanyProfileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCompanyProfileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCompanyProfileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CompanyProfile company_profile = 1;
   */ _define_property(this, "companyProfile", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCompanyProfileRequest, "runtime", proto3);
_define_property(CreateCompanyProfileRequest, "typeName", "mono.datagateway.v1.CreateCompanyProfileRequest");
_define_property(CreateCompanyProfileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_profile",
            kind: "message",
            T: CompanyProfile
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateCompanyProfileResponse
 */ export class CreateCompanyProfileResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateCompanyProfileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCompanyProfileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCompanyProfileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCompanyProfileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CompanyProfile company_profile = 1;
   */ _define_property(this, "companyProfile", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCompanyProfileResponse, "runtime", proto3);
_define_property(CreateCompanyProfileResponse, "typeName", "mono.datagateway.v1.CreateCompanyProfileResponse");
_define_property(CreateCompanyProfileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_profile",
            kind: "message",
            T: CompanyProfile
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateCompanyProfileRequest
 */ export class UpdateCompanyProfileRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCompanyProfileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCompanyProfileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCompanyProfileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCompanyProfileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CompanyProfile company_profile = 1;
   */ _define_property(this, "companyProfile", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCompanyProfileRequest, "runtime", proto3);
_define_property(UpdateCompanyProfileRequest, "typeName", "mono.datagateway.v1.UpdateCompanyProfileRequest");
_define_property(UpdateCompanyProfileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_profile",
            kind: "message",
            T: CompanyProfile
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateCompanyProfileResponse
 */ export class UpdateCompanyProfileResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCompanyProfileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCompanyProfileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCompanyProfileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCompanyProfileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CompanyProfile company_profile = 1;
   */ _define_property(this, "companyProfile", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCompanyProfileResponse, "runtime", proto3);
_define_property(UpdateCompanyProfileResponse, "typeName", "mono.datagateway.v1.UpdateCompanyProfileResponse");
_define_property(UpdateCompanyProfileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_profile",
            kind: "message",
            T: CompanyProfile
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCompanyProfilesRequest
 */ export class ListCompanyProfilesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCompanyProfilesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCompanyProfilesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCompanyProfilesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCompanyProfilesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CompanyProfileFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCompanyProfilesRequest, "runtime", proto3);
_define_property(ListCompanyProfilesRequest, "typeName", "mono.datagateway.v1.ListCompanyProfilesRequest");
_define_property(ListCompanyProfilesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: CompanyProfileFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCompanyProfilesResponse
 */ export class ListCompanyProfilesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCompanyProfilesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCompanyProfilesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCompanyProfilesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCompanyProfilesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CompanyProfile company_profiles = 1;
   */ _define_property(this, "companyProfiles", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCompanyProfilesResponse, "runtime", proto3);
_define_property(ListCompanyProfilesResponse, "typeName", "mono.datagateway.v1.ListCompanyProfilesResponse");
_define_property(ListCompanyProfilesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_profiles",
            kind: "message",
            T: CompanyProfile,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCompanyProfileRequest
 */ export class DeleteCompanyProfileRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCompanyProfileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCompanyProfileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCompanyProfileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCompanyProfileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCompanyProfileRequest, "runtime", proto3);
_define_property(DeleteCompanyProfileRequest, "typeName", "mono.datagateway.v1.DeleteCompanyProfileRequest");
_define_property(DeleteCompanyProfileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCompanyProfileResponse
 */ export class DeleteCompanyProfileResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCompanyProfileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCompanyProfileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCompanyProfileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCompanyProfileResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCompanyProfileResponse, "runtime", proto3);
_define_property(DeleteCompanyProfileResponse, "typeName", "mono.datagateway.v1.DeleteCompanyProfileResponse");
_define_property(DeleteCompanyProfileResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetOwnCompanyProfileRequest
 */ export class GetOwnCompanyProfileRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetOwnCompanyProfileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOwnCompanyProfileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOwnCompanyProfileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOwnCompanyProfileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOwnCompanyProfileRequest, "runtime", proto3);
_define_property(GetOwnCompanyProfileRequest, "typeName", "mono.datagateway.v1.GetOwnCompanyProfileRequest");
_define_property(GetOwnCompanyProfileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * company_profile is unset when no flagged profile exists and no live
 * profile's name matches the tenant's name.
 *
 * @generated from message mono.datagateway.v1.GetOwnCompanyProfileResponse
 */ export class GetOwnCompanyProfileResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetOwnCompanyProfileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOwnCompanyProfileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOwnCompanyProfileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOwnCompanyProfileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CompanyProfile company_profile = 1;
   */ _define_property(this, "companyProfile", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOwnCompanyProfileResponse, "runtime", proto3);
_define_property(GetOwnCompanyProfileResponse, "typeName", "mono.datagateway.v1.GetOwnCompanyProfileResponse");
_define_property(GetOwnCompanyProfileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_profile",
            kind: "message",
            T: CompanyProfile
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetOwnCompanyProfileRequest
 */ export class SetOwnCompanyProfileRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetOwnCompanyProfileRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetOwnCompanyProfileRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetOwnCompanyProfileRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetOwnCompanyProfileRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string company_profile_id = 2;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string decided_by_user_id = 3;
   */ _define_property(this, "decidedByUserId", ""), /**
   * @generated from field: string reason = 4;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetOwnCompanyProfileRequest, "runtime", proto3);
_define_property(SetOwnCompanyProfileRequest, "typeName", "mono.datagateway.v1.SetOwnCompanyProfileRequest");
_define_property(SetOwnCompanyProfileRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "decided_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetOwnCompanyProfileResponse
 */ export class SetOwnCompanyProfileResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetOwnCompanyProfileResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetOwnCompanyProfileResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetOwnCompanyProfileResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetOwnCompanyProfileResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CompanyProfile company_profile = 1;
   */ _define_property(this, "companyProfile", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetOwnCompanyProfileResponse, "runtime", proto3);
_define_property(SetOwnCompanyProfileResponse, "typeName", "mono.datagateway.v1.SetOwnCompanyProfileResponse");
_define_property(SetOwnCompanyProfileResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "company_profile",
            kind: "message",
            T: CompanyProfile
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListOwnCompanyDesignationsRequest
 */ export class ListOwnCompanyDesignationsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListOwnCompanyDesignationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOwnCompanyDesignationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOwnCompanyDesignationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOwnCompanyDesignationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: int32 limit = 2;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOwnCompanyDesignationsRequest, "runtime", proto3);
_define_property(ListOwnCompanyDesignationsRequest, "typeName", "mono.datagateway.v1.ListOwnCompanyDesignationsRequest");
_define_property(ListOwnCompanyDesignationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListOwnCompanyDesignationsResponse
 */ export class ListOwnCompanyDesignationsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListOwnCompanyDesignationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOwnCompanyDesignationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOwnCompanyDesignationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOwnCompanyDesignationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.OwnCompanyDesignation designations = 1;
   */ _define_property(this, "designations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOwnCompanyDesignationsResponse, "runtime", proto3);
_define_property(ListOwnCompanyDesignationsResponse, "typeName", "mono.datagateway.v1.ListOwnCompanyDesignationsResponse");
_define_property(ListOwnCompanyDesignationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "designations",
            kind: "message",
            T: OwnCompanyDesignation,
            repeated: true
        }
    ]));
/**
 * OwnCompanyDesignation is the append-only audit record of who designated
 * which company_profiles row as a tenant's Our Company, and what it
 * superseded (migration 000264, SAD-548).
 *
 * @generated from message mono.datagateway.v1.OwnCompanyDesignation
 */ export class OwnCompanyDesignation extends Message {
    static fromBinary(bytes, options) {
        return new OwnCompanyDesignation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OwnCompanyDesignation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OwnCompanyDesignation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OwnCompanyDesignation, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string company_profile_id = 3;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string previous_company_profile_id = 4;
   */ _define_property(this, "previousCompanyProfileId", ""), /**
   * @generated from field: string decided_by_user_id = 5;
   */ _define_property(this, "decidedByUserId", ""), /**
   * @generated from field: string reason = 6;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: google.protobuf.Timestamp decided_at = 7;
   */ _define_property(this, "decidedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OwnCompanyDesignation, "runtime", proto3);
_define_property(OwnCompanyDesignation, "typeName", "mono.datagateway.v1.OwnCompanyDesignation");
_define_property(OwnCompanyDesignation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "previous_company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "decided_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "decided_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetContactRequest
 */ export class GetContactRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetContactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetContactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetContactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetContactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetContactRequest, "runtime", proto3);
_define_property(GetContactRequest, "typeName", "mono.datagateway.v1.GetContactRequest");
_define_property(GetContactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetContactResponse
 */ export class GetContactResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetContactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetContactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetContactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetContactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Contact contact = 1;
   */ _define_property(this, "contact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetContactResponse, "runtime", proto3);
_define_property(GetContactResponse, "typeName", "mono.datagateway.v1.GetContactResponse");
_define_property(GetContactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact",
            kind: "message",
            T: Contact
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateContactRequest
 */ export class CreateContactRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateContactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateContactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateContactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateContactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Contact contact = 1;
   */ _define_property(this, "contact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateContactRequest, "runtime", proto3);
_define_property(CreateContactRequest, "typeName", "mono.datagateway.v1.CreateContactRequest");
_define_property(CreateContactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact",
            kind: "message",
            T: Contact
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateContactResponse
 */ export class CreateContactResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateContactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateContactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateContactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateContactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Contact contact = 1;
   */ _define_property(this, "contact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateContactResponse, "runtime", proto3);
_define_property(CreateContactResponse, "typeName", "mono.datagateway.v1.CreateContactResponse");
_define_property(CreateContactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact",
            kind: "message",
            T: Contact
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateContactRequest
 */ export class UpdateContactRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateContactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateContactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateContactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateContactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Contact contact = 1;
   */ _define_property(this, "contact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateContactRequest, "runtime", proto3);
_define_property(UpdateContactRequest, "typeName", "mono.datagateway.v1.UpdateContactRequest");
_define_property(UpdateContactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact",
            kind: "message",
            T: Contact
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateContactResponse
 */ export class UpdateContactResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateContactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateContactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateContactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateContactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Contact contact = 1;
   */ _define_property(this, "contact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateContactResponse, "runtime", proto3);
_define_property(UpdateContactResponse, "typeName", "mono.datagateway.v1.UpdateContactResponse");
_define_property(UpdateContactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact",
            kind: "message",
            T: Contact
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListContactsRequest
 */ export class ListContactsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListContactsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContactsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContactsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContactsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContactFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContactsRequest, "runtime", proto3);
_define_property(ListContactsRequest, "typeName", "mono.datagateway.v1.ListContactsRequest");
_define_property(ListContactsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: ContactFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListContactsResponse
 */ export class ListContactsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListContactsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContactsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContactsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContactsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.Contact contacts = 1;
   */ _define_property(this, "contacts", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContactsResponse, "runtime", proto3);
_define_property(ListContactsResponse, "typeName", "mono.datagateway.v1.ListContactsResponse");
_define_property(ListContactsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contacts",
            kind: "message",
            T: Contact,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteContactRequest
 */ export class DeleteContactRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteContactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteContactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteContactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteContactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteContactRequest, "runtime", proto3);
_define_property(DeleteContactRequest, "typeName", "mono.datagateway.v1.DeleteContactRequest");
_define_property(DeleteContactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteContactResponse
 */ export class DeleteContactResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteContactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteContactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteContactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteContactResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteContactResponse, "runtime", proto3);
_define_property(DeleteContactResponse, "typeName", "mono.datagateway.v1.DeleteContactResponse");
_define_property(DeleteContactResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * SetContactActive is the non-destructive lifecycle switch (SAD-433): it flips
 * is_active only. Employments, touchpoint links and staffing are untouched, and
 * the row stays fetchable by id.
 *
 * @generated from message mono.datagateway.v1.SetContactActiveRequest
 */ export class SetContactActiveRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetContactActiveRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetContactActiveRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetContactActiveRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetContactActiveRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool is_active = 3;
   */ _define_property(this, "isActive", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetContactActiveRequest, "runtime", proto3);
_define_property(SetContactActiveRequest, "typeName", "mono.datagateway.v1.SetContactActiveRequest");
_define_property(SetContactActiveRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "is_active",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetContactActiveResponse
 */ export class SetContactActiveResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetContactActiveResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetContactActiveResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetContactActiveResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetContactActiveResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Contact contact = 1;
   */ _define_property(this, "contact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetContactActiveResponse, "runtime", proto3);
_define_property(SetContactActiveResponse, "typeName", "mono.datagateway.v1.SetContactActiveResponse");
_define_property(SetContactActiveResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact",
            kind: "message",
            T: Contact
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCapabilityRequest
 */ export class GetCapabilityRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCapabilityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCapabilityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCapabilityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCapabilityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCapabilityRequest, "runtime", proto3);
_define_property(GetCapabilityRequest, "typeName", "mono.datagateway.v1.GetCapabilityRequest");
_define_property(GetCapabilityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCapabilityResponse
 */ export class GetCapabilityResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCapabilityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCapabilityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCapabilityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCapabilityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Capability capability = 1;
   */ _define_property(this, "capability", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCapabilityResponse, "runtime", proto3);
_define_property(GetCapabilityResponse, "typeName", "mono.datagateway.v1.GetCapabilityResponse");
_define_property(GetCapabilityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability",
            kind: "message",
            T: Capability
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateCapabilityRequest
 */ export class CreateCapabilityRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateCapabilityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCapabilityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCapabilityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCapabilityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Capability capability = 1;
   */ _define_property(this, "capability", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCapabilityRequest, "runtime", proto3);
_define_property(CreateCapabilityRequest, "typeName", "mono.datagateway.v1.CreateCapabilityRequest");
_define_property(CreateCapabilityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability",
            kind: "message",
            T: Capability
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateCapabilityResponse
 */ export class CreateCapabilityResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateCapabilityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCapabilityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCapabilityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCapabilityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Capability capability = 1;
   */ _define_property(this, "capability", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCapabilityResponse, "runtime", proto3);
_define_property(CreateCapabilityResponse, "typeName", "mono.datagateway.v1.CreateCapabilityResponse");
_define_property(CreateCapabilityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability",
            kind: "message",
            T: Capability
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateCapabilityRequest
 */ export class UpdateCapabilityRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCapabilityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCapabilityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCapabilityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCapabilityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Capability capability = 1;
   */ _define_property(this, "capability", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCapabilityRequest, "runtime", proto3);
_define_property(UpdateCapabilityRequest, "typeName", "mono.datagateway.v1.UpdateCapabilityRequest");
_define_property(UpdateCapabilityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability",
            kind: "message",
            T: Capability
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateCapabilityResponse
 */ export class UpdateCapabilityResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCapabilityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCapabilityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCapabilityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCapabilityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Capability capability = 1;
   */ _define_property(this, "capability", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCapabilityResponse, "runtime", proto3);
_define_property(UpdateCapabilityResponse, "typeName", "mono.datagateway.v1.UpdateCapabilityResponse");
_define_property(UpdateCapabilityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability",
            kind: "message",
            T: Capability
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCapabilitiesRequest
 */ export class ListCapabilitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCapabilitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCapabilitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCapabilitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCapabilitiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CapabilityFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false), /**
   * @generated from field: bool include_retired = 5;
   */ _define_property(this, "includeRetired", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCapabilitiesRequest, "runtime", proto3);
_define_property(ListCapabilitiesRequest, "typeName", "mono.datagateway.v1.ListCapabilitiesRequest");
_define_property(ListCapabilitiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: CapabilityFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "include_retired",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCapabilitiesResponse
 */ export class ListCapabilitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCapabilitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCapabilitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCapabilitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCapabilitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.Capability capabilities = 1;
   */ _define_property(this, "capabilities", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCapabilitiesResponse, "runtime", proto3);
_define_property(ListCapabilitiesResponse, "typeName", "mono.datagateway.v1.ListCapabilitiesResponse");
_define_property(ListCapabilitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capabilities",
            kind: "message",
            T: Capability,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCapabilityRequest
 */ export class DeleteCapabilityRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCapabilityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCapabilityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCapabilityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCapabilityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false), /**
   * The caller's tenant, used to scope the delete; optional for backward compatibility.
   *
   * @generated from field: string tenant_id = 3;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCapabilityRequest, "runtime", proto3);
_define_property(DeleteCapabilityRequest, "typeName", "mono.datagateway.v1.DeleteCapabilityRequest");
_define_property(DeleteCapabilityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCapabilityResponse
 */ export class DeleteCapabilityResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCapabilityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCapabilityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCapabilityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCapabilityResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCapabilityResponse, "runtime", proto3);
_define_property(DeleteCapabilityResponse, "typeName", "mono.datagateway.v1.DeleteCapabilityResponse");
_define_property(DeleteCapabilityResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * Retire hides a capability from new selections for tenant_id only; the row,
 * its _system origin and every program reference survive. id must be the
 * tenant's own row or a _system starter.
 *
 * @generated from message mono.datagateway.v1.RetireCapabilityRequest
 */ export class RetireCapabilityRequest extends Message {
    static fromBinary(bytes, options) {
        return new RetireCapabilityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RetireCapabilityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RetireCapabilityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RetireCapabilityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string actor = 3;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RetireCapabilityRequest, "runtime", proto3);
_define_property(RetireCapabilityRequest, "typeName", "mono.datagateway.v1.RetireCapabilityRequest");
_define_property(RetireCapabilityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RetireCapabilityResponse
 */ export class RetireCapabilityResponse extends Message {
    static fromBinary(bytes, options) {
        return new RetireCapabilityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RetireCapabilityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RetireCapabilityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RetireCapabilityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Capability capability = 1;
   */ _define_property(this, "capability", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RetireCapabilityResponse, "runtime", proto3);
_define_property(RetireCapabilityResponse, "typeName", "mono.datagateway.v1.RetireCapabilityResponse");
_define_property(RetireCapabilityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability",
            kind: "message",
            T: Capability
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReactivateCapabilityRequest
 */ export class ReactivateCapabilityRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReactivateCapabilityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReactivateCapabilityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReactivateCapabilityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReactivateCapabilityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReactivateCapabilityRequest, "runtime", proto3);
_define_property(ReactivateCapabilityRequest, "typeName", "mono.datagateway.v1.ReactivateCapabilityRequest");
_define_property(ReactivateCapabilityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReactivateCapabilityResponse
 */ export class ReactivateCapabilityResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReactivateCapabilityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReactivateCapabilityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReactivateCapabilityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReactivateCapabilityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Capability capability = 1;
   */ _define_property(this, "capability", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReactivateCapabilityResponse, "runtime", proto3);
_define_property(ReactivateCapabilityResponse, "typeName", "mono.datagateway.v1.ReactivateCapabilityResponse");
_define_property(ReactivateCapabilityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability",
            kind: "message",
            T: Capability
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetContractVehicleRequest
 */ export class GetContractVehicleRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetContractVehicleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetContractVehicleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetContractVehicleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetContractVehicleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetContractVehicleRequest, "runtime", proto3);
_define_property(GetContractVehicleRequest, "typeName", "mono.datagateway.v1.GetContractVehicleRequest");
_define_property(GetContractVehicleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetContractVehicleResponse
 */ export class GetContractVehicleResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetContractVehicleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetContractVehicleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetContractVehicleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetContractVehicleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractVehicle contract_vehicle = 1;
   */ _define_property(this, "contractVehicle", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetContractVehicleResponse, "runtime", proto3);
_define_property(GetContractVehicleResponse, "typeName", "mono.datagateway.v1.GetContractVehicleResponse");
_define_property(GetContractVehicleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_vehicle",
            kind: "message",
            T: ContractVehicle
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateContractVehicleRequest
 */ export class CreateContractVehicleRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateContractVehicleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateContractVehicleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateContractVehicleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateContractVehicleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractVehicle contract_vehicle = 1;
   */ _define_property(this, "contractVehicle", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateContractVehicleRequest, "runtime", proto3);
_define_property(CreateContractVehicleRequest, "typeName", "mono.datagateway.v1.CreateContractVehicleRequest");
_define_property(CreateContractVehicleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_vehicle",
            kind: "message",
            T: ContractVehicle
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateContractVehicleResponse
 */ export class CreateContractVehicleResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateContractVehicleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateContractVehicleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateContractVehicleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateContractVehicleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractVehicle contract_vehicle = 1;
   */ _define_property(this, "contractVehicle", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateContractVehicleResponse, "runtime", proto3);
_define_property(CreateContractVehicleResponse, "typeName", "mono.datagateway.v1.CreateContractVehicleResponse");
_define_property(CreateContractVehicleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_vehicle",
            kind: "message",
            T: ContractVehicle
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateContractVehicleRequest
 */ export class UpdateContractVehicleRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateContractVehicleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateContractVehicleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateContractVehicleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateContractVehicleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractVehicle contract_vehicle = 1;
   */ _define_property(this, "contractVehicle", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateContractVehicleRequest, "runtime", proto3);
_define_property(UpdateContractVehicleRequest, "typeName", "mono.datagateway.v1.UpdateContractVehicleRequest");
_define_property(UpdateContractVehicleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_vehicle",
            kind: "message",
            T: ContractVehicle
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateContractVehicleResponse
 */ export class UpdateContractVehicleResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateContractVehicleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateContractVehicleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateContractVehicleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateContractVehicleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractVehicle contract_vehicle = 1;
   */ _define_property(this, "contractVehicle", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateContractVehicleResponse, "runtime", proto3);
_define_property(UpdateContractVehicleResponse, "typeName", "mono.datagateway.v1.UpdateContractVehicleResponse");
_define_property(UpdateContractVehicleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_vehicle",
            kind: "message",
            T: ContractVehicle
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListContractVehiclesRequest
 */ export class ListContractVehiclesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListContractVehiclesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContractVehiclesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContractVehiclesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContractVehiclesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractVehicleFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContractVehiclesRequest, "runtime", proto3);
_define_property(ListContractVehiclesRequest, "typeName", "mono.datagateway.v1.ListContractVehiclesRequest");
_define_property(ListContractVehiclesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: ContractVehicleFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListContractVehiclesResponse
 */ export class ListContractVehiclesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListContractVehiclesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContractVehiclesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContractVehiclesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContractVehiclesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ContractVehicle contract_vehicles = 1;
   */ _define_property(this, "contractVehicles", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContractVehiclesResponse, "runtime", proto3);
_define_property(ListContractVehiclesResponse, "typeName", "mono.datagateway.v1.ListContractVehiclesResponse");
_define_property(ListContractVehiclesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_vehicles",
            kind: "message",
            T: ContractVehicle,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteContractVehicleRequest
 */ export class DeleteContractVehicleRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteContractVehicleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteContractVehicleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteContractVehicleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteContractVehicleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteContractVehicleRequest, "runtime", proto3);
_define_property(DeleteContractVehicleRequest, "typeName", "mono.datagateway.v1.DeleteContractVehicleRequest");
_define_property(DeleteContractVehicleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteContractVehicleResponse
 */ export class DeleteContractVehicleResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteContractVehicleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteContractVehicleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteContractVehicleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteContractVehicleResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteContractVehicleResponse, "runtime", proto3);
_define_property(DeleteContractVehicleResponse, "typeName", "mono.datagateway.v1.DeleteContractVehicleResponse");
_define_property(DeleteContractVehicleResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetProgramRequest
 */ export class GetProgramRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramRequest, "runtime", proto3);
_define_property(GetProgramRequest, "typeName", "mono.datagateway.v1.GetProgramRequest");
_define_property(GetProgramRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProgramResponse
 */ export class GetProgramResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Program program = 1;
   */ _define_property(this, "program", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramResponse, "runtime", proto3);
_define_property(GetProgramResponse, "typeName", "mono.datagateway.v1.GetProgramResponse");
_define_property(GetProgramResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program",
            kind: "message",
            T: Program
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateProgramRequest
 */ export class CreateProgramRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateProgramRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProgramRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProgramRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProgramRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Program program = 1;
   */ _define_property(this, "program", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProgramRequest, "runtime", proto3);
_define_property(CreateProgramRequest, "typeName", "mono.datagateway.v1.CreateProgramRequest");
_define_property(CreateProgramRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program",
            kind: "message",
            T: Program
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateProgramResponse
 */ export class CreateProgramResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateProgramResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProgramResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProgramResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProgramResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Program program = 1;
   */ _define_property(this, "program", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProgramResponse, "runtime", proto3);
_define_property(CreateProgramResponse, "typeName", "mono.datagateway.v1.CreateProgramResponse");
_define_property(CreateProgramResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program",
            kind: "message",
            T: Program
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateProgramRequest
 */ export class UpdateProgramRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProgramRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProgramRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProgramRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProgramRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Program program = 1;
   */ _define_property(this, "program", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProgramRequest, "runtime", proto3);
_define_property(UpdateProgramRequest, "typeName", "mono.datagateway.v1.UpdateProgramRequest");
_define_property(UpdateProgramRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program",
            kind: "message",
            T: Program
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateProgramResponse
 */ export class UpdateProgramResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProgramResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProgramResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProgramResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProgramResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Program program = 1;
   */ _define_property(this, "program", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProgramResponse, "runtime", proto3);
_define_property(UpdateProgramResponse, "typeName", "mono.datagateway.v1.UpdateProgramResponse");
_define_property(UpdateProgramResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program",
            kind: "message",
            T: Program
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramsRequest
 */ export class ListProgramsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramsRequest, "runtime", proto3);
_define_property(ListProgramsRequest, "typeName", "mono.datagateway.v1.ListProgramsRequest");
_define_property(ListProgramsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: ProgramFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramsResponse
 */ export class ListProgramsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.Program programs = 1;
   */ _define_property(this, "programs", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramsResponse, "runtime", proto3);
_define_property(ListProgramsResponse, "typeName", "mono.datagateway.v1.ListProgramsResponse");
_define_property(ListProgramsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "programs",
            kind: "message",
            T: Program,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteProgramRequest
 */ export class DeleteProgramRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramRequest, "runtime", proto3);
_define_property(DeleteProgramRequest, "typeName", "mono.datagateway.v1.DeleteProgramRequest");
_define_property(DeleteProgramRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteProgramResponse
 */ export class DeleteProgramResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramResponse, "runtime", proto3);
_define_property(DeleteProgramResponse, "typeName", "mono.datagateway.v1.DeleteProgramResponse");
_define_property(DeleteProgramResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.PurgeProgramRequest
 */ export class PurgeProgramRequest extends Message {
    static fromBinary(bytes, options) {
        return new PurgeProgramRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PurgeProgramRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PurgeProgramRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PurgeProgramRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: bool dry_run = 3;
   */ _define_property(this, "dryRun", false), /**
   * Recorded as revoked_by on the grants the purge revokes. Required.
   *
   * @generated from field: string purged_by = 4;
   */ _define_property(this, "purgedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PurgeProgramRequest, "runtime", proto3);
_define_property(PurgeProgramRequest, "typeName", "mono.datagateway.v1.PurgeProgramRequest");
_define_property(PurgeProgramRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "dry_run",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "purged_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * PurgeTableCount is one table the purge touched. rows_updated covers
 * SET NULL cascades, re-parented scope nodes and revoked grants.
 *
 * @generated from message mono.datagateway.v1.PurgeTableCount
 */ export class PurgeTableCount extends Message {
    static fromBinary(bytes, options) {
        return new PurgeTableCount().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PurgeTableCount().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PurgeTableCount().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PurgeTableCount, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string table = 1;
   */ _define_property(this, "table", ""), /**
   * @generated from field: int64 rows_deleted = 2;
   */ _define_property(this, "rowsDeleted", protoInt64.zero), /**
   * @generated from field: int64 rows_updated = 3;
   */ _define_property(this, "rowsUpdated", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PurgeTableCount, "runtime", proto3);
_define_property(PurgeTableCount, "typeName", "mono.datagateway.v1.PurgeTableCount");
_define_property(PurgeTableCount, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "table",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rows_deleted",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 3,
            name: "rows_updated",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.PurgeProgramResponse
 */ export class PurgeProgramResponse extends Message {
    static fromBinary(bytes, options) {
        return new PurgeProgramResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PurgeProgramResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PurgeProgramResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PurgeProgramResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string program_name = 2;
   */ _define_property(this, "programName", ""), /**
   * @generated from field: bool dry_run = 3;
   */ _define_property(this, "dryRun", false), /**
   * @generated from field: repeated mono.datagateway.v1.PurgeTableCount tables = 4;
   */ _define_property(this, "tables", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PurgeProgramResponse, "runtime", proto3);
_define_property(PurgeProgramResponse, "typeName", "mono.datagateway.v1.PurgeProgramResponse");
_define_property(PurgeProgramResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "dry_run",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "tables",
            kind: "message",
            T: PurgeTableCount,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProgramRoleRequest
 */ export class GetProgramRoleRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramRoleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramRoleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramRoleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramRoleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramRoleRequest, "runtime", proto3);
_define_property(GetProgramRoleRequest, "typeName", "mono.datagateway.v1.GetProgramRoleRequest");
_define_property(GetProgramRoleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProgramRoleResponse
 */ export class GetProgramRoleResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramRoleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramRoleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramRoleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramRoleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramRole program_role = 1;
   */ _define_property(this, "programRole", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramRoleResponse, "runtime", proto3);
_define_property(GetProgramRoleResponse, "typeName", "mono.datagateway.v1.GetProgramRoleResponse");
_define_property(GetProgramRoleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_role",
            kind: "message",
            T: ProgramRole
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateProgramRoleRequest
 */ export class CreateProgramRoleRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateProgramRoleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProgramRoleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProgramRoleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProgramRoleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramRole program_role = 1;
   */ _define_property(this, "programRole", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProgramRoleRequest, "runtime", proto3);
_define_property(CreateProgramRoleRequest, "typeName", "mono.datagateway.v1.CreateProgramRoleRequest");
_define_property(CreateProgramRoleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_role",
            kind: "message",
            T: ProgramRole
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateProgramRoleResponse
 */ export class CreateProgramRoleResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateProgramRoleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProgramRoleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProgramRoleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProgramRoleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramRole program_role = 1;
   */ _define_property(this, "programRole", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProgramRoleResponse, "runtime", proto3);
_define_property(CreateProgramRoleResponse, "typeName", "mono.datagateway.v1.CreateProgramRoleResponse");
_define_property(CreateProgramRoleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_role",
            kind: "message",
            T: ProgramRole
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateProgramRoleRequest
 */ export class UpdateProgramRoleRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProgramRoleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProgramRoleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProgramRoleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProgramRoleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramRole program_role = 1;
   */ _define_property(this, "programRole", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProgramRoleRequest, "runtime", proto3);
_define_property(UpdateProgramRoleRequest, "typeName", "mono.datagateway.v1.UpdateProgramRoleRequest");
_define_property(UpdateProgramRoleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_role",
            kind: "message",
            T: ProgramRole
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateProgramRoleResponse
 */ export class UpdateProgramRoleResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProgramRoleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProgramRoleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProgramRoleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProgramRoleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramRole program_role = 1;
   */ _define_property(this, "programRole", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProgramRoleResponse, "runtime", proto3);
_define_property(UpdateProgramRoleResponse, "typeName", "mono.datagateway.v1.UpdateProgramRoleResponse");
_define_property(UpdateProgramRoleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_role",
            kind: "message",
            T: ProgramRole
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramRolesRequest
 */ export class ListProgramRolesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramRolesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramRolesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramRolesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramRolesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramRoleFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramRolesRequest, "runtime", proto3);
_define_property(ListProgramRolesRequest, "typeName", "mono.datagateway.v1.ListProgramRolesRequest");
_define_property(ListProgramRolesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: ProgramRoleFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramRolesResponse
 */ export class ListProgramRolesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramRolesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramRolesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramRolesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramRolesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ProgramRole program_roles = 1;
   */ _define_property(this, "programRoles", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramRolesResponse, "runtime", proto3);
_define_property(ListProgramRolesResponse, "typeName", "mono.datagateway.v1.ListProgramRolesResponse");
_define_property(ListProgramRolesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_roles",
            kind: "message",
            T: ProgramRole,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteProgramRoleRequest
 */ export class DeleteProgramRoleRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramRoleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramRoleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramRoleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramRoleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramRoleRequest, "runtime", proto3);
_define_property(DeleteProgramRoleRequest, "typeName", "mono.datagateway.v1.DeleteProgramRoleRequest");
_define_property(DeleteProgramRoleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteProgramRoleResponse
 */ export class DeleteProgramRoleResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramRoleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramRoleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramRoleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramRoleResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramRoleResponse, "runtime", proto3);
_define_property(DeleteProgramRoleResponse, "typeName", "mono.datagateway.v1.DeleteProgramRoleResponse");
_define_property(DeleteProgramRoleResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetProgramCapabilityRequest
 */ export class GetProgramCapabilityRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramCapabilityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramCapabilityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramCapabilityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramCapabilityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramCapabilityRequest, "runtime", proto3);
_define_property(GetProgramCapabilityRequest, "typeName", "mono.datagateway.v1.GetProgramCapabilityRequest");
_define_property(GetProgramCapabilityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProgramCapabilityResponse
 */ export class GetProgramCapabilityResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramCapabilityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramCapabilityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramCapabilityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramCapabilityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramCapability program_capability = 1;
   */ _define_property(this, "programCapability", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramCapabilityResponse, "runtime", proto3);
_define_property(GetProgramCapabilityResponse, "typeName", "mono.datagateway.v1.GetProgramCapabilityResponse");
_define_property(GetProgramCapabilityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_capability",
            kind: "message",
            T: ProgramCapability
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateProgramCapabilityRequest
 */ export class CreateProgramCapabilityRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateProgramCapabilityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProgramCapabilityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProgramCapabilityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProgramCapabilityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramCapability program_capability = 1;
   */ _define_property(this, "programCapability", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProgramCapabilityRequest, "runtime", proto3);
_define_property(CreateProgramCapabilityRequest, "typeName", "mono.datagateway.v1.CreateProgramCapabilityRequest");
_define_property(CreateProgramCapabilityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_capability",
            kind: "message",
            T: ProgramCapability
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateProgramCapabilityResponse
 */ export class CreateProgramCapabilityResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateProgramCapabilityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProgramCapabilityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProgramCapabilityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProgramCapabilityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramCapability program_capability = 1;
   */ _define_property(this, "programCapability", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProgramCapabilityResponse, "runtime", proto3);
_define_property(CreateProgramCapabilityResponse, "typeName", "mono.datagateway.v1.CreateProgramCapabilityResponse");
_define_property(CreateProgramCapabilityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_capability",
            kind: "message",
            T: ProgramCapability
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateProgramCapabilityRequest
 */ export class UpdateProgramCapabilityRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProgramCapabilityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProgramCapabilityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProgramCapabilityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProgramCapabilityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramCapability program_capability = 1;
   */ _define_property(this, "programCapability", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProgramCapabilityRequest, "runtime", proto3);
_define_property(UpdateProgramCapabilityRequest, "typeName", "mono.datagateway.v1.UpdateProgramCapabilityRequest");
_define_property(UpdateProgramCapabilityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_capability",
            kind: "message",
            T: ProgramCapability
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateProgramCapabilityResponse
 */ export class UpdateProgramCapabilityResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProgramCapabilityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProgramCapabilityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProgramCapabilityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProgramCapabilityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramCapability program_capability = 1;
   */ _define_property(this, "programCapability", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProgramCapabilityResponse, "runtime", proto3);
_define_property(UpdateProgramCapabilityResponse, "typeName", "mono.datagateway.v1.UpdateProgramCapabilityResponse");
_define_property(UpdateProgramCapabilityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_capability",
            kind: "message",
            T: ProgramCapability
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramCapabilitiesRequest
 */ export class ListProgramCapabilitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramCapabilitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramCapabilitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramCapabilitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramCapabilitiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramCapabilityFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramCapabilitiesRequest, "runtime", proto3);
_define_property(ListProgramCapabilitiesRequest, "typeName", "mono.datagateway.v1.ListProgramCapabilitiesRequest");
_define_property(ListProgramCapabilitiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: ProgramCapabilityFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramCapabilitiesResponse
 */ export class ListProgramCapabilitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramCapabilitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramCapabilitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramCapabilitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramCapabilitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ProgramCapability program_capabilities = 1;
   */ _define_property(this, "programCapabilities", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramCapabilitiesResponse, "runtime", proto3);
_define_property(ListProgramCapabilitiesResponse, "typeName", "mono.datagateway.v1.ListProgramCapabilitiesResponse");
_define_property(ListProgramCapabilitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_capabilities",
            kind: "message",
            T: ProgramCapability,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteProgramCapabilityRequest
 */ export class DeleteProgramCapabilityRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramCapabilityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramCapabilityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramCapabilityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramCapabilityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramCapabilityRequest, "runtime", proto3);
_define_property(DeleteProgramCapabilityRequest, "typeName", "mono.datagateway.v1.DeleteProgramCapabilityRequest");
_define_property(DeleteProgramCapabilityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteProgramCapabilityResponse
 */ export class DeleteProgramCapabilityResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramCapabilityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramCapabilityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramCapabilityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramCapabilityResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramCapabilityResponse, "runtime", proto3);
_define_property(DeleteProgramCapabilityResponse, "typeName", "mono.datagateway.v1.DeleteProgramCapabilityResponse");
_define_property(DeleteProgramCapabilityResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetProgramCompanyAssignmentRequest
 */ export class GetProgramCompanyAssignmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramCompanyAssignmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramCompanyAssignmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramCompanyAssignmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramCompanyAssignmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramCompanyAssignmentRequest, "runtime", proto3);
_define_property(GetProgramCompanyAssignmentRequest, "typeName", "mono.datagateway.v1.GetProgramCompanyAssignmentRequest");
_define_property(GetProgramCompanyAssignmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProgramCompanyAssignmentResponse
 */ export class GetProgramCompanyAssignmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramCompanyAssignmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramCompanyAssignmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramCompanyAssignmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramCompanyAssignmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramCompanyAssignment program_company_assignment = 1;
   */ _define_property(this, "programCompanyAssignment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramCompanyAssignmentResponse, "runtime", proto3);
_define_property(GetProgramCompanyAssignmentResponse, "typeName", "mono.datagateway.v1.GetProgramCompanyAssignmentResponse");
_define_property(GetProgramCompanyAssignmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_company_assignment",
            kind: "message",
            T: ProgramCompanyAssignment
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateProgramCompanyAssignmentRequest
 */ export class CreateProgramCompanyAssignmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateProgramCompanyAssignmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProgramCompanyAssignmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProgramCompanyAssignmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProgramCompanyAssignmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramCompanyAssignment program_company_assignment = 1;
   */ _define_property(this, "programCompanyAssignment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProgramCompanyAssignmentRequest, "runtime", proto3);
_define_property(CreateProgramCompanyAssignmentRequest, "typeName", "mono.datagateway.v1.CreateProgramCompanyAssignmentRequest");
_define_property(CreateProgramCompanyAssignmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_company_assignment",
            kind: "message",
            T: ProgramCompanyAssignment
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateProgramCompanyAssignmentResponse
 */ export class CreateProgramCompanyAssignmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateProgramCompanyAssignmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProgramCompanyAssignmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProgramCompanyAssignmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProgramCompanyAssignmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramCompanyAssignment program_company_assignment = 1;
   */ _define_property(this, "programCompanyAssignment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProgramCompanyAssignmentResponse, "runtime", proto3);
_define_property(CreateProgramCompanyAssignmentResponse, "typeName", "mono.datagateway.v1.CreateProgramCompanyAssignmentResponse");
_define_property(CreateProgramCompanyAssignmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_company_assignment",
            kind: "message",
            T: ProgramCompanyAssignment
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateProgramCompanyAssignmentRequest
 */ export class UpdateProgramCompanyAssignmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProgramCompanyAssignmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProgramCompanyAssignmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProgramCompanyAssignmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProgramCompanyAssignmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramCompanyAssignment program_company_assignment = 1;
   */ _define_property(this, "programCompanyAssignment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProgramCompanyAssignmentRequest, "runtime", proto3);
_define_property(UpdateProgramCompanyAssignmentRequest, "typeName", "mono.datagateway.v1.UpdateProgramCompanyAssignmentRequest");
_define_property(UpdateProgramCompanyAssignmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_company_assignment",
            kind: "message",
            T: ProgramCompanyAssignment
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateProgramCompanyAssignmentResponse
 */ export class UpdateProgramCompanyAssignmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProgramCompanyAssignmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProgramCompanyAssignmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProgramCompanyAssignmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProgramCompanyAssignmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramCompanyAssignment program_company_assignment = 1;
   */ _define_property(this, "programCompanyAssignment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProgramCompanyAssignmentResponse, "runtime", proto3);
_define_property(UpdateProgramCompanyAssignmentResponse, "typeName", "mono.datagateway.v1.UpdateProgramCompanyAssignmentResponse");
_define_property(UpdateProgramCompanyAssignmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_company_assignment",
            kind: "message",
            T: ProgramCompanyAssignment
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramCompanyAssignmentsRequest
 */ export class ListProgramCompanyAssignmentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramCompanyAssignmentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramCompanyAssignmentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramCompanyAssignmentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramCompanyAssignmentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramCompanyAssignmentFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramCompanyAssignmentsRequest, "runtime", proto3);
_define_property(ListProgramCompanyAssignmentsRequest, "typeName", "mono.datagateway.v1.ListProgramCompanyAssignmentsRequest");
_define_property(ListProgramCompanyAssignmentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: ProgramCompanyAssignmentFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramCompanyAssignmentsResponse
 */ export class ListProgramCompanyAssignmentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramCompanyAssignmentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramCompanyAssignmentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramCompanyAssignmentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramCompanyAssignmentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ProgramCompanyAssignment program_company_assignments = 1;
   */ _define_property(this, "programCompanyAssignments", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramCompanyAssignmentsResponse, "runtime", proto3);
_define_property(ListProgramCompanyAssignmentsResponse, "typeName", "mono.datagateway.v1.ListProgramCompanyAssignmentsResponse");
_define_property(ListProgramCompanyAssignmentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_company_assignments",
            kind: "message",
            T: ProgramCompanyAssignment,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteProgramCompanyAssignmentRequest
 */ export class DeleteProgramCompanyAssignmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramCompanyAssignmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramCompanyAssignmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramCompanyAssignmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramCompanyAssignmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramCompanyAssignmentRequest, "runtime", proto3);
_define_property(DeleteProgramCompanyAssignmentRequest, "typeName", "mono.datagateway.v1.DeleteProgramCompanyAssignmentRequest");
_define_property(DeleteProgramCompanyAssignmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteProgramCompanyAssignmentResponse
 */ export class DeleteProgramCompanyAssignmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramCompanyAssignmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramCompanyAssignmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramCompanyAssignmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramCompanyAssignmentResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramCompanyAssignmentResponse, "runtime", proto3);
_define_property(DeleteProgramCompanyAssignmentResponse, "typeName", "mono.datagateway.v1.DeleteProgramCompanyAssignmentResponse");
_define_property(DeleteProgramCompanyAssignmentResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetProgramCompanyStaffingLineRequest
 */ export class GetProgramCompanyStaffingLineRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramCompanyStaffingLineRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramCompanyStaffingLineRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramCompanyStaffingLineRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramCompanyStaffingLineRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramCompanyStaffingLineRequest, "runtime", proto3);
_define_property(GetProgramCompanyStaffingLineRequest, "typeName", "mono.datagateway.v1.GetProgramCompanyStaffingLineRequest");
_define_property(GetProgramCompanyStaffingLineRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProgramCompanyStaffingLineResponse
 */ export class GetProgramCompanyStaffingLineResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramCompanyStaffingLineResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramCompanyStaffingLineResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramCompanyStaffingLineResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramCompanyStaffingLineResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramCompanyStaffingLine program_company_staffing_line = 1;
   */ _define_property(this, "programCompanyStaffingLine", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramCompanyStaffingLineResponse, "runtime", proto3);
_define_property(GetProgramCompanyStaffingLineResponse, "typeName", "mono.datagateway.v1.GetProgramCompanyStaffingLineResponse");
_define_property(GetProgramCompanyStaffingLineResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_company_staffing_line",
            kind: "message",
            T: ProgramCompanyStaffingLine
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateProgramCompanyStaffingLineRequest
 */ export class CreateProgramCompanyStaffingLineRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateProgramCompanyStaffingLineRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProgramCompanyStaffingLineRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProgramCompanyStaffingLineRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProgramCompanyStaffingLineRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramCompanyStaffingLine program_company_staffing_line = 1;
   */ _define_property(this, "programCompanyStaffingLine", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProgramCompanyStaffingLineRequest, "runtime", proto3);
_define_property(CreateProgramCompanyStaffingLineRequest, "typeName", "mono.datagateway.v1.CreateProgramCompanyStaffingLineRequest");
_define_property(CreateProgramCompanyStaffingLineRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_company_staffing_line",
            kind: "message",
            T: ProgramCompanyStaffingLine
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateProgramCompanyStaffingLineResponse
 */ export class CreateProgramCompanyStaffingLineResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateProgramCompanyStaffingLineResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProgramCompanyStaffingLineResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProgramCompanyStaffingLineResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProgramCompanyStaffingLineResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramCompanyStaffingLine program_company_staffing_line = 1;
   */ _define_property(this, "programCompanyStaffingLine", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProgramCompanyStaffingLineResponse, "runtime", proto3);
_define_property(CreateProgramCompanyStaffingLineResponse, "typeName", "mono.datagateway.v1.CreateProgramCompanyStaffingLineResponse");
_define_property(CreateProgramCompanyStaffingLineResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_company_staffing_line",
            kind: "message",
            T: ProgramCompanyStaffingLine
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateProgramCompanyStaffingLineRequest
 */ export class UpdateProgramCompanyStaffingLineRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProgramCompanyStaffingLineRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProgramCompanyStaffingLineRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProgramCompanyStaffingLineRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProgramCompanyStaffingLineRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramCompanyStaffingLine program_company_staffing_line = 1;
   */ _define_property(this, "programCompanyStaffingLine", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProgramCompanyStaffingLineRequest, "runtime", proto3);
_define_property(UpdateProgramCompanyStaffingLineRequest, "typeName", "mono.datagateway.v1.UpdateProgramCompanyStaffingLineRequest");
_define_property(UpdateProgramCompanyStaffingLineRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_company_staffing_line",
            kind: "message",
            T: ProgramCompanyStaffingLine
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateProgramCompanyStaffingLineResponse
 */ export class UpdateProgramCompanyStaffingLineResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProgramCompanyStaffingLineResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProgramCompanyStaffingLineResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProgramCompanyStaffingLineResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProgramCompanyStaffingLineResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramCompanyStaffingLine program_company_staffing_line = 1;
   */ _define_property(this, "programCompanyStaffingLine", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProgramCompanyStaffingLineResponse, "runtime", proto3);
_define_property(UpdateProgramCompanyStaffingLineResponse, "typeName", "mono.datagateway.v1.UpdateProgramCompanyStaffingLineResponse");
_define_property(UpdateProgramCompanyStaffingLineResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_company_staffing_line",
            kind: "message",
            T: ProgramCompanyStaffingLine
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramCompanyStaffingLinesRequest
 */ export class ListProgramCompanyStaffingLinesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramCompanyStaffingLinesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramCompanyStaffingLinesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramCompanyStaffingLinesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramCompanyStaffingLinesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramCompanyStaffingLineFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramCompanyStaffingLinesRequest, "runtime", proto3);
_define_property(ListProgramCompanyStaffingLinesRequest, "typeName", "mono.datagateway.v1.ListProgramCompanyStaffingLinesRequest");
_define_property(ListProgramCompanyStaffingLinesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: ProgramCompanyStaffingLineFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramCompanyStaffingLinesResponse
 */ export class ListProgramCompanyStaffingLinesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramCompanyStaffingLinesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramCompanyStaffingLinesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramCompanyStaffingLinesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramCompanyStaffingLinesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ProgramCompanyStaffingLine program_company_staffing_lines = 1;
   */ _define_property(this, "programCompanyStaffingLines", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramCompanyStaffingLinesResponse, "runtime", proto3);
_define_property(ListProgramCompanyStaffingLinesResponse, "typeName", "mono.datagateway.v1.ListProgramCompanyStaffingLinesResponse");
_define_property(ListProgramCompanyStaffingLinesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_company_staffing_lines",
            kind: "message",
            T: ProgramCompanyStaffingLine,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteProgramCompanyStaffingLineRequest
 */ export class DeleteProgramCompanyStaffingLineRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramCompanyStaffingLineRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramCompanyStaffingLineRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramCompanyStaffingLineRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramCompanyStaffingLineRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramCompanyStaffingLineRequest, "runtime", proto3);
_define_property(DeleteProgramCompanyStaffingLineRequest, "typeName", "mono.datagateway.v1.DeleteProgramCompanyStaffingLineRequest");
_define_property(DeleteProgramCompanyStaffingLineRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteProgramCompanyStaffingLineResponse
 */ export class DeleteProgramCompanyStaffingLineResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramCompanyStaffingLineResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramCompanyStaffingLineResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramCompanyStaffingLineResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramCompanyStaffingLineResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramCompanyStaffingLineResponse, "runtime", proto3);
_define_property(DeleteProgramCompanyStaffingLineResponse, "typeName", "mono.datagateway.v1.DeleteProgramCompanyStaffingLineResponse");
_define_property(DeleteProgramCompanyStaffingLineResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetProgramContactRequest
 */ export class GetProgramContactRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramContactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramContactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramContactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramContactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramContactRequest, "runtime", proto3);
_define_property(GetProgramContactRequest, "typeName", "mono.datagateway.v1.GetProgramContactRequest");
_define_property(GetProgramContactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProgramContactResponse
 */ export class GetProgramContactResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramContactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramContactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramContactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramContactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramContact program_contact = 1;
   */ _define_property(this, "programContact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramContactResponse, "runtime", proto3);
_define_property(GetProgramContactResponse, "typeName", "mono.datagateway.v1.GetProgramContactResponse");
_define_property(GetProgramContactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_contact",
            kind: "message",
            T: ProgramContact
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateProgramContactRequest
 */ export class CreateProgramContactRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateProgramContactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProgramContactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProgramContactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProgramContactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramContact program_contact = 1;
   */ _define_property(this, "programContact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProgramContactRequest, "runtime", proto3);
_define_property(CreateProgramContactRequest, "typeName", "mono.datagateway.v1.CreateProgramContactRequest");
_define_property(CreateProgramContactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_contact",
            kind: "message",
            T: ProgramContact
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateProgramContactResponse
 */ export class CreateProgramContactResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateProgramContactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProgramContactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProgramContactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProgramContactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramContact program_contact = 1;
   */ _define_property(this, "programContact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProgramContactResponse, "runtime", proto3);
_define_property(CreateProgramContactResponse, "typeName", "mono.datagateway.v1.CreateProgramContactResponse");
_define_property(CreateProgramContactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_contact",
            kind: "message",
            T: ProgramContact
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateProgramContactRequest
 */ export class UpdateProgramContactRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProgramContactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProgramContactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProgramContactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProgramContactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramContact program_contact = 1;
   */ _define_property(this, "programContact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProgramContactRequest, "runtime", proto3);
_define_property(UpdateProgramContactRequest, "typeName", "mono.datagateway.v1.UpdateProgramContactRequest");
_define_property(UpdateProgramContactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_contact",
            kind: "message",
            T: ProgramContact
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateProgramContactResponse
 */ export class UpdateProgramContactResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProgramContactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProgramContactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProgramContactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProgramContactResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramContact program_contact = 1;
   */ _define_property(this, "programContact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProgramContactResponse, "runtime", proto3);
_define_property(UpdateProgramContactResponse, "typeName", "mono.datagateway.v1.UpdateProgramContactResponse");
_define_property(UpdateProgramContactResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_contact",
            kind: "message",
            T: ProgramContact
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramContactsRequest
 */ export class ListProgramContactsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramContactsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramContactsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramContactsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramContactsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramContactFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramContactsRequest, "runtime", proto3);
_define_property(ListProgramContactsRequest, "typeName", "mono.datagateway.v1.ListProgramContactsRequest");
_define_property(ListProgramContactsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: ProgramContactFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramContactsResponse
 */ export class ListProgramContactsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramContactsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramContactsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramContactsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramContactsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ProgramContact program_contacts = 1;
   */ _define_property(this, "programContacts", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramContactsResponse, "runtime", proto3);
_define_property(ListProgramContactsResponse, "typeName", "mono.datagateway.v1.ListProgramContactsResponse");
_define_property(ListProgramContactsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_contacts",
            kind: "message",
            T: ProgramContact,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteProgramContactRequest
 */ export class DeleteProgramContactRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramContactRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramContactRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramContactRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramContactRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramContactRequest, "runtime", proto3);
_define_property(DeleteProgramContactRequest, "typeName", "mono.datagateway.v1.DeleteProgramContactRequest");
_define_property(DeleteProgramContactRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteProgramContactResponse
 */ export class DeleteProgramContactResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramContactResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramContactResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramContactResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramContactResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramContactResponse, "runtime", proto3);
_define_property(DeleteProgramContactResponse, "typeName", "mono.datagateway.v1.DeleteProgramContactResponse");
_define_property(DeleteProgramContactResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetPeriodOfPerformanceRequest
 */ export class GetPeriodOfPerformanceRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPeriodOfPerformanceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPeriodOfPerformanceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPeriodOfPerformanceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPeriodOfPerformanceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPeriodOfPerformanceRequest, "runtime", proto3);
_define_property(GetPeriodOfPerformanceRequest, "typeName", "mono.datagateway.v1.GetPeriodOfPerformanceRequest");
_define_property(GetPeriodOfPerformanceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetPeriodOfPerformanceResponse
 */ export class GetPeriodOfPerformanceResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPeriodOfPerformanceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPeriodOfPerformanceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPeriodOfPerformanceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPeriodOfPerformanceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PeriodOfPerformance period_of_performance = 1;
   */ _define_property(this, "periodOfPerformance", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPeriodOfPerformanceResponse, "runtime", proto3);
_define_property(GetPeriodOfPerformanceResponse, "typeName", "mono.datagateway.v1.GetPeriodOfPerformanceResponse");
_define_property(GetPeriodOfPerformanceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "period_of_performance",
            kind: "message",
            T: PeriodOfPerformance
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreatePeriodOfPerformanceRequest
 */ export class CreatePeriodOfPerformanceRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreatePeriodOfPerformanceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreatePeriodOfPerformanceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreatePeriodOfPerformanceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreatePeriodOfPerformanceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PeriodOfPerformance period_of_performance = 1;
   */ _define_property(this, "periodOfPerformance", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreatePeriodOfPerformanceRequest, "runtime", proto3);
_define_property(CreatePeriodOfPerformanceRequest, "typeName", "mono.datagateway.v1.CreatePeriodOfPerformanceRequest");
_define_property(CreatePeriodOfPerformanceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "period_of_performance",
            kind: "message",
            T: PeriodOfPerformance
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreatePeriodOfPerformanceResponse
 */ export class CreatePeriodOfPerformanceResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreatePeriodOfPerformanceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreatePeriodOfPerformanceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreatePeriodOfPerformanceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreatePeriodOfPerformanceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PeriodOfPerformance period_of_performance = 1;
   */ _define_property(this, "periodOfPerformance", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreatePeriodOfPerformanceResponse, "runtime", proto3);
_define_property(CreatePeriodOfPerformanceResponse, "typeName", "mono.datagateway.v1.CreatePeriodOfPerformanceResponse");
_define_property(CreatePeriodOfPerformanceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "period_of_performance",
            kind: "message",
            T: PeriodOfPerformance
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdatePeriodOfPerformanceRequest
 */ export class UpdatePeriodOfPerformanceRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdatePeriodOfPerformanceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdatePeriodOfPerformanceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdatePeriodOfPerformanceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdatePeriodOfPerformanceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PeriodOfPerformance period_of_performance = 1;
   */ _define_property(this, "periodOfPerformance", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdatePeriodOfPerformanceRequest, "runtime", proto3);
_define_property(UpdatePeriodOfPerformanceRequest, "typeName", "mono.datagateway.v1.UpdatePeriodOfPerformanceRequest");
_define_property(UpdatePeriodOfPerformanceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "period_of_performance",
            kind: "message",
            T: PeriodOfPerformance
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdatePeriodOfPerformanceResponse
 */ export class UpdatePeriodOfPerformanceResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdatePeriodOfPerformanceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdatePeriodOfPerformanceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdatePeriodOfPerformanceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdatePeriodOfPerformanceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PeriodOfPerformance period_of_performance = 1;
   */ _define_property(this, "periodOfPerformance", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdatePeriodOfPerformanceResponse, "runtime", proto3);
_define_property(UpdatePeriodOfPerformanceResponse, "typeName", "mono.datagateway.v1.UpdatePeriodOfPerformanceResponse");
_define_property(UpdatePeriodOfPerformanceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "period_of_performance",
            kind: "message",
            T: PeriodOfPerformance
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPeriodsOfPerformanceRequest
 */ export class ListPeriodsOfPerformanceRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPeriodsOfPerformanceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPeriodsOfPerformanceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPeriodsOfPerformanceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPeriodsOfPerformanceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PeriodOfPerformanceFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPeriodsOfPerformanceRequest, "runtime", proto3);
_define_property(ListPeriodsOfPerformanceRequest, "typeName", "mono.datagateway.v1.ListPeriodsOfPerformanceRequest");
_define_property(ListPeriodsOfPerformanceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: PeriodOfPerformanceFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPeriodsOfPerformanceResponse
 */ export class ListPeriodsOfPerformanceResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPeriodsOfPerformanceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPeriodsOfPerformanceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPeriodsOfPerformanceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPeriodsOfPerformanceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.PeriodOfPerformance periods_of_performance = 1;
   */ _define_property(this, "periodsOfPerformance", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPeriodsOfPerformanceResponse, "runtime", proto3);
_define_property(ListPeriodsOfPerformanceResponse, "typeName", "mono.datagateway.v1.ListPeriodsOfPerformanceResponse");
_define_property(ListPeriodsOfPerformanceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "periods_of_performance",
            kind: "message",
            T: PeriodOfPerformance,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeletePeriodOfPerformanceRequest
 */ export class DeletePeriodOfPerformanceRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeletePeriodOfPerformanceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeletePeriodOfPerformanceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeletePeriodOfPerformanceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeletePeriodOfPerformanceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeletePeriodOfPerformanceRequest, "runtime", proto3);
_define_property(DeletePeriodOfPerformanceRequest, "typeName", "mono.datagateway.v1.DeletePeriodOfPerformanceRequest");
_define_property(DeletePeriodOfPerformanceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeletePeriodOfPerformanceResponse
 */ export class DeletePeriodOfPerformanceResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeletePeriodOfPerformanceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeletePeriodOfPerformanceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeletePeriodOfPerformanceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeletePeriodOfPerformanceResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeletePeriodOfPerformanceResponse, "runtime", proto3);
_define_property(DeletePeriodOfPerformanceResponse, "typeName", "mono.datagateway.v1.DeletePeriodOfPerformanceResponse");
_define_property(DeletePeriodOfPerformanceResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetOptionalTaskRequest
 */ export class GetOptionalTaskRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetOptionalTaskRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOptionalTaskRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOptionalTaskRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOptionalTaskRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOptionalTaskRequest, "runtime", proto3);
_define_property(GetOptionalTaskRequest, "typeName", "mono.datagateway.v1.GetOptionalTaskRequest");
_define_property(GetOptionalTaskRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetOptionalTaskResponse
 */ export class GetOptionalTaskResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetOptionalTaskResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOptionalTaskResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOptionalTaskResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOptionalTaskResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OptionalTask optional_task = 1;
   */ _define_property(this, "optionalTask", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOptionalTaskResponse, "runtime", proto3);
_define_property(GetOptionalTaskResponse, "typeName", "mono.datagateway.v1.GetOptionalTaskResponse");
_define_property(GetOptionalTaskResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "optional_task",
            kind: "message",
            T: OptionalTask
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateOptionalTaskRequest
 */ export class CreateOptionalTaskRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateOptionalTaskRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateOptionalTaskRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateOptionalTaskRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateOptionalTaskRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OptionalTask optional_task = 1;
   */ _define_property(this, "optionalTask", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateOptionalTaskRequest, "runtime", proto3);
_define_property(CreateOptionalTaskRequest, "typeName", "mono.datagateway.v1.CreateOptionalTaskRequest");
_define_property(CreateOptionalTaskRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "optional_task",
            kind: "message",
            T: OptionalTask
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateOptionalTaskResponse
 */ export class CreateOptionalTaskResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateOptionalTaskResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateOptionalTaskResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateOptionalTaskResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateOptionalTaskResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OptionalTask optional_task = 1;
   */ _define_property(this, "optionalTask", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateOptionalTaskResponse, "runtime", proto3);
_define_property(CreateOptionalTaskResponse, "typeName", "mono.datagateway.v1.CreateOptionalTaskResponse");
_define_property(CreateOptionalTaskResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "optional_task",
            kind: "message",
            T: OptionalTask
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateOptionalTaskRequest
 */ export class UpdateOptionalTaskRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateOptionalTaskRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateOptionalTaskRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateOptionalTaskRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateOptionalTaskRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OptionalTask optional_task = 1;
   */ _define_property(this, "optionalTask", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateOptionalTaskRequest, "runtime", proto3);
_define_property(UpdateOptionalTaskRequest, "typeName", "mono.datagateway.v1.UpdateOptionalTaskRequest");
_define_property(UpdateOptionalTaskRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "optional_task",
            kind: "message",
            T: OptionalTask
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateOptionalTaskResponse
 */ export class UpdateOptionalTaskResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateOptionalTaskResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateOptionalTaskResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateOptionalTaskResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateOptionalTaskResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OptionalTask optional_task = 1;
   */ _define_property(this, "optionalTask", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateOptionalTaskResponse, "runtime", proto3);
_define_property(UpdateOptionalTaskResponse, "typeName", "mono.datagateway.v1.UpdateOptionalTaskResponse");
_define_property(UpdateOptionalTaskResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "optional_task",
            kind: "message",
            T: OptionalTask
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListOptionalTasksRequest
 */ export class ListOptionalTasksRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListOptionalTasksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOptionalTasksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOptionalTasksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOptionalTasksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OptionalTaskFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOptionalTasksRequest, "runtime", proto3);
_define_property(ListOptionalTasksRequest, "typeName", "mono.datagateway.v1.ListOptionalTasksRequest");
_define_property(ListOptionalTasksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: OptionalTaskFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListOptionalTasksResponse
 */ export class ListOptionalTasksResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListOptionalTasksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOptionalTasksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOptionalTasksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOptionalTasksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.OptionalTask optional_tasks = 1;
   */ _define_property(this, "optionalTasks", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOptionalTasksResponse, "runtime", proto3);
_define_property(ListOptionalTasksResponse, "typeName", "mono.datagateway.v1.ListOptionalTasksResponse");
_define_property(ListOptionalTasksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "optional_tasks",
            kind: "message",
            T: OptionalTask,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteOptionalTaskRequest
 */ export class DeleteOptionalTaskRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteOptionalTaskRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteOptionalTaskRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteOptionalTaskRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteOptionalTaskRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteOptionalTaskRequest, "runtime", proto3);
_define_property(DeleteOptionalTaskRequest, "typeName", "mono.datagateway.v1.DeleteOptionalTaskRequest");
_define_property(DeleteOptionalTaskRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteOptionalTaskResponse
 */ export class DeleteOptionalTaskResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteOptionalTaskResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteOptionalTaskResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteOptionalTaskResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteOptionalTaskResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteOptionalTaskResponse, "runtime", proto3);
_define_property(DeleteOptionalTaskResponse, "typeName", "mono.datagateway.v1.DeleteOptionalTaskResponse");
_define_property(DeleteOptionalTaskResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * Create maintains the parent's derived `exercised` flag; the response carries
 * the updated parent so callers don't need a follow-up read.
 *
 * @generated from message mono.datagateway.v1.CreateOptionalTaskExerciseRequest
 */ export class CreateOptionalTaskExerciseRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateOptionalTaskExerciseRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateOptionalTaskExerciseRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateOptionalTaskExerciseRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateOptionalTaskExerciseRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OptionalTaskExercise exercise = 1;
   */ _define_property(this, "exercise", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateOptionalTaskExerciseRequest, "runtime", proto3);
_define_property(CreateOptionalTaskExerciseRequest, "typeName", "mono.datagateway.v1.CreateOptionalTaskExerciseRequest");
_define_property(CreateOptionalTaskExerciseRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "exercise",
            kind: "message",
            T: OptionalTaskExercise
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateOptionalTaskExerciseResponse
 */ export class CreateOptionalTaskExerciseResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateOptionalTaskExerciseResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateOptionalTaskExerciseResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateOptionalTaskExerciseResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateOptionalTaskExerciseResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OptionalTaskExercise exercise = 1;
   */ _define_property(this, "exercise", void 0), /**
   * @generated from field: mono.datagateway.v1.OptionalTask optional_task = 2;
   */ _define_property(this, "optionalTask", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateOptionalTaskExerciseResponse, "runtime", proto3);
_define_property(CreateOptionalTaskExerciseResponse, "typeName", "mono.datagateway.v1.CreateOptionalTaskExerciseResponse");
_define_property(CreateOptionalTaskExerciseResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "exercise",
            kind: "message",
            T: OptionalTaskExercise
        },
        {
            no: 2,
            name: "optional_task",
            kind: "message",
            T: OptionalTask
        }
    ]));
/**
 * UpdateOptionalTaskExercise rewrites an exercise's terms in place: the id,
 * its task, its lines and their team links are kept, a line holding a copy
 * of a corrected term follows it, and the program's dates re-mint (D112).
 * exercise.id, tenant_id and program_id address it; another program's or
 * tenant's id is NotFound.
 *
 * @generated from message mono.datagateway.v1.UpdateOptionalTaskExerciseRequest
 */ export class UpdateOptionalTaskExerciseRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateOptionalTaskExerciseRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateOptionalTaskExerciseRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateOptionalTaskExerciseRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateOptionalTaskExerciseRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OptionalTaskExercise exercise = 1;
   */ _define_property(this, "exercise", void 0), /**
   * apply_pop_to_lines sets every line's PoP to the exercise's new PoP in the
   * same transaction. Unset, only a line term that copied the exercise's old
   * value follows (SAD-822: a mod-applied exercise's lines carry their own).
   *
   * @generated from field: bool apply_pop_to_lines = 2;
   */ _define_property(this, "applyPopToLines", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateOptionalTaskExerciseRequest, "runtime", proto3);
_define_property(UpdateOptionalTaskExerciseRequest, "typeName", "mono.datagateway.v1.UpdateOptionalTaskExerciseRequest");
_define_property(UpdateOptionalTaskExerciseRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "exercise",
            kind: "message",
            T: OptionalTaskExercise
        },
        {
            no: 2,
            name: "apply_pop_to_lines",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateOptionalTaskExerciseResponse
 */ export class UpdateOptionalTaskExerciseResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateOptionalTaskExerciseResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateOptionalTaskExerciseResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateOptionalTaskExerciseResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateOptionalTaskExerciseResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OptionalTaskExercise exercise = 1;
   */ _define_property(this, "exercise", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateOptionalTaskExerciseResponse, "runtime", proto3);
_define_property(UpdateOptionalTaskExerciseResponse, "typeName", "mono.datagateway.v1.UpdateOptionalTaskExerciseResponse");
_define_property(UpdateOptionalTaskExerciseResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "exercise",
            kind: "message",
            T: OptionalTaskExercise
        }
    ]));
/**
 * UpdateOptionalTaskExerciseLine corrects one SLIN line of an exercise in
 * place (SAD-822) and re-mints the program in the same transaction. id,
 * tenant_id, program_id and exercise_id address it; any other line is
 * NotFound. The PoP is replaced as sent (unset = not stated); clin_number ""
 * and an absent quantity keep the stored value.
 *
 * @generated from message mono.datagateway.v1.UpdateOptionalTaskExerciseLineRequest
 */ export class UpdateOptionalTaskExerciseLineRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateOptionalTaskExerciseLineRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateOptionalTaskExerciseLineRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateOptionalTaskExerciseLineRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateOptionalTaskExerciseLineRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string exercise_id = 4;
   */ _define_property(this, "exerciseId", ""), /**
   * @generated from field: string clin_number = 5;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: optional double quantity = 6;
   */ _define_property(this, "quantity", void 0), /**
   * @generated from field: google.protobuf.Timestamp pop_start_date = 7;
   */ _define_property(this, "popStartDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp pop_end_date = 8;
   */ _define_property(this, "popEndDate", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateOptionalTaskExerciseLineRequest, "runtime", proto3);
_define_property(UpdateOptionalTaskExerciseLineRequest, "typeName", "mono.datagateway.v1.UpdateOptionalTaskExerciseLineRequest");
_define_property(UpdateOptionalTaskExerciseLineRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "exercise_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "quantity",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 7,
            name: "pop_start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "pop_end_date",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateOptionalTaskExerciseLineResponse
 */ export class UpdateOptionalTaskExerciseLineResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateOptionalTaskExerciseLineResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateOptionalTaskExerciseLineResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateOptionalTaskExerciseLineResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateOptionalTaskExerciseLineResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OptionalTaskExerciseSlin line = 1;
   */ _define_property(this, "line", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateOptionalTaskExerciseLineResponse, "runtime", proto3);
_define_property(UpdateOptionalTaskExerciseLineResponse, "typeName", "mono.datagateway.v1.UpdateOptionalTaskExerciseLineResponse");
_define_property(UpdateOptionalTaskExerciseLineResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "line",
            kind: "message",
            T: OptionalTaskExerciseSlin
        }
    ]));
/**
 * optional_task_id empty → all exercises for the program. Ordered by
 * exercised_at ASC (a chronological ledger, not a latest-activity list).
 *
 * @generated from message mono.datagateway.v1.OptionalTaskExerciseFilter
 */ export class OptionalTaskExerciseFilter extends Message {
    static fromBinary(bytes, options) {
        return new OptionalTaskExerciseFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OptionalTaskExerciseFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OptionalTaskExerciseFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OptionalTaskExerciseFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string optional_task_id = 3;
   */ _define_property(this, "optionalTaskId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OptionalTaskExerciseFilter, "runtime", proto3);
_define_property(OptionalTaskExerciseFilter, "typeName", "mono.datagateway.v1.OptionalTaskExerciseFilter");
_define_property(OptionalTaskExerciseFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "optional_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListOptionalTaskExercisesRequest
 */ export class ListOptionalTaskExercisesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListOptionalTaskExercisesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOptionalTaskExercisesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOptionalTaskExercisesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOptionalTaskExercisesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OptionalTaskExerciseFilter filter = 1;
   */ _define_property(this, "filter", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOptionalTaskExercisesRequest, "runtime", proto3);
_define_property(ListOptionalTaskExercisesRequest, "typeName", "mono.datagateway.v1.ListOptionalTaskExercisesRequest");
_define_property(ListOptionalTaskExercisesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: OptionalTaskExerciseFilter
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListOptionalTaskExercisesResponse
 */ export class ListOptionalTaskExercisesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListOptionalTaskExercisesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOptionalTaskExercisesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOptionalTaskExercisesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOptionalTaskExercisesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.OptionalTaskExercise exercises = 1;
   */ _define_property(this, "exercises", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOptionalTaskExercisesResponse, "runtime", proto3);
_define_property(ListOptionalTaskExercisesResponse, "typeName", "mono.datagateway.v1.ListOptionalTaskExercisesResponse");
_define_property(ListOptionalTaskExercisesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "exercises",
            kind: "message",
            T: OptionalTaskExercise,
            repeated: true
        }
    ]));
/**
 * tenant_id + program_id guard the soft delete at the data plane
 * (WHERE id AND tenant_id AND program_id) — program_id closes the in-tenant
 * confused deputy where a caller scoped to program A names an exercise id
 * from program B. Deleting the last live exercise clears the parent's
 * `exercised` flag; the response carries the updated parent.
 *
 * @generated from message mono.datagateway.v1.DeleteOptionalTaskExerciseRequest
 */ export class DeleteOptionalTaskExerciseRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteOptionalTaskExerciseRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteOptionalTaskExerciseRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteOptionalTaskExerciseRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteOptionalTaskExerciseRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteOptionalTaskExerciseRequest, "runtime", proto3);
_define_property(DeleteOptionalTaskExerciseRequest, "typeName", "mono.datagateway.v1.DeleteOptionalTaskExerciseRequest");
_define_property(DeleteOptionalTaskExerciseRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteOptionalTaskExerciseResponse
 */ export class DeleteOptionalTaskExerciseResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteOptionalTaskExerciseResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteOptionalTaskExerciseResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteOptionalTaskExerciseResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteOptionalTaskExerciseResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OptionalTask optional_task = 1;
   */ _define_property(this, "optionalTask", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteOptionalTaskExerciseResponse, "runtime", proto3);
_define_property(DeleteOptionalTaskExerciseResponse, "typeName", "mono.datagateway.v1.DeleteOptionalTaskExerciseResponse");
_define_property(DeleteOptionalTaskExerciseResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "optional_task",
            kind: "message",
            T: OptionalTask
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProgramTaskRequest
 */ export class GetProgramTaskRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramTaskRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramTaskRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramTaskRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramTaskRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramTaskRequest, "runtime", proto3);
_define_property(GetProgramTaskRequest, "typeName", "mono.datagateway.v1.GetProgramTaskRequest");
_define_property(GetProgramTaskRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProgramTaskResponse
 */ export class GetProgramTaskResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramTaskResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramTaskResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramTaskResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramTaskResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramTask program_task = 1;
   */ _define_property(this, "programTask", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramTaskResponse, "runtime", proto3);
_define_property(GetProgramTaskResponse, "typeName", "mono.datagateway.v1.GetProgramTaskResponse");
_define_property(GetProgramTaskResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_task",
            kind: "message",
            T: ProgramTask
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateProgramTaskRequest
 */ export class CreateProgramTaskRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateProgramTaskRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProgramTaskRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProgramTaskRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProgramTaskRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramTask program_task = 1;
   */ _define_property(this, "programTask", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProgramTaskRequest, "runtime", proto3);
_define_property(CreateProgramTaskRequest, "typeName", "mono.datagateway.v1.CreateProgramTaskRequest");
_define_property(CreateProgramTaskRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_task",
            kind: "message",
            T: ProgramTask
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateProgramTaskResponse
 */ export class CreateProgramTaskResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateProgramTaskResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProgramTaskResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProgramTaskResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProgramTaskResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramTask program_task = 1;
   */ _define_property(this, "programTask", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProgramTaskResponse, "runtime", proto3);
_define_property(CreateProgramTaskResponse, "typeName", "mono.datagateway.v1.CreateProgramTaskResponse");
_define_property(CreateProgramTaskResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_task",
            kind: "message",
            T: ProgramTask
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateProgramTaskRequest
 */ export class UpdateProgramTaskRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProgramTaskRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProgramTaskRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProgramTaskRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProgramTaskRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramTask program_task = 1;
   */ _define_property(this, "programTask", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProgramTaskRequest, "runtime", proto3);
_define_property(UpdateProgramTaskRequest, "typeName", "mono.datagateway.v1.UpdateProgramTaskRequest");
_define_property(UpdateProgramTaskRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_task",
            kind: "message",
            T: ProgramTask
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateProgramTaskResponse
 */ export class UpdateProgramTaskResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProgramTaskResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProgramTaskResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProgramTaskResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProgramTaskResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramTask program_task = 1;
   */ _define_property(this, "programTask", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProgramTaskResponse, "runtime", proto3);
_define_property(UpdateProgramTaskResponse, "typeName", "mono.datagateway.v1.UpdateProgramTaskResponse");
_define_property(UpdateProgramTaskResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_task",
            kind: "message",
            T: ProgramTask
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramTasksRequest
 */ export class ListProgramTasksRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramTasksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramTasksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramTasksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramTasksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramTaskFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramTasksRequest, "runtime", proto3);
_define_property(ListProgramTasksRequest, "typeName", "mono.datagateway.v1.ListProgramTasksRequest");
_define_property(ListProgramTasksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: ProgramTaskFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramTasksResponse
 */ export class ListProgramTasksResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramTasksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramTasksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramTasksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramTasksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ProgramTask program_tasks = 1;
   */ _define_property(this, "programTasks", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramTasksResponse, "runtime", proto3);
_define_property(ListProgramTasksResponse, "typeName", "mono.datagateway.v1.ListProgramTasksResponse");
_define_property(ListProgramTasksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_tasks",
            kind: "message",
            T: ProgramTask,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MaterializeProgramTaskDeliverablesRequest
 */ export class MaterializeProgramTaskDeliverablesRequest extends Message {
    static fromBinary(bytes, options) {
        return new MaterializeProgramTaskDeliverablesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MaterializeProgramTaskDeliverablesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MaterializeProgramTaskDeliverablesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MaterializeProgramTaskDeliverablesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_task_id = 2;
   */ _define_property(this, "programTaskId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MaterializeProgramTaskDeliverablesRequest, "runtime", proto3);
_define_property(MaterializeProgramTaskDeliverablesRequest, "typeName", "mono.datagateway.v1.MaterializeProgramTaskDeliverablesRequest");
_define_property(MaterializeProgramTaskDeliverablesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MaterializeProgramTaskDeliverablesResponse
 */ export class MaterializeProgramTaskDeliverablesResponse extends Message {
    static fromBinary(bytes, options) {
        return new MaterializeProgramTaskDeliverablesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MaterializeProgramTaskDeliverablesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MaterializeProgramTaskDeliverablesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MaterializeProgramTaskDeliverablesResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(MaterializeProgramTaskDeliverablesResponse, "runtime", proto3);
_define_property(MaterializeProgramTaskDeliverablesResponse, "typeName", "mono.datagateway.v1.MaterializeProgramTaskDeliverablesResponse");
_define_property(MaterializeProgramTaskDeliverablesResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * DeliverableInstanceView is one materialized occurrence joined with its
 * definition — enough for the tracker to group by deliverable, badge N/M
 * complete, and surface each dated occurrence's status.
 *
 * @generated from message mono.datagateway.v1.DeliverableInstanceView
 */ export class DeliverableInstanceView extends Message {
    static fromBinary(bytes, options) {
        return new DeliverableInstanceView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeliverableInstanceView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeliverableInstanceView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeliverableInstanceView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string deliverable_definition_id = 2;
   */ _define_property(this, "deliverableDefinitionId", ""), /**
   * @generated from field: string program_task_id = 3;
   */ _define_property(this, "programTaskId", ""), /**
   * @generated from field: string clin_number = 4;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string deliverable_number = 5;
   */ _define_property(this, "deliverableNumber", ""), /**
   * @generated from field: string title = 6;
   */ _define_property(this, "title", ""), /**
   * cadence text ("weekly", "monthly", …)
   *
   * @generated from field: string recurrence_rule = 7;
   */ _define_property(this, "recurrenceRule", ""), /**
   * @generated from field: google.protobuf.Timestamp due_at = 8;
   */ _define_property(this, "dueAt", void 0), /**
   * NOT_STARTED|IN_PROGRESS|SUBMITTED|ACCEPTED|REJECTED|OVERDUE
   *
   * @generated from field: string status = 9;
   */ _define_property(this, "status", ""), /**
   * NONE|PARTIAL|COMPLETE|UNDER_REVIEW
   *
   * @generated from field: string evidence_status = 10;
   */ _define_property(this, "evidenceStatus", ""), /**
   * @generated from field: string proof_of_delivery_status = 11;
   */ _define_property(this, "proofOfDeliveryStatus", ""), /**
   * @generated from field: google.protobuf.Timestamp submitted_at = 12;
   */ _define_property(this, "submittedAt", void 0), /**
   * @generated from field: bool on_time_flag = 13;
   */ _define_property(this, "onTimeFlag", false), /**
   * Deduplicated ids of every artifact ever attached to this occurrence
   * (across submissions) — powers upload chips on list surfaces without an
   * extra evidence RPC. Absorbed from PR #872 (matt-issue 21).
   *
   * @generated from field: repeated string artifact_ids = 14;
   */ _define_property(this, "artifactIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeliverableInstanceView, "runtime", proto3);
_define_property(DeliverableInstanceView, "typeName", "mono.datagateway.v1.DeliverableInstanceView");
_define_property(DeliverableInstanceView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "deliverable_definition_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "deliverable_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "recurrence_rule",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "due_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "evidence_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "proof_of_delivery_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "submitted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "on_time_flag",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 14,
            name: "artifact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListDeliverableInstancesRequest
 */ export class ListDeliverableInstancesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListDeliverableInstancesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDeliverableInstancesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDeliverableInstancesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDeliverableInstancesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: int32 offset = 3;
   */ _define_property(this, "offset", 0), /**
   * 0 = no limit (legacy fetch-all)
   *
   * @generated from field: int32 limit = 4;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: google.protobuf.Timestamp due_after = 5;
   */ _define_property(this, "dueAfter", void 0), /**
   * @generated from field: google.protobuf.Timestamp due_before = 6;
   */ _define_property(this, "dueBefore", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDeliverableInstancesRequest, "runtime", proto3);
_define_property(ListDeliverableInstancesRequest, "typeName", "mono.datagateway.v1.ListDeliverableInstancesRequest");
_define_property(ListDeliverableInstancesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "due_after",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "due_before",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListDeliverableInstancesResponse
 */ export class ListDeliverableInstancesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListDeliverableInstancesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDeliverableInstancesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDeliverableInstancesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDeliverableInstancesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.DeliverableInstanceView instances = 1;
   */ _define_property(this, "instances", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDeliverableInstancesResponse, "runtime", proto3);
_define_property(ListDeliverableInstancesResponse, "typeName", "mono.datagateway.v1.ListDeliverableInstancesResponse");
_define_property(ListDeliverableInstancesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "instances",
            kind: "message",
            T: DeliverableInstanceView,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * SubmitDeliverableOccurrenceRequest records delivery of one occurrence. The
 * delivery date is stated (back-datable) — distinct from when it was recorded
 * (created_at) and who recorded it (submitted_by_user_id), so a back-fill is
 * auditable and on-time is computed against the real delivery date.
 *
 * @generated from message mono.datagateway.v1.SubmitDeliverableOccurrenceRequest
 */ export class SubmitDeliverableOccurrenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new SubmitDeliverableOccurrenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubmitDeliverableOccurrenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubmitDeliverableOccurrenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubmitDeliverableOccurrenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string deliverable_instance_id = 2;
   */ _define_property(this, "deliverableInstanceId", ""), /**
   * stated delivery date
   *
   * @generated from field: google.protobuf.Timestamp delivered_at = 3;
   */ _define_property(this, "deliveredAt", void 0), /**
   * actor (recording the delivery)
   *
   * @generated from field: string submitted_by_user_id = 4;
   */ _define_property(this, "submittedByUserId", ""), /**
   * Artifact | ExternalReference
   *
   * @generated from field: string evidence_type = 5;
   */ _define_property(this, "evidenceType", ""), /**
   * one or more uploaded proof artifacts
   *
   * @generated from field: repeated string artifact_ids = 6;
   */ _define_property(this, "artifactIds", []), /**
   * @generated from field: string external_reference_id = 7;
   */ _define_property(this, "externalReferenceId", ""), /**
   * @generated from field: repeated string submitted_to_emails = 8;
   */ _define_property(this, "submittedToEmails", []), /**
   * @generated from field: string proof_method = 9;
   */ _define_property(this, "proofMethod", ""), /**
   * @generated from field: bool screenshot_attached = 10;
   */ _define_property(this, "screenshotAttached", false), /**
   * @generated from field: bool email_file_attached = 11;
   */ _define_property(this, "emailFileAttached", false), /**
   * @generated from field: bool customer_receipt_attached = 12;
   */ _define_property(this, "customerReceiptAttached", false), /**
   * The four dates a Proof-of-Delivery review keeps distinct from
   * delivered_at (unchanged): what the PM claimed, what was extracted from
   * the proof, and what a human accepted as operational, plus the
   * verification state comparing them. Unset means "not yet evaluated".
   *
   * @generated from field: google.protobuf.Timestamp claimed_delivery_timestamp = 13;
   */ _define_property(this, "claimedDeliveryTimestamp", void 0), /**
   * @generated from field: google.protobuf.Timestamp extracted_sent_timestamp = 14;
   */ _define_property(this, "extractedSentTimestamp", void 0), /**
   * @generated from field: string extracted_sent_raw = 15;
   */ _define_property(this, "extractedSentRaw", ""), /**
   * @generated from field: string extracted_sent_utc_offset = 16;
   */ _define_property(this, "extractedSentUtcOffset", ""), /**
   * @generated from field: string extracted_sent_timezone = 17;
   */ _define_property(this, "extractedSentTimezone", ""), /**
   * @generated from field: google.protobuf.Timestamp accepted_delivery_timestamp = 18;
   */ _define_property(this, "acceptedDeliveryTimestamp", void 0), /**
   * Match|Mismatch|NotFound|Ambiguous|Unsupported
   *
   * @generated from field: string date_verification_state = 19;
   */ _define_property(this, "dateVerificationState", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SubmitDeliverableOccurrenceRequest, "runtime", proto3);
_define_property(SubmitDeliverableOccurrenceRequest, "typeName", "mono.datagateway.v1.SubmitDeliverableOccurrenceRequest");
_define_property(SubmitDeliverableOccurrenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "deliverable_instance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "delivered_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "submitted_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "evidence_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "artifact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "external_reference_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "submitted_to_emails",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "proof_method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "screenshot_attached",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "email_file_attached",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "customer_receipt_attached",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "claimed_delivery_timestamp",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "extracted_sent_timestamp",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "extracted_sent_raw",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "extracted_sent_utc_offset",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "extracted_sent_timezone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "accepted_delivery_timestamp",
            kind: "message",
            T: Timestamp
        },
        {
            no: 19,
            name: "date_verification_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SubmitDeliverableOccurrenceResponse
 */ export class SubmitDeliverableOccurrenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new SubmitDeliverableOccurrenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubmitDeliverableOccurrenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubmitDeliverableOccurrenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubmitDeliverableOccurrenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DeliverableInstanceView instance = 1;
   */ _define_property(this, "instance", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SubmitDeliverableOccurrenceResponse, "runtime", proto3);
_define_property(SubmitDeliverableOccurrenceResponse, "typeName", "mono.datagateway.v1.SubmitDeliverableOccurrenceResponse");
_define_property(SubmitDeliverableOccurrenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "instance",
            kind: "message",
            T: DeliverableInstanceView
        }
    ]));
/**
 * One live evidence row attached to an occurrence (a submit writes one row
 * per uploaded artifact, or a single row for external-reference proof).
 *
 * @generated from message mono.datagateway.v1.DeliverableEvidenceView
 */ export class DeliverableEvidenceView extends Message {
    static fromBinary(bytes, options) {
        return new DeliverableEvidenceView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeliverableEvidenceView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeliverableEvidenceView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeliverableEvidenceView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string deliverable_instance_id = 2;
   */ _define_property(this, "deliverableInstanceId", ""), /**
   * Artifact|ExternalReference
   *
   * @generated from field: string evidence_type = 3;
   */ _define_property(this, "evidenceType", ""), /**
   * zou attachment id when evidence_type=Artifact
   *
   * @generated from field: string artifact_id = 4;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string external_reference_id = 5;
   */ _define_property(this, "externalReferenceId", ""), /**
   * @generated from field: google.protobuf.Timestamp delivery_timestamp = 6;
   */ _define_property(this, "deliveryTimestamp", void 0), /**
   * @generated from field: string submitted_by_user_id = 7;
   */ _define_property(this, "submittedByUserId", ""), /**
   * JSON []string
   *
   * @generated from field: string submitted_to_emails = 8;
   */ _define_property(this, "submittedToEmails", ""), /**
   * @generated from field: string proof_method = 9;
   */ _define_property(this, "proofMethod", ""), /**
   * @generated from field: bool screenshot_attached = 10;
   */ _define_property(this, "screenshotAttached", false), /**
   * @generated from field: bool email_file_attached = 11;
   */ _define_property(this, "emailFileAttached", false), /**
   * @generated from field: bool customer_receipt_attached = 12;
   */ _define_property(this, "customerReceiptAttached", false), /**
   * @generated from field: string validation_state = 13;
   */ _define_property(this, "validationState", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp claimed_delivery_timestamp = 15;
   */ _define_property(this, "claimedDeliveryTimestamp", void 0), /**
   * @generated from field: google.protobuf.Timestamp extracted_sent_timestamp = 16;
   */ _define_property(this, "extractedSentTimestamp", void 0), /**
   * @generated from field: string extracted_sent_raw = 17;
   */ _define_property(this, "extractedSentRaw", ""), /**
   * @generated from field: string extracted_sent_utc_offset = 18;
   */ _define_property(this, "extractedSentUtcOffset", ""), /**
   * @generated from field: string extracted_sent_timezone = 19;
   */ _define_property(this, "extractedSentTimezone", ""), /**
   * @generated from field: google.protobuf.Timestamp accepted_delivery_timestamp = 20;
   */ _define_property(this, "acceptedDeliveryTimestamp", void 0), /**
   * Match|Mismatch|NotFound|Ambiguous|Unsupported
   *
   * @generated from field: string date_verification_state = 21;
   */ _define_property(this, "dateVerificationState", ""), /**
   * SAD-106 (migration 000151): projected straight from the same
   * DeliverableEvidence row's customer_acceptance_status / delivery_notes /
   * submitted_to_contact_id columns (delivery_sds.proto fields 29-31) so an
   * occurrence-scoped read carries the customer record alongside the rest of
   * the evidence, not just the task-scoped DeliverableEvidence entity.
   *
   * @generated from field: string customer_acceptance_status = 22;
   */ _define_property(this, "customerAcceptanceStatus", ""), /**
   * @generated from field: string delivery_notes = 23;
   */ _define_property(this, "deliveryNotes", ""), /**
   * @generated from field: string submitted_to_contact_id = 24;
   */ _define_property(this, "submittedToContactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeliverableEvidenceView, "runtime", proto3);
_define_property(DeliverableEvidenceView, "typeName", "mono.datagateway.v1.DeliverableEvidenceView");
_define_property(DeliverableEvidenceView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "deliverable_instance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "evidence_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "external_reference_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "delivery_timestamp",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "submitted_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "submitted_to_emails",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "proof_method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "screenshot_attached",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "email_file_attached",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "customer_receipt_attached",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "validation_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "claimed_delivery_timestamp",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "extracted_sent_timestamp",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "extracted_sent_raw",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "extracted_sent_utc_offset",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "extracted_sent_timezone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "accepted_delivery_timestamp",
            kind: "message",
            T: Timestamp
        },
        {
            no: 21,
            name: "date_verification_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "customer_acceptance_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "delivery_notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "submitted_to_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListDeliverableEvidenceRequest
 */ export class ListDeliverableEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListDeliverableEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDeliverableEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDeliverableEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDeliverableEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string deliverable_instance_id = 2;
   */ _define_property(this, "deliverableInstanceId", ""), /**
   * Alternative scope: all live evidence for one task (across its
   * occurrences). Exactly one of instance_id / task_id must be set.
   *
   * @generated from field: string program_task_id = 3;
   */ _define_property(this, "programTaskId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDeliverableEvidenceRequest, "runtime", proto3);
_define_property(ListDeliverableEvidenceRequest, "typeName", "mono.datagateway.v1.ListDeliverableEvidenceRequest");
_define_property(ListDeliverableEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "deliverable_instance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListDeliverableEvidenceResponse
 */ export class ListDeliverableEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListDeliverableEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDeliverableEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDeliverableEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDeliverableEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.DeliverableEvidenceView evidence = 1;
   */ _define_property(this, "evidence", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDeliverableEvidenceResponse, "runtime", proto3);
_define_property(ListDeliverableEvidenceResponse, "typeName", "mono.datagateway.v1.ListDeliverableEvidenceResponse");
_define_property(ListDeliverableEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "evidence",
            kind: "message",
            T: DeliverableEvidenceView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteDeliverableEvidenceRequest
 */ export class DeleteDeliverableEvidenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteDeliverableEvidenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteDeliverableEvidenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteDeliverableEvidenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteDeliverableEvidenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string evidence_id = 2;
   */ _define_property(this, "evidenceId", ""), /**
   * recorded on the operational audit event
   *
   * @generated from field: string actor_user_id = 3;
   */ _define_property(this, "actorUserId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteDeliverableEvidenceRequest, "runtime", proto3);
_define_property(DeleteDeliverableEvidenceRequest, "typeName", "mono.datagateway.v1.DeleteDeliverableEvidenceRequest");
_define_property(DeleteDeliverableEvidenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "evidence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Returns the occurrence after its derived state was recomputed from the
 * remaining live evidence (deleting the last row reverts it to NOT_STARTED).
 *
 * @generated from message mono.datagateway.v1.DeleteDeliverableEvidenceResponse
 */ export class DeleteDeliverableEvidenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteDeliverableEvidenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteDeliverableEvidenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteDeliverableEvidenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteDeliverableEvidenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DeliverableInstanceView instance = 1;
   */ _define_property(this, "instance", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteDeliverableEvidenceResponse, "runtime", proto3);
_define_property(DeleteDeliverableEvidenceResponse, "typeName", "mono.datagateway.v1.DeleteDeliverableEvidenceResponse");
_define_property(DeleteDeliverableEvidenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "instance",
            kind: "message",
            T: DeliverableInstanceView
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteProgramTaskRequest
 */ export class DeleteProgramTaskRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramTaskRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramTaskRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramTaskRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramTaskRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramTaskRequest, "runtime", proto3);
_define_property(DeleteProgramTaskRequest, "typeName", "mono.datagateway.v1.DeleteProgramTaskRequest");
_define_property(DeleteProgramTaskRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteProgramTaskResponse
 */ export class DeleteProgramTaskResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramTaskResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramTaskResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramTaskResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramTaskResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramTaskResponse, "runtime", proto3);
_define_property(DeleteProgramTaskResponse, "typeName", "mono.datagateway.v1.DeleteProgramTaskResponse");
_define_property(DeleteProgramTaskResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetTaskAttachmentRequest
 */ export class GetTaskAttachmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetTaskAttachmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetTaskAttachmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetTaskAttachmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetTaskAttachmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetTaskAttachmentRequest, "runtime", proto3);
_define_property(GetTaskAttachmentRequest, "typeName", "mono.datagateway.v1.GetTaskAttachmentRequest");
_define_property(GetTaskAttachmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetTaskAttachmentResponse
 */ export class GetTaskAttachmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetTaskAttachmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetTaskAttachmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetTaskAttachmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetTaskAttachmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.TaskAttachment task_attachment = 1;
   */ _define_property(this, "taskAttachment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetTaskAttachmentResponse, "runtime", proto3);
_define_property(GetTaskAttachmentResponse, "typeName", "mono.datagateway.v1.GetTaskAttachmentResponse");
_define_property(GetTaskAttachmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "task_attachment",
            kind: "message",
            T: TaskAttachment
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateTaskAttachmentRequest
 */ export class CreateTaskAttachmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateTaskAttachmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateTaskAttachmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateTaskAttachmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateTaskAttachmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.TaskAttachment task_attachment = 1;
   */ _define_property(this, "taskAttachment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateTaskAttachmentRequest, "runtime", proto3);
_define_property(CreateTaskAttachmentRequest, "typeName", "mono.datagateway.v1.CreateTaskAttachmentRequest");
_define_property(CreateTaskAttachmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "task_attachment",
            kind: "message",
            T: TaskAttachment
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateTaskAttachmentResponse
 */ export class CreateTaskAttachmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateTaskAttachmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateTaskAttachmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateTaskAttachmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateTaskAttachmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.TaskAttachment task_attachment = 1;
   */ _define_property(this, "taskAttachment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateTaskAttachmentResponse, "runtime", proto3);
_define_property(CreateTaskAttachmentResponse, "typeName", "mono.datagateway.v1.CreateTaskAttachmentResponse");
_define_property(CreateTaskAttachmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "task_attachment",
            kind: "message",
            T: TaskAttachment
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateTaskAttachmentRequest
 */ export class UpdateTaskAttachmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateTaskAttachmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateTaskAttachmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateTaskAttachmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateTaskAttachmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.TaskAttachment task_attachment = 1;
   */ _define_property(this, "taskAttachment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateTaskAttachmentRequest, "runtime", proto3);
_define_property(UpdateTaskAttachmentRequest, "typeName", "mono.datagateway.v1.UpdateTaskAttachmentRequest");
_define_property(UpdateTaskAttachmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "task_attachment",
            kind: "message",
            T: TaskAttachment
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateTaskAttachmentResponse
 */ export class UpdateTaskAttachmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateTaskAttachmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateTaskAttachmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateTaskAttachmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateTaskAttachmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.TaskAttachment task_attachment = 1;
   */ _define_property(this, "taskAttachment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateTaskAttachmentResponse, "runtime", proto3);
_define_property(UpdateTaskAttachmentResponse, "typeName", "mono.datagateway.v1.UpdateTaskAttachmentResponse");
_define_property(UpdateTaskAttachmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "task_attachment",
            kind: "message",
            T: TaskAttachment
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListTaskAttachmentsRequest
 */ export class ListTaskAttachmentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListTaskAttachmentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListTaskAttachmentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListTaskAttachmentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListTaskAttachmentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.TaskAttachmentFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListTaskAttachmentsRequest, "runtime", proto3);
_define_property(ListTaskAttachmentsRequest, "typeName", "mono.datagateway.v1.ListTaskAttachmentsRequest");
_define_property(ListTaskAttachmentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: TaskAttachmentFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListTaskAttachmentsResponse
 */ export class ListTaskAttachmentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListTaskAttachmentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListTaskAttachmentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListTaskAttachmentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListTaskAttachmentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.TaskAttachment task_attachments = 1;
   */ _define_property(this, "taskAttachments", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListTaskAttachmentsResponse, "runtime", proto3);
_define_property(ListTaskAttachmentsResponse, "typeName", "mono.datagateway.v1.ListTaskAttachmentsResponse");
_define_property(ListTaskAttachmentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "task_attachments",
            kind: "message",
            T: TaskAttachment,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteTaskAttachmentRequest
 */ export class DeleteTaskAttachmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteTaskAttachmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteTaskAttachmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteTaskAttachmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteTaskAttachmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteTaskAttachmentRequest, "runtime", proto3);
_define_property(DeleteTaskAttachmentRequest, "typeName", "mono.datagateway.v1.DeleteTaskAttachmentRequest");
_define_property(DeleteTaskAttachmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteTaskAttachmentResponse
 */ export class DeleteTaskAttachmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteTaskAttachmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteTaskAttachmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteTaskAttachmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteTaskAttachmentResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteTaskAttachmentResponse, "runtime", proto3);
_define_property(DeleteTaskAttachmentResponse, "typeName", "mono.datagateway.v1.DeleteTaskAttachmentResponse");
_define_property(DeleteTaskAttachmentResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetAuditRequest
 */ export class GetAuditRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetAuditRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAuditRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAuditRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAuditRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetAuditRequest, "runtime", proto3);
_define_property(GetAuditRequest, "typeName", "mono.datagateway.v1.GetAuditRequest");
_define_property(GetAuditRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetAuditResponse
 */ export class GetAuditResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetAuditResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAuditResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAuditResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAuditResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Audit audit = 1;
   */ _define_property(this, "audit", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetAuditResponse, "runtime", proto3);
_define_property(GetAuditResponse, "typeName", "mono.datagateway.v1.GetAuditResponse");
_define_property(GetAuditResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit",
            kind: "message",
            T: Audit
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateAuditRequest
 */ export class CreateAuditRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateAuditRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateAuditRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateAuditRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateAuditRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Audit audit = 1;
   */ _define_property(this, "audit", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateAuditRequest, "runtime", proto3);
_define_property(CreateAuditRequest, "typeName", "mono.datagateway.v1.CreateAuditRequest");
_define_property(CreateAuditRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit",
            kind: "message",
            T: Audit
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateAuditResponse
 */ export class CreateAuditResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateAuditResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateAuditResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateAuditResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateAuditResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Audit audit = 1;
   */ _define_property(this, "audit", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateAuditResponse, "runtime", proto3);
_define_property(CreateAuditResponse, "typeName", "mono.datagateway.v1.CreateAuditResponse");
_define_property(CreateAuditResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit",
            kind: "message",
            T: Audit
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateAuditRequest
 */ export class UpdateAuditRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateAuditRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateAuditRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateAuditRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateAuditRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Audit audit = 1;
   */ _define_property(this, "audit", void 0), /**
   * Optimistic guard: when set, the update only applies if the row's current
   * state is NOT this value, and a no-match returns FailedPrecondition. Used to
   * make the CompleteAudit freeze a compare-and-swap so a second concurrent
   * Complete can't blind-overwrite a frozen audit.
   *
   * @generated from field: string if_state_not = 2;
   */ _define_property(this, "ifStateNot", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateAuditRequest, "runtime", proto3);
_define_property(UpdateAuditRequest, "typeName", "mono.datagateway.v1.UpdateAuditRequest");
_define_property(UpdateAuditRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit",
            kind: "message",
            T: Audit
        },
        {
            no: 2,
            name: "if_state_not",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateAuditResponse
 */ export class UpdateAuditResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateAuditResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateAuditResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateAuditResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateAuditResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Audit audit = 1;
   */ _define_property(this, "audit", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateAuditResponse, "runtime", proto3);
_define_property(UpdateAuditResponse, "typeName", "mono.datagateway.v1.UpdateAuditResponse");
_define_property(UpdateAuditResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit",
            kind: "message",
            T: Audit
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListAuditsRequest
 */ export class ListAuditsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListAuditsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAuditsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAuditsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAuditsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AuditFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAuditsRequest, "runtime", proto3);
_define_property(ListAuditsRequest, "typeName", "mono.datagateway.v1.ListAuditsRequest");
_define_property(ListAuditsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: AuditFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListAuditsResponse
 */ export class ListAuditsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListAuditsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAuditsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAuditsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAuditsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.Audit audits = 1;
   */ _define_property(this, "audits", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAuditsResponse, "runtime", proto3);
_define_property(ListAuditsResponse, "typeName", "mono.datagateway.v1.ListAuditsResponse");
_define_property(ListAuditsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audits",
            kind: "message",
            T: Audit,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteAuditRequest
 */ export class DeleteAuditRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteAuditRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteAuditRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteAuditRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteAuditRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteAuditRequest, "runtime", proto3);
_define_property(DeleteAuditRequest, "typeName", "mono.datagateway.v1.DeleteAuditRequest");
_define_property(DeleteAuditRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteAuditResponse
 */ export class DeleteAuditResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteAuditResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteAuditResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteAuditResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteAuditResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteAuditResponse, "runtime", proto3);
_define_property(DeleteAuditResponse, "typeName", "mono.datagateway.v1.DeleteAuditResponse");
_define_property(DeleteAuditResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetAuditQuestionRequest
 */ export class GetAuditQuestionRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetAuditQuestionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAuditQuestionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAuditQuestionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAuditQuestionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetAuditQuestionRequest, "runtime", proto3);
_define_property(GetAuditQuestionRequest, "typeName", "mono.datagateway.v1.GetAuditQuestionRequest");
_define_property(GetAuditQuestionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetAuditQuestionResponse
 */ export class GetAuditQuestionResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetAuditQuestionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAuditQuestionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAuditQuestionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAuditQuestionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AuditQuestion audit_question = 1;
   */ _define_property(this, "auditQuestion", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetAuditQuestionResponse, "runtime", proto3);
_define_property(GetAuditQuestionResponse, "typeName", "mono.datagateway.v1.GetAuditQuestionResponse");
_define_property(GetAuditQuestionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit_question",
            kind: "message",
            T: AuditQuestion
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateAuditQuestionRequest
 */ export class CreateAuditQuestionRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateAuditQuestionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateAuditQuestionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateAuditQuestionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateAuditQuestionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AuditQuestion audit_question = 1;
   */ _define_property(this, "auditQuestion", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateAuditQuestionRequest, "runtime", proto3);
_define_property(CreateAuditQuestionRequest, "typeName", "mono.datagateway.v1.CreateAuditQuestionRequest");
_define_property(CreateAuditQuestionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit_question",
            kind: "message",
            T: AuditQuestion
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateAuditQuestionResponse
 */ export class CreateAuditQuestionResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateAuditQuestionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateAuditQuestionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateAuditQuestionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateAuditQuestionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AuditQuestion audit_question = 1;
   */ _define_property(this, "auditQuestion", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateAuditQuestionResponse, "runtime", proto3);
_define_property(CreateAuditQuestionResponse, "typeName", "mono.datagateway.v1.CreateAuditQuestionResponse");
_define_property(CreateAuditQuestionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit_question",
            kind: "message",
            T: AuditQuestion
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateAuditQuestionRequest
 */ export class UpdateAuditQuestionRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateAuditQuestionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateAuditQuestionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateAuditQuestionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateAuditQuestionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AuditQuestion audit_question = 1;
   */ _define_property(this, "auditQuestion", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateAuditQuestionRequest, "runtime", proto3);
_define_property(UpdateAuditQuestionRequest, "typeName", "mono.datagateway.v1.UpdateAuditQuestionRequest");
_define_property(UpdateAuditQuestionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit_question",
            kind: "message",
            T: AuditQuestion
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateAuditQuestionResponse
 */ export class UpdateAuditQuestionResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateAuditQuestionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateAuditQuestionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateAuditQuestionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateAuditQuestionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AuditQuestion audit_question = 1;
   */ _define_property(this, "auditQuestion", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateAuditQuestionResponse, "runtime", proto3);
_define_property(UpdateAuditQuestionResponse, "typeName", "mono.datagateway.v1.UpdateAuditQuestionResponse");
_define_property(UpdateAuditQuestionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit_question",
            kind: "message",
            T: AuditQuestion
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListAuditQuestionsRequest
 */ export class ListAuditQuestionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListAuditQuestionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAuditQuestionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAuditQuestionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAuditQuestionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AuditQuestionFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAuditQuestionsRequest, "runtime", proto3);
_define_property(ListAuditQuestionsRequest, "typeName", "mono.datagateway.v1.ListAuditQuestionsRequest");
_define_property(ListAuditQuestionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: AuditQuestionFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListAuditQuestionsResponse
 */ export class ListAuditQuestionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListAuditQuestionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAuditQuestionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAuditQuestionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAuditQuestionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.AuditQuestion audit_questions = 1;
   */ _define_property(this, "auditQuestions", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAuditQuestionsResponse, "runtime", proto3);
_define_property(ListAuditQuestionsResponse, "typeName", "mono.datagateway.v1.ListAuditQuestionsResponse");
_define_property(ListAuditQuestionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit_questions",
            kind: "message",
            T: AuditQuestion,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteAuditQuestionRequest
 */ export class DeleteAuditQuestionRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteAuditQuestionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteAuditQuestionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteAuditQuestionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteAuditQuestionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteAuditQuestionRequest, "runtime", proto3);
_define_property(DeleteAuditQuestionRequest, "typeName", "mono.datagateway.v1.DeleteAuditQuestionRequest");
_define_property(DeleteAuditQuestionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteAuditQuestionResponse
 */ export class DeleteAuditQuestionResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteAuditQuestionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteAuditQuestionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteAuditQuestionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteAuditQuestionResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteAuditQuestionResponse, "runtime", proto3);
_define_property(DeleteAuditQuestionResponse, "typeName", "mono.datagateway.v1.DeleteAuditQuestionResponse");
_define_property(DeleteAuditQuestionResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetCorrectiveActionRequest
 */ export class GetCorrectiveActionRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCorrectiveActionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCorrectiveActionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCorrectiveActionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCorrectiveActionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCorrectiveActionRequest, "runtime", proto3);
_define_property(GetCorrectiveActionRequest, "typeName", "mono.datagateway.v1.GetCorrectiveActionRequest");
_define_property(GetCorrectiveActionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCorrectiveActionResponse
 */ export class GetCorrectiveActionResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCorrectiveActionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCorrectiveActionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCorrectiveActionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCorrectiveActionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CorrectiveAction corrective_action = 1;
   */ _define_property(this, "correctiveAction", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCorrectiveActionResponse, "runtime", proto3);
_define_property(GetCorrectiveActionResponse, "typeName", "mono.datagateway.v1.GetCorrectiveActionResponse");
_define_property(GetCorrectiveActionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "corrective_action",
            kind: "message",
            T: CorrectiveAction
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateCorrectiveActionRequest
 */ export class CreateCorrectiveActionRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateCorrectiveActionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCorrectiveActionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCorrectiveActionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCorrectiveActionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CorrectiveAction corrective_action = 1;
   */ _define_property(this, "correctiveAction", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCorrectiveActionRequest, "runtime", proto3);
_define_property(CreateCorrectiveActionRequest, "typeName", "mono.datagateway.v1.CreateCorrectiveActionRequest");
_define_property(CreateCorrectiveActionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "corrective_action",
            kind: "message",
            T: CorrectiveAction
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateCorrectiveActionResponse
 */ export class CreateCorrectiveActionResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateCorrectiveActionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCorrectiveActionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCorrectiveActionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCorrectiveActionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CorrectiveAction corrective_action = 1;
   */ _define_property(this, "correctiveAction", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCorrectiveActionResponse, "runtime", proto3);
_define_property(CreateCorrectiveActionResponse, "typeName", "mono.datagateway.v1.CreateCorrectiveActionResponse");
_define_property(CreateCorrectiveActionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "corrective_action",
            kind: "message",
            T: CorrectiveAction
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateCorrectiveActionRequest
 */ export class UpdateCorrectiveActionRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCorrectiveActionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCorrectiveActionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCorrectiveActionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCorrectiveActionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CorrectiveAction corrective_action = 1;
   */ _define_property(this, "correctiveAction", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCorrectiveActionRequest, "runtime", proto3);
_define_property(UpdateCorrectiveActionRequest, "typeName", "mono.datagateway.v1.UpdateCorrectiveActionRequest");
_define_property(UpdateCorrectiveActionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "corrective_action",
            kind: "message",
            T: CorrectiveAction
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateCorrectiveActionResponse
 */ export class UpdateCorrectiveActionResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCorrectiveActionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCorrectiveActionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCorrectiveActionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCorrectiveActionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CorrectiveAction corrective_action = 1;
   */ _define_property(this, "correctiveAction", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCorrectiveActionResponse, "runtime", proto3);
_define_property(UpdateCorrectiveActionResponse, "typeName", "mono.datagateway.v1.UpdateCorrectiveActionResponse");
_define_property(UpdateCorrectiveActionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "corrective_action",
            kind: "message",
            T: CorrectiveAction
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCorrectiveActionsRequest
 */ export class ListCorrectiveActionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCorrectiveActionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCorrectiveActionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCorrectiveActionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCorrectiveActionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CorrectiveActionFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCorrectiveActionsRequest, "runtime", proto3);
_define_property(ListCorrectiveActionsRequest, "typeName", "mono.datagateway.v1.ListCorrectiveActionsRequest");
_define_property(ListCorrectiveActionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: CorrectiveActionFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCorrectiveActionsResponse
 */ export class ListCorrectiveActionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCorrectiveActionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCorrectiveActionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCorrectiveActionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCorrectiveActionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CorrectiveAction corrective_actions = 1;
   */ _define_property(this, "correctiveActions", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCorrectiveActionsResponse, "runtime", proto3);
_define_property(ListCorrectiveActionsResponse, "typeName", "mono.datagateway.v1.ListCorrectiveActionsResponse");
_define_property(ListCorrectiveActionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "corrective_actions",
            kind: "message",
            T: CorrectiveAction,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCorrectiveActionRequest
 */ export class DeleteCorrectiveActionRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCorrectiveActionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCorrectiveActionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCorrectiveActionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCorrectiveActionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCorrectiveActionRequest, "runtime", proto3);
_define_property(DeleteCorrectiveActionRequest, "typeName", "mono.datagateway.v1.DeleteCorrectiveActionRequest");
_define_property(DeleteCorrectiveActionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCorrectiveActionResponse
 */ export class DeleteCorrectiveActionResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCorrectiveActionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCorrectiveActionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCorrectiveActionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCorrectiveActionResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCorrectiveActionResponse, "runtime", proto3);
_define_property(DeleteCorrectiveActionResponse, "typeName", "mono.datagateway.v1.DeleteCorrectiveActionResponse");
_define_property(DeleteCorrectiveActionResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.CountOpenCorrectiveActionsRequest
 */ export class CountOpenCorrectiveActionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new CountOpenCorrectiveActionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CountOpenCorrectiveActionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CountOpenCorrectiveActionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CountOpenCorrectiveActionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CountOpenCorrectiveActionsRequest, "runtime", proto3);
_define_property(CountOpenCorrectiveActionsRequest, "typeName", "mono.datagateway.v1.CountOpenCorrectiveActionsRequest");
_define_property(CountOpenCorrectiveActionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * OpenCorrectiveActionCount is one program's count of open corrective
 * actions. A program with zero open actions is absent from the response
 * entirely — callers must read a missing program_id as zero, not as an
 * error or an unknown program.
 *
 * @generated from message mono.datagateway.v1.OpenCorrectiveActionCount
 */ export class OpenCorrectiveActionCount extends Message {
    static fromBinary(bytes, options) {
        return new OpenCorrectiveActionCount().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OpenCorrectiveActionCount().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OpenCorrectiveActionCount().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OpenCorrectiveActionCount, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: int64 open_count = 2;
   */ _define_property(this, "openCount", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OpenCorrectiveActionCount, "runtime", proto3);
_define_property(OpenCorrectiveActionCount, "typeName", "mono.datagateway.v1.OpenCorrectiveActionCount");
_define_property(OpenCorrectiveActionCount, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "open_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CountOpenCorrectiveActionsResponse
 */ export class CountOpenCorrectiveActionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new CountOpenCorrectiveActionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CountOpenCorrectiveActionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CountOpenCorrectiveActionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CountOpenCorrectiveActionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.OpenCorrectiveActionCount counts = 1;
   */ _define_property(this, "counts", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CountOpenCorrectiveActionsResponse, "runtime", proto3);
_define_property(CountOpenCorrectiveActionsResponse, "typeName", "mono.datagateway.v1.CountOpenCorrectiveActionsResponse");
_define_property(CountOpenCorrectiveActionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "counts",
            kind: "message",
            T: OpenCorrectiveActionCount,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetDeviationRequest
 */ export class GetDeviationRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDeviationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDeviationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDeviationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDeviationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDeviationRequest, "runtime", proto3);
_define_property(GetDeviationRequest, "typeName", "mono.datagateway.v1.GetDeviationRequest");
_define_property(GetDeviationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetDeviationResponse
 */ export class GetDeviationResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDeviationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDeviationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDeviationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDeviationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Deviation deviation = 1;
   */ _define_property(this, "deviation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDeviationResponse, "runtime", proto3);
_define_property(GetDeviationResponse, "typeName", "mono.datagateway.v1.GetDeviationResponse");
_define_property(GetDeviationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "deviation",
            kind: "message",
            T: Deviation
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateDeviationRequest
 */ export class CreateDeviationRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateDeviationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateDeviationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateDeviationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateDeviationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Deviation deviation = 1;
   */ _define_property(this, "deviation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateDeviationRequest, "runtime", proto3);
_define_property(CreateDeviationRequest, "typeName", "mono.datagateway.v1.CreateDeviationRequest");
_define_property(CreateDeviationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "deviation",
            kind: "message",
            T: Deviation
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateDeviationResponse
 */ export class CreateDeviationResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateDeviationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateDeviationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateDeviationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateDeviationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Deviation deviation = 1;
   */ _define_property(this, "deviation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateDeviationResponse, "runtime", proto3);
_define_property(CreateDeviationResponse, "typeName", "mono.datagateway.v1.CreateDeviationResponse");
_define_property(CreateDeviationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "deviation",
            kind: "message",
            T: Deviation
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateDeviationRequest
 */ export class UpdateDeviationRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateDeviationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateDeviationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateDeviationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateDeviationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Deviation deviation = 1;
   */ _define_property(this, "deviation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateDeviationRequest, "runtime", proto3);
_define_property(UpdateDeviationRequest, "typeName", "mono.datagateway.v1.UpdateDeviationRequest");
_define_property(UpdateDeviationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "deviation",
            kind: "message",
            T: Deviation
        }
    ]));
/**
 * previous_state and state_changed report what the write transaction
 * actually committed, read from the row-locked pre-write row (SAD-285) —
 * they are the authoritative answer about the transition, superseding any
 * state the caller read before the call. Absent means the server predates
 * SAD-285.
 *
 * @generated from message mono.datagateway.v1.UpdateDeviationResponse
 */ export class UpdateDeviationResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateDeviationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateDeviationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateDeviationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateDeviationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Deviation deviation = 1;
   */ _define_property(this, "deviation", void 0), /**
   * @generated from field: optional string previous_state = 2;
   */ _define_property(this, "previousState", void 0), /**
   * @generated from field: optional bool state_changed = 3;
   */ _define_property(this, "stateChanged", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateDeviationResponse, "runtime", proto3);
_define_property(UpdateDeviationResponse, "typeName", "mono.datagateway.v1.UpdateDeviationResponse");
_define_property(UpdateDeviationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "deviation",
            kind: "message",
            T: Deviation
        },
        {
            no: 2,
            name: "previous_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 3,
            name: "state_changed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListDeviationsRequest
 */ export class ListDeviationsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListDeviationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDeviationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDeviationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDeviationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DeviationFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDeviationsRequest, "runtime", proto3);
_define_property(ListDeviationsRequest, "typeName", "mono.datagateway.v1.ListDeviationsRequest");
_define_property(ListDeviationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: DeviationFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListDeviationsResponse
 */ export class ListDeviationsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListDeviationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDeviationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDeviationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDeviationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.Deviation deviations = 1;
   */ _define_property(this, "deviations", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDeviationsResponse, "runtime", proto3);
_define_property(ListDeviationsResponse, "typeName", "mono.datagateway.v1.ListDeviationsResponse");
_define_property(ListDeviationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "deviations",
            kind: "message",
            T: Deviation,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteDeviationRequest
 */ export class DeleteDeviationRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteDeviationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteDeviationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteDeviationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteDeviationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteDeviationRequest, "runtime", proto3);
_define_property(DeleteDeviationRequest, "typeName", "mono.datagateway.v1.DeleteDeviationRequest");
_define_property(DeleteDeviationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteDeviationResponse
 */ export class DeleteDeviationResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteDeviationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteDeviationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteDeviationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteDeviationResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteDeviationResponse, "runtime", proto3);
_define_property(DeleteDeviationResponse, "typeName", "mono.datagateway.v1.DeleteDeviationResponse");
_define_property(DeleteDeviationResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetDSOEntryRequest
 */ export class GetDSOEntryRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDSOEntryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDSOEntryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDSOEntryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDSOEntryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDSOEntryRequest, "runtime", proto3);
_define_property(GetDSOEntryRequest, "typeName", "mono.datagateway.v1.GetDSOEntryRequest");
_define_property(GetDSOEntryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetDSOEntryResponse
 */ export class GetDSOEntryResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDSOEntryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDSOEntryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDSOEntryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDSOEntryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DSOEntry dso_entry = 1;
   */ _define_property(this, "dsoEntry", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDSOEntryResponse, "runtime", proto3);
_define_property(GetDSOEntryResponse, "typeName", "mono.datagateway.v1.GetDSOEntryResponse");
_define_property(GetDSOEntryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "dso_entry",
            kind: "message",
            T: DSOEntry
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateDSOEntryRequest
 */ export class CreateDSOEntryRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateDSOEntryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateDSOEntryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateDSOEntryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateDSOEntryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DSOEntry dso_entry = 1;
   */ _define_property(this, "dsoEntry", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateDSOEntryRequest, "runtime", proto3);
_define_property(CreateDSOEntryRequest, "typeName", "mono.datagateway.v1.CreateDSOEntryRequest");
_define_property(CreateDSOEntryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "dso_entry",
            kind: "message",
            T: DSOEntry
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateDSOEntryResponse
 */ export class CreateDSOEntryResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateDSOEntryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateDSOEntryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateDSOEntryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateDSOEntryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DSOEntry dso_entry = 1;
   */ _define_property(this, "dsoEntry", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateDSOEntryResponse, "runtime", proto3);
_define_property(CreateDSOEntryResponse, "typeName", "mono.datagateway.v1.CreateDSOEntryResponse");
_define_property(CreateDSOEntryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "dso_entry",
            kind: "message",
            T: DSOEntry
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateDSOEntryRequest
 */ export class UpdateDSOEntryRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateDSOEntryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateDSOEntryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateDSOEntryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateDSOEntryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DSOEntry dso_entry = 1;
   */ _define_property(this, "dsoEntry", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateDSOEntryRequest, "runtime", proto3);
_define_property(UpdateDSOEntryRequest, "typeName", "mono.datagateway.v1.UpdateDSOEntryRequest");
_define_property(UpdateDSOEntryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "dso_entry",
            kind: "message",
            T: DSOEntry
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateDSOEntryResponse
 */ export class UpdateDSOEntryResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateDSOEntryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateDSOEntryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateDSOEntryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateDSOEntryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DSOEntry dso_entry = 1;
   */ _define_property(this, "dsoEntry", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateDSOEntryResponse, "runtime", proto3);
_define_property(UpdateDSOEntryResponse, "typeName", "mono.datagateway.v1.UpdateDSOEntryResponse");
_define_property(UpdateDSOEntryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "dso_entry",
            kind: "message",
            T: DSOEntry
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListDSOEntriesRequest
 */ export class ListDSOEntriesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListDSOEntriesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDSOEntriesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDSOEntriesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDSOEntriesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DSOEntryFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDSOEntriesRequest, "runtime", proto3);
_define_property(ListDSOEntriesRequest, "typeName", "mono.datagateway.v1.ListDSOEntriesRequest");
_define_property(ListDSOEntriesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: DSOEntryFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListDSOEntriesResponse
 */ export class ListDSOEntriesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListDSOEntriesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDSOEntriesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDSOEntriesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDSOEntriesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.DSOEntry dso_entries = 1;
   */ _define_property(this, "dsoEntries", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDSOEntriesResponse, "runtime", proto3);
_define_property(ListDSOEntriesResponse, "typeName", "mono.datagateway.v1.ListDSOEntriesResponse");
_define_property(ListDSOEntriesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "dso_entries",
            kind: "message",
            T: DSOEntry,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteDSOEntryRequest
 */ export class DeleteDSOEntryRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteDSOEntryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteDSOEntryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteDSOEntryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteDSOEntryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteDSOEntryRequest, "runtime", proto3);
_define_property(DeleteDSOEntryRequest, "typeName", "mono.datagateway.v1.DeleteDSOEntryRequest");
_define_property(DeleteDSOEntryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteDSOEntryResponse
 */ export class DeleteDSOEntryResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteDSOEntryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteDSOEntryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteDSOEntryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteDSOEntryResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteDSOEntryResponse, "runtime", proto3);
_define_property(DeleteDSOEntryResponse, "typeName", "mono.datagateway.v1.DeleteDSOEntryResponse");
_define_property(DeleteDSOEntryResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetEACEntryRequest
 */ export class GetEACEntryRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetEACEntryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetEACEntryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetEACEntryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetEACEntryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetEACEntryRequest, "runtime", proto3);
_define_property(GetEACEntryRequest, "typeName", "mono.datagateway.v1.GetEACEntryRequest");
_define_property(GetEACEntryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetEACEntryResponse
 */ export class GetEACEntryResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetEACEntryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetEACEntryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetEACEntryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetEACEntryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.EACEntry eac_entry = 1;
   */ _define_property(this, "eacEntry", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetEACEntryResponse, "runtime", proto3);
_define_property(GetEACEntryResponse, "typeName", "mono.datagateway.v1.GetEACEntryResponse");
_define_property(GetEACEntryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "eac_entry",
            kind: "message",
            T: EACEntry
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateEACEntryRequest
 */ export class CreateEACEntryRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateEACEntryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateEACEntryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateEACEntryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateEACEntryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.EACEntry eac_entry = 1;
   */ _define_property(this, "eacEntry", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateEACEntryRequest, "runtime", proto3);
_define_property(CreateEACEntryRequest, "typeName", "mono.datagateway.v1.CreateEACEntryRequest");
_define_property(CreateEACEntryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "eac_entry",
            kind: "message",
            T: EACEntry
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateEACEntryResponse
 */ export class CreateEACEntryResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateEACEntryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateEACEntryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateEACEntryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateEACEntryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.EACEntry eac_entry = 1;
   */ _define_property(this, "eacEntry", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateEACEntryResponse, "runtime", proto3);
_define_property(CreateEACEntryResponse, "typeName", "mono.datagateway.v1.CreateEACEntryResponse");
_define_property(CreateEACEntryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "eac_entry",
            kind: "message",
            T: EACEntry
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateEACEntryRequest
 */ export class UpdateEACEntryRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateEACEntryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateEACEntryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateEACEntryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateEACEntryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.EACEntry eac_entry = 1;
   */ _define_property(this, "eacEntry", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateEACEntryRequest, "runtime", proto3);
_define_property(UpdateEACEntryRequest, "typeName", "mono.datagateway.v1.UpdateEACEntryRequest");
_define_property(UpdateEACEntryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "eac_entry",
            kind: "message",
            T: EACEntry
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateEACEntryResponse
 */ export class UpdateEACEntryResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateEACEntryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateEACEntryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateEACEntryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateEACEntryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.EACEntry eac_entry = 1;
   */ _define_property(this, "eacEntry", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateEACEntryResponse, "runtime", proto3);
_define_property(UpdateEACEntryResponse, "typeName", "mono.datagateway.v1.UpdateEACEntryResponse");
_define_property(UpdateEACEntryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "eac_entry",
            kind: "message",
            T: EACEntry
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListEACEntriesRequest
 */ export class ListEACEntriesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListEACEntriesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListEACEntriesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListEACEntriesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListEACEntriesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.EACEntryFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListEACEntriesRequest, "runtime", proto3);
_define_property(ListEACEntriesRequest, "typeName", "mono.datagateway.v1.ListEACEntriesRequest");
_define_property(ListEACEntriesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: EACEntryFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListEACEntriesResponse
 */ export class ListEACEntriesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListEACEntriesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListEACEntriesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListEACEntriesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListEACEntriesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.EACEntry eac_entries = 1;
   */ _define_property(this, "eacEntries", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListEACEntriesResponse, "runtime", proto3);
_define_property(ListEACEntriesResponse, "typeName", "mono.datagateway.v1.ListEACEntriesResponse");
_define_property(ListEACEntriesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "eac_entries",
            kind: "message",
            T: EACEntry,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteEACEntryRequest
 */ export class DeleteEACEntryRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteEACEntryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteEACEntryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteEACEntryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteEACEntryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteEACEntryRequest, "runtime", proto3);
_define_property(DeleteEACEntryRequest, "typeName", "mono.datagateway.v1.DeleteEACEntryRequest");
_define_property(DeleteEACEntryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteEACEntryResponse
 */ export class DeleteEACEntryResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteEACEntryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteEACEntryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteEACEntryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteEACEntryResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteEACEntryResponse, "runtime", proto3);
_define_property(DeleteEACEntryResponse, "typeName", "mono.datagateway.v1.DeleteEACEntryResponse");
_define_property(DeleteEACEntryResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetProgramFinancialMonthRequest
 */ export class GetProgramFinancialMonthRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramFinancialMonthRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramFinancialMonthRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramFinancialMonthRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramFinancialMonthRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramFinancialMonthRequest, "runtime", proto3);
_define_property(GetProgramFinancialMonthRequest, "typeName", "mono.datagateway.v1.GetProgramFinancialMonthRequest");
_define_property(GetProgramFinancialMonthRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProgramFinancialMonthResponse
 */ export class GetProgramFinancialMonthResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramFinancialMonthResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramFinancialMonthResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramFinancialMonthResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramFinancialMonthResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramFinancialMonth program_financial_month = 1;
   */ _define_property(this, "programFinancialMonth", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramFinancialMonthResponse, "runtime", proto3);
_define_property(GetProgramFinancialMonthResponse, "typeName", "mono.datagateway.v1.GetProgramFinancialMonthResponse");
_define_property(GetProgramFinancialMonthResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_financial_month",
            kind: "message",
            T: ProgramFinancialMonth
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertProgramFinancialMonthRequest
 */ export class UpsertProgramFinancialMonthRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertProgramFinancialMonthRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertProgramFinancialMonthRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertProgramFinancialMonthRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertProgramFinancialMonthRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramFinancialMonth program_financial_month = 1;
   */ _define_property(this, "programFinancialMonth", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertProgramFinancialMonthRequest, "runtime", proto3);
_define_property(UpsertProgramFinancialMonthRequest, "typeName", "mono.datagateway.v1.UpsertProgramFinancialMonthRequest");
_define_property(UpsertProgramFinancialMonthRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_financial_month",
            kind: "message",
            T: ProgramFinancialMonth
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertProgramFinancialMonthResponse
 */ export class UpsertProgramFinancialMonthResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertProgramFinancialMonthResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertProgramFinancialMonthResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertProgramFinancialMonthResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertProgramFinancialMonthResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramFinancialMonth program_financial_month = 1;
   */ _define_property(this, "programFinancialMonth", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertProgramFinancialMonthResponse, "runtime", proto3);
_define_property(UpsertProgramFinancialMonthResponse, "typeName", "mono.datagateway.v1.UpsertProgramFinancialMonthResponse");
_define_property(UpsertProgramFinancialMonthResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_financial_month",
            kind: "message",
            T: ProgramFinancialMonth
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramFinancialMonthsRequest
 */ export class ListProgramFinancialMonthsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramFinancialMonthsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramFinancialMonthsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramFinancialMonthsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramFinancialMonthsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramFinancialMonthFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramFinancialMonthsRequest, "runtime", proto3);
_define_property(ListProgramFinancialMonthsRequest, "typeName", "mono.datagateway.v1.ListProgramFinancialMonthsRequest");
_define_property(ListProgramFinancialMonthsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: ProgramFinancialMonthFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramFinancialMonthsResponse
 */ export class ListProgramFinancialMonthsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramFinancialMonthsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramFinancialMonthsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramFinancialMonthsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramFinancialMonthsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ProgramFinancialMonth program_financial_months = 1;
   */ _define_property(this, "programFinancialMonths", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramFinancialMonthsResponse, "runtime", proto3);
_define_property(ListProgramFinancialMonthsResponse, "typeName", "mono.datagateway.v1.ListProgramFinancialMonthsResponse");
_define_property(ListProgramFinancialMonthsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_financial_months",
            kind: "message",
            T: ProgramFinancialMonth,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteProgramFinancialMonthRequest
 */ export class DeleteProgramFinancialMonthRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramFinancialMonthRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramFinancialMonthRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramFinancialMonthRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramFinancialMonthRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramFinancialMonthRequest, "runtime", proto3);
_define_property(DeleteProgramFinancialMonthRequest, "typeName", "mono.datagateway.v1.DeleteProgramFinancialMonthRequest");
_define_property(DeleteProgramFinancialMonthRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteProgramFinancialMonthResponse
 */ export class DeleteProgramFinancialMonthResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramFinancialMonthResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramFinancialMonthResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramFinancialMonthResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramFinancialMonthResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramFinancialMonthResponse, "runtime", proto3);
_define_property(DeleteProgramFinancialMonthResponse, "typeName", "mono.datagateway.v1.DeleteProgramFinancialMonthResponse");
_define_property(DeleteProgramFinancialMonthResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * ProgramOrderCeiling is one document's value of one order ceiling. The
 * last of a kind, in document order, is the current one.
 *
 * @generated from message mono.datagateway.v1.ProgramOrderCeiling
 */ export class ProgramOrderCeiling extends Message {
    static fromBinary(bytes, options) {
        return new ProgramOrderCeiling().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramOrderCeiling().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramOrderCeiling().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramOrderCeiling, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string kind = 3;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: double ceiling_amount = 4;
   */ _define_property(this, "ceilingAmount", 0), /**
   * "award", or the modification number that states it.
   *
   * @generated from field: string source_ref = 5;
   */ _define_property(this, "sourceRef", ""), /**
   * ISO date the stating document takes effect; empty when unstated.
   *
   * @generated from field: string effective_date = 6;
   */ _define_property(this, "effectiveDate", ""), /**
   * @generated from field: string source_artifact_id = 7;
   */ _define_property(this, "sourceArtifactId", ""), /**
   * @generated from field: int32 source_page = 8;
   */ _define_property(this, "sourcePage", 0), /**
   * @generated from field: string source_quote = 9;
   */ _define_property(this, "sourceQuote", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramOrderCeiling, "runtime", proto3);
_define_property(ProgramOrderCeiling, "typeName", "mono.datagateway.v1.ProgramOrderCeiling");
_define_property(ProgramOrderCeiling, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "ceiling_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "source_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "effective_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "source_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "source_page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "source_quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramOrderCeilingsRequest
 */ export class ListProgramOrderCeilingsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramOrderCeilingsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramOrderCeilingsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramOrderCeilingsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramOrderCeilingsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramOrderCeilingsRequest, "runtime", proto3);
_define_property(ListProgramOrderCeilingsRequest, "typeName", "mono.datagateway.v1.ListProgramOrderCeilingsRequest");
_define_property(ListProgramOrderCeilingsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramOrderCeilingsResponse
 */ export class ListProgramOrderCeilingsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramOrderCeilingsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramOrderCeilingsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramOrderCeilingsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramOrderCeilingsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ProgramOrderCeiling ceilings = 1;
   */ _define_property(this, "ceilings", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramOrderCeilingsResponse, "runtime", proto3);
_define_property(ListProgramOrderCeilingsResponse, "typeName", "mono.datagateway.v1.ListProgramOrderCeilingsResponse");
_define_property(ListProgramOrderCeilingsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "ceilings",
            kind: "message",
            T: ProgramOrderCeiling,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCPARSScoreRequest
 */ export class GetCPARSScoreRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCPARSScoreRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCPARSScoreRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCPARSScoreRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCPARSScoreRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCPARSScoreRequest, "runtime", proto3);
_define_property(GetCPARSScoreRequest, "typeName", "mono.datagateway.v1.GetCPARSScoreRequest");
_define_property(GetCPARSScoreRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCPARSScoreResponse
 */ export class GetCPARSScoreResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCPARSScoreResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCPARSScoreResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCPARSScoreResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCPARSScoreResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CPARSScore cpars_score = 1;
   */ _define_property(this, "cparsScore", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCPARSScoreResponse, "runtime", proto3);
_define_property(GetCPARSScoreResponse, "typeName", "mono.datagateway.v1.GetCPARSScoreResponse");
_define_property(GetCPARSScoreResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "cpars_score",
            kind: "message",
            T: CPARSScore
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateCPARSScoreRequest
 */ export class CreateCPARSScoreRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateCPARSScoreRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCPARSScoreRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCPARSScoreRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCPARSScoreRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CPARSScore cpars_score = 1;
   */ _define_property(this, "cparsScore", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCPARSScoreRequest, "runtime", proto3);
_define_property(CreateCPARSScoreRequest, "typeName", "mono.datagateway.v1.CreateCPARSScoreRequest");
_define_property(CreateCPARSScoreRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "cpars_score",
            kind: "message",
            T: CPARSScore
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateCPARSScoreResponse
 */ export class CreateCPARSScoreResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateCPARSScoreResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCPARSScoreResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCPARSScoreResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCPARSScoreResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CPARSScore cpars_score = 1;
   */ _define_property(this, "cparsScore", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCPARSScoreResponse, "runtime", proto3);
_define_property(CreateCPARSScoreResponse, "typeName", "mono.datagateway.v1.CreateCPARSScoreResponse");
_define_property(CreateCPARSScoreResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "cpars_score",
            kind: "message",
            T: CPARSScore
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateCPARSScoreRequest
 */ export class UpdateCPARSScoreRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCPARSScoreRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCPARSScoreRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCPARSScoreRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCPARSScoreRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CPARSScore cpars_score = 1;
   */ _define_property(this, "cparsScore", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCPARSScoreRequest, "runtime", proto3);
_define_property(UpdateCPARSScoreRequest, "typeName", "mono.datagateway.v1.UpdateCPARSScoreRequest");
_define_property(UpdateCPARSScoreRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "cpars_score",
            kind: "message",
            T: CPARSScore
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateCPARSScoreResponse
 */ export class UpdateCPARSScoreResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCPARSScoreResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCPARSScoreResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCPARSScoreResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCPARSScoreResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CPARSScore cpars_score = 1;
   */ _define_property(this, "cparsScore", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCPARSScoreResponse, "runtime", proto3);
_define_property(UpdateCPARSScoreResponse, "typeName", "mono.datagateway.v1.UpdateCPARSScoreResponse");
_define_property(UpdateCPARSScoreResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "cpars_score",
            kind: "message",
            T: CPARSScore
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCPARSScoresRequest
 */ export class ListCPARSScoresRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCPARSScoresRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCPARSScoresRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCPARSScoresRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCPARSScoresRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CPARSScoreFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCPARSScoresRequest, "runtime", proto3);
_define_property(ListCPARSScoresRequest, "typeName", "mono.datagateway.v1.ListCPARSScoresRequest");
_define_property(ListCPARSScoresRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: CPARSScoreFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCPARSScoresResponse
 */ export class ListCPARSScoresResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCPARSScoresResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCPARSScoresResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCPARSScoresResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCPARSScoresResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CPARSScore cpars_scores = 1;
   */ _define_property(this, "cparsScores", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCPARSScoresResponse, "runtime", proto3);
_define_property(ListCPARSScoresResponse, "typeName", "mono.datagateway.v1.ListCPARSScoresResponse");
_define_property(ListCPARSScoresResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "cpars_scores",
            kind: "message",
            T: CPARSScore,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCPARSScoreRequest
 */ export class DeleteCPARSScoreRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCPARSScoreRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCPARSScoreRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCPARSScoreRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCPARSScoreRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCPARSScoreRequest, "runtime", proto3);
_define_property(DeleteCPARSScoreRequest, "typeName", "mono.datagateway.v1.DeleteCPARSScoreRequest");
_define_property(DeleteCPARSScoreRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCPARSScoreResponse
 */ export class DeleteCPARSScoreResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCPARSScoreResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCPARSScoreResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCPARSScoreResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCPARSScoreResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCPARSScoreResponse, "runtime", proto3);
_define_property(DeleteCPARSScoreResponse, "typeName", "mono.datagateway.v1.DeleteCPARSScoreResponse");
_define_property(DeleteCPARSScoreResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetQASPScoreRequest
 */ export class GetQASPScoreRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetQASPScoreRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetQASPScoreRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetQASPScoreRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetQASPScoreRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetQASPScoreRequest, "runtime", proto3);
_define_property(GetQASPScoreRequest, "typeName", "mono.datagateway.v1.GetQASPScoreRequest");
_define_property(GetQASPScoreRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetQASPScoreResponse
 */ export class GetQASPScoreResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetQASPScoreResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetQASPScoreResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetQASPScoreResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetQASPScoreResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.QASPScore qasp_score = 1;
   */ _define_property(this, "qaspScore", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetQASPScoreResponse, "runtime", proto3);
_define_property(GetQASPScoreResponse, "typeName", "mono.datagateway.v1.GetQASPScoreResponse");
_define_property(GetQASPScoreResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "qasp_score",
            kind: "message",
            T: QASPScore
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateQASPScoreRequest
 */ export class CreateQASPScoreRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateQASPScoreRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateQASPScoreRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateQASPScoreRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateQASPScoreRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.QASPScore qasp_score = 1;
   */ _define_property(this, "qaspScore", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateQASPScoreRequest, "runtime", proto3);
_define_property(CreateQASPScoreRequest, "typeName", "mono.datagateway.v1.CreateQASPScoreRequest");
_define_property(CreateQASPScoreRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "qasp_score",
            kind: "message",
            T: QASPScore
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateQASPScoreResponse
 */ export class CreateQASPScoreResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateQASPScoreResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateQASPScoreResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateQASPScoreResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateQASPScoreResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.QASPScore qasp_score = 1;
   */ _define_property(this, "qaspScore", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateQASPScoreResponse, "runtime", proto3);
_define_property(CreateQASPScoreResponse, "typeName", "mono.datagateway.v1.CreateQASPScoreResponse");
_define_property(CreateQASPScoreResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "qasp_score",
            kind: "message",
            T: QASPScore
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateQASPScoreRequest
 */ export class UpdateQASPScoreRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateQASPScoreRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateQASPScoreRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateQASPScoreRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateQASPScoreRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.QASPScore qasp_score = 1;
   */ _define_property(this, "qaspScore", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateQASPScoreRequest, "runtime", proto3);
_define_property(UpdateQASPScoreRequest, "typeName", "mono.datagateway.v1.UpdateQASPScoreRequest");
_define_property(UpdateQASPScoreRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "qasp_score",
            kind: "message",
            T: QASPScore
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateQASPScoreResponse
 */ export class UpdateQASPScoreResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateQASPScoreResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateQASPScoreResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateQASPScoreResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateQASPScoreResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.QASPScore qasp_score = 1;
   */ _define_property(this, "qaspScore", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateQASPScoreResponse, "runtime", proto3);
_define_property(UpdateQASPScoreResponse, "typeName", "mono.datagateway.v1.UpdateQASPScoreResponse");
_define_property(UpdateQASPScoreResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "qasp_score",
            kind: "message",
            T: QASPScore
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListQASPScoresRequest
 */ export class ListQASPScoresRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListQASPScoresRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListQASPScoresRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListQASPScoresRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListQASPScoresRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.QASPScoreFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListQASPScoresRequest, "runtime", proto3);
_define_property(ListQASPScoresRequest, "typeName", "mono.datagateway.v1.ListQASPScoresRequest");
_define_property(ListQASPScoresRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: QASPScoreFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListQASPScoresResponse
 */ export class ListQASPScoresResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListQASPScoresResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListQASPScoresResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListQASPScoresResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListQASPScoresResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.QASPScore qasp_scores = 1;
   */ _define_property(this, "qaspScores", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListQASPScoresResponse, "runtime", proto3);
_define_property(ListQASPScoresResponse, "typeName", "mono.datagateway.v1.ListQASPScoresResponse");
_define_property(ListQASPScoresResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "qasp_scores",
            kind: "message",
            T: QASPScore,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteQASPScoreRequest
 */ export class DeleteQASPScoreRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteQASPScoreRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteQASPScoreRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteQASPScoreRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteQASPScoreRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteQASPScoreRequest, "runtime", proto3);
_define_property(DeleteQASPScoreRequest, "typeName", "mono.datagateway.v1.DeleteQASPScoreRequest");
_define_property(DeleteQASPScoreRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteQASPScoreResponse
 */ export class DeleteQASPScoreResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteQASPScoreResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteQASPScoreResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteQASPScoreResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteQASPScoreResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteQASPScoreResponse, "runtime", proto3);
_define_property(DeleteQASPScoreResponse, "typeName", "mono.datagateway.v1.DeleteQASPScoreResponse");
_define_property(DeleteQASPScoreResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetRiskRequest
 */ export class GetRiskRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetRiskRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRiskRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRiskRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRiskRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRiskRequest, "runtime", proto3);
_define_property(GetRiskRequest, "typeName", "mono.datagateway.v1.GetRiskRequest");
_define_property(GetRiskRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetRiskResponse
 */ export class GetRiskResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetRiskResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRiskResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRiskResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRiskResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Risk risk = 1;
   */ _define_property(this, "risk", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRiskResponse, "runtime", proto3);
_define_property(GetRiskResponse, "typeName", "mono.datagateway.v1.GetRiskResponse");
_define_property(GetRiskResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "risk",
            kind: "message",
            T: Risk
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateRiskRequest
 */ export class CreateRiskRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateRiskRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRiskRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRiskRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRiskRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Risk risk = 1;
   */ _define_property(this, "risk", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRiskRequest, "runtime", proto3);
_define_property(CreateRiskRequest, "typeName", "mono.datagateway.v1.CreateRiskRequest");
_define_property(CreateRiskRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "risk",
            kind: "message",
            T: Risk
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateRiskResponse
 */ export class CreateRiskResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateRiskResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRiskResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRiskResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRiskResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Risk risk = 1;
   */ _define_property(this, "risk", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRiskResponse, "runtime", proto3);
_define_property(CreateRiskResponse, "typeName", "mono.datagateway.v1.CreateRiskResponse");
_define_property(CreateRiskResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "risk",
            kind: "message",
            T: Risk
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateRiskRequest
 */ export class UpdateRiskRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateRiskRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateRiskRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateRiskRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateRiskRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Risk risk = 1;
   */ _define_property(this, "risk", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateRiskRequest, "runtime", proto3);
_define_property(UpdateRiskRequest, "typeName", "mono.datagateway.v1.UpdateRiskRequest");
_define_property(UpdateRiskRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "risk",
            kind: "message",
            T: Risk
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateRiskResponse
 */ export class UpdateRiskResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateRiskResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateRiskResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateRiskResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateRiskResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Risk risk = 1;
   */ _define_property(this, "risk", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateRiskResponse, "runtime", proto3);
_define_property(UpdateRiskResponse, "typeName", "mono.datagateway.v1.UpdateRiskResponse");
_define_property(UpdateRiskResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "risk",
            kind: "message",
            T: Risk
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRisksRequest
 */ export class ListRisksRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRisksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRisksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRisksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRisksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RiskFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRisksRequest, "runtime", proto3);
_define_property(ListRisksRequest, "typeName", "mono.datagateway.v1.ListRisksRequest");
_define_property(ListRisksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: RiskFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRisksResponse
 */ export class ListRisksResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRisksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRisksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRisksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRisksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.Risk risks = 1;
   */ _define_property(this, "risks", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRisksResponse, "runtime", proto3);
_define_property(ListRisksResponse, "typeName", "mono.datagateway.v1.ListRisksResponse");
_define_property(ListRisksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "risks",
            kind: "message",
            T: Risk,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteRiskRequest
 */ export class DeleteRiskRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteRiskRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteRiskRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteRiskRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteRiskRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteRiskRequest, "runtime", proto3);
_define_property(DeleteRiskRequest, "typeName", "mono.datagateway.v1.DeleteRiskRequest");
_define_property(DeleteRiskRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteRiskResponse
 */ export class DeleteRiskResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteRiskResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteRiskResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteRiskResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteRiskResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteRiskResponse, "runtime", proto3);
_define_property(DeleteRiskResponse, "typeName", "mono.datagateway.v1.DeleteRiskResponse");
_define_property(DeleteRiskResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.EscalateRiskToLeadershipRequest
 */ export class EscalateRiskToLeadershipRequest extends Message {
    static fromBinary(bytes, options) {
        return new EscalateRiskToLeadershipRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EscalateRiskToLeadershipRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EscalateRiskToLeadershipRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EscalateRiskToLeadershipRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EscalateRiskToLeadershipRequest, "runtime", proto3);
_define_property(EscalateRiskToLeadershipRequest, "typeName", "mono.datagateway.v1.EscalateRiskToLeadershipRequest");
_define_property(EscalateRiskToLeadershipRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.EscalateRiskToLeadershipResponse
 */ export class EscalateRiskToLeadershipResponse extends Message {
    static fromBinary(bytes, options) {
        return new EscalateRiskToLeadershipResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EscalateRiskToLeadershipResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EscalateRiskToLeadershipResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EscalateRiskToLeadershipResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Risk risk = 1;
   */ _define_property(this, "risk", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EscalateRiskToLeadershipResponse, "runtime", proto3);
_define_property(EscalateRiskToLeadershipResponse, "typeName", "mono.datagateway.v1.EscalateRiskToLeadershipResponse");
_define_property(EscalateRiskToLeadershipResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "risk",
            kind: "message",
            T: Risk
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetIssueRequest
 */ export class GetIssueRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetIssueRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetIssueRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetIssueRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetIssueRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetIssueRequest, "runtime", proto3);
_define_property(GetIssueRequest, "typeName", "mono.datagateway.v1.GetIssueRequest");
_define_property(GetIssueRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetIssueResponse
 */ export class GetIssueResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetIssueResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetIssueResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetIssueResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetIssueResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Issue issue = 1;
   */ _define_property(this, "issue", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetIssueResponse, "runtime", proto3);
_define_property(GetIssueResponse, "typeName", "mono.datagateway.v1.GetIssueResponse");
_define_property(GetIssueResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "issue",
            kind: "message",
            T: Issue
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateIssueRequest
 */ export class CreateIssueRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateIssueRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateIssueRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateIssueRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateIssueRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Issue issue = 1;
   */ _define_property(this, "issue", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateIssueRequest, "runtime", proto3);
_define_property(CreateIssueRequest, "typeName", "mono.datagateway.v1.CreateIssueRequest");
_define_property(CreateIssueRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "issue",
            kind: "message",
            T: Issue
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateIssueResponse
 */ export class CreateIssueResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateIssueResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateIssueResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateIssueResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateIssueResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Issue issue = 1;
   */ _define_property(this, "issue", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateIssueResponse, "runtime", proto3);
_define_property(CreateIssueResponse, "typeName", "mono.datagateway.v1.CreateIssueResponse");
_define_property(CreateIssueResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "issue",
            kind: "message",
            T: Issue
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateIssueRequest
 */ export class UpdateIssueRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateIssueRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateIssueRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateIssueRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateIssueRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Issue issue = 1;
   */ _define_property(this, "issue", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateIssueRequest, "runtime", proto3);
_define_property(UpdateIssueRequest, "typeName", "mono.datagateway.v1.UpdateIssueRequest");
_define_property(UpdateIssueRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "issue",
            kind: "message",
            T: Issue
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateIssueResponse
 */ export class UpdateIssueResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateIssueResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateIssueResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateIssueResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateIssueResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Issue issue = 1;
   */ _define_property(this, "issue", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateIssueResponse, "runtime", proto3);
_define_property(UpdateIssueResponse, "typeName", "mono.datagateway.v1.UpdateIssueResponse");
_define_property(UpdateIssueResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "issue",
            kind: "message",
            T: Issue
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListIssuesRequest
 */ export class ListIssuesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListIssuesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListIssuesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListIssuesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListIssuesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.IssueFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListIssuesRequest, "runtime", proto3);
_define_property(ListIssuesRequest, "typeName", "mono.datagateway.v1.ListIssuesRequest");
_define_property(ListIssuesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: IssueFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListIssuesResponse
 */ export class ListIssuesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListIssuesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListIssuesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListIssuesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListIssuesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.Issue issues = 1;
   */ _define_property(this, "issues", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListIssuesResponse, "runtime", proto3);
_define_property(ListIssuesResponse, "typeName", "mono.datagateway.v1.ListIssuesResponse");
_define_property(ListIssuesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "issues",
            kind: "message",
            T: Issue,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteIssueRequest
 */ export class DeleteIssueRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteIssueRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteIssueRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteIssueRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteIssueRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteIssueRequest, "runtime", proto3);
_define_property(DeleteIssueRequest, "typeName", "mono.datagateway.v1.DeleteIssueRequest");
_define_property(DeleteIssueRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteIssueResponse
 */ export class DeleteIssueResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteIssueResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteIssueResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteIssueResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteIssueResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteIssueResponse, "runtime", proto3);
_define_property(DeleteIssueResponse, "typeName", "mono.datagateway.v1.DeleteIssueResponse");
_define_property(DeleteIssueResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.CreateIssueCommentRequest
 */ export class CreateIssueCommentRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateIssueCommentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateIssueCommentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateIssueCommentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateIssueCommentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.IssueComment issue_comment = 1;
   */ _define_property(this, "issueComment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateIssueCommentRequest, "runtime", proto3);
_define_property(CreateIssueCommentRequest, "typeName", "mono.datagateway.v1.CreateIssueCommentRequest");
_define_property(CreateIssueCommentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "issue_comment",
            kind: "message",
            T: IssueComment
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateIssueCommentResponse
 */ export class CreateIssueCommentResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateIssueCommentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateIssueCommentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateIssueCommentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateIssueCommentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.IssueComment issue_comment = 1;
   */ _define_property(this, "issueComment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateIssueCommentResponse, "runtime", proto3);
_define_property(CreateIssueCommentResponse, "typeName", "mono.datagateway.v1.CreateIssueCommentResponse");
_define_property(CreateIssueCommentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "issue_comment",
            kind: "message",
            T: IssueComment
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListIssueCommentsRequest
 */ export class ListIssueCommentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListIssueCommentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListIssueCommentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListIssueCommentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListIssueCommentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.IssueCommentFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListIssueCommentsRequest, "runtime", proto3);
_define_property(ListIssueCommentsRequest, "typeName", "mono.datagateway.v1.ListIssueCommentsRequest");
_define_property(ListIssueCommentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: IssueCommentFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListIssueCommentsResponse
 */ export class ListIssueCommentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListIssueCommentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListIssueCommentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListIssueCommentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListIssueCommentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.IssueComment issue_comments = 1;
   */ _define_property(this, "issueComments", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListIssueCommentsResponse, "runtime", proto3);
_define_property(ListIssueCommentsResponse, "typeName", "mono.datagateway.v1.ListIssueCommentsResponse");
_define_property(ListIssueCommentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "issue_comments",
            kind: "message",
            T: IssueComment,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCustomerTouchpointRequest
 */ export class GetCustomerTouchpointRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCustomerTouchpointRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCustomerTouchpointRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCustomerTouchpointRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCustomerTouchpointRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCustomerTouchpointRequest, "runtime", proto3);
_define_property(GetCustomerTouchpointRequest, "typeName", "mono.datagateway.v1.GetCustomerTouchpointRequest");
_define_property(GetCustomerTouchpointRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCustomerTouchpointResponse
 */ export class GetCustomerTouchpointResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCustomerTouchpointResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCustomerTouchpointResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCustomerTouchpointResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCustomerTouchpointResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CustomerTouchpoint customer_touchpoint = 1;
   */ _define_property(this, "customerTouchpoint", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCustomerTouchpointResponse, "runtime", proto3);
_define_property(GetCustomerTouchpointResponse, "typeName", "mono.datagateway.v1.GetCustomerTouchpointResponse");
_define_property(GetCustomerTouchpointResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "customer_touchpoint",
            kind: "message",
            T: CustomerTouchpoint
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateCustomerTouchpointRequest
 */ export class CreateCustomerTouchpointRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateCustomerTouchpointRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCustomerTouchpointRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCustomerTouchpointRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCustomerTouchpointRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CustomerTouchpoint customer_touchpoint = 1;
   */ _define_property(this, "customerTouchpoint", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCustomerTouchpointRequest, "runtime", proto3);
_define_property(CreateCustomerTouchpointRequest, "typeName", "mono.datagateway.v1.CreateCustomerTouchpointRequest");
_define_property(CreateCustomerTouchpointRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "customer_touchpoint",
            kind: "message",
            T: CustomerTouchpoint
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateCustomerTouchpointResponse
 */ export class CreateCustomerTouchpointResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateCustomerTouchpointResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCustomerTouchpointResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCustomerTouchpointResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCustomerTouchpointResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CustomerTouchpoint customer_touchpoint = 1;
   */ _define_property(this, "customerTouchpoint", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCustomerTouchpointResponse, "runtime", proto3);
_define_property(CreateCustomerTouchpointResponse, "typeName", "mono.datagateway.v1.CreateCustomerTouchpointResponse");
_define_property(CreateCustomerTouchpointResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "customer_touchpoint",
            kind: "message",
            T: CustomerTouchpoint
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateCustomerTouchpointRequest
 */ export class UpdateCustomerTouchpointRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCustomerTouchpointRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCustomerTouchpointRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCustomerTouchpointRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCustomerTouchpointRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CustomerTouchpoint customer_touchpoint = 1;
   */ _define_property(this, "customerTouchpoint", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCustomerTouchpointRequest, "runtime", proto3);
_define_property(UpdateCustomerTouchpointRequest, "typeName", "mono.datagateway.v1.UpdateCustomerTouchpointRequest");
_define_property(UpdateCustomerTouchpointRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "customer_touchpoint",
            kind: "message",
            T: CustomerTouchpoint
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateCustomerTouchpointResponse
 */ export class UpdateCustomerTouchpointResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateCustomerTouchpointResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateCustomerTouchpointResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateCustomerTouchpointResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateCustomerTouchpointResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CustomerTouchpoint customer_touchpoint = 1;
   */ _define_property(this, "customerTouchpoint", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateCustomerTouchpointResponse, "runtime", proto3);
_define_property(UpdateCustomerTouchpointResponse, "typeName", "mono.datagateway.v1.UpdateCustomerTouchpointResponse");
_define_property(UpdateCustomerTouchpointResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "customer_touchpoint",
            kind: "message",
            T: CustomerTouchpoint
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCustomerTouchpointsRequest
 */ export class ListCustomerTouchpointsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCustomerTouchpointsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCustomerTouchpointsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCustomerTouchpointsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCustomerTouchpointsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CustomerTouchpointFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCustomerTouchpointsRequest, "runtime", proto3);
_define_property(ListCustomerTouchpointsRequest, "typeName", "mono.datagateway.v1.ListCustomerTouchpointsRequest");
_define_property(ListCustomerTouchpointsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: CustomerTouchpointFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCustomerTouchpointsResponse
 */ export class ListCustomerTouchpointsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCustomerTouchpointsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCustomerTouchpointsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCustomerTouchpointsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCustomerTouchpointsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CustomerTouchpoint customer_touchpoints = 1;
   */ _define_property(this, "customerTouchpoints", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCustomerTouchpointsResponse, "runtime", proto3);
_define_property(ListCustomerTouchpointsResponse, "typeName", "mono.datagateway.v1.ListCustomerTouchpointsResponse");
_define_property(ListCustomerTouchpointsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "customer_touchpoints",
            kind: "message",
            T: CustomerTouchpoint,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCustomerTouchpointRequest
 */ export class DeleteCustomerTouchpointRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCustomerTouchpointRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCustomerTouchpointRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCustomerTouchpointRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCustomerTouchpointRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCustomerTouchpointRequest, "runtime", proto3);
_define_property(DeleteCustomerTouchpointRequest, "typeName", "mono.datagateway.v1.DeleteCustomerTouchpointRequest");
_define_property(DeleteCustomerTouchpointRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCustomerTouchpointResponse
 */ export class DeleteCustomerTouchpointResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCustomerTouchpointResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCustomerTouchpointResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCustomerTouchpointResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCustomerTouchpointResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCustomerTouchpointResponse, "runtime", proto3);
_define_property(DeleteCustomerTouchpointResponse, "typeName", "mono.datagateway.v1.DeleteCustomerTouchpointResponse");
_define_property(DeleteCustomerTouchpointResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetGrowthOpportunityRequest
 */ export class GetGrowthOpportunityRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetGrowthOpportunityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetGrowthOpportunityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetGrowthOpportunityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetGrowthOpportunityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetGrowthOpportunityRequest, "runtime", proto3);
_define_property(GetGrowthOpportunityRequest, "typeName", "mono.datagateway.v1.GetGrowthOpportunityRequest");
_define_property(GetGrowthOpportunityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetGrowthOpportunityResponse
 */ export class GetGrowthOpportunityResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetGrowthOpportunityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetGrowthOpportunityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetGrowthOpportunityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetGrowthOpportunityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GrowthOpportunity growth_opportunity = 1;
   */ _define_property(this, "growthOpportunity", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetGrowthOpportunityResponse, "runtime", proto3);
_define_property(GetGrowthOpportunityResponse, "typeName", "mono.datagateway.v1.GetGrowthOpportunityResponse");
_define_property(GetGrowthOpportunityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "growth_opportunity",
            kind: "message",
            T: GrowthOpportunity
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateGrowthOpportunityRequest
 */ export class CreateGrowthOpportunityRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateGrowthOpportunityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateGrowthOpportunityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateGrowthOpportunityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateGrowthOpportunityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GrowthOpportunity growth_opportunity = 1;
   */ _define_property(this, "growthOpportunity", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateGrowthOpportunityRequest, "runtime", proto3);
_define_property(CreateGrowthOpportunityRequest, "typeName", "mono.datagateway.v1.CreateGrowthOpportunityRequest");
_define_property(CreateGrowthOpportunityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "growth_opportunity",
            kind: "message",
            T: GrowthOpportunity
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateGrowthOpportunityResponse
 */ export class CreateGrowthOpportunityResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateGrowthOpportunityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateGrowthOpportunityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateGrowthOpportunityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateGrowthOpportunityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GrowthOpportunity growth_opportunity = 1;
   */ _define_property(this, "growthOpportunity", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateGrowthOpportunityResponse, "runtime", proto3);
_define_property(CreateGrowthOpportunityResponse, "typeName", "mono.datagateway.v1.CreateGrowthOpportunityResponse");
_define_property(CreateGrowthOpportunityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "growth_opportunity",
            kind: "message",
            T: GrowthOpportunity
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateGrowthOpportunityRequest
 */ export class UpdateGrowthOpportunityRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateGrowthOpportunityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateGrowthOpportunityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateGrowthOpportunityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateGrowthOpportunityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GrowthOpportunity growth_opportunity = 1;
   */ _define_property(this, "growthOpportunity", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateGrowthOpportunityRequest, "runtime", proto3);
_define_property(UpdateGrowthOpportunityRequest, "typeName", "mono.datagateway.v1.UpdateGrowthOpportunityRequest");
_define_property(UpdateGrowthOpportunityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "growth_opportunity",
            kind: "message",
            T: GrowthOpportunity
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateGrowthOpportunityResponse
 */ export class UpdateGrowthOpportunityResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateGrowthOpportunityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateGrowthOpportunityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateGrowthOpportunityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateGrowthOpportunityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GrowthOpportunity growth_opportunity = 1;
   */ _define_property(this, "growthOpportunity", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateGrowthOpportunityResponse, "runtime", proto3);
_define_property(UpdateGrowthOpportunityResponse, "typeName", "mono.datagateway.v1.UpdateGrowthOpportunityResponse");
_define_property(UpdateGrowthOpportunityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "growth_opportunity",
            kind: "message",
            T: GrowthOpportunity
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListGrowthOpportunitiesRequest
 */ export class ListGrowthOpportunitiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListGrowthOpportunitiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListGrowthOpportunitiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListGrowthOpportunitiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListGrowthOpportunitiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GrowthOpportunityFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListGrowthOpportunitiesRequest, "runtime", proto3);
_define_property(ListGrowthOpportunitiesRequest, "typeName", "mono.datagateway.v1.ListGrowthOpportunitiesRequest");
_define_property(ListGrowthOpportunitiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: GrowthOpportunityFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListGrowthOpportunitiesResponse
 */ export class ListGrowthOpportunitiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListGrowthOpportunitiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListGrowthOpportunitiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListGrowthOpportunitiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListGrowthOpportunitiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.GrowthOpportunity growth_opportunities = 1;
   */ _define_property(this, "growthOpportunities", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListGrowthOpportunitiesResponse, "runtime", proto3);
_define_property(ListGrowthOpportunitiesResponse, "typeName", "mono.datagateway.v1.ListGrowthOpportunitiesResponse");
_define_property(ListGrowthOpportunitiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "growth_opportunities",
            kind: "message",
            T: GrowthOpportunity,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteGrowthOpportunityRequest
 */ export class DeleteGrowthOpportunityRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteGrowthOpportunityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteGrowthOpportunityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteGrowthOpportunityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteGrowthOpportunityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteGrowthOpportunityRequest, "runtime", proto3);
_define_property(DeleteGrowthOpportunityRequest, "typeName", "mono.datagateway.v1.DeleteGrowthOpportunityRequest");
_define_property(DeleteGrowthOpportunityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteGrowthOpportunityResponse
 */ export class DeleteGrowthOpportunityResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteGrowthOpportunityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteGrowthOpportunityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteGrowthOpportunityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteGrowthOpportunityResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteGrowthOpportunityResponse, "runtime", proto3);
_define_property(DeleteGrowthOpportunityResponse, "typeName", "mono.datagateway.v1.DeleteGrowthOpportunityResponse");
_define_property(DeleteGrowthOpportunityResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetSubcontractorReviewRequest
 */ export class GetSubcontractorReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetSubcontractorReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSubcontractorReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSubcontractorReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSubcontractorReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSubcontractorReviewRequest, "runtime", proto3);
_define_property(GetSubcontractorReviewRequest, "typeName", "mono.datagateway.v1.GetSubcontractorReviewRequest");
_define_property(GetSubcontractorReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetSubcontractorReviewResponse
 */ export class GetSubcontractorReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetSubcontractorReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetSubcontractorReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetSubcontractorReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetSubcontractorReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SubcontractorReview subcontractor_review = 1;
   */ _define_property(this, "subcontractorReview", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetSubcontractorReviewResponse, "runtime", proto3);
_define_property(GetSubcontractorReviewResponse, "typeName", "mono.datagateway.v1.GetSubcontractorReviewResponse");
_define_property(GetSubcontractorReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "subcontractor_review",
            kind: "message",
            T: SubcontractorReview
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateSubcontractorReviewRequest
 */ export class CreateSubcontractorReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateSubcontractorReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateSubcontractorReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateSubcontractorReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateSubcontractorReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SubcontractorReview subcontractor_review = 1;
   */ _define_property(this, "subcontractorReview", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateSubcontractorReviewRequest, "runtime", proto3);
_define_property(CreateSubcontractorReviewRequest, "typeName", "mono.datagateway.v1.CreateSubcontractorReviewRequest");
_define_property(CreateSubcontractorReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "subcontractor_review",
            kind: "message",
            T: SubcontractorReview
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateSubcontractorReviewResponse
 */ export class CreateSubcontractorReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateSubcontractorReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateSubcontractorReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateSubcontractorReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateSubcontractorReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SubcontractorReview subcontractor_review = 1;
   */ _define_property(this, "subcontractorReview", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateSubcontractorReviewResponse, "runtime", proto3);
_define_property(CreateSubcontractorReviewResponse, "typeName", "mono.datagateway.v1.CreateSubcontractorReviewResponse");
_define_property(CreateSubcontractorReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "subcontractor_review",
            kind: "message",
            T: SubcontractorReview
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateSubcontractorReviewRequest
 */ export class UpdateSubcontractorReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateSubcontractorReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateSubcontractorReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateSubcontractorReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateSubcontractorReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SubcontractorReview subcontractor_review = 1;
   */ _define_property(this, "subcontractorReview", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateSubcontractorReviewRequest, "runtime", proto3);
_define_property(UpdateSubcontractorReviewRequest, "typeName", "mono.datagateway.v1.UpdateSubcontractorReviewRequest");
_define_property(UpdateSubcontractorReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "subcontractor_review",
            kind: "message",
            T: SubcontractorReview
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateSubcontractorReviewResponse
 */ export class UpdateSubcontractorReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateSubcontractorReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateSubcontractorReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateSubcontractorReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateSubcontractorReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SubcontractorReview subcontractor_review = 1;
   */ _define_property(this, "subcontractorReview", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateSubcontractorReviewResponse, "runtime", proto3);
_define_property(UpdateSubcontractorReviewResponse, "typeName", "mono.datagateway.v1.UpdateSubcontractorReviewResponse");
_define_property(UpdateSubcontractorReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "subcontractor_review",
            kind: "message",
            T: SubcontractorReview
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListSubcontractorReviewsRequest
 */ export class ListSubcontractorReviewsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListSubcontractorReviewsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSubcontractorReviewsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSubcontractorReviewsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSubcontractorReviewsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.SubcontractorReviewFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSubcontractorReviewsRequest, "runtime", proto3);
_define_property(ListSubcontractorReviewsRequest, "typeName", "mono.datagateway.v1.ListSubcontractorReviewsRequest");
_define_property(ListSubcontractorReviewsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: SubcontractorReviewFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListSubcontractorReviewsResponse
 */ export class ListSubcontractorReviewsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListSubcontractorReviewsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSubcontractorReviewsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSubcontractorReviewsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSubcontractorReviewsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.SubcontractorReview subcontractor_reviews = 1;
   */ _define_property(this, "subcontractorReviews", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSubcontractorReviewsResponse, "runtime", proto3);
_define_property(ListSubcontractorReviewsResponse, "typeName", "mono.datagateway.v1.ListSubcontractorReviewsResponse");
_define_property(ListSubcontractorReviewsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "subcontractor_reviews",
            kind: "message",
            T: SubcontractorReview,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteSubcontractorReviewRequest
 */ export class DeleteSubcontractorReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteSubcontractorReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteSubcontractorReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteSubcontractorReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteSubcontractorReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteSubcontractorReviewRequest, "runtime", proto3);
_define_property(DeleteSubcontractorReviewRequest, "typeName", "mono.datagateway.v1.DeleteSubcontractorReviewRequest");
_define_property(DeleteSubcontractorReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteSubcontractorReviewResponse
 */ export class DeleteSubcontractorReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteSubcontractorReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteSubcontractorReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteSubcontractorReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteSubcontractorReviewResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteSubcontractorReviewResponse, "runtime", proto3);
_define_property(DeleteSubcontractorReviewResponse, "typeName", "mono.datagateway.v1.DeleteSubcontractorReviewResponse");
_define_property(DeleteSubcontractorReviewResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetProgramDocumentRequest
 */ export class GetProgramDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramDocumentRequest, "runtime", proto3);
_define_property(GetProgramDocumentRequest, "typeName", "mono.datagateway.v1.GetProgramDocumentRequest");
_define_property(GetProgramDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProgramDocumentResponse
 */ export class GetProgramDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramDocument program_document = 1;
   */ _define_property(this, "programDocument", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramDocumentResponse, "runtime", proto3);
_define_property(GetProgramDocumentResponse, "typeName", "mono.datagateway.v1.GetProgramDocumentResponse");
_define_property(GetProgramDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_document",
            kind: "message",
            T: ProgramDocument
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateProgramDocumentRequest
 */ export class CreateProgramDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateProgramDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProgramDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProgramDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProgramDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramDocument program_document = 1;
   */ _define_property(this, "programDocument", void 0), /**
   * When the (program, artifact) pair exists but was tombstoned by a user
   * removal, clear the tombstone (a HUMAN re-adding the document). The
   * pipeline's service lane never sets this, so automatic linking cannot
   * undo a removal.
   *
   * @generated from field: bool resurrect_removed = 2;
   */ _define_property(this, "resurrectRemoved", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProgramDocumentRequest, "runtime", proto3);
_define_property(CreateProgramDocumentRequest, "typeName", "mono.datagateway.v1.CreateProgramDocumentRequest");
_define_property(CreateProgramDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_document",
            kind: "message",
            T: ProgramDocument
        },
        {
            no: 2,
            name: "resurrect_removed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateProgramDocumentResponse
 */ export class CreateProgramDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateProgramDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProgramDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProgramDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProgramDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramDocument program_document = 1;
   */ _define_property(this, "programDocument", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProgramDocumentResponse, "runtime", proto3);
_define_property(CreateProgramDocumentResponse, "typeName", "mono.datagateway.v1.CreateProgramDocumentResponse");
_define_property(CreateProgramDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_document",
            kind: "message",
            T: ProgramDocument
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateProgramDocumentRequest
 */ export class UpdateProgramDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProgramDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProgramDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProgramDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProgramDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramDocument program_document = 1;
   */ _define_property(this, "programDocument", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProgramDocumentRequest, "runtime", proto3);
_define_property(UpdateProgramDocumentRequest, "typeName", "mono.datagateway.v1.UpdateProgramDocumentRequest");
_define_property(UpdateProgramDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_document",
            kind: "message",
            T: ProgramDocument
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateProgramDocumentResponse
 */ export class UpdateProgramDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProgramDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProgramDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProgramDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProgramDocumentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramDocument program_document = 1;
   */ _define_property(this, "programDocument", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProgramDocumentResponse, "runtime", proto3);
_define_property(UpdateProgramDocumentResponse, "typeName", "mono.datagateway.v1.UpdateProgramDocumentResponse");
_define_property(UpdateProgramDocumentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_document",
            kind: "message",
            T: ProgramDocument
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramDocumentsRequest
 */ export class ListProgramDocumentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramDocumentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramDocumentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramDocumentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramDocumentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramDocumentFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramDocumentsRequest, "runtime", proto3);
_define_property(ListProgramDocumentsRequest, "typeName", "mono.datagateway.v1.ListProgramDocumentsRequest");
_define_property(ListProgramDocumentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: ProgramDocumentFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramDocumentsResponse
 */ export class ListProgramDocumentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramDocumentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramDocumentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramDocumentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramDocumentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ProgramDocument program_documents = 1;
   */ _define_property(this, "programDocuments", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramDocumentsResponse, "runtime", proto3);
_define_property(ListProgramDocumentsResponse, "typeName", "mono.datagateway.v1.ListProgramDocumentsResponse");
_define_property(ListProgramDocumentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_documents",
            kind: "message",
            T: ProgramDocument,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteProgramDocumentRequest
 */ export class DeleteProgramDocumentRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramDocumentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramDocumentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramDocumentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramDocumentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramDocumentRequest, "runtime", proto3);
_define_property(DeleteProgramDocumentRequest, "typeName", "mono.datagateway.v1.DeleteProgramDocumentRequest");
_define_property(DeleteProgramDocumentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteProgramDocumentResponse
 */ export class DeleteProgramDocumentResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramDocumentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramDocumentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramDocumentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramDocumentResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramDocumentResponse, "runtime", proto3);
_define_property(DeleteProgramDocumentResponse, "typeName", "mono.datagateway.v1.DeleteProgramDocumentResponse");
_define_property(DeleteProgramDocumentResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.SetProgramDocumentTagsRequest
 */ export class SetProgramDocumentTagsRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetProgramDocumentTagsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetProgramDocumentTagsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetProgramDocumentTagsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetProgramDocumentTagsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: repeated string tags = 3;
   */ _define_property(this, "tags", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetProgramDocumentTagsRequest, "runtime", proto3);
_define_property(SetProgramDocumentTagsRequest, "typeName", "mono.datagateway.v1.SetProgramDocumentTagsRequest");
_define_property(SetProgramDocumentTagsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "tags",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetProgramDocumentTagsResponse
 */ export class SetProgramDocumentTagsResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetProgramDocumentTagsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetProgramDocumentTagsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetProgramDocumentTagsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetProgramDocumentTagsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramDocument program_document = 1;
   */ _define_property(this, "programDocument", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetProgramDocumentTagsResponse, "runtime", proto3);
_define_property(SetProgramDocumentTagsResponse, "typeName", "mono.datagateway.v1.SetProgramDocumentTagsResponse");
_define_property(SetProgramDocumentTagsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_document",
            kind: "message",
            T: ProgramDocument
        }
    ]));
/**
 * Records the processing outcome of the program's document for artifact_id.
 *
 * @generated from message mono.datagateway.v1.SetProgramDocumentProcessingRequest
 */ export class SetProgramDocumentProcessingRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetProgramDocumentProcessingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetProgramDocumentProcessingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetProgramDocumentProcessingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetProgramDocumentProcessingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string artifact_id = 3;
   */ _define_property(this, "artifactId", ""), /**
   * "processing", "ready" or "failed"
   *
   * @generated from field: string status = 4;
   */ _define_property(this, "status", ""), /**
   * plain reason; kept only when failed
   *
   * @generated from field: string reason = 5;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetProgramDocumentProcessingRequest, "runtime", proto3);
_define_property(SetProgramDocumentProcessingRequest, "typeName", "mono.datagateway.v1.SetProgramDocumentProcessingRequest");
_define_property(SetProgramDocumentProcessingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetProgramDocumentProcessingResponse
 */ export class SetProgramDocumentProcessingResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetProgramDocumentProcessingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetProgramDocumentProcessingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetProgramDocumentProcessingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetProgramDocumentProcessingResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetProgramDocumentProcessingResponse, "runtime", proto3);
_define_property(SetProgramDocumentProcessingResponse, "typeName", "mono.datagateway.v1.SetProgramDocumentProcessingResponse");
_define_property(SetProgramDocumentProcessingResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetProgramModificationRequest
 */ export class GetProgramModificationRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramModificationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramModificationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramModificationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramModificationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramModificationRequest, "runtime", proto3);
_define_property(GetProgramModificationRequest, "typeName", "mono.datagateway.v1.GetProgramModificationRequest");
_define_property(GetProgramModificationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProgramModificationResponse
 */ export class GetProgramModificationResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramModificationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramModificationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramModificationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramModificationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramModification program_modification = 1;
   */ _define_property(this, "programModification", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramModificationResponse, "runtime", proto3);
_define_property(GetProgramModificationResponse, "typeName", "mono.datagateway.v1.GetProgramModificationResponse");
_define_property(GetProgramModificationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_modification",
            kind: "message",
            T: ProgramModification
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateProgramModificationRequest
 */ export class CreateProgramModificationRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateProgramModificationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProgramModificationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProgramModificationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProgramModificationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramModification program_modification = 1;
   */ _define_property(this, "programModification", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProgramModificationRequest, "runtime", proto3);
_define_property(CreateProgramModificationRequest, "typeName", "mono.datagateway.v1.CreateProgramModificationRequest");
_define_property(CreateProgramModificationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_modification",
            kind: "message",
            T: ProgramModification
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateProgramModificationResponse
 */ export class CreateProgramModificationResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateProgramModificationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProgramModificationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProgramModificationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProgramModificationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramModification program_modification = 1;
   */ _define_property(this, "programModification", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProgramModificationResponse, "runtime", proto3);
_define_property(CreateProgramModificationResponse, "typeName", "mono.datagateway.v1.CreateProgramModificationResponse");
_define_property(CreateProgramModificationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_modification",
            kind: "message",
            T: ProgramModification
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateProgramModificationRequest
 */ export class UpdateProgramModificationRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProgramModificationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProgramModificationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProgramModificationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProgramModificationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramModification program_modification = 1;
   */ _define_property(this, "programModification", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProgramModificationRequest, "runtime", proto3);
_define_property(UpdateProgramModificationRequest, "typeName", "mono.datagateway.v1.UpdateProgramModificationRequest");
_define_property(UpdateProgramModificationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_modification",
            kind: "message",
            T: ProgramModification
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateProgramModificationResponse
 */ export class UpdateProgramModificationResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProgramModificationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProgramModificationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProgramModificationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProgramModificationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramModification program_modification = 1;
   */ _define_property(this, "programModification", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProgramModificationResponse, "runtime", proto3);
_define_property(UpdateProgramModificationResponse, "typeName", "mono.datagateway.v1.UpdateProgramModificationResponse");
_define_property(UpdateProgramModificationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_modification",
            kind: "message",
            T: ProgramModification
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramModificationsRequest
 */ export class ListProgramModificationsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramModificationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramModificationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramModificationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramModificationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramModificationFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramModificationsRequest, "runtime", proto3);
_define_property(ListProgramModificationsRequest, "typeName", "mono.datagateway.v1.ListProgramModificationsRequest");
_define_property(ListProgramModificationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: ProgramModificationFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramModificationsResponse
 */ export class ListProgramModificationsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramModificationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramModificationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramModificationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramModificationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ProgramModification program_modifications = 1;
   */ _define_property(this, "programModifications", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramModificationsResponse, "runtime", proto3);
_define_property(ListProgramModificationsResponse, "typeName", "mono.datagateway.v1.ListProgramModificationsResponse");
_define_property(ListProgramModificationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_modifications",
            kind: "message",
            T: ProgramModification,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteProgramModificationRequest
 */ export class DeleteProgramModificationRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramModificationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramModificationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramModificationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramModificationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramModificationRequest, "runtime", proto3);
_define_property(DeleteProgramModificationRequest, "typeName", "mono.datagateway.v1.DeleteProgramModificationRequest");
_define_property(DeleteProgramModificationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteProgramModificationResponse
 */ export class DeleteProgramModificationResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramModificationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramModificationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramModificationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramModificationResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramModificationResponse, "runtime", proto3);
_define_property(DeleteProgramModificationResponse, "typeName", "mono.datagateway.v1.DeleteProgramModificationResponse");
_define_property(DeleteProgramModificationResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetAuditTemplateRequest
 */ export class GetAuditTemplateRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetAuditTemplateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAuditTemplateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAuditTemplateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAuditTemplateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetAuditTemplateRequest, "runtime", proto3);
_define_property(GetAuditTemplateRequest, "typeName", "mono.datagateway.v1.GetAuditTemplateRequest");
_define_property(GetAuditTemplateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetAuditTemplateResponse
 */ export class GetAuditTemplateResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetAuditTemplateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAuditTemplateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAuditTemplateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAuditTemplateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AuditTemplate audit_template = 1;
   */ _define_property(this, "auditTemplate", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetAuditTemplateResponse, "runtime", proto3);
_define_property(GetAuditTemplateResponse, "typeName", "mono.datagateway.v1.GetAuditTemplateResponse");
_define_property(GetAuditTemplateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit_template",
            kind: "message",
            T: AuditTemplate
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateAuditTemplateRequest
 */ export class CreateAuditTemplateRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateAuditTemplateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateAuditTemplateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateAuditTemplateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateAuditTemplateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AuditTemplate audit_template = 1;
   */ _define_property(this, "auditTemplate", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateAuditTemplateRequest, "runtime", proto3);
_define_property(CreateAuditTemplateRequest, "typeName", "mono.datagateway.v1.CreateAuditTemplateRequest");
_define_property(CreateAuditTemplateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit_template",
            kind: "message",
            T: AuditTemplate
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateAuditTemplateResponse
 */ export class CreateAuditTemplateResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateAuditTemplateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateAuditTemplateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateAuditTemplateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateAuditTemplateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AuditTemplate audit_template = 1;
   */ _define_property(this, "auditTemplate", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateAuditTemplateResponse, "runtime", proto3);
_define_property(CreateAuditTemplateResponse, "typeName", "mono.datagateway.v1.CreateAuditTemplateResponse");
_define_property(CreateAuditTemplateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit_template",
            kind: "message",
            T: AuditTemplate
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateAuditTemplateRequest
 */ export class UpdateAuditTemplateRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateAuditTemplateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateAuditTemplateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateAuditTemplateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateAuditTemplateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AuditTemplate audit_template = 1;
   */ _define_property(this, "auditTemplate", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateAuditTemplateRequest, "runtime", proto3);
_define_property(UpdateAuditTemplateRequest, "typeName", "mono.datagateway.v1.UpdateAuditTemplateRequest");
_define_property(UpdateAuditTemplateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit_template",
            kind: "message",
            T: AuditTemplate
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateAuditTemplateResponse
 */ export class UpdateAuditTemplateResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateAuditTemplateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateAuditTemplateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateAuditTemplateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateAuditTemplateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AuditTemplate audit_template = 1;
   */ _define_property(this, "auditTemplate", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateAuditTemplateResponse, "runtime", proto3);
_define_property(UpdateAuditTemplateResponse, "typeName", "mono.datagateway.v1.UpdateAuditTemplateResponse");
_define_property(UpdateAuditTemplateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit_template",
            kind: "message",
            T: AuditTemplate
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListAuditTemplatesRequest
 */ export class ListAuditTemplatesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListAuditTemplatesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAuditTemplatesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAuditTemplatesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAuditTemplatesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AuditTemplateFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAuditTemplatesRequest, "runtime", proto3);
_define_property(ListAuditTemplatesRequest, "typeName", "mono.datagateway.v1.ListAuditTemplatesRequest");
_define_property(ListAuditTemplatesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: AuditTemplateFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListAuditTemplatesResponse
 */ export class ListAuditTemplatesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListAuditTemplatesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAuditTemplatesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAuditTemplatesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAuditTemplatesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.AuditTemplate audit_templates = 1;
   */ _define_property(this, "auditTemplates", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAuditTemplatesResponse, "runtime", proto3);
_define_property(ListAuditTemplatesResponse, "typeName", "mono.datagateway.v1.ListAuditTemplatesResponse");
_define_property(ListAuditTemplatesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit_templates",
            kind: "message",
            T: AuditTemplate,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteAuditTemplateRequest
 */ export class DeleteAuditTemplateRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteAuditTemplateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteAuditTemplateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteAuditTemplateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteAuditTemplateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteAuditTemplateRequest, "runtime", proto3);
_define_property(DeleteAuditTemplateRequest, "typeName", "mono.datagateway.v1.DeleteAuditTemplateRequest");
_define_property(DeleteAuditTemplateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteAuditTemplateResponse
 */ export class DeleteAuditTemplateResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteAuditTemplateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteAuditTemplateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteAuditTemplateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteAuditTemplateResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteAuditTemplateResponse, "runtime", proto3);
_define_property(DeleteAuditTemplateResponse, "typeName", "mono.datagateway.v1.DeleteAuditTemplateResponse");
_define_property(DeleteAuditTemplateResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetAuditTemplateQuestionRequest
 */ export class GetAuditTemplateQuestionRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetAuditTemplateQuestionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAuditTemplateQuestionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAuditTemplateQuestionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAuditTemplateQuestionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetAuditTemplateQuestionRequest, "runtime", proto3);
_define_property(GetAuditTemplateQuestionRequest, "typeName", "mono.datagateway.v1.GetAuditTemplateQuestionRequest");
_define_property(GetAuditTemplateQuestionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetAuditTemplateQuestionResponse
 */ export class GetAuditTemplateQuestionResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetAuditTemplateQuestionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAuditTemplateQuestionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAuditTemplateQuestionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAuditTemplateQuestionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AuditTemplateQuestion audit_template_question = 1;
   */ _define_property(this, "auditTemplateQuestion", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetAuditTemplateQuestionResponse, "runtime", proto3);
_define_property(GetAuditTemplateQuestionResponse, "typeName", "mono.datagateway.v1.GetAuditTemplateQuestionResponse");
_define_property(GetAuditTemplateQuestionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit_template_question",
            kind: "message",
            T: AuditTemplateQuestion
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateAuditTemplateQuestionRequest
 */ export class CreateAuditTemplateQuestionRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateAuditTemplateQuestionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateAuditTemplateQuestionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateAuditTemplateQuestionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateAuditTemplateQuestionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AuditTemplateQuestion audit_template_question = 1;
   */ _define_property(this, "auditTemplateQuestion", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateAuditTemplateQuestionRequest, "runtime", proto3);
_define_property(CreateAuditTemplateQuestionRequest, "typeName", "mono.datagateway.v1.CreateAuditTemplateQuestionRequest");
_define_property(CreateAuditTemplateQuestionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit_template_question",
            kind: "message",
            T: AuditTemplateQuestion
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateAuditTemplateQuestionResponse
 */ export class CreateAuditTemplateQuestionResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateAuditTemplateQuestionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateAuditTemplateQuestionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateAuditTemplateQuestionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateAuditTemplateQuestionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AuditTemplateQuestion audit_template_question = 1;
   */ _define_property(this, "auditTemplateQuestion", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateAuditTemplateQuestionResponse, "runtime", proto3);
_define_property(CreateAuditTemplateQuestionResponse, "typeName", "mono.datagateway.v1.CreateAuditTemplateQuestionResponse");
_define_property(CreateAuditTemplateQuestionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit_template_question",
            kind: "message",
            T: AuditTemplateQuestion
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateAuditTemplateQuestionRequest
 */ export class UpdateAuditTemplateQuestionRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateAuditTemplateQuestionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateAuditTemplateQuestionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateAuditTemplateQuestionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateAuditTemplateQuestionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AuditTemplateQuestion audit_template_question = 1;
   */ _define_property(this, "auditTemplateQuestion", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateAuditTemplateQuestionRequest, "runtime", proto3);
_define_property(UpdateAuditTemplateQuestionRequest, "typeName", "mono.datagateway.v1.UpdateAuditTemplateQuestionRequest");
_define_property(UpdateAuditTemplateQuestionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit_template_question",
            kind: "message",
            T: AuditTemplateQuestion
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateAuditTemplateQuestionResponse
 */ export class UpdateAuditTemplateQuestionResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateAuditTemplateQuestionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateAuditTemplateQuestionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateAuditTemplateQuestionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateAuditTemplateQuestionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AuditTemplateQuestion audit_template_question = 1;
   */ _define_property(this, "auditTemplateQuestion", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateAuditTemplateQuestionResponse, "runtime", proto3);
_define_property(UpdateAuditTemplateQuestionResponse, "typeName", "mono.datagateway.v1.UpdateAuditTemplateQuestionResponse");
_define_property(UpdateAuditTemplateQuestionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit_template_question",
            kind: "message",
            T: AuditTemplateQuestion
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListAuditTemplateQuestionsRequest
 */ export class ListAuditTemplateQuestionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListAuditTemplateQuestionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAuditTemplateQuestionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAuditTemplateQuestionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAuditTemplateQuestionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AuditTemplateQuestionFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAuditTemplateQuestionsRequest, "runtime", proto3);
_define_property(ListAuditTemplateQuestionsRequest, "typeName", "mono.datagateway.v1.ListAuditTemplateQuestionsRequest");
_define_property(ListAuditTemplateQuestionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: AuditTemplateQuestionFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListAuditTemplateQuestionsResponse
 */ export class ListAuditTemplateQuestionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListAuditTemplateQuestionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAuditTemplateQuestionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAuditTemplateQuestionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAuditTemplateQuestionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.AuditTemplateQuestion audit_template_questions = 1;
   */ _define_property(this, "auditTemplateQuestions", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAuditTemplateQuestionsResponse, "runtime", proto3);
_define_property(ListAuditTemplateQuestionsResponse, "typeName", "mono.datagateway.v1.ListAuditTemplateQuestionsResponse");
_define_property(ListAuditTemplateQuestionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit_template_questions",
            kind: "message",
            T: AuditTemplateQuestion,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteAuditTemplateQuestionRequest
 */ export class DeleteAuditTemplateQuestionRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteAuditTemplateQuestionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteAuditTemplateQuestionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteAuditTemplateQuestionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteAuditTemplateQuestionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteAuditTemplateQuestionRequest, "runtime", proto3);
_define_property(DeleteAuditTemplateQuestionRequest, "typeName", "mono.datagateway.v1.DeleteAuditTemplateQuestionRequest");
_define_property(DeleteAuditTemplateQuestionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteAuditTemplateQuestionResponse
 */ export class DeleteAuditTemplateQuestionResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteAuditTemplateQuestionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteAuditTemplateQuestionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteAuditTemplateQuestionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteAuditTemplateQuestionResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteAuditTemplateQuestionResponse, "runtime", proto3);
_define_property(DeleteAuditTemplateQuestionResponse, "typeName", "mono.datagateway.v1.DeleteAuditTemplateQuestionResponse");
_define_property(DeleteAuditTemplateQuestionResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * SyncProgramFromExtraction is the find-or-create entry point reverie calls
 * via ryugu after document extraction. Wraps program upsert + contract-
 * vehicle find-or-create + replace contacts + replace company assignments +
 * replace periods of performance + replace program modifications, all in one
 * DB transaction. Mirrors the legacy ryugu.SyncFromExtraction shape with
 * company_id renamed tenant_id and pre-computed/normalized inputs.
 *
 * @generated from message mono.datagateway.v1.SyncProgramFromExtractionRequest
 */ export class SyncProgramFromExtractionRequest extends Message {
    static fromBinary(bytes, options) {
        return new SyncProgramFromExtractionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncProgramFromExtractionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncProgramFromExtractionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncProgramFromExtractionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string zou_project_id = 2;
   */ _define_property(this, "zouProjectId", ""), /**
   * @generated from field: string contract_number = 3;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string task_number = 4;
   */ _define_property(this, "taskNumber", ""), /**
   * @generated from field: string contract_title = 5;
   */ _define_property(this, "contractTitle", ""), /**
   * @generated from field: string contract_type = 6;
   */ _define_property(this, "contractType", ""), /**
   * @generated from field: string agency_name = 7;
   */ _define_property(this, "agencyName", ""), /**
   * @generated from field: string agency_acronym = 8;
   */ _define_property(this, "agencyAcronym", ""), /**
   * @generated from field: string contract_vehicle = 9;
   */ _define_property(this, "contractVehicle", ""), /**
   * @generated from field: string vehicle_type = 10;
   */ _define_property(this, "vehicleType", ""), /**
   * @generated from field: google.protobuf.Timestamp contract_start_date = 11;
   */ _define_property(this, "contractStartDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp contract_end_date = 12;
   */ _define_property(this, "contractEndDate", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.SyncExtractedParty parties = 13;
   */ _define_property(this, "parties", []), /**
   * @generated from field: repeated mono.datagateway.v1.SyncExtractedContact contacts = 14;
   */ _define_property(this, "contacts", []), /**
   * @generated from field: repeated mono.datagateway.v1.SyncExtractedPeriod periods = 15;
   */ _define_property(this, "periods", []), /**
   * @generated from field: repeated mono.datagateway.v1.SyncExtractedModification modifications = 16;
   */ _define_property(this, "modifications", []), /**
   * @generated from field: repeated mono.datagateway.v1.SyncExtractedClin clins = 17;
   */ _define_property(this, "clins", []), /**
   * @generated from field: repeated mono.datagateway.v1.SyncExtractedPlaceOfPerformance places_of_performance = 18;
   */ _define_property(this, "placesOfPerformance", []), /**
   * @generated from field: string solicitation_number = 19;
   */ _define_property(this, "solicitationNumber", ""), /**
   * @generated from field: string naics_code = 20;
   */ _define_property(this, "naicsCode", ""), /**
   * ISO 8601
   *
   * @generated from field: string award_date = 21;
   */ _define_property(this, "awardDate", ""), /**
   * ISO 8601
   *
   * @generated from field: string effective_date = 22;
   */ _define_property(this, "effectiveDate", ""), /**
   * Vehicle/IDIQ contract number (parent of a task order) → contract_vehicles.
   *
   * @generated from field: string vehicle_contract_number = 23;
   */ _define_property(this, "vehicleContractNumber", ""), /**
   * The document's own declared total ("The Total Task Order Value is $X") —
   * the evaluated award value. When present it becomes tcv_on_award; the
   * computed CLIN-parent sum (which prices optional-task CEILINGS) lands on
   * total_ceiling instead of masquerading as the award value. 0 = unstated.
   *
   * @generated from field: double stated_total_value = 24;
   */ _define_property(this, "statedTotalValue", 0), /**
   * Facts code could not settle (D93). Staged, in the same transaction as the
   * CLIN write, into the program's one open ContractIntake change set;
   * decided items carry over by key on re-sync.
   *
   * @generated from field: repeated mono.common.v1.ReviewItem review_items = 25;
   */ _define_property(this, "reviewItems", []), /**
   * S7a priced-line duties (SAD-752 S7c-lite). Upserted by duty_key into
   * delivery.duties / schedule_rules inside the sync transaction.
   *
   * @generated from field: repeated mono.common.v1.AwardPricedDuty award_duties = 26;
   */ _define_property(this, "awardDuties", []), /**
   * Upload identity for import-event dedupe (SAD-788). Scoped with
   * tenant_id + zou_project_id: one upload's syncs share these values; a
   * later upload (different document or job) records a fresh import.
   *
   * @generated from field: string source_document_id = 27;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string import_job_id = 28;
   */ _define_property(this, "importJobId", ""), /**
   * Acting-user attribution for History when X-Audit-Actor-Id is absent
   * (unverified home-tenant mismatch or lookup error). Verified uploaders
   * still ride the audit header; these fields record the claim either way.
   *
   * @generated from field: string claimed_acting_user_id = 29;
   */ _define_property(this, "claimedActingUserId", ""), /**
   * @generated from field: bool acting_user_verified = 30;
   */ _define_property(this, "actingUserVerified", false), /**
   * @generated from field: string acting_user_unverified_reason = 31;
   */ _define_property(this, "actingUserUnverifiedReason", ""), /**
   * The issuing (contracting) office printed under agency_name, and its
   * code; resolved against the government organization registry to the
   * program's government_organization_id when it is unset.
   *
   * @generated from field: string sub_agency = 32;
   */ _define_property(this, "subAgency", ""), /**
   * @generated from field: string sub_agency_acronym = 33;
   */ _define_property(this, "subAgencyAcronym", ""), /**
   * The obligated total the award prints (SAD-885). When present it is the
   * program's funded amount (funding_basis names how it was printed); the
   * lines' funding is the fallback, and a disagreement between the two is a
   * review item.
   *
   * @generated from field: mono.common.v1.StatedObligation stated_obligation = 34;
   */ _define_property(this, "statedObligation", void 0), /**
   * reextract (SAD-974): this read is an explicit Re-extract of the award,
   * not an upload's. On a program a sync already landed on, the header it
   * reads differently is staged on the intake for review, never written.
   *
   * @generated from field: bool reextract = 35;
   */ _define_property(this, "reextract", false), /**
   * The ceilings the award states for the whole order: each is written as
   * the award's value of its kind, beside what each modification states.
   *
   * @generated from field: repeated mono.common.v1.OrderCeiling order_ceilings = 36;
   */ _define_property(this, "orderCeilings", []), /**
   * The award's weekend/holiday roll for due dates: written as the program's
   * deliverable_roll when the program states none yet, and its dates
   * re-minted. A roll already on file is never overwritten by a read.
   *
   * @generated from field: mono.common.v1.AwardDeliverableRoll deliverable_roll = 37;
   */ _define_property(this, "deliverableRoll", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SyncProgramFromExtractionRequest, "runtime", proto3);
_define_property(SyncProgramFromExtractionRequest, "typeName", "mono.datagateway.v1.SyncProgramFromExtractionRequest");
_define_property(SyncProgramFromExtractionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "task_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "contract_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "contract_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "agency_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "agency_acronym",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "contract_vehicle",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "vehicle_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "contract_start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "contract_end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "parties",
            kind: "message",
            T: SyncExtractedParty,
            repeated: true
        },
        {
            no: 14,
            name: "contacts",
            kind: "message",
            T: SyncExtractedContact,
            repeated: true
        },
        {
            no: 15,
            name: "periods",
            kind: "message",
            T: SyncExtractedPeriod,
            repeated: true
        },
        {
            no: 16,
            name: "modifications",
            kind: "message",
            T: SyncExtractedModification,
            repeated: true
        },
        {
            no: 17,
            name: "clins",
            kind: "message",
            T: SyncExtractedClin,
            repeated: true
        },
        {
            no: 18,
            name: "places_of_performance",
            kind: "message",
            T: SyncExtractedPlaceOfPerformance,
            repeated: true
        },
        {
            no: 19,
            name: "solicitation_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "naics_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "award_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "effective_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "vehicle_contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "stated_total_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 25,
            name: "review_items",
            kind: "message",
            T: ReviewItem,
            repeated: true
        },
        {
            no: 26,
            name: "award_duties",
            kind: "message",
            T: AwardPricedDuty,
            repeated: true
        },
        {
            no: 27,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 28,
            name: "import_job_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 29,
            name: "claimed_acting_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 30,
            name: "acting_user_verified",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 31,
            name: "acting_user_unverified_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 32,
            name: "sub_agency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 33,
            name: "sub_agency_acronym",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 34,
            name: "stated_obligation",
            kind: "message",
            T: StatedObligation
        },
        {
            no: 35,
            name: "reextract",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 36,
            name: "order_ceilings",
            kind: "message",
            T: OrderCeiling,
            repeated: true
        },
        {
            no: 37,
            name: "deliverable_roll",
            kind: "message",
            T: AwardDeliverableRoll
        }
    ]));
/**
 * SyncExtractedParty mirrors ryuguv1.ExtractedParty 1:1. Role is pre-mapped
 * to a canonical value (Prime, Subcontractor, etc.) by ryugu before send.
 *
 * @generated from message mono.datagateway.v1.SyncExtractedParty
 */ export class SyncExtractedParty extends Message {
    static fromBinary(bytes, options) {
        return new SyncExtractedParty().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncExtractedParty().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncExtractedParty().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncExtractedParty, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string role = 2;
   */ _define_property(this, "role", ""), /**
   * @generated from field: string duns = 3;
   */ _define_property(this, "duns", ""), /**
   * @generated from field: string uei = 4;
   */ _define_property(this, "uei", ""), /**
   * @generated from field: string cage_code = 5;
   */ _define_property(this, "cageCode", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SyncExtractedParty, "runtime", proto3);
_define_property(SyncExtractedParty, "typeName", "mono.datagateway.v1.SyncExtractedParty");
_define_property(SyncExtractedParty, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "duns",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "uei",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "cage_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * SyncExtractedContact accepts pre-split first/last names — ryugu owns the
 * name-splitting heuristic since it is UI-facing and may evolve. Role is
 * pre-mapped to a canonical value by ryugu before send.
 *
 * @generated from message mono.datagateway.v1.SyncExtractedContact
 */ export class SyncExtractedContact extends Message {
    static fromBinary(bytes, options) {
        return new SyncExtractedContact().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncExtractedContact().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncExtractedContact().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncExtractedContact, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string role = 1;
   */ _define_property(this, "role", ""), /**
   * @generated from field: string first_name = 2;
   */ _define_property(this, "firstName", ""), /**
   * @generated from field: string last_name = 3;
   */ _define_property(this, "lastName", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string email = 5;
   */ _define_property(this, "email", ""), /**
   * @generated from field: string phone = 6;
   */ _define_property(this, "phone", ""), /**
   * @generated from field: string organization = 7;
   */ _define_property(this, "organization", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SyncExtractedContact, "runtime", proto3);
_define_property(SyncExtractedContact, "typeName", "mono.datagateway.v1.SyncExtractedContact");
_define_property(SyncExtractedContact, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "first_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "last_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "phone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "organization",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SyncExtractedPeriod
 */ export class SyncExtractedPeriod extends Message {
    static fromBinary(bytes, options) {
        return new SyncExtractedPeriod().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncExtractedPeriod().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncExtractedPeriod().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncExtractedPeriod, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string type = 2;
   */ _define_property(this, "type", ""), /**
   * @generated from field: int32 option_number = 3;
   */ _define_property(this, "optionNumber", 0), /**
   * @generated from field: google.protobuf.Timestamp start_date = 4;
   */ _define_property(this, "startDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_date = 5;
   */ _define_property(this, "endDate", void 0), /**
   * @generated from field: double total_value = 6;
   */ _define_property(this, "totalValue", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SyncExtractedPeriod, "runtime", proto3);
_define_property(SyncExtractedPeriod, "typeName", "mono.datagateway.v1.SyncExtractedPeriod");
_define_property(SyncExtractedPeriod, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "option_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "end_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "total_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * SyncExtractedModification carries the modification record + its JSON
 * sidecars (change_categories, period_changes, funding_changes, scope_changes)
 * pre-encoded by ryugu so pangaea can do a flat insert. Storing JSON-as-string
 * matches the existing column shape.
 *
 * @generated from message mono.datagateway.v1.SyncExtractedModification
 */ export class SyncExtractedModification extends Message {
    static fromBinary(bytes, options) {
        return new SyncExtractedModification().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncExtractedModification().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncExtractedModification().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncExtractedModification, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string modification_number = 1;
   */ _define_property(this, "modificationNumber", ""), /**
   * @generated from field: string modification_type = 2;
   */ _define_property(this, "modificationType", ""), /**
   * @generated from field: google.protobuf.Timestamp effective_date = 3;
   */ _define_property(this, "effectiveDate", void 0), /**
   * @generated from field: string purpose = 4;
   */ _define_property(this, "purpose", ""), /**
   * @generated from field: string change_categories_json = 5;
   */ _define_property(this, "changeCategoriesJson", ""), /**
   * @generated from field: bool no_cost_modification = 6;
   */ _define_property(this, "noCostModification", false), /**
   * @generated from field: double total_funding_impact = 7;
   */ _define_property(this, "totalFundingImpact", 0), /**
   * @generated from field: double cumulative_contract_value = 8;
   */ _define_property(this, "cumulativeContractValue", 0), /**
   * @generated from field: string period_changes_json = 9;
   */ _define_property(this, "periodChangesJson", ""), /**
   * @generated from field: string funding_changes_json = 10;
   */ _define_property(this, "fundingChangesJson", ""), /**
   * @generated from field: string scope_changes_json = 11;
   */ _define_property(this, "scopeChangesJson", ""), /**
   * @generated from field: string document_attachment_id = 12;
   */ _define_property(this, "documentAttachmentId", ""), /**
   * @generated from field: string zou_modification_id = 13;
   */ _define_property(this, "zouModificationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SyncExtractedModification, "runtime", proto3);
_define_property(SyncExtractedModification, "typeName", "mono.datagateway.v1.SyncExtractedModification");
_define_property(SyncExtractedModification, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "modification_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "modification_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "effective_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "purpose",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "change_categories_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "no_cost_modification",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "total_funding_impact",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "cumulative_contract_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "period_changes_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "funding_changes_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "scope_changes_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "document_attachment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "zou_modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * SyncExtractedClin mirrors ryuguv1.ExtractedClin — contract line items
 * including SLINs (non-empty parent_clin_number marks a subline). Ref
 * lists arrive pre-encoded as JSON by ryugu to match pangaea's flat
 * column shape, like the modification sidecars.
 *
 * @generated from message mono.datagateway.v1.SyncExtractedClin
 */ export class SyncExtractedClin extends Message {
    static fromBinary(bytes, options) {
        return new SyncExtractedClin().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncExtractedClin().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncExtractedClin().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncExtractedClin, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string clin_number = 1;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string parent_clin_number = 2;
   */ _define_property(this, "parentClinNumber", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 4;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string option_type = 5;
   */ _define_property(this, "optionType", ""), /**
   * @generated from field: string contract_type = 6;
   */ _define_property(this, "contractType", ""), /**
   * @generated from field: string unit = 7;
   */ _define_property(this, "unit", ""), /**
   * @generated from field: double unit_price = 8;
   */ _define_property(this, "unitPrice", 0), /**
   * @generated from field: double extended_price = 9;
   */ _define_property(this, "extendedPrice", 0), /**
   * @generated from field: bool not_separately_priced = 10;
   */ _define_property(this, "notSeparatelyPriced", false), /**
   * @generated from field: bool not_to_exceed = 11;
   */ _define_property(this, "notToExceed", false), /**
   * @generated from field: double nte_ceiling = 12;
   */ _define_property(this, "nteCeiling", 0), /**
   * @generated from field: bool to_be_determined = 13;
   */ _define_property(this, "toBeDetermined", false), /**
   * @generated from field: string period_name = 14;
   */ _define_property(this, "periodName", ""), /**
   * @generated from field: string period_type = 15;
   */ _define_property(this, "periodType", ""), /**
   * @generated from field: int32 option_number = 16;
   */ _define_property(this, "optionNumber", 0), /**
   * @generated from field: string amendment_status = 17;
   */ _define_property(this, "amendmentStatus", ""), /**
   * @generated from field: int32 last_modified_in = 18;
   */ _define_property(this, "lastModifiedIn", 0), /**
   * @generated from field: string corresponding_base_clin = 19;
   */ _define_property(this, "correspondingBaseClin", ""), /**
   * @generated from field: string pws_references_json = 20;
   */ _define_property(this, "pwsReferencesJson", ""), /**
   * @generated from field: string attachment_references_json = 21;
   */ _define_property(this, "attachmentReferencesJson", ""), /**
   * @generated from field: double confidence = 22;
   */ _define_property(this, "confidence", 0), /**
   * @generated from field: string source_json = 23;
   */ _define_property(this, "sourceJson", ""), /**
   * @generated from field: int32 quantity = 24;
   */ _define_property(this, "quantity", 0), /**
   * @generated from field: double funded_amount = 25;
   */ _define_property(this, "fundedAmount", 0), /**
   * @generated from field: double unfunded_amount = 26;
   */ _define_property(this, "unfundedAmount", 0), /**
   * Deliverables borne by this CLIN (empty for non-deliverable/T&M iteration lines).
   * MUST stay at tag 27 (shipped on main); new fields appended at 28+.
   *
   * @generated from field: repeated mono.datagateway.v1.SyncExtractedDeliverable deliverables = 27;
   */ _define_property(this, "deliverables", []), /**
   * Per-CLIN period of performance (can differ from the contract option period).
   *
   * @generated from field: string pop_start_date = 28;
   */ _define_property(this, "popStartDate", ""), /**
   * @generated from field: string pop_end_date = 29;
   */ _define_property(this, "popEndDate", ""), /**
   * @generated from field: string pop_period_name = 30;
   */ _define_property(this, "popPeriodName", ""), /**
   * JSON rate card from the CLIN's embedded LCAT table → contract_clins.labor_mix_json.
   *
   * @generated from field: string labor_mix_json = 31;
   */ _define_property(this, "laborMixJson", ""), /**
   * Optional-task identity (baltigo description detector) → the delivery
   * Optional Tasks model + contract_clins.is_optional_task/number/title.
   *
   * @generated from field: bool is_optional_task = 32;
   */ _define_property(this, "isOptionalTask", false), /**
   * @generated from field: int32 optional_task_number = 33;
   */ _define_property(this, "optionalTaskNumber", 0), /**
   * @generated from field: string optional_task_title = 34;
   */ _define_property(this, "optionalTaskTitle", ""), /**
   * Cost classification → contract_clins.cost_type (labor/travel/odc/…).
   *
   * @generated from field: string cost_type = 35;
   */ _define_property(this, "costType", ""), /**
   * Original pricing observations. Presence distinguishes older producers from
   * an explicitly supplied empty cell. Parsed JSON retains its presence flags;
   * these strings do not authorize funding or repair an unsupported quantity.
   *
   * @generated from field: optional string raw_unit_price = 36;
   */ _define_property(this, "rawUnitPrice", void 0), /**
   * @generated from field: optional string raw_extended_price = 37;
   */ _define_property(this, "rawExtendedPrice", void 0), /**
   * @generated from field: optional string raw_quantity = 38;
   */ _define_property(this, "rawQuantity", void 0), /**
   * @generated from field: optional string raw_ceiling = 39;
   */ _define_property(this, "rawCeiling", void 0), /**
   * @generated from field: optional string unit_price_parsed_json = 40;
   */ _define_property(this, "unitPriceParsedJson", void 0), /**
   * @generated from field: optional string extended_price_parsed_json = 41;
   */ _define_property(this, "extendedPriceParsedJson", void 0), /**
   * K9c-1c (D103): the task's exercise cap, read from the document's own
   * "may be exercised up to N times" sentences (Section B, and the PWS's "can
   * be exercised up to N times"), never from the family's printed quantity.
   * Set on the family's parent line only; known is false when the document
   * states none, and a stated 0 (or "once" = 1) is known.
   *
   * @generated from field: int32 optional_task_max_exercises = 42;
   */ _define_property(this, "optionalTaskMaxExercises", 0), /**
   * @generated from field: bool optional_task_max_exercises_known = 43;
   */ _define_property(this, "optionalTaskMaxExercisesKnown", false), /**
   * @generated from field: repeated mono.common.v1.ReviewSource optional_task_max_exercises_sources = 44;
   */ _define_property(this, "optionalTaskMaxExercisesSources", []), /**
   * The line's exercise terms as compact JSON (baltigo's CLINExerciseInfo,
   * the shape contract_clins.exercise_info_json stores). Carries the line's
   * scope identity: the name its own row states, or the project a funding
   * map pairs it with. Empty when the line states none.
   *
   * @generated from field: string exercise_info_json = 45;
   */ _define_property(this, "exerciseInfoJson", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SyncExtractedClin, "runtime", proto3);
_define_property(SyncExtractedClin, "typeName", "mono.datagateway.v1.SyncExtractedClin");
_define_property(SyncExtractedClin, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "parent_clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "option_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "contract_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "unit_price",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "extended_price",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 10,
            name: "not_separately_priced",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "not_to_exceed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "nte_ceiling",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 13,
            name: "to_be_determined",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 14,
            name: "period_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "period_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "option_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 17,
            name: "amendment_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "last_modified_in",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 19,
            name: "corresponding_base_clin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "pws_references_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "attachment_references_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 23,
            name: "source_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "quantity",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 25,
            name: "funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 26,
            name: "unfunded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 27,
            name: "deliverables",
            kind: "message",
            T: SyncExtractedDeliverable,
            repeated: true
        },
        {
            no: 28,
            name: "pop_start_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 29,
            name: "pop_end_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 30,
            name: "pop_period_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 31,
            name: "labor_mix_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 32,
            name: "is_optional_task",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 33,
            name: "optional_task_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 34,
            name: "optional_task_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 35,
            name: "cost_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 36,
            name: "raw_unit_price",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 37,
            name: "raw_extended_price",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 38,
            name: "raw_quantity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 39,
            name: "raw_ceiling",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 40,
            name: "unit_price_parsed_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 41,
            name: "extended_price_parsed_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 42,
            name: "optional_task_max_exercises",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 43,
            name: "optional_task_max_exercises_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 44,
            name: "optional_task_max_exercises_sources",
            kind: "message",
            T: ReviewSource,
            repeated: true
        },
        {
            no: 45,
            name: "exercise_info_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * SyncExtractedDeliverable mirrors ryuguv1.ExtractedDeliverable — a contract
 * deliverable with its due-date rule + cadence, synced into
 * delivery.deliverable_definitions + delivery.program_tasks.
 *
 * @generated from message mono.datagateway.v1.SyncExtractedDeliverable
 */ export class SyncExtractedDeliverable extends Message {
    static fromBinary(bytes, options) {
        return new SyncExtractedDeliverable().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncExtractedDeliverable().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncExtractedDeliverable().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncExtractedDeliverable, a, b);
    }
    constructor(data){
        super(), /**
   * Tags 1-8 MUST match main; new fields appended at 9+.
   *
   * @generated from field: string title = 1;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 2;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string due_date = 3;
   */ _define_property(this, "dueDate", ""), /**
   * @generated from field: string cadence = 4;
   */ _define_property(this, "cadence", ""), /**
   * @generated from field: string deliverable_type = 5;
   */ _define_property(this, "deliverableType", ""), /**
   * @generated from field: string cdrl_reference = 6;
   */ _define_property(this, "cdrlReference", ""), /**
   * Deprecated: CDRL-ness derives from cdrl_reference; kept at tag 7 (not
   * reused/deleted) for wire compatibility with pre-award-accuracy payloads.
   *
   * @generated from field: bool is_cdrl = 7;
   */ _define_property(this, "isCdrl", false), /**
   * @generated from field: string recurring_detail = 8;
   */ _define_property(this, "recurringDetail", ""), /**
   * @generated from field: string deliverable_number = 9;
   */ _define_property(this, "deliverableNumber", ""), /**
   * @generated from field: repeated string pws_references = 10;
   */ _define_property(this, "pwsReferences", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SyncExtractedDeliverable, "runtime", proto3);
_define_property(SyncExtractedDeliverable, "typeName", "mono.datagateway.v1.SyncExtractedDeliverable");
_define_property(SyncExtractedDeliverable, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "due_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "cadence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "deliverable_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "cdrl_reference",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "is_cdrl",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "recurring_detail",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "deliverable_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "pws_references",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * SyncExtractedPlaceOfPerformance mirrors ryuguv1.ExtractedPlaceOfPerformance
 * — a work location read from the contract, replace-synced per program.
 *
 * @generated from message mono.datagateway.v1.SyncExtractedPlaceOfPerformance
 */ export class SyncExtractedPlaceOfPerformance extends Message {
    static fromBinary(bytes, options) {
        return new SyncExtractedPlaceOfPerformance().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncExtractedPlaceOfPerformance().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncExtractedPlaceOfPerformance().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncExtractedPlaceOfPerformance, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool primary = 1;
   */ _define_property(this, "primary", false), /**
   * @generated from field: string description = 2;
   */ _define_property(this, "description", ""), /**
   * @generated from field: double percentage = 3;
   */ _define_property(this, "percentage", 0), /**
   * @generated from field: string city = 4;
   */ _define_property(this, "city", ""), /**
   * @generated from field: string state = 5;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string zip_code = 6;
   */ _define_property(this, "zipCode", ""), /**
   * @generated from field: string country = 7;
   */ _define_property(this, "country", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SyncExtractedPlaceOfPerformance, "runtime", proto3);
_define_property(SyncExtractedPlaceOfPerformance, "typeName", "mono.datagateway.v1.SyncExtractedPlaceOfPerformance");
_define_property(SyncExtractedPlaceOfPerformance, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "primary",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "percentage",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "city",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "zip_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "country",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SyncProgramFromExtractionResponse
 */ export class SyncProgramFromExtractionResponse extends Message {
    static fromBinary(bytes, options) {
        return new SyncProgramFromExtractionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncProgramFromExtractionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncProgramFromExtractionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncProgramFromExtractionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SyncProgramFromExtractionResponse, "runtime", proto3);
_define_property(SyncProgramFromExtractionResponse, "typeName", "mono.datagateway.v1.SyncProgramFromExtractionResponse");
_define_property(SyncProgramFromExtractionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * UpsertAuditTemplateWithQuestions creates-or-updates an audit template and
 * fully replaces its questions in one transaction. When id is empty the
 * template is created; when id is set the template is updated and its old
 * questions are deleted before the new ones are inserted. The handler refuses
 * to mutate system templates (is_system = true) — those are read-only.
 *
 * @generated from message mono.datagateway.v1.UpsertAuditTemplateWithQuestionsRequest
 */ export class UpsertAuditTemplateWithQuestionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertAuditTemplateWithQuestionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertAuditTemplateWithQuestionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertAuditTemplateWithQuestionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertAuditTemplateWithQuestionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string area = 4;
   */ _define_property(this, "area", ""), /**
   * @generated from field: bool is_default = 5;
   */ _define_property(this, "isDefault", false), /**
   * @generated from field: string program_id = 6;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: repeated mono.datagateway.v1.AuditTemplateQuestionInput questions = 7;
   */ _define_property(this, "questions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertAuditTemplateWithQuestionsRequest, "runtime", proto3);
_define_property(UpsertAuditTemplateWithQuestionsRequest, "typeName", "mono.datagateway.v1.UpsertAuditTemplateWithQuestionsRequest");
_define_property(UpsertAuditTemplateWithQuestionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "area",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "is_default",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "questions",
            kind: "message",
            T: AuditTemplateQuestionInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AuditTemplateQuestionInput
 */ export class AuditTemplateQuestionInput extends Message {
    static fromBinary(bytes, options) {
        return new AuditTemplateQuestionInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuditTemplateQuestionInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuditTemplateQuestionInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuditTemplateQuestionInput, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string question = 1;
   */ _define_property(this, "question", ""), /**
   * @generated from field: int32 sort_order = 2;
   */ _define_property(this, "sortOrder", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AuditTemplateQuestionInput, "runtime", proto3);
_define_property(AuditTemplateQuestionInput, "typeName", "mono.datagateway.v1.AuditTemplateQuestionInput");
_define_property(AuditTemplateQuestionInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "question",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertAuditTemplateWithQuestionsResponse
 */ export class UpsertAuditTemplateWithQuestionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertAuditTemplateWithQuestionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertAuditTemplateWithQuestionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertAuditTemplateWithQuestionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertAuditTemplateWithQuestionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.AuditTemplate template = 1;
   */ _define_property(this, "template", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.AuditTemplateQuestion questions = 2;
   */ _define_property(this, "questions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertAuditTemplateWithQuestionsResponse, "runtime", proto3);
_define_property(UpsertAuditTemplateWithQuestionsResponse, "typeName", "mono.datagateway.v1.UpsertAuditTemplateWithQuestionsResponse");
_define_property(UpsertAuditTemplateWithQuestionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "template",
            kind: "message",
            T: AuditTemplate
        },
        {
            no: 2,
            name: "questions",
            kind: "message",
            T: AuditTemplateQuestion,
            repeated: true
        }
    ]));
/**
 * CreateAuditFromTemplate creates a new Audit and clones every question from
 * the named template into AuditQuestion rows, all in one transaction. The
 * handler validates the template belongs to the target program's tenant (or
 * is a system template).
 *
 * @generated from message mono.datagateway.v1.CreateAuditFromTemplateRequest
 */ export class CreateAuditFromTemplateRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateAuditFromTemplateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateAuditFromTemplateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateAuditFromTemplateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateAuditFromTemplateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string template_id = 3;
   */ _define_property(this, "templateId", ""), /**
   * @generated from field: google.protobuf.Timestamp audit_date = 4;
   */ _define_property(this, "auditDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp period_start = 5;
   */ _define_property(this, "periodStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp period_end = 6;
   */ _define_property(this, "periodEnd", void 0), /**
   * @generated from field: string assigned_to = 7;
   */ _define_property(this, "assignedTo", ""), /**
   * @generated from field: bool is_final = 8;
   */ _define_property(this, "isFinal", false), /**
   * The monthly workflow's StartAudit sets these so the audit is born fully
   * formed in one transaction (the (program, period_month) unique index then
   * guards the create). state defaults to "Draft" when empty.
   *
   * @generated from field: string period_month = 9;
   */ _define_property(this, "periodMonth", ""), /**
   * @generated from field: string state = 10;
   */ _define_property(this, "state", ""), /**
   * @generated from field: google.protobuf.Timestamp started_at = 11;
   */ _define_property(this, "startedAt", void 0), /**
   * @generated from field: string started_by = 12;
   */ _define_property(this, "startedBy", ""), /**
   * @generated from field: string started_by_contact_id = 13;
   */ _define_property(this, "startedByContactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateAuditFromTemplateRequest, "runtime", proto3);
_define_property(CreateAuditFromTemplateRequest, "typeName", "mono.datagateway.v1.CreateAuditFromTemplateRequest");
_define_property(CreateAuditFromTemplateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "audit_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "period_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "period_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "assigned_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "is_final",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "period_month",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "started_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "started_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "started_by_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateAuditFromTemplateResponse
 */ export class CreateAuditFromTemplateResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateAuditFromTemplateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateAuditFromTemplateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateAuditFromTemplateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateAuditFromTemplateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Audit audit = 1;
   */ _define_property(this, "audit", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.AuditQuestion questions = 2;
   */ _define_property(this, "questions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateAuditFromTemplateResponse, "runtime", proto3);
_define_property(CreateAuditFromTemplateResponse, "typeName", "mono.datagateway.v1.CreateAuditFromTemplateResponse");
_define_property(CreateAuditFromTemplateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "audit",
            kind: "message",
            T: Audit
        },
        {
            no: 2,
            name: "questions",
            kind: "message",
            T: AuditQuestion,
            repeated: true
        }
    ]));
/**
 * BulkCreateProgramTasks idempotently inserts a batch of ProgramTask rows in
 * one transaction. Idempotency key per row: (program_id, deliverable_number,
 * due_date, zou_deliverable_id). Existing matches are silently skipped; the
 * response only contains the newly inserted rows. Callers compute the cadence
 * dates client-side (ryugu owns generateCadenceDates) and pass the full set.
 *
 * @generated from message mono.datagateway.v1.BulkCreateProgramTasksRequest
 */ export class BulkCreateProgramTasksRequest extends Message {
    static fromBinary(bytes, options) {
        return new BulkCreateProgramTasksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BulkCreateProgramTasksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BulkCreateProgramTasksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BulkCreateProgramTasksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: repeated mono.datagateway.v1.ProgramTask tasks = 2;
   */ _define_property(this, "tasks", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BulkCreateProgramTasksRequest, "runtime", proto3);
_define_property(BulkCreateProgramTasksRequest, "typeName", "mono.datagateway.v1.BulkCreateProgramTasksRequest");
_define_property(BulkCreateProgramTasksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tasks",
            kind: "message",
            T: ProgramTask,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BulkCreateProgramTasksResponse
 */ export class BulkCreateProgramTasksResponse extends Message {
    static fromBinary(bytes, options) {
        return new BulkCreateProgramTasksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BulkCreateProgramTasksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BulkCreateProgramTasksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BulkCreateProgramTasksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 tasks_created = 1;
   */ _define_property(this, "tasksCreated", 0), /**
   * @generated from field: repeated mono.datagateway.v1.ProgramTask tasks = 2;
   */ _define_property(this, "tasks", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BulkCreateProgramTasksResponse, "runtime", proto3);
_define_property(BulkCreateProgramTasksResponse, "typeName", "mono.datagateway.v1.BulkCreateProgramTasksResponse");
_define_property(BulkCreateProgramTasksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tasks_created",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "tasks",
            kind: "message",
            T: ProgramTask,
            repeated: true
        }
    ]));
/**
 * ContractCLIN — wholly absorbed from zou.ContractCLIN. SLINs continue to be
 * modeled as subline rows pointing at a parent CLIN via parent_clin_number +
 * is_subline_item; a standalone SLIN entity is deliberately not introduced.
 *
 * @generated from message mono.datagateway.v1.ContractCLIN
 */ export class ContractCLIN extends Message {
    static fromBinary(bytes, options) {
        return new ContractCLIN().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractCLIN().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractCLIN().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractCLIN, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string contract_id = 4;
   */ _define_property(this, "contractId", ""), /**
   * @generated from field: string contract_number = 5;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string clin_number = 6;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string parent_clin_number = 7;
   */ _define_property(this, "parentClinNumber", ""), /**
   * @generated from field: bool is_subline_item = 8;
   */ _define_property(this, "isSublineItem", false), /**
   * @generated from field: string subline_type = 9;
   */ _define_property(this, "sublineType", ""), /**
   * @generated from field: string option_type = 10;
   */ _define_property(this, "optionType", ""), /**
   * @generated from field: int32 option_period_number = 11;
   */ _define_property(this, "optionPeriodNumber", 0), /**
   * @generated from field: string contract_type = 12;
   */ _define_property(this, "contractType", ""), /**
   * @generated from field: string description = 13;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string short_title = 14;
   */ _define_property(this, "shortTitle", ""), /**
   * @generated from field: string pws_sections = 15;
   */ _define_property(this, "pwsSections", ""), /**
   * @generated from field: int32 quantity = 16;
   */ _define_property(this, "quantity", 0), /**
   * @generated from field: string unit = 17;
   */ _define_property(this, "unit", ""), /**
   * @generated from field: double pricing_unit_price = 18;
   */ _define_property(this, "pricingUnitPrice", 0), /**
   * @generated from field: double pricing_extended_price = 19;
   */ _define_property(this, "pricingExtendedPrice", 0), /**
   * @generated from field: bool pricing_is_nsp = 20;
   */ _define_property(this, "pricingIsNsp", false), /**
   * @generated from field: bool pricing_is_nte = 21;
   */ _define_property(this, "pricingIsNte", false), /**
   * @generated from field: double pricing_nte_ceiling = 22;
   */ _define_property(this, "pricingNteCeiling", 0), /**
   * @generated from field: double pricing_funded_amount = 23;
   */ _define_property(this, "pricingFundedAmount", 0), /**
   * @generated from field: double pricing_unfunded_amount = 24;
   */ _define_property(this, "pricingUnfundedAmount", 0), /**
   * @generated from field: double pricing_handling_rate = 25;
   */ _define_property(this, "pricingHandlingRate", 0), /**
   * @generated from field: double pricing_award_amount = 26;
   */ _define_property(this, "pricingAwardAmount", 0), /**
   * @generated from field: double pricing_invoiced_amount = 27;
   */ _define_property(this, "pricingInvoicedAmount", 0), /**
   * @generated from field: double pricing_paid_amount = 28;
   */ _define_property(this, "pricingPaidAmount", 0), /**
   * string in zou (varchar 50); preserved
   *
   * @generated from field: string pop_start_date = 29;
   */ _define_property(this, "popStartDate", ""), /**
   * @generated from field: string pop_end_date = 30;
   */ _define_property(this, "popEndDate", ""), /**
   * @generated from field: int32 pop_duration_months = 31;
   */ _define_property(this, "popDurationMonths", 0), /**
   * @generated from field: string pop_period_name = 32;
   */ _define_property(this, "popPeriodName", ""), /**
   * @generated from field: bool has_deliverables = 33;
   */ _define_property(this, "hasDeliverables", false), /**
   * JSON []string
   *
   * @generated from field: string deliverable_ids = 34;
   */ _define_property(this, "deliverableIds", ""), /**
   * @generated from field: bool has_labor_mix = 35;
   */ _define_property(this, "hasLaborMix", false), /**
   * @generated from field: string labor_mix_json = 36;
   */ _define_property(this, "laborMixJson", ""), /**
   * @generated from field: string funding_status = 37;
   */ _define_property(this, "fundingStatus", ""), /**
   * JSON []FundingHistoryEntry
   *
   * @generated from field: string funding_history_json = 38;
   */ _define_property(this, "fundingHistoryJson", ""), /**
   * @generated from field: string corresponding_base_clin = 39;
   */ _define_property(this, "correspondingBaseClin", ""), /**
   * @generated from field: int32 sort_order = 40;
   */ _define_property(this, "sortOrder", 0), /**
   * JSON []ScopedPWSReference
   *
   * @generated from field: string scoped_pws_refs_json = 41;
   */ _define_property(this, "scopedPwsRefsJson", ""), /**
   * JSON CLINExerciseInfo
   *
   * @generated from field: string exercise_info_json = 42;
   */ _define_property(this, "exerciseInfoJson", ""), /**
   * @generated from field: string cost_type = 43;
   */ _define_property(this, "costType", ""), /**
   * @generated from field: bool needs_team_pricing = 44;
   */ _define_property(this, "needsTeamPricing", false), /**
   * @generated from field: string extracted_team_tiers_json = 45;
   */ _define_property(this, "extractedTeamTiersJson", ""), /**
   * @generated from field: string extracted_fee_target_json = 46;
   */ _define_property(this, "extractedFeeTargetJson", ""), /**
   * @generated from field: bool is_optional_task = 47;
   */ _define_property(this, "isOptionalTask", false), /**
   * @generated from field: int32 optional_task_number = 48;
   */ _define_property(this, "optionalTaskNumber", 0), /**
   * @generated from field: string optional_task_title = 49;
   */ _define_property(this, "optionalTaskTitle", ""), /**
   * JSON []string
   *
   * @generated from field: string attachment_references = 50;
   */ _define_property(this, "attachmentReferences", ""), /**
   * @generated from field: double confidence = 51;
   */ _define_property(this, "confidence", 0), /**
   * @generated from field: string status = 52;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string notes = 53;
   */ _define_property(this, "notes", ""), /**
   * JSON []string
   *
   * @generated from field: string tags = 54;
   */ _define_property(this, "tags", ""), /**
   * @generated from field: string extracted_at = 55;
   */ _define_property(this, "extractedAt", ""), /**
   * @generated from field: string period_type = 56;
   */ _define_property(this, "periodType", ""), /**
   * JSON RequirementSourceInfo
   *
   * @generated from field: string source_json = 57;
   */ _define_property(this, "sourceJson", ""), /**
   * @generated from field: string pricing_raw_unit_price = 58;
   */ _define_property(this, "pricingRawUnitPrice", ""), /**
   * @generated from field: string pricing_raw_extended_price = 59;
   */ _define_property(this, "pricingRawExtendedPrice", ""), /**
   * @generated from field: string pricing_raw_quantity = 60;
   */ _define_property(this, "pricingRawQuantity", ""), /**
   * @generated from field: string pricing_raw_ceiling = 61;
   */ _define_property(this, "pricingRawCeiling", ""), /**
   * @generated from field: bool pricing_is_tbd = 62;
   */ _define_property(this, "pricingIsTbd", false), /**
   * @generated from field: string pricing_unit_price_parsed_json = 63;
   */ _define_property(this, "pricingUnitPriceParsedJson", ""), /**
   * @generated from field: string pricing_extended_price_parsed_json = 64;
   */ _define_property(this, "pricingExtendedPriceParsedJson", ""), /**
   * UNCHANGED | MODIFIED | ADDED | REMOVED
   *
   * @generated from field: string amendment_status = 65;
   */ _define_property(this, "amendmentStatus", ""), /**
   * @generated from field: int32 last_modified_in = 66;
   */ _define_property(this, "lastModifiedIn", 0), /**
   * Provenance from baltigo merge stage.
   *
   * @generated from field: string source_document_id = 67;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string source_filename = 68;
   */ _define_property(this, "sourceFilename", ""), /**
   * @generated from field: bool is_from_amendment = 69;
   */ _define_property(this, "isFromAmendment", false), /**
   * @generated from field: string amendment_number = 70;
   */ _define_property(this, "amendmentNumber", ""), /**
   * @generated from field: int32 amendment_sequence = 71;
   */ _define_property(this, "amendmentSequence", 0), /**
   * @generated from field: string logical_key = 72;
   */ _define_property(this, "logicalKey", ""), /**
   * @generated from field: bool is_current_version = 73;
   */ _define_property(this, "isCurrentVersion", false), /**
   * FK back to zou.ContractCLIN.ID during cutover
   *
   * @generated from field: string zou_clin_id = 74;
   */ _define_property(this, "zouClinId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 75;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 76;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 77;
   */ _define_property(this, "deletedAt", void 0), /**
   * Read-only canonical storage state. Absent means an older server did not
   * report nullability; true means SQL NULL; false means the exact date string
   * above is stored, including an empty string. Never infer NULL from "".
   * These markers do not change the semantics of ordinary write requests.
   *
   * @generated from field: optional bool pop_start_date_is_null = 78;
   */ _define_property(this, "popStartDateIsNull", void 0), /**
   * @generated from field: optional bool pop_end_date_is_null = 79;
   */ _define_property(this, "popEndDateIsNull", void 0), /**
   * @generated from field: optional string funding_basis = 80;
   */ _define_property(this, "fundingBasis", void 0), /**
   * @generated from field: optional bool pricing_unit_price_known = 81;
   */ _define_property(this, "pricingUnitPriceKnown", void 0), /**
   * @generated from field: optional bool pricing_extended_price_known = 82;
   */ _define_property(this, "pricingExtendedPriceKnown", void 0), /**
   * @generated from field: optional bool pricing_ceiling_known = 83;
   */ _define_property(this, "pricingCeilingKnown", void 0), /**
   * Read-only source quantity, including qualifiers. Absent means no stored reading.
   *
   * @generated from field: optional string raw_quantity = 84;
   */ _define_property(this, "rawQuantity", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractCLIN, "runtime", proto3);
_define_property(ContractCLIN, "typeName", "mono.datagateway.v1.ContractCLIN");
_define_property(ContractCLIN, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "parent_clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "is_subline_item",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "subline_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "option_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "option_period_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 12,
            name: "contract_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "short_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "pws_sections",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "quantity",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 17,
            name: "unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "pricing_unit_price",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 19,
            name: "pricing_extended_price",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 20,
            name: "pricing_is_nsp",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 21,
            name: "pricing_is_nte",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 22,
            name: "pricing_nte_ceiling",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 23,
            name: "pricing_funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 24,
            name: "pricing_unfunded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 25,
            name: "pricing_handling_rate",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 26,
            name: "pricing_award_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 27,
            name: "pricing_invoiced_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 28,
            name: "pricing_paid_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 29,
            name: "pop_start_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 30,
            name: "pop_end_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 31,
            name: "pop_duration_months",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 32,
            name: "pop_period_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 33,
            name: "has_deliverables",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 34,
            name: "deliverable_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 35,
            name: "has_labor_mix",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 36,
            name: "labor_mix_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 37,
            name: "funding_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 38,
            name: "funding_history_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 39,
            name: "corresponding_base_clin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 40,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 41,
            name: "scoped_pws_refs_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 42,
            name: "exercise_info_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 43,
            name: "cost_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 44,
            name: "needs_team_pricing",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 45,
            name: "extracted_team_tiers_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 46,
            name: "extracted_fee_target_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 47,
            name: "is_optional_task",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 48,
            name: "optional_task_number",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 49,
            name: "optional_task_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 50,
            name: "attachment_references",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 51,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 52,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 53,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 54,
            name: "tags",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 55,
            name: "extracted_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 56,
            name: "period_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 57,
            name: "source_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 58,
            name: "pricing_raw_unit_price",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 59,
            name: "pricing_raw_extended_price",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 60,
            name: "pricing_raw_quantity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 61,
            name: "pricing_raw_ceiling",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 62,
            name: "pricing_is_tbd",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 63,
            name: "pricing_unit_price_parsed_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 64,
            name: "pricing_extended_price_parsed_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 65,
            name: "amendment_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 66,
            name: "last_modified_in",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 67,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 68,
            name: "source_filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 69,
            name: "is_from_amendment",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 70,
            name: "amendment_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 71,
            name: "amendment_sequence",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 72,
            name: "logical_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 73,
            name: "is_current_version",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 74,
            name: "zou_clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 75,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 76,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 77,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 78,
            name: "pop_start_date_is_null",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 79,
            name: "pop_end_date_is_null",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 80,
            name: "funding_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 81,
            name: "pricing_unit_price_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 82,
            name: "pricing_extended_price_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 83,
            name: "pricing_ceiling_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        },
        {
            no: 84,
            name: "raw_quantity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * PlaceOfPerformance — absorbed from zou.PlaceOfPerformance.
 *
 * @generated from message mono.datagateway.v1.PlaceOfPerformance
 */ export class PlaceOfPerformance extends Message {
    static fromBinary(bytes, options) {
        return new PlaceOfPerformance().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PlaceOfPerformance().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PlaceOfPerformance().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PlaceOfPerformance, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: bool primary = 4;
   */ _define_property(this, "primary", false), /**
   * @generated from field: string description = 5;
   */ _define_property(this, "description", ""), /**
   * @generated from field: double percentage = 6;
   */ _define_property(this, "percentage", 0), /**
   * @generated from field: string city = 7;
   */ _define_property(this, "city", ""), /**
   * @generated from field: string state = 8;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string zip_code = 9;
   */ _define_property(this, "zipCode", ""), /**
   * @generated from field: string country = 10;
   */ _define_property(this, "country", ""), /**
   * @generated from field: string zou_id = 11;
   */ _define_property(this, "zouId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 13;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 14;
   */ _define_property(this, "deletedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PlaceOfPerformance, "runtime", proto3);
_define_property(PlaceOfPerformance, "typeName", "mono.datagateway.v1.PlaceOfPerformance");
_define_property(PlaceOfPerformance, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "primary",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "percentage",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "city",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "zip_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "country",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "zou_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * OperationalAuditEvent — immutable operational audit log per SDS §10.
 * Distinct from quality/governance Audit (delivery.Audit). Every state-
 * changing handler in zou or ryugu writes one row here, optionally grouped
 * by correlation_id for multi-step user actions.
 *
 * @generated from message mono.datagateway.v1.OperationalAuditEvent
 */ export class OperationalAuditEvent extends Message {
    static fromBinary(bytes, options) {
        return new OperationalAuditEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OperationalAuditEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OperationalAuditEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OperationalAuditEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string actor_user_id = 3;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: string actor_role_context = 4;
   */ _define_property(this, "actorRoleContext", ""), /**
   * namespaced: "proposal.convert_to_pre_award", "discrepancy.resolve", ...
   *
   * @generated from field: string action_key = 5;
   */ _define_property(this, "actionKey", ""), /**
   * @generated from field: string object_type = 6;
   */ _define_property(this, "objectType", ""), /**
   * @generated from field: string object_id = 7;
   */ _define_property(this, "objectId", ""), /**
   * @generated from field: string previous_state_json = 8;
   */ _define_property(this, "previousStateJson", ""), /**
   * @generated from field: string new_state_json = 9;
   */ _define_property(this, "newStateJson", ""), /**
   * @generated from field: string field_diffs_json = 10;
   */ _define_property(this, "fieldDiffsJson", ""), /**
   * allow | deny | conditional
   *
   * @generated from field: string policy_decision = 11;
   */ _define_property(this, "policyDecision", ""), /**
   * @generated from field: string correlation_id = 12;
   */ _define_property(this, "correlationId", ""), /**
   * handler | automation | copilot
   *
   * @generated from field: string source = 13;
   */ _define_property(this, "source", ""), /**
   * @generated from field: google.protobuf.Timestamp timestamp = 14;
   */ _define_property(this, "timestamp", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 15;
   */ _define_property(this, "createdAt", void 0), /**
   * WS8 audit read model: the authoritative scope node the action happened
   * under (server-stamped; drives object-history filtering).
   *
   * @generated from field: string scope_node_id = 16;
   */ _define_property(this, "scopeNodeId", ""), /**
   * WS5: set when the actor's authorizing grant was a DESIGNEE grant — the
   * action is ledgered against both the actor and the grant's owner.
   *
   * @generated from field: string acting_on_behalf_of_user_id = 17;
   */ _define_property(this, "actingOnBehalfOfUserId", ""), /**
   * FND-27 AWR-4: the Assist proposal an accepted write came from,
   * "<conversation_id>:<tool_call_id>". Set only with source = "copilot";
   * metadata, never an authorization input (AWR-5).
   *
   * @generated from field: string assist_run_id = 18;
   */ _define_property(this, "assistRunId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OperationalAuditEvent, "runtime", proto3);
_define_property(OperationalAuditEvent, "typeName", "mono.datagateway.v1.OperationalAuditEvent");
_define_property(OperationalAuditEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "actor_role_context",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "action_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "previous_state_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "new_state_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "field_diffs_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "policy_decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "correlation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "timestamp",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "scope_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "acting_on_behalf_of_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "assist_run_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractCLINFilter
 */ export class ContractCLINFilter extends Message {
    static fromBinary(bytes, options) {
        return new ContractCLINFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractCLINFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractCLINFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractCLINFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string contract_id = 3;
   */ _define_property(this, "contractId", ""), /**
   * @generated from field: string clin_number = 4;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string funding_status = 5;
   */ _define_property(this, "fundingStatus", ""), /**
   * @generated from field: bool only_current_version = 6;
   */ _define_property(this, "onlyCurrentVersion", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractCLINFilter, "runtime", proto3);
_define_property(ContractCLINFilter, "typeName", "mono.datagateway.v1.ContractCLINFilter");
_define_property(ContractCLINFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "funding_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "only_current_version",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetContractCLINRequest
 */ export class GetContractCLINRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetContractCLINRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetContractCLINRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetContractCLINRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetContractCLINRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetContractCLINRequest, "runtime", proto3);
_define_property(GetContractCLINRequest, "typeName", "mono.datagateway.v1.GetContractCLINRequest");
_define_property(GetContractCLINRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetContractCLINResponse
 */ export class GetContractCLINResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetContractCLINResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetContractCLINResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetContractCLINResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetContractCLINResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractCLIN contract_clin = 1;
   */ _define_property(this, "contractClin", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetContractCLINResponse, "runtime", proto3);
_define_property(GetContractCLINResponse, "typeName", "mono.datagateway.v1.GetContractCLINResponse");
_define_property(GetContractCLINResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_clin",
            kind: "message",
            T: ContractCLIN
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateContractCLINRequest
 */ export class CreateContractCLINRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateContractCLINRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateContractCLINRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateContractCLINRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateContractCLINRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractCLIN contract_clin = 1;
   */ _define_property(this, "contractClin", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateContractCLINRequest, "runtime", proto3);
_define_property(CreateContractCLINRequest, "typeName", "mono.datagateway.v1.CreateContractCLINRequest");
_define_property(CreateContractCLINRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_clin",
            kind: "message",
            T: ContractCLIN
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateContractCLINResponse
 */ export class CreateContractCLINResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateContractCLINResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateContractCLINResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateContractCLINResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateContractCLINResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractCLIN contract_clin = 1;
   */ _define_property(this, "contractClin", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateContractCLINResponse, "runtime", proto3);
_define_property(CreateContractCLINResponse, "typeName", "mono.datagateway.v1.CreateContractCLINResponse");
_define_property(CreateContractCLINResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_clin",
            kind: "message",
            T: ContractCLIN
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateContractCLINRequest
 */ export class UpdateContractCLINRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateContractCLINRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateContractCLINRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateContractCLINRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateContractCLINRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractCLIN contract_clin = 1;
   */ _define_property(this, "contractClin", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateContractCLINRequest, "runtime", proto3);
_define_property(UpdateContractCLINRequest, "typeName", "mono.datagateway.v1.UpdateContractCLINRequest");
_define_property(UpdateContractCLINRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_clin",
            kind: "message",
            T: ContractCLIN
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateContractCLINResponse
 */ export class UpdateContractCLINResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateContractCLINResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateContractCLINResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateContractCLINResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateContractCLINResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractCLIN contract_clin = 1;
   */ _define_property(this, "contractClin", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateContractCLINResponse, "runtime", proto3);
_define_property(UpdateContractCLINResponse, "typeName", "mono.datagateway.v1.UpdateContractCLINResponse");
_define_property(UpdateContractCLINResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_clin",
            kind: "message",
            T: ContractCLIN
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListContractCLINsRequest
 */ export class ListContractCLINsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListContractCLINsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContractCLINsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContractCLINsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContractCLINsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractCLINFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContractCLINsRequest, "runtime", proto3);
_define_property(ListContractCLINsRequest, "typeName", "mono.datagateway.v1.ListContractCLINsRequest");
_define_property(ListContractCLINsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: ContractCLINFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListContractCLINsResponse
 */ export class ListContractCLINsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListContractCLINsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListContractCLINsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListContractCLINsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListContractCLINsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ContractCLIN contract_clins = 1;
   */ _define_property(this, "contractClins", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListContractCLINsResponse, "runtime", proto3);
_define_property(ListContractCLINsResponse, "typeName", "mono.datagateway.v1.ListContractCLINsResponse");
_define_property(ListContractCLINsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_clins",
            kind: "message",
            T: ContractCLIN,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteContractCLINRequest
 */ export class DeleteContractCLINRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteContractCLINRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteContractCLINRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteContractCLINRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteContractCLINRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteContractCLINRequest, "runtime", proto3);
_define_property(DeleteContractCLINRequest, "typeName", "mono.datagateway.v1.DeleteContractCLINRequest");
_define_property(DeleteContractCLINRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteContractCLINResponse
 */ export class DeleteContractCLINResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteContractCLINResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteContractCLINResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteContractCLINResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteContractCLINResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteContractCLINResponse, "runtime", proto3);
_define_property(DeleteContractCLINResponse, "typeName", "mono.datagateway.v1.DeleteContractCLINResponse");
_define_property(DeleteContractCLINResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.UpsertContractCLINByZouIDRequest
 */ export class UpsertContractCLINByZouIDRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertContractCLINByZouIDRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertContractCLINByZouIDRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertContractCLINByZouIDRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertContractCLINByZouIDRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractCLIN contract_clin = 1;
   */ _define_property(this, "contractClin", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertContractCLINByZouIDRequest, "runtime", proto3);
_define_property(UpsertContractCLINByZouIDRequest, "typeName", "mono.datagateway.v1.UpsertContractCLINByZouIDRequest");
_define_property(UpsertContractCLINByZouIDRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_clin",
            kind: "message",
            T: ContractCLIN
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertContractCLINByZouIDResponse
 */ export class UpsertContractCLINByZouIDResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertContractCLINByZouIDResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertContractCLINByZouIDResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertContractCLINByZouIDResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertContractCLINByZouIDResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractCLIN contract_clin = 1;
   */ _define_property(this, "contractClin", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertContractCLINByZouIDResponse, "runtime", proto3);
_define_property(UpsertContractCLINByZouIDResponse, "typeName", "mono.datagateway.v1.UpsertContractCLINByZouIDResponse");
_define_property(UpsertContractCLINByZouIDResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_clin",
            kind: "message",
            T: ContractCLIN
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * Only the set (present) fields are written. The row must match id, tenant_id
 * and program_id and not be soft-deleted.
 *
 * @generated from message mono.datagateway.v1.PatchContractCLINRequest
 */ export class PatchContractCLINRequest extends Message {
    static fromBinary(bytes, options) {
        return new PatchContractCLINRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PatchContractCLINRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PatchContractCLINRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PatchContractCLINRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: optional string funding_status = 4;
   */ _define_property(this, "fundingStatus", void 0), /**
   * @generated from field: optional string notes = 5;
   */ _define_property(this, "notes", void 0), /**
   * @generated from field: optional string short_title = 6;
   */ _define_property(this, "shortTitle", void 0), /**
   * @generated from field: optional string description = 7;
   */ _define_property(this, "description", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PatchContractCLINRequest, "runtime", proto3);
_define_property(PatchContractCLINRequest, "typeName", "mono.datagateway.v1.PatchContractCLINRequest");
_define_property(PatchContractCLINRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "funding_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 5,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 6,
            name: "short_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 7,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.PatchContractCLINResponse
 */ export class PatchContractCLINResponse extends Message {
    static fromBinary(bytes, options) {
        return new PatchContractCLINResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PatchContractCLINResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PatchContractCLINResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PatchContractCLINResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractCLIN contract_clin = 1;
   */ _define_property(this, "contractClin", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PatchContractCLINResponse, "runtime", proto3);
_define_property(PatchContractCLINResponse, "typeName", "mono.datagateway.v1.PatchContractCLINResponse");
_define_property(PatchContractCLINResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_clin",
            kind: "message",
            T: ContractCLIN
        }
    ]));
/**
 * Every row must carry tenant_id (equal to the request's) and zou_clin_id.
 *
 * @generated from message mono.datagateway.v1.UpsertContractCLINsByZouIDRequest
 */ export class UpsertContractCLINsByZouIDRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertContractCLINsByZouIDRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertContractCLINsByZouIDRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertContractCLINsByZouIDRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertContractCLINsByZouIDRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: repeated mono.datagateway.v1.ContractCLIN contract_clins = 2;
   */ _define_property(this, "contractClins", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertContractCLINsByZouIDRequest, "runtime", proto3);
_define_property(UpsertContractCLINsByZouIDRequest, "typeName", "mono.datagateway.v1.UpsertContractCLINsByZouIDRequest");
_define_property(UpsertContractCLINsByZouIDRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contract_clins",
            kind: "message",
            T: ContractCLIN,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertContractCLINsByZouIDResponse
 */ export class UpsertContractCLINsByZouIDResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertContractCLINsByZouIDResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertContractCLINsByZouIDResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertContractCLINsByZouIDResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertContractCLINsByZouIDResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ContractCLIN contract_clins = 1;
   */ _define_property(this, "contractClins", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertContractCLINsByZouIDResponse, "runtime", proto3);
_define_property(UpsertContractCLINsByZouIDResponse, "typeName", "mono.datagateway.v1.UpsertContractCLINsByZouIDResponse");
_define_property(UpsertContractCLINsByZouIDResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contract_clins",
            kind: "message",
            T: ContractCLIN,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.PlaceOfPerformanceFilter
 */ export class PlaceOfPerformanceFilter extends Message {
    static fromBinary(bytes, options) {
        return new PlaceOfPerformanceFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PlaceOfPerformanceFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PlaceOfPerformanceFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PlaceOfPerformanceFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PlaceOfPerformanceFilter, "runtime", proto3);
_define_property(PlaceOfPerformanceFilter, "typeName", "mono.datagateway.v1.PlaceOfPerformanceFilter");
_define_property(PlaceOfPerformanceFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetPlaceOfPerformanceRequest
 */ export class GetPlaceOfPerformanceRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPlaceOfPerformanceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPlaceOfPerformanceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPlaceOfPerformanceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPlaceOfPerformanceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPlaceOfPerformanceRequest, "runtime", proto3);
_define_property(GetPlaceOfPerformanceRequest, "typeName", "mono.datagateway.v1.GetPlaceOfPerformanceRequest");
_define_property(GetPlaceOfPerformanceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetPlaceOfPerformanceResponse
 */ export class GetPlaceOfPerformanceResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPlaceOfPerformanceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPlaceOfPerformanceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPlaceOfPerformanceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPlaceOfPerformanceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PlaceOfPerformance place_of_performance = 1;
   */ _define_property(this, "placeOfPerformance", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPlaceOfPerformanceResponse, "runtime", proto3);
_define_property(GetPlaceOfPerformanceResponse, "typeName", "mono.datagateway.v1.GetPlaceOfPerformanceResponse");
_define_property(GetPlaceOfPerformanceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "place_of_performance",
            kind: "message",
            T: PlaceOfPerformance
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreatePlaceOfPerformanceRequest
 */ export class CreatePlaceOfPerformanceRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreatePlaceOfPerformanceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreatePlaceOfPerformanceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreatePlaceOfPerformanceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreatePlaceOfPerformanceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PlaceOfPerformance place_of_performance = 1;
   */ _define_property(this, "placeOfPerformance", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreatePlaceOfPerformanceRequest, "runtime", proto3);
_define_property(CreatePlaceOfPerformanceRequest, "typeName", "mono.datagateway.v1.CreatePlaceOfPerformanceRequest");
_define_property(CreatePlaceOfPerformanceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "place_of_performance",
            kind: "message",
            T: PlaceOfPerformance
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreatePlaceOfPerformanceResponse
 */ export class CreatePlaceOfPerformanceResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreatePlaceOfPerformanceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreatePlaceOfPerformanceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreatePlaceOfPerformanceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreatePlaceOfPerformanceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PlaceOfPerformance place_of_performance = 1;
   */ _define_property(this, "placeOfPerformance", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreatePlaceOfPerformanceResponse, "runtime", proto3);
_define_property(CreatePlaceOfPerformanceResponse, "typeName", "mono.datagateway.v1.CreatePlaceOfPerformanceResponse");
_define_property(CreatePlaceOfPerformanceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "place_of_performance",
            kind: "message",
            T: PlaceOfPerformance
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdatePlaceOfPerformanceRequest
 */ export class UpdatePlaceOfPerformanceRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdatePlaceOfPerformanceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdatePlaceOfPerformanceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdatePlaceOfPerformanceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdatePlaceOfPerformanceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PlaceOfPerformance place_of_performance = 1;
   */ _define_property(this, "placeOfPerformance", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdatePlaceOfPerformanceRequest, "runtime", proto3);
_define_property(UpdatePlaceOfPerformanceRequest, "typeName", "mono.datagateway.v1.UpdatePlaceOfPerformanceRequest");
_define_property(UpdatePlaceOfPerformanceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "place_of_performance",
            kind: "message",
            T: PlaceOfPerformance
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdatePlaceOfPerformanceResponse
 */ export class UpdatePlaceOfPerformanceResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdatePlaceOfPerformanceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdatePlaceOfPerformanceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdatePlaceOfPerformanceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdatePlaceOfPerformanceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PlaceOfPerformance place_of_performance = 1;
   */ _define_property(this, "placeOfPerformance", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdatePlaceOfPerformanceResponse, "runtime", proto3);
_define_property(UpdatePlaceOfPerformanceResponse, "typeName", "mono.datagateway.v1.UpdatePlaceOfPerformanceResponse");
_define_property(UpdatePlaceOfPerformanceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "place_of_performance",
            kind: "message",
            T: PlaceOfPerformance
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPlacesOfPerformanceRequest
 */ export class ListPlacesOfPerformanceRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPlacesOfPerformanceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPlacesOfPerformanceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPlacesOfPerformanceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPlacesOfPerformanceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PlaceOfPerformanceFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPlacesOfPerformanceRequest, "runtime", proto3);
_define_property(ListPlacesOfPerformanceRequest, "typeName", "mono.datagateway.v1.ListPlacesOfPerformanceRequest");
_define_property(ListPlacesOfPerformanceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: PlaceOfPerformanceFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPlacesOfPerformanceResponse
 */ export class ListPlacesOfPerformanceResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPlacesOfPerformanceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPlacesOfPerformanceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPlacesOfPerformanceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPlacesOfPerformanceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.PlaceOfPerformance places_of_performance = 1;
   */ _define_property(this, "placesOfPerformance", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPlacesOfPerformanceResponse, "runtime", proto3);
_define_property(ListPlacesOfPerformanceResponse, "typeName", "mono.datagateway.v1.ListPlacesOfPerformanceResponse");
_define_property(ListPlacesOfPerformanceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "places_of_performance",
            kind: "message",
            T: PlaceOfPerformance,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeletePlaceOfPerformanceRequest
 */ export class DeletePlaceOfPerformanceRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeletePlaceOfPerformanceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeletePlaceOfPerformanceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeletePlaceOfPerformanceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeletePlaceOfPerformanceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeletePlaceOfPerformanceRequest, "runtime", proto3);
_define_property(DeletePlaceOfPerformanceRequest, "typeName", "mono.datagateway.v1.DeletePlaceOfPerformanceRequest");
_define_property(DeletePlaceOfPerformanceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeletePlaceOfPerformanceResponse
 */ export class DeletePlaceOfPerformanceResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeletePlaceOfPerformanceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeletePlaceOfPerformanceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeletePlaceOfPerformanceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeletePlaceOfPerformanceResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeletePlaceOfPerformanceResponse, "runtime", proto3);
_define_property(DeletePlaceOfPerformanceResponse, "typeName", "mono.datagateway.v1.DeletePlaceOfPerformanceResponse");
_define_property(DeletePlaceOfPerformanceResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * S11b — one employee owner per state (region) of a program's places of
 * performance. owner_name is denormalized beside owner_contact_id, mirroring
 * risk.owner, so the name still renders after the contact leaves the program.
 *
 * @generated from message mono.datagateway.v1.RegionAssignment
 */ export class RegionAssignment extends Message {
    static fromBinary(bytes, options) {
        return new RegionAssignment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegionAssignment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegionAssignment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegionAssignment, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string state = 4;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string owner_contact_id = 5;
   */ _define_property(this, "ownerContactId", ""), /**
   * @generated from field: string owner_name = 6;
   */ _define_property(this, "ownerName", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 9;
   */ _define_property(this, "deletedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegionAssignment, "runtime", proto3);
_define_property(RegionAssignment, "typeName", "mono.datagateway.v1.RegionAssignment");
_define_property(RegionAssignment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "owner_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "owner_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RegionAssignmentFilter
 */ export class RegionAssignmentFilter extends Message {
    static fromBinary(bytes, options) {
        return new RegionAssignmentFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RegionAssignmentFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RegionAssignmentFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RegionAssignmentFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RegionAssignmentFilter, "runtime", proto3);
_define_property(RegionAssignmentFilter, "typeName", "mono.datagateway.v1.RegionAssignmentFilter");
_define_property(RegionAssignmentFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertRegionAssignmentRequest
 */ export class UpsertRegionAssignmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertRegionAssignmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertRegionAssignmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertRegionAssignmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertRegionAssignmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegionAssignment region_assignment = 1;
   */ _define_property(this, "regionAssignment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertRegionAssignmentRequest, "runtime", proto3);
_define_property(UpsertRegionAssignmentRequest, "typeName", "mono.datagateway.v1.UpsertRegionAssignmentRequest");
_define_property(UpsertRegionAssignmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "region_assignment",
            kind: "message",
            T: RegionAssignment
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertRegionAssignmentResponse
 */ export class UpsertRegionAssignmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertRegionAssignmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertRegionAssignmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertRegionAssignmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertRegionAssignmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegionAssignment region_assignment = 1;
   */ _define_property(this, "regionAssignment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertRegionAssignmentResponse, "runtime", proto3);
_define_property(UpsertRegionAssignmentResponse, "typeName", "mono.datagateway.v1.UpsertRegionAssignmentResponse");
_define_property(UpsertRegionAssignmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "region_assignment",
            kind: "message",
            T: RegionAssignment
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRegionAssignmentsRequest
 */ export class ListRegionAssignmentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRegionAssignmentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRegionAssignmentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRegionAssignmentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRegionAssignmentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RegionAssignmentFilter filter = 1;
   */ _define_property(this, "filter", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRegionAssignmentsRequest, "runtime", proto3);
_define_property(ListRegionAssignmentsRequest, "typeName", "mono.datagateway.v1.ListRegionAssignmentsRequest");
_define_property(ListRegionAssignmentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: RegionAssignmentFilter
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRegionAssignmentsResponse
 */ export class ListRegionAssignmentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRegionAssignmentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRegionAssignmentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRegionAssignmentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRegionAssignmentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.RegionAssignment region_assignments = 1;
   */ _define_property(this, "regionAssignments", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRegionAssignmentsResponse, "runtime", proto3);
_define_property(ListRegionAssignmentsResponse, "typeName", "mono.datagateway.v1.ListRegionAssignmentsResponse");
_define_property(ListRegionAssignmentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "region_assignments",
            kind: "message",
            T: RegionAssignment,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.OperationalAuditEventFilter
 */ export class OperationalAuditEventFilter extends Message {
    static fromBinary(bytes, options) {
        return new OperationalAuditEventFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OperationalAuditEventFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OperationalAuditEventFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OperationalAuditEventFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string actor_user_id = 2;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: string action_key_prefix = 3;
   */ _define_property(this, "actionKeyPrefix", ""), /**
   * @generated from field: string object_type = 4;
   */ _define_property(this, "objectType", ""), /**
   * @generated from field: string object_id = 5;
   */ _define_property(this, "objectId", ""), /**
   * @generated from field: string correlation_id = 6;
   */ _define_property(this, "correlationId", ""), /**
   * @generated from field: google.protobuf.Timestamp since = 7;
   */ _define_property(this, "since", void 0), /**
   * @generated from field: google.protobuf.Timestamp until = 8;
   */ _define_property(this, "until", void 0), /**
   * Round 11: when true and the object is a program, ALSO match events
   * stamped with that program's scope_node_id — access-request
   * adjudications and other scope-stamped events surface on the program
   * timeline (they carry the scope, not the program's object id).
   *
   * @generated from field: bool include_scope_events = 9;
   */ _define_property(this, "includeScopeEvents", false), /**
   * SAD-125: match any event whose action_key starts with one of these
   * prefixes (OR'd together, AND'd with action_key_prefix and the rest of
   * the filter). Empty means no prefix-set constraint. The program History
   * surface passes a curated allowlist of key-workflow prefixes here so the
   * append-only ledger's internal churn (access-projection resolver rows,
   * view telemetry) stays off a user-facing timeline while the count and
   * pagination totals still reflect the filtered set.
   *
   * @generated from field: repeated string action_key_prefixes = 10;
   */ _define_property(this, "actionKeyPrefixes", []), /**
   * SAD-777: drop any event whose action_key starts with one of these
   * prefixes (AND'd with the rest of the filter). The program History surface
   * excludes only the access-projection resolver churn (access.*) here, so
   * every other recorded write shows — a denylist of one known flood instead
   * of an allowlist that hid most of the ledger.
   *
   * @generated from field: repeated string exclude_action_key_prefixes = 11;
   */ _define_property(this, "excludeActionKeyPrefixes", []), /**
   * FND-27: exact match on OperationalAuditEvent.assist_run_id.
   *
   * @generated from field: string assist_run_id = 12;
   */ _define_property(this, "assistRunId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OperationalAuditEventFilter, "runtime", proto3);
_define_property(OperationalAuditEventFilter, "typeName", "mono.datagateway.v1.OperationalAuditEventFilter");
_define_property(OperationalAuditEventFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "action_key_prefix",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "correlation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "since",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "until",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "include_scope_events",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "action_key_prefixes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 11,
            name: "exclude_action_key_prefixes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 12,
            name: "assist_run_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.WriteOperationalAuditEventRequest
 */ export class WriteOperationalAuditEventRequest extends Message {
    static fromBinary(bytes, options) {
        return new WriteOperationalAuditEventRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WriteOperationalAuditEventRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WriteOperationalAuditEventRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WriteOperationalAuditEventRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OperationalAuditEvent event = 1;
   */ _define_property(this, "event", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WriteOperationalAuditEventRequest, "runtime", proto3);
_define_property(WriteOperationalAuditEventRequest, "typeName", "mono.datagateway.v1.WriteOperationalAuditEventRequest");
_define_property(WriteOperationalAuditEventRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "event",
            kind: "message",
            T: OperationalAuditEvent
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.WriteOperationalAuditEventResponse
 */ export class WriteOperationalAuditEventResponse extends Message {
    static fromBinary(bytes, options) {
        return new WriteOperationalAuditEventResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WriteOperationalAuditEventResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WriteOperationalAuditEventResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WriteOperationalAuditEventResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OperationalAuditEvent event = 1;
   */ _define_property(this, "event", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WriteOperationalAuditEventResponse, "runtime", proto3);
_define_property(WriteOperationalAuditEventResponse, "typeName", "mono.datagateway.v1.WriteOperationalAuditEventResponse");
_define_property(WriteOperationalAuditEventResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "event",
            kind: "message",
            T: OperationalAuditEvent
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetOperationalAuditEventRequest
 */ export class GetOperationalAuditEventRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetOperationalAuditEventRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOperationalAuditEventRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOperationalAuditEventRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOperationalAuditEventRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOperationalAuditEventRequest, "runtime", proto3);
_define_property(GetOperationalAuditEventRequest, "typeName", "mono.datagateway.v1.GetOperationalAuditEventRequest");
_define_property(GetOperationalAuditEventRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetOperationalAuditEventResponse
 */ export class GetOperationalAuditEventResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetOperationalAuditEventResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOperationalAuditEventResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOperationalAuditEventResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOperationalAuditEventResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OperationalAuditEvent event = 1;
   */ _define_property(this, "event", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOperationalAuditEventResponse, "runtime", proto3);
_define_property(GetOperationalAuditEventResponse, "typeName", "mono.datagateway.v1.GetOperationalAuditEventResponse");
_define_property(GetOperationalAuditEventResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "event",
            kind: "message",
            T: OperationalAuditEvent
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.QueryOperationalAuditEventsRequest
 */ export class QueryOperationalAuditEventsRequest extends Message {
    static fromBinary(bytes, options) {
        return new QueryOperationalAuditEventsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryOperationalAuditEventsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryOperationalAuditEventsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryOperationalAuditEventsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OperationalAuditEventFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(QueryOperationalAuditEventsRequest, "runtime", proto3);
_define_property(QueryOperationalAuditEventsRequest, "typeName", "mono.datagateway.v1.QueryOperationalAuditEventsRequest");
_define_property(QueryOperationalAuditEventsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: OperationalAuditEventFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.QueryOperationalAuditEventsResponse
 */ export class QueryOperationalAuditEventsResponse extends Message {
    static fromBinary(bytes, options) {
        return new QueryOperationalAuditEventsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QueryOperationalAuditEventsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QueryOperationalAuditEventsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QueryOperationalAuditEventsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.OperationalAuditEvent events = 1;
   */ _define_property(this, "events", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(QueryOperationalAuditEventsResponse, "runtime", proto3);
_define_property(QueryOperationalAuditEventsResponse, "typeName", "mono.datagateway.v1.QueryOperationalAuditEventsResponse");
_define_property(QueryOperationalAuditEventsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "events",
            kind: "message",
            T: OperationalAuditEvent,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetByCorrelationOperationalAuditEventsRequest
 */ export class GetByCorrelationOperationalAuditEventsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetByCorrelationOperationalAuditEventsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetByCorrelationOperationalAuditEventsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetByCorrelationOperationalAuditEventsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetByCorrelationOperationalAuditEventsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string correlation_id = 2;
   */ _define_property(this, "correlationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetByCorrelationOperationalAuditEventsRequest, "runtime", proto3);
_define_property(GetByCorrelationOperationalAuditEventsRequest, "typeName", "mono.datagateway.v1.GetByCorrelationOperationalAuditEventsRequest");
_define_property(GetByCorrelationOperationalAuditEventsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "correlation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetByCorrelationOperationalAuditEventsResponse
 */ export class GetByCorrelationOperationalAuditEventsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetByCorrelationOperationalAuditEventsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetByCorrelationOperationalAuditEventsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetByCorrelationOperationalAuditEventsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetByCorrelationOperationalAuditEventsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.OperationalAuditEvent events = 1;
   */ _define_property(this, "events", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetByCorrelationOperationalAuditEventsResponse, "runtime", proto3);
_define_property(GetByCorrelationOperationalAuditEventsResponse, "typeName", "mono.datagateway.v1.GetByCorrelationOperationalAuditEventsResponse");
_define_property(GetByCorrelationOperationalAuditEventsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "events",
            kind: "message",
            T: OperationalAuditEvent,
            repeated: true
        }
    ]));
/**
 * ListMyActivityRequest pages the caller's own operational-audit events.
 * tenant_id is present so the tenant-scope interceptor can bind the request
 * to the principal; the handler reads the tenant and the actor from the
 * principal, never from a caller-supplied actor field (there is none).
 *
 * @generated from message mono.datagateway.v1.ListMyActivityRequest
 */ export class ListMyActivityRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListMyActivityRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListMyActivityRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListMyActivityRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListMyActivityRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * Opaque keyset token from the previous page. Empty starts at the newest event.
   *
   * @generated from field: string cursor = 2;
   */ _define_property(this, "cursor", ""), /**
   * 0 selects the server default. Values above the server cap are clamped.
   *
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * action_key prefix, for example "change_set" or "document". Empty is every kind.
   *
   * @generated from field: string kind = 4;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: google.protobuf.Timestamp since = 5;
   */ _define_property(this, "since", void 0), /**
   * @generated from field: google.protobuf.Timestamp until = 6;
   */ _define_property(this, "until", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListMyActivityRequest, "runtime", proto3);
_define_property(ListMyActivityRequest, "typeName", "mono.datagateway.v1.ListMyActivityRequest");
_define_property(ListMyActivityRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "cursor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "since",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "until",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * MyActivityEvent is one of the caller's own audit rows after view masking.
 * When record_hidden is set, the name and the identifiers of the record are
 * blank: the caller can see that they did something, and when, but not which
 * record. When details_withheld is set, the before/after payloads are blank
 * even if the record's name is still shown (the same gate as program History).
 *
 * @generated from message mono.datagateway.v1.MyActivityEvent
 */ export class MyActivityEvent extends Message {
    static fromBinary(bytes, options) {
        return new MyActivityEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MyActivityEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MyActivityEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MyActivityEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string action_key = 2;
   */ _define_property(this, "actionKey", ""), /**
   * @generated from field: string kind = 3;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string object_type = 4;
   */ _define_property(this, "objectType", ""), /**
   * @generated from field: string object_id = 5;
   */ _define_property(this, "objectId", ""), /**
   * @generated from field: string program_id = 6;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string record_name = 7;
   */ _define_property(this, "recordName", ""), /**
   * @generated from field: string previous_state_json = 8;
   */ _define_property(this, "previousStateJson", ""), /**
   * @generated from field: string new_state_json = 9;
   */ _define_property(this, "newStateJson", ""), /**
   * @generated from field: google.protobuf.Timestamp occurred_at = 10;
   */ _define_property(this, "occurredAt", void 0), /**
   * @generated from field: bool details_withheld = 11;
   */ _define_property(this, "detailsWithheld", false), /**
   * @generated from field: bool record_hidden = 12;
   */ _define_property(this, "recordHidden", false), /**
   * @generated from field: string correlation_id = 13;
   */ _define_property(this, "correlationId", ""), /**
   * The program this record belongs to, when the caller can still read that
   * program. record_name stays the record's own name; this is context only.
   *
   * @generated from field: string program_name = 14;
   */ _define_property(this, "programName", ""), /**
   * The other person on a role grant or revoke. Empty for every other kind.
   *
   * @generated from field: string counterpart_name = 15;
   */ _define_property(this, "counterpartName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MyActivityEvent, "runtime", proto3);
_define_property(MyActivityEvent, "typeName", "mono.datagateway.v1.MyActivityEvent");
_define_property(MyActivityEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "action_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "record_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "previous_state_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "new_state_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "occurred_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "details_withheld",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "record_hidden",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "correlation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "program_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "counterpart_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListMyActivityResponse
 */ export class ListMyActivityResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListMyActivityResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListMyActivityResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListMyActivityResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListMyActivityResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.MyActivityEvent events = 1;
   */ _define_property(this, "events", []), /**
   * @generated from field: string next_cursor = 2;
   */ _define_property(this, "nextCursor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListMyActivityResponse, "runtime", proto3);
_define_property(ListMyActivityResponse, "typeName", "mono.datagateway.v1.ListMyActivityResponse");
_define_property(ListMyActivityResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "events",
            kind: "message",
            T: MyActivityEvent,
            repeated: true
        },
        {
            no: 2,
            name: "next_cursor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.TenantEnumValue
 */ export class TenantEnumValue extends Message {
    static fromBinary(bytes, options) {
        return new TenantEnumValue().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TenantEnumValue().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TenantEnumValue().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TenantEnumValue, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string domain = 3;
   */ _define_property(this, "domain", ""), /**
   * @generated from field: string code = 4;
   */ _define_property(this, "code", ""), /**
   * @generated from field: string display_label = 5;
   */ _define_property(this, "displayLabel", ""), /**
   * @generated from field: string description = 6;
   */ _define_property(this, "description", ""), /**
   * @generated from field: int32 sort_order = 7;
   */ _define_property(this, "sortOrder", 0), /**
   * @generated from field: bool is_system = 8;
   */ _define_property(this, "isSystem", false), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 11;
   */ _define_property(this, "deletedAt", void 0), /**
   * @generated from field: bool is_leadership = 12;
   */ _define_property(this, "isLeadership", false), /**
   * Names a row in authz.role_bundle — the permission template this role name
   * resolves to. Empty means "no bundle linked": the name is purely
   * informational and grants nothing. Only meaningful when domain='role_type'
   * (a DB CHECK rejects it elsewhere). No FK: bundles are global (tenant_id
   * NULL) or tenant-scoped, so the key alone is not unique; pangaea validates
   * it on write via RoleBundleRepository.GetByKey.
   *
   * @generated from field: string role_bundle_key = 13;
   */ _define_property(this, "roleBundleKey", ""), /**
   * Business unit this role name is offered in. Empty/NULL means "available in
   * EVERY business unit", not "unassigned" — most role names are company-wide.
   * Only meaningful when domain='role_type'.
   *
   * @generated from field: string business_unit_id = 14;
   */ _define_property(this, "businessUnitId", ""), /**
   * JSON-encoded free-form metadata. role_type rows carry the roster->grant
   * mapping here: {"bundle_key": "...", "self_service": bool}.
   *
   * @generated from field: string metadata_json = 15;
   */ _define_property(this, "metadataJson", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TenantEnumValue, "runtime", proto3);
_define_property(TenantEnumValue, "typeName", "mono.datagateway.v1.TenantEnumValue");
_define_property(TenantEnumValue, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "domain",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "display_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "is_system",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "is_leadership",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "role_bundle_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "metadata_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.TenantEnumListFilter
 */ export class TenantEnumListFilter extends Message {
    static fromBinary(bytes, options) {
        return new TenantEnumListFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TenantEnumListFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TenantEnumListFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TenantEnumListFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string domain = 2;
   */ _define_property(this, "domain", ""), /**
   * @generated from field: bool include_system = 3;
   */ _define_property(this, "includeSystem", false), /**
   * When set, returns rows whose business_unit_id IS NULL **OR** equals this
   * id — the globally-available role names PLUS this BU's own. This is NOT an
   * equality filter: a plain `business_unit_id = ?` would hide every global
   * role name (PM, PfD, …) and leave a BU showing only its handful of local
   * ones. Empty means no BU filtering at all (every row, global and scoped).
   *
   * @generated from field: string business_unit_id = 4;
   */ _define_property(this, "businessUnitId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TenantEnumListFilter, "runtime", proto3);
_define_property(TenantEnumListFilter, "typeName", "mono.datagateway.v1.TenantEnumListFilter");
_define_property(TenantEnumListFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "domain",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "include_system",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GovernmentOrganization
 */ export class GovernmentOrganization extends Message {
    static fromBinary(bytes, options) {
        return new GovernmentOrganization().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GovernmentOrganization().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GovernmentOrganization().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GovernmentOrganization, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string acronym = 4;
   */ _define_property(this, "acronym", ""), /**
   * @generated from field: string org_type = 5;
   */ _define_property(this, "orgType", ""), /**
   * @generated from field: string parent_id = 6;
   */ _define_property(this, "parentId", ""), /**
   * @generated from field: int32 level = 7;
   */ _define_property(this, "level", 0), /**
   * @generated from field: string materialized_path = 8;
   */ _define_property(this, "materializedPath", ""), /**
   * @generated from field: string website = 9;
   */ _define_property(this, "website", ""), /**
   * @generated from field: string notes = 10;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 13;
   */ _define_property(this, "deletedAt", void 0), /**
   * Ancestor chain for pickers, e.g. "Department of Veterans Affairs › VBA › VR&E".
   *
   * @generated from field: string display_path = 14;
   */ _define_property(this, "displayPath", ""), /**
   * REG-55: survivor id when this row was merged into another; lists hide losers.
   *
   * @generated from field: string merged_into_id = 15;
   */ _define_property(this, "mergedIntoId", ""), /**
   * SAM AAC; trimmed+uppercased, empty = none; unique per tenant
   *
   * @generated from field: string office_code = 16;
   */ _define_property(this, "officeCode", ""), /**
   * @generated from field: string location_text = 17;
   */ _define_property(this, "locationText", ""), /**
   * TENANT|USASPENDING|CURATED|SAM_FEDERAL_HIERARCHY (empty = TENANT)
   *
   * @generated from field: string reference_source = 18;
   */ _define_property(this, "referenceSource", ""), /**
   * @generated from field: string reference_source_id = 19;
   */ _define_property(this, "referenceSourceId", ""), /**
   * USAspending toptier agency code; read-only reference fact
   *
   * @generated from field: string toptier_code = 20;
   */ _define_property(this, "toptierCode", ""), /**
   * USAspending subtier agency code; learned by the resolver
   *
   * @generated from field: string subtier_code = 21;
   */ _define_property(this, "subtierCode", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GovernmentOrganization, "runtime", proto3);
_define_property(GovernmentOrganization, "typeName", "mono.datagateway.v1.GovernmentOrganization");
_define_property(GovernmentOrganization, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "acronym",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "org_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "parent_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "level",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "materialized_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "website",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "display_path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "merged_into_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "office_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "location_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "reference_source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "reference_source_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "toptier_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "subtier_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GovernmentOrganizationListFilter
 */ export class GovernmentOrganizationListFilter extends Message {
    static fromBinary(bytes, options) {
        return new GovernmentOrganizationListFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GovernmentOrganizationListFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GovernmentOrganizationListFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GovernmentOrganizationListFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string parent_id = 2;
   */ _define_property(this, "parentId", ""), /**
   * @generated from field: string org_type = 3;
   */ _define_property(this, "orgType", ""), /**
   * @generated from field: string name_prefix = 4;
   */ _define_property(this, "namePrefix", ""), /**
   * @generated from field: bool include_system = 5;
   */ _define_property(this, "includeSystem", false), /**
   * When false (default), excludes USAspending tier=office (fiscal/obligation codes).
   * Curated FOM nodes and USAspending cabinet/subtier (tier=cabinet|agency) remain visible.
   *
   * @generated from field: bool include_usaspending_offices = 6;
   */ _define_property(this, "includeUsaspendingOffices", false), /**
   * Case-insensitive substring match on name and acronym (ignores parent_id when set).
   *
   * @generated from field: string search = 7;
   */ _define_property(this, "search", ""), /**
   * When true, only top-level nodes (parent_id IS NULL). Mutually exclusive with search.
   *
   * @generated from field: bool roots_only = 8;
   */ _define_property(this, "rootsOnly", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GovernmentOrganizationListFilter, "runtime", proto3);
_define_property(GovernmentOrganizationListFilter, "typeName", "mono.datagateway.v1.GovernmentOrganizationListFilter");
_define_property(GovernmentOrganizationListFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "parent_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "org_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "name_prefix",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "include_system",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "include_usaspending_offices",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "roots_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProgramRoleAssignment
 */ export class ProgramRoleAssignment extends Message {
    static fromBinary(bytes, options) {
        return new ProgramRoleAssignment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramRoleAssignment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramRoleAssignment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramRoleAssignment, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string contact_id = 4;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string role_category = 5;
   */ _define_property(this, "roleCategory", ""), /**
   * @generated from field: string role_type_id = 6;
   */ _define_property(this, "roleTypeId", ""), /**
   * denormalized from enum
   *
   * @generated from field: string role_type_code = 7;
   */ _define_property(this, "roleTypeCode", ""), /**
   * @generated from field: string organization_id = 8;
   */ _define_property(this, "organizationId", ""), /**
   * @generated from field: bool is_primary = 9;
   */ _define_property(this, "isPrimary", false), /**
   * @generated from field: google.protobuf.Timestamp assigned_at = 10;
   */ _define_property(this, "assignedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp removed_at = 11;
   */ _define_property(this, "removedAt", void 0), /**
   * @generated from field: string notes = 12;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 14;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 15;
   */ _define_property(this, "deletedAt", void 0), /**
   * @generated from field: string contact_display_name = 16;
   */ _define_property(this, "contactDisplayName", ""), /**
   * @generated from field: string contact_email = 17;
   */ _define_property(this, "contactEmail", ""), /**
   * @generated from field: string contact_title = 18;
   */ _define_property(this, "contactTitle", ""), /**
   * @generated from field: string role_type_label = 19;
   */ _define_property(this, "roleTypeLabel", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramRoleAssignment, "runtime", proto3);
_define_property(ProgramRoleAssignment, "typeName", "mono.datagateway.v1.ProgramRoleAssignment");
_define_property(ProgramRoleAssignment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "role_category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "role_type_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "role_type_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "is_primary",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "assigned_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "removed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 15,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "contact_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "contact_email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "contact_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "role_type_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProgramRoleAssignmentListFilter
 */ export class ProgramRoleAssignmentListFilter extends Message {
    static fromBinary(bytes, options) {
        return new ProgramRoleAssignmentListFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramRoleAssignmentListFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramRoleAssignmentListFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramRoleAssignmentListFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string contact_id = 3;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string role_category = 4;
   */ _define_property(this, "roleCategory", ""), /**
   * @generated from field: bool active_only = 5;
   */ _define_property(this, "activeOnly", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramRoleAssignmentListFilter, "runtime", proto3);
_define_property(ProgramRoleAssignmentListFilter, "typeName", "mono.datagateway.v1.ProgramRoleAssignmentListFilter");
_define_property(ProgramRoleAssignmentListFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "role_category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "active_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetTenantEnumValueRequest
 */ export class GetTenantEnumValueRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetTenantEnumValueRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetTenantEnumValueRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetTenantEnumValueRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetTenantEnumValueRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetTenantEnumValueRequest, "runtime", proto3);
_define_property(GetTenantEnumValueRequest, "typeName", "mono.datagateway.v1.GetTenantEnumValueRequest");
_define_property(GetTenantEnumValueRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetTenantEnumValueResponse
 */ export class GetTenantEnumValueResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetTenantEnumValueResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetTenantEnumValueResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetTenantEnumValueResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetTenantEnumValueResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.TenantEnumValue tenant_enum_value = 1;
   */ _define_property(this, "tenantEnumValue", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetTenantEnumValueResponse, "runtime", proto3);
_define_property(GetTenantEnumValueResponse, "typeName", "mono.datagateway.v1.GetTenantEnumValueResponse");
_define_property(GetTenantEnumValueResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_enum_value",
            kind: "message",
            T: TenantEnumValue
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateTenantEnumValueRequest
 */ export class CreateTenantEnumValueRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateTenantEnumValueRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateTenantEnumValueRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateTenantEnumValueRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateTenantEnumValueRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.TenantEnumValue tenant_enum_value = 1;
   */ _define_property(this, "tenantEnumValue", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateTenantEnumValueRequest, "runtime", proto3);
_define_property(CreateTenantEnumValueRequest, "typeName", "mono.datagateway.v1.CreateTenantEnumValueRequest");
_define_property(CreateTenantEnumValueRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_enum_value",
            kind: "message",
            T: TenantEnumValue
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateTenantEnumValueResponse
 */ export class CreateTenantEnumValueResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateTenantEnumValueResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateTenantEnumValueResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateTenantEnumValueResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateTenantEnumValueResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.TenantEnumValue tenant_enum_value = 1;
   */ _define_property(this, "tenantEnumValue", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateTenantEnumValueResponse, "runtime", proto3);
_define_property(CreateTenantEnumValueResponse, "typeName", "mono.datagateway.v1.CreateTenantEnumValueResponse");
_define_property(CreateTenantEnumValueResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_enum_value",
            kind: "message",
            T: TenantEnumValue
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateTenantEnumValueRequest
 */ export class UpdateTenantEnumValueRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateTenantEnumValueRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateTenantEnumValueRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateTenantEnumValueRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateTenantEnumValueRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.TenantEnumValue tenant_enum_value = 1;
   */ _define_property(this, "tenantEnumValue", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateTenantEnumValueRequest, "runtime", proto3);
_define_property(UpdateTenantEnumValueRequest, "typeName", "mono.datagateway.v1.UpdateTenantEnumValueRequest");
_define_property(UpdateTenantEnumValueRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_enum_value",
            kind: "message",
            T: TenantEnumValue
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateTenantEnumValueResponse
 */ export class UpdateTenantEnumValueResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateTenantEnumValueResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateTenantEnumValueResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateTenantEnumValueResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateTenantEnumValueResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.TenantEnumValue tenant_enum_value = 1;
   */ _define_property(this, "tenantEnumValue", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateTenantEnumValueResponse, "runtime", proto3);
_define_property(UpdateTenantEnumValueResponse, "typeName", "mono.datagateway.v1.UpdateTenantEnumValueResponse");
_define_property(UpdateTenantEnumValueResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_enum_value",
            kind: "message",
            T: TenantEnumValue
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListTenantEnumValuesRequest
 */ export class ListTenantEnumValuesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListTenantEnumValuesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListTenantEnumValuesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListTenantEnumValuesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListTenantEnumValuesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.TenantEnumListFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListTenantEnumValuesRequest, "runtime", proto3);
_define_property(ListTenantEnumValuesRequest, "typeName", "mono.datagateway.v1.ListTenantEnumValuesRequest");
_define_property(ListTenantEnumValuesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: TenantEnumListFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListTenantEnumValuesResponse
 */ export class ListTenantEnumValuesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListTenantEnumValuesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListTenantEnumValuesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListTenantEnumValuesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListTenantEnumValuesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.TenantEnumValue tenant_enum_values = 1;
   */ _define_property(this, "tenantEnumValues", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero), /**
   * @generated from field: map<string, int32> usage_program_count_by_id = 3;
   */ _define_property(this, "usageProgramCountById", {}), /**
   * Distinct registry contracts linked (govcon.program_opportunity_links) to programs whose roster uses the role.
   *
   * @generated from field: map<string, int32> usage_contract_count_by_id = 4;
   */ _define_property(this, "usageContractCountById", {});
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListTenantEnumValuesResponse, "runtime", proto3);
_define_property(ListTenantEnumValuesResponse, "typeName", "mono.datagateway.v1.ListTenantEnumValuesResponse");
_define_property(ListTenantEnumValuesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_enum_values",
            kind: "message",
            T: TenantEnumValue,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 3,
            name: "usage_program_count_by_id",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 5 /* ScalarType.INT32 */ 
            }
        },
        {
            no: 4,
            name: "usage_contract_count_by_id",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 5 /* ScalarType.INT32 */ 
            }
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteTenantEnumValueRequest
 */ export class DeleteTenantEnumValueRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteTenantEnumValueRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteTenantEnumValueRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteTenantEnumValueRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteTenantEnumValueRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteTenantEnumValueRequest, "runtime", proto3);
_define_property(DeleteTenantEnumValueRequest, "typeName", "mono.datagateway.v1.DeleteTenantEnumValueRequest");
_define_property(DeleteTenantEnumValueRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteTenantEnumValueResponse
 */ export class DeleteTenantEnumValueResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteTenantEnumValueResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteTenantEnumValueResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteTenantEnumValueResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteTenantEnumValueResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteTenantEnumValueResponse, "runtime", proto3);
_define_property(DeleteTenantEnumValueResponse, "typeName", "mono.datagateway.v1.DeleteTenantEnumValueResponse");
_define_property(DeleteTenantEnumValueResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetGovernmentOrganizationRequest
 */ export class GetGovernmentOrganizationRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetGovernmentOrganizationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetGovernmentOrganizationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetGovernmentOrganizationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetGovernmentOrganizationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetGovernmentOrganizationRequest, "runtime", proto3);
_define_property(GetGovernmentOrganizationRequest, "typeName", "mono.datagateway.v1.GetGovernmentOrganizationRequest");
_define_property(GetGovernmentOrganizationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetGovernmentOrganizationResponse
 */ export class GetGovernmentOrganizationResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetGovernmentOrganizationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetGovernmentOrganizationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetGovernmentOrganizationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetGovernmentOrganizationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GovernmentOrganization government_organization = 1;
   */ _define_property(this, "governmentOrganization", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetGovernmentOrganizationResponse, "runtime", proto3);
_define_property(GetGovernmentOrganizationResponse, "typeName", "mono.datagateway.v1.GetGovernmentOrganizationResponse");
_define_property(GetGovernmentOrganizationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "government_organization",
            kind: "message",
            T: GovernmentOrganization
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateGovernmentOrganizationRequest
 */ export class CreateGovernmentOrganizationRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateGovernmentOrganizationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateGovernmentOrganizationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateGovernmentOrganizationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateGovernmentOrganizationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GovernmentOrganization government_organization = 1;
   */ _define_property(this, "governmentOrganization", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateGovernmentOrganizationRequest, "runtime", proto3);
_define_property(CreateGovernmentOrganizationRequest, "typeName", "mono.datagateway.v1.CreateGovernmentOrganizationRequest");
_define_property(CreateGovernmentOrganizationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "government_organization",
            kind: "message",
            T: GovernmentOrganization
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateGovernmentOrganizationResponse
 */ export class CreateGovernmentOrganizationResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateGovernmentOrganizationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateGovernmentOrganizationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateGovernmentOrganizationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateGovernmentOrganizationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GovernmentOrganization government_organization = 1;
   */ _define_property(this, "governmentOrganization", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateGovernmentOrganizationResponse, "runtime", proto3);
_define_property(CreateGovernmentOrganizationResponse, "typeName", "mono.datagateway.v1.CreateGovernmentOrganizationResponse");
_define_property(CreateGovernmentOrganizationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "government_organization",
            kind: "message",
            T: GovernmentOrganization
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateGovernmentOrganizationRequest
 */ export class UpdateGovernmentOrganizationRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateGovernmentOrganizationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateGovernmentOrganizationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateGovernmentOrganizationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateGovernmentOrganizationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GovernmentOrganization government_organization = 1;
   */ _define_property(this, "governmentOrganization", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateGovernmentOrganizationRequest, "runtime", proto3);
_define_property(UpdateGovernmentOrganizationRequest, "typeName", "mono.datagateway.v1.UpdateGovernmentOrganizationRequest");
_define_property(UpdateGovernmentOrganizationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "government_organization",
            kind: "message",
            T: GovernmentOrganization
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateGovernmentOrganizationResponse
 */ export class UpdateGovernmentOrganizationResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateGovernmentOrganizationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateGovernmentOrganizationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateGovernmentOrganizationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateGovernmentOrganizationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GovernmentOrganization government_organization = 1;
   */ _define_property(this, "governmentOrganization", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateGovernmentOrganizationResponse, "runtime", proto3);
_define_property(UpdateGovernmentOrganizationResponse, "typeName", "mono.datagateway.v1.UpdateGovernmentOrganizationResponse");
_define_property(UpdateGovernmentOrganizationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "government_organization",
            kind: "message",
            T: GovernmentOrganization
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListGovernmentOrganizationsRequest
 */ export class ListGovernmentOrganizationsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListGovernmentOrganizationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListGovernmentOrganizationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListGovernmentOrganizationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListGovernmentOrganizationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GovernmentOrganizationListFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListGovernmentOrganizationsRequest, "runtime", proto3);
_define_property(ListGovernmentOrganizationsRequest, "typeName", "mono.datagateway.v1.ListGovernmentOrganizationsRequest");
_define_property(ListGovernmentOrganizationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: GovernmentOrganizationListFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListGovernmentOrganizationsResponse
 */ export class ListGovernmentOrganizationsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListGovernmentOrganizationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListGovernmentOrganizationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListGovernmentOrganizationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListGovernmentOrganizationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.GovernmentOrganization government_organizations = 1;
   */ _define_property(this, "governmentOrganizations", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListGovernmentOrganizationsResponse, "runtime", proto3);
_define_property(ListGovernmentOrganizationsResponse, "typeName", "mono.datagateway.v1.ListGovernmentOrganizationsResponse");
_define_property(ListGovernmentOrganizationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "government_organizations",
            kind: "message",
            T: GovernmentOrganization,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * tenant_id is the caller's tenant: a row of any other tenant is NotFound, and a
 * `_system` row is PermissionDenied regardless (SAD-435).
 *
 * @generated from message mono.datagateway.v1.DeleteGovernmentOrganizationRequest
 */ export class DeleteGovernmentOrganizationRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteGovernmentOrganizationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteGovernmentOrganizationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteGovernmentOrganizationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteGovernmentOrganizationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false), /**
   * @generated from field: string tenant_id = 3;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteGovernmentOrganizationRequest, "runtime", proto3);
_define_property(DeleteGovernmentOrganizationRequest, "typeName", "mono.datagateway.v1.DeleteGovernmentOrganizationRequest");
_define_property(DeleteGovernmentOrganizationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteGovernmentOrganizationResponse
 */ export class DeleteGovernmentOrganizationResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteGovernmentOrganizationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteGovernmentOrganizationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteGovernmentOrganizationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteGovernmentOrganizationResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteGovernmentOrganizationResponse, "runtime", proto3);
_define_property(DeleteGovernmentOrganizationResponse, "typeName", "mono.datagateway.v1.DeleteGovernmentOrganizationResponse");
_define_property(DeleteGovernmentOrganizationResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.GetProgramRoleAssignmentRequest
 */ export class GetProgramRoleAssignmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramRoleAssignmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramRoleAssignmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramRoleAssignmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramRoleAssignmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramRoleAssignmentRequest, "runtime", proto3);
_define_property(GetProgramRoleAssignmentRequest, "typeName", "mono.datagateway.v1.GetProgramRoleAssignmentRequest");
_define_property(GetProgramRoleAssignmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProgramRoleAssignmentResponse
 */ export class GetProgramRoleAssignmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramRoleAssignmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramRoleAssignmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramRoleAssignmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramRoleAssignmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramRoleAssignment program_role_assignment = 1;
   */ _define_property(this, "programRoleAssignment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramRoleAssignmentResponse, "runtime", proto3);
_define_property(GetProgramRoleAssignmentResponse, "typeName", "mono.datagateway.v1.GetProgramRoleAssignmentResponse");
_define_property(GetProgramRoleAssignmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_role_assignment",
            kind: "message",
            T: ProgramRoleAssignment
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateProgramRoleAssignmentRequest
 */ export class CreateProgramRoleAssignmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateProgramRoleAssignmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProgramRoleAssignmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProgramRoleAssignmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProgramRoleAssignmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramRoleAssignment program_role_assignment = 1;
   */ _define_property(this, "programRoleAssignment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProgramRoleAssignmentRequest, "runtime", proto3);
_define_property(CreateProgramRoleAssignmentRequest, "typeName", "mono.datagateway.v1.CreateProgramRoleAssignmentRequest");
_define_property(CreateProgramRoleAssignmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_role_assignment",
            kind: "message",
            T: ProgramRoleAssignment
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateProgramRoleAssignmentResponse
 */ export class CreateProgramRoleAssignmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateProgramRoleAssignmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateProgramRoleAssignmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateProgramRoleAssignmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateProgramRoleAssignmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramRoleAssignment program_role_assignment = 1;
   */ _define_property(this, "programRoleAssignment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateProgramRoleAssignmentResponse, "runtime", proto3);
_define_property(CreateProgramRoleAssignmentResponse, "typeName", "mono.datagateway.v1.CreateProgramRoleAssignmentResponse");
_define_property(CreateProgramRoleAssignmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_role_assignment",
            kind: "message",
            T: ProgramRoleAssignment
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateProgramRoleAssignmentRequest
 */ export class UpdateProgramRoleAssignmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProgramRoleAssignmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProgramRoleAssignmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProgramRoleAssignmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProgramRoleAssignmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramRoleAssignment program_role_assignment = 1;
   */ _define_property(this, "programRoleAssignment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProgramRoleAssignmentRequest, "runtime", proto3);
_define_property(UpdateProgramRoleAssignmentRequest, "typeName", "mono.datagateway.v1.UpdateProgramRoleAssignmentRequest");
_define_property(UpdateProgramRoleAssignmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_role_assignment",
            kind: "message",
            T: ProgramRoleAssignment
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateProgramRoleAssignmentResponse
 */ export class UpdateProgramRoleAssignmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateProgramRoleAssignmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateProgramRoleAssignmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateProgramRoleAssignmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateProgramRoleAssignmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramRoleAssignment program_role_assignment = 1;
   */ _define_property(this, "programRoleAssignment", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateProgramRoleAssignmentResponse, "runtime", proto3);
_define_property(UpdateProgramRoleAssignmentResponse, "typeName", "mono.datagateway.v1.UpdateProgramRoleAssignmentResponse");
_define_property(UpdateProgramRoleAssignmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_role_assignment",
            kind: "message",
            T: ProgramRoleAssignment
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramRoleAssignmentsRequest
 */ export class ListProgramRoleAssignmentsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramRoleAssignmentsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramRoleAssignmentsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramRoleAssignmentsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramRoleAssignmentsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ProgramRoleAssignmentListFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0), /**
   * @generated from field: bool include_deleted = 4;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramRoleAssignmentsRequest, "runtime", proto3);
_define_property(ListProgramRoleAssignmentsRequest, "typeName", "mono.datagateway.v1.ListProgramRoleAssignmentsRequest");
_define_property(ListProgramRoleAssignmentsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: ProgramRoleAssignmentListFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramRoleAssignmentsResponse
 */ export class ListProgramRoleAssignmentsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramRoleAssignmentsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramRoleAssignmentsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramRoleAssignmentsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramRoleAssignmentsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ProgramRoleAssignment program_role_assignments = 1;
   */ _define_property(this, "programRoleAssignments", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramRoleAssignmentsResponse, "runtime", proto3);
_define_property(ListProgramRoleAssignmentsResponse, "typeName", "mono.datagateway.v1.ListProgramRoleAssignmentsResponse");
_define_property(ListProgramRoleAssignmentsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_role_assignments",
            kind: "message",
            T: ProgramRoleAssignment,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteProgramRoleAssignmentRequest
 */ export class DeleteProgramRoleAssignmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramRoleAssignmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramRoleAssignmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramRoleAssignmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramRoleAssignmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool hard_delete = 2;
   */ _define_property(this, "hardDelete", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramRoleAssignmentRequest, "runtime", proto3);
_define_property(DeleteProgramRoleAssignmentRequest, "typeName", "mono.datagateway.v1.DeleteProgramRoleAssignmentRequest");
_define_property(DeleteProgramRoleAssignmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hard_delete",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteProgramRoleAssignmentResponse
 */ export class DeleteProgramRoleAssignmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteProgramRoleAssignmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteProgramRoleAssignmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteProgramRoleAssignmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteProgramRoleAssignmentResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteProgramRoleAssignmentResponse, "runtime", proto3);
_define_property(DeleteProgramRoleAssignmentResponse, "typeName", "mono.datagateway.v1.DeleteProgramRoleAssignmentResponse");
_define_property(DeleteProgramRoleAssignmentResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * KPIFilter scopes a rollup to a tenant and, optionally, an org slice +
 * contract lifecycle state. tenant_id is required; empty optional fields are
 * ignored (no predicate). program_id narrows to a single program (used by
 * ryugu's per-program financial summary).
 *
 * @generated from message mono.datagateway.v1.KPIFilter
 */ export class KPIFilter extends Message {
    static fromBinary(bytes, options) {
        return new KPIFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new KPIFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new KPIFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(KPIFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string sector_id = 2;
   */ _define_property(this, "sectorId", ""), /**
   * @generated from field: string business_unit_id = 3;
   */ _define_property(this, "businessUnitId", ""), /**
   * @generated from field: string portfolio_id = 4;
   */ _define_property(this, "portfolioId", ""), /**
   * @generated from field: string contract_state = 5;
   */ _define_property(this, "contractState", ""), /**
   * @generated from field: string program_id = 6;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(KPIFilter, "runtime", proto3);
_define_property(KPIFilter, "typeName", "mono.datagateway.v1.KPIFilter");
_define_property(KPIFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "sector_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "portfolio_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "contract_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ProgramKPIRow is the SQL-computed aggregate for one program. ryugu maps it to
 * a dashboard health row and applies the KPI1-4 compliance thresholds; the
 * command-center rollups sum these across programs. has_* flags distinguish
 * "no evaluation yet" (treated as compliant) from a real zero.
 *
 * @generated from message mono.datagateway.v1.ProgramKPIRow
 */ export class ProgramKPIRow extends Message {
    static fromBinary(bytes, options) {
        return new ProgramKPIRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProgramKPIRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProgramKPIRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProgramKPIRow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * program_name_short
   *
   * @generated from field: string program_name = 2;
   */ _define_property(this, "programName", ""), /**
   * @generated from field: string contract_number = 3;
   */ _define_property(this, "contractNumber", ""), /**
   * @generated from field: string sector_id = 4;
   */ _define_property(this, "sectorId", ""), /**
   * @generated from field: string business_unit_id = 5;
   */ _define_property(this, "businessUnitId", ""), /**
   * @generated from field: string portfolio_id = 6;
   */ _define_property(this, "portfolioId", ""), /**
   * @generated from field: string operational_state_id = 7;
   */ _define_property(this, "operationalStateId", ""), /**
   * @generated from field: string operational_state_label = 8;
   */ _define_property(this, "operationalStateLabel", ""), /**
   * Funding / value
   *
   * SUM(PoP totals) + SUM(optional-task totals)
   *
   * @generated from field: double current_tcv = 9;
   */ _define_property(this, "currentTcv", 0), /**
   * SUM(PoP funded) + SUM(optional-task funded)
   *
   * @generated from field: double funded_amount = 10;
   */ _define_property(this, "fundedAmount", 0), /**
   * funded_amount / current_tcv * 100
   *
   * @generated from field: double funded_percent = 11;
   */ _define_property(this, "fundedPercent", 0), /**
   * SUM(clin invoiced) / SUM(clin funded) * 100
   *
   * @generated from field: double funding_utilization_pct = 12;
   */ _define_property(this, "fundingUtilizationPct", 0), /**
   * SUM(company-assignment fte_count)
   *
   * @generated from field: double total_ftes = 13;
   */ _define_property(this, "totalFtes", 0), /**
   * KPI 1 inputs (deliverables)
   *
   * @generated from field: int64 total_tasks_closed = 14;
   */ _define_property(this, "totalTasksClosed", protoInt64.zero), /**
   * @generated from field: int64 tasks_closed_on_time = 15;
   */ _define_property(this, "tasksClosedOnTime", protoInt64.zero), /**
   * @generated from field: int64 overdue_tasks = 16;
   */ _define_property(this, "overdueTasks", protoInt64.zero), /**
   * SDS delivery-truth metrics
   *
   * on_time_flag true / evaluated tasks
   *
   * @generated from field: double on_time_pct = 17;
   */ _define_property(this, "onTimePct", 0), /**
   * evidence complete|exception|waived / all tasks
   *
   * @generated from field: double evidence_completeness_pct = 18;
   */ _define_property(this, "evidenceCompletenessPct", 0), /**
   * @generated from field: int64 open_risk_count = 19;
   */ _define_property(this, "openRiskCount", protoInt64.zero), /**
   * @generated from field: int64 open_issue_count = 20;
   */ _define_property(this, "openIssueCount", protoInt64.zero), /**
   * KPI 2 inputs (CPARS / QASP)
   *
   * @generated from field: bool has_cpars = 21;
   */ _define_property(this, "hasCpars", false), /**
   * @generated from field: double latest_cpars = 22;
   */ _define_property(this, "latestCpars", 0), /**
   * @generated from field: bool has_qasp = 23;
   */ _define_property(this, "hasQasp", false), /**
   * @generated from field: double latest_qasp = 24;
   */ _define_property(this, "latestQasp", 0), /**
   * KPI 3 inputs (financial). DSO compliance is computed in ryugu because it
   * needs the 3-month + deliverable-based-invoicing exemptions.
   *
   * @generated from field: bool has_eac = 25;
   */ _define_property(this, "hasEac", false), /**
   * @generated from field: double latest_dpaf_margin = 26;
   */ _define_property(this, "latestDpafMargin", 0), /**
   * @generated from field: double target_dpaf_margin = 27;
   */ _define_property(this, "targetDpafMargin", 0), /**
   * @generated from field: bool has_dso = 28;
   */ _define_property(this, "hasDso", false), /**
   * @generated from field: int32 latest_dso = 29;
   */ _define_property(this, "latestDso", 0), /**
   * @generated from field: google.protobuf.Timestamp dso_period_end = 30;
   */ _define_property(this, "dsoPeriodEnd", void 0), /**
   * @generated from field: google.protobuf.Timestamp contract_start_date = 31;
   */ _define_property(this, "contractStartDate", void 0), /**
   * @generated from field: bool deliverable_based_invoicing = 32;
   */ _define_property(this, "deliverableBasedInvoicing", false), /**
   * KPI 4 inputs (audit). pass/total are resolved in pangaea (frozen when the
   * latest non-final Program audit is published/closed, else live-counted from
   * its questions), so ryugu only compares pass == total.
   *
   * @generated from field: bool has_audit = 33;
   */ _define_property(this, "hasAudit", false), /**
   * @generated from field: int32 audit_pass = 34;
   */ _define_property(this, "auditPass", 0), /**
   * @generated from field: int32 audit_total = 35;
   */ _define_property(this, "auditTotal", 0), /**
   * Raw rollup inputs (Phase 5d closure). The numerator/denominator pairs
   * behind the three derived percentages, exposed so a viewer-projected rollup
   * can re-sum them over the surviving programs (percentages are derived from
   * summed inputs, never averaged — same rule as the SQL rollups).
   *
   * @generated from field: double clin_invoiced = 36;
   */ _define_property(this, "clinInvoiced", 0), /**
   * @generated from field: double clin_funded = 37;
   */ _define_property(this, "clinFunded", 0), /**
   * @generated from field: int64 on_time_num = 38;
   */ _define_property(this, "onTimeNum", protoInt64.zero), /**
   * @generated from field: int64 on_time_den = 39;
   */ _define_property(this, "onTimeDen", protoInt64.zero), /**
   * @generated from field: int64 evidence_num = 40;
   */ _define_property(this, "evidenceNum", protoInt64.zero), /**
   * @generated from field: int64 evidence_den = 41;
   */ _define_property(this, "evidenceDen", protoInt64.zero), /**
   * SAD-178 (RPT-02): current self-assessment (Program Lead audit). Selection
   * rule + evidence live on the cur_aud CTE comment in pangaea's
   * delivery_kpi_repository.go. has_self_assessment distinguishes "no
   * assessment this cycle" from a genuine 0/0 readiness figure. The readiness
   * pair's meaning depends on state: for a Complete assessment it is the
   * frozen first-pass score (num passed without a corrective action / total
   * applicable); for an in-flight one it is reviewed-vs-total checklist item
   * progress.
   *
   * @generated from field: bool has_self_assessment = 42;
   */ _define_property(this, "hasSelfAssessment", false), /**
   * @generated from field: string self_assessment_state = 43;
   */ _define_property(this, "selfAssessmentState", ""), /**
   * @generated from field: string self_assessment_period_month = 44;
   */ _define_property(this, "selfAssessmentPeriodMonth", ""), /**
   * @generated from field: int32 self_assessment_readiness_num = 45;
   */ _define_property(this, "selfAssessmentReadinessNum", 0), /**
   * @generated from field: int32 self_assessment_readiness_den = 46;
   */ _define_property(this, "selfAssessmentReadinessDen", 0), /**
   * KPI 3's input (SAD-387): whether a delivery.program_financial_months row
   * exists for this program for the current UTC calendar month.
   *
   * @generated from field: bool has_current_financial_month = 47;
   */ _define_property(this, "hasCurrentFinancialMonth", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProgramKPIRow, "runtime", proto3);
_define_property(ProgramKPIRow, "typeName", "mono.datagateway.v1.ProgramKPIRow");
_define_property(ProgramKPIRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "sector_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "portfolio_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "operational_state_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "operational_state_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "current_tcv",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 10,
            name: "funded_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 11,
            name: "funded_percent",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 12,
            name: "funding_utilization_pct",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 13,
            name: "total_ftes",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 14,
            name: "total_tasks_closed",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 15,
            name: "tasks_closed_on_time",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 16,
            name: "overdue_tasks",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 17,
            name: "on_time_pct",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 18,
            name: "evidence_completeness_pct",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 19,
            name: "open_risk_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 20,
            name: "open_issue_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 21,
            name: "has_cpars",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 22,
            name: "latest_cpars",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 23,
            name: "has_qasp",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 24,
            name: "latest_qasp",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 25,
            name: "has_eac",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 26,
            name: "latest_dpaf_margin",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 27,
            name: "target_dpaf_margin",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 28,
            name: "has_dso",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 29,
            name: "latest_dso",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 30,
            name: "dso_period_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 31,
            name: "contract_start_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 32,
            name: "deliverable_based_invoicing",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 33,
            name: "has_audit",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 34,
            name: "audit_pass",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 35,
            name: "audit_total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 36,
            name: "clin_invoiced",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 37,
            name: "clin_funded",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 38,
            name: "on_time_num",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 39,
            name: "on_time_den",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 40,
            name: "evidence_num",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 41,
            name: "evidence_den",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 42,
            name: "has_self_assessment",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 43,
            name: "self_assessment_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 44,
            name: "self_assessment_period_month",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 45,
            name: "self_assessment_readiness_num",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 46,
            name: "self_assessment_readiness_den",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 47,
            name: "has_current_financial_month",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * KPIRollupRow is one org-node rollup, summed from the per-program raw counts
 * (percentages are derived from summed numerators/denominators, never averaged).
 *
 * @generated from message mono.datagateway.v1.KPIRollupRow
 */ export class KPIRollupRow extends Message {
    static fromBinary(bytes, options) {
        return new KPIRollupRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new KPIRollupRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new KPIRollupRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(KPIRollupRow, a, b);
    }
    constructor(data){
        super(), /**
   * portfolio_id or sector_id; "" = unassigned
   *
   * @generated from field: string scope_id = 1;
   */ _define_property(this, "scopeId", ""), /**
   * @generated from field: int32 program_count = 2;
   */ _define_property(this, "programCount", 0), /**
   * @generated from field: double total_tcv = 3;
   */ _define_property(this, "totalTcv", 0), /**
   * @generated from field: double total_funded = 4;
   */ _define_property(this, "totalFunded", 0), /**
   * @generated from field: double funding_utilization_pct = 5;
   */ _define_property(this, "fundingUtilizationPct", 0), /**
   * @generated from field: double on_time_pct = 6;
   */ _define_property(this, "onTimePct", 0), /**
   * @generated from field: double evidence_completeness_pct = 7;
   */ _define_property(this, "evidenceCompletenessPct", 0), /**
   * @generated from field: int64 open_risk_count = 8;
   */ _define_property(this, "openRiskCount", protoInt64.zero), /**
   * @generated from field: int64 open_issue_count = 9;
   */ _define_property(this, "openIssueCount", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(KPIRollupRow, "runtime", proto3);
_define_property(KPIRollupRow, "typeName", "mono.datagateway.v1.KPIRollupRow");
_define_property(KPIRollupRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scope_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "total_tcv",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "total_funded",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "funding_utilization_pct",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "on_time_pct",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "evidence_completeness_pct",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 8,
            name: "open_risk_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 9,
            name: "open_issue_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramKPIsRequest
 */ export class ListProgramKPIsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramKPIsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramKPIsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramKPIsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramKPIsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.KPIFilter filter = 1;
   */ _define_property(this, "filter", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramKPIsRequest, "runtime", proto3);
_define_property(ListProgramKPIsRequest, "typeName", "mono.datagateway.v1.ListProgramKPIsRequest");
_define_property(ListProgramKPIsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: KPIFilter
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListProgramKPIsResponse
 */ export class ListProgramKPIsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProgramKPIsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProgramKPIsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProgramKPIsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProgramKPIsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ProgramKPIRow rows = 1;
   */ _define_property(this, "rows", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProgramKPIsResponse, "runtime", proto3);
_define_property(ListProgramKPIsResponse, "typeName", "mono.datagateway.v1.ListProgramKPIsResponse");
_define_property(ListProgramKPIsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rows",
            kind: "message",
            T: ProgramKPIRow,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPortfolioKPIsRequest
 */ export class ListPortfolioKPIsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPortfolioKPIsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPortfolioKPIsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPortfolioKPIsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPortfolioKPIsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.KPIFilter filter = 1;
   */ _define_property(this, "filter", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPortfolioKPIsRequest, "runtime", proto3);
_define_property(ListPortfolioKPIsRequest, "typeName", "mono.datagateway.v1.ListPortfolioKPIsRequest");
_define_property(ListPortfolioKPIsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: KPIFilter
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPortfolioKPIsResponse
 */ export class ListPortfolioKPIsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPortfolioKPIsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPortfolioKPIsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPortfolioKPIsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPortfolioKPIsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.KPIRollupRow rows = 1;
   */ _define_property(this, "rows", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPortfolioKPIsResponse, "runtime", proto3);
_define_property(ListPortfolioKPIsResponse, "typeName", "mono.datagateway.v1.ListPortfolioKPIsResponse");
_define_property(ListPortfolioKPIsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rows",
            kind: "message",
            T: KPIRollupRow,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListSectorKPIsRequest
 */ export class ListSectorKPIsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListSectorKPIsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSectorKPIsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSectorKPIsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSectorKPIsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.KPIFilter filter = 1;
   */ _define_property(this, "filter", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSectorKPIsRequest, "runtime", proto3);
_define_property(ListSectorKPIsRequest, "typeName", "mono.datagateway.v1.ListSectorKPIsRequest");
_define_property(ListSectorKPIsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: KPIFilter
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListSectorKPIsResponse
 */ export class ListSectorKPIsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListSectorKPIsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListSectorKPIsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListSectorKPIsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListSectorKPIsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.KPIRollupRow rows = 1;
   */ _define_property(this, "rows", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListSectorKPIsResponse, "runtime", proto3);
_define_property(ListSectorKPIsResponse, "typeName", "mono.datagateway.v1.ListSectorKPIsResponse");
_define_property(ListSectorKPIsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rows",
            kind: "message",
            T: KPIRollupRow,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListKPIRollupsRequest
 */ export class ListKPIRollupsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListKPIRollupsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListKPIRollupsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListKPIRollupsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListKPIRollupsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.KPIFilter filter = 1;
   */ _define_property(this, "filter", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListKPIRollupsRequest, "runtime", proto3);
_define_property(ListKPIRollupsRequest, "typeName", "mono.datagateway.v1.ListKPIRollupsRequest");
_define_property(ListKPIRollupsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: KPIFilter
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListKPIRollupsResponse
 */ export class ListKPIRollupsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListKPIRollupsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListKPIRollupsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListKPIRollupsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListKPIRollupsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.KPIRollupRow portfolio_rollups = 1;
   */ _define_property(this, "portfolioRollups", []), /**
   * @generated from field: repeated mono.datagateway.v1.KPIRollupRow sector_rollups = 2;
   */ _define_property(this, "sectorRollups", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListKPIRollupsResponse, "runtime", proto3);
_define_property(ListKPIRollupsResponse, "typeName", "mono.datagateway.v1.ListKPIRollupsResponse");
_define_property(ListKPIRollupsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "portfolio_rollups",
            kind: "message",
            T: KPIRollupRow,
            repeated: true
        },
        {
            no: 2,
            name: "sector_rollups",
            kind: "message",
            T: KPIRollupRow,
            repeated: true
        }
    ]));
/**
 * GetOnTimeReportRequest scopes RPT-01's on-time drill-down. tenant_id is
 * required; empty program_id means tenant-wide. from/to form a half-open
 * window [from, to) over submitted_at; both unset means cumulative (no window
 * predicate). from/to are UTC instants — callers are responsible for deriving
 * their own trailing windows in UTC before passing them in.
 *
 * @generated from message mono.datagateway.v1.GetOnTimeReportRequest
 */ export class GetOnTimeReportRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetOnTimeReportRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOnTimeReportRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOnTimeReportRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOnTimeReportRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: google.protobuf.Timestamp from = 3;
   */ _define_property(this, "from", void 0), /**
   * @generated from field: google.protobuf.Timestamp to = 4;
   */ _define_property(this, "to", void 0), /**
   * window and explicit from/to are mutually exclusive: setting both is an
   * InvalidArgument error. UNSPECIFIED means cumulative, so a caller that sets
   * neither window nor from/to still gets the cumulative report.
   *
   * @generated from field: mono.datagateway.v1.OnTimeWindow window = 5;
   */ _define_property(this, "window", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOnTimeReportRequest, "runtime", proto3);
_define_property(GetOnTimeReportRequest, "typeName", "mono.datagateway.v1.GetOnTimeReportRequest");
_define_property(GetOnTimeReportRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "from",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "to",
            kind: "message",
            T: Timestamp
        },
        {
            no: 5,
            name: "window",
            kind: "enum",
            T: proto3.getEnumType(OnTimeWindow)
        }
    ]));
/**
 * OnTimeReportRow is one submitted deliverable instance in the drill-down.
 *
 * @generated from message mono.datagateway.v1.OnTimeReportRow
 */ export class OnTimeReportRow extends Message {
    static fromBinary(bytes, options) {
        return new OnTimeReportRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OnTimeReportRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OnTimeReportRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OnTimeReportRow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string instance_id = 1;
   */ _define_property(this, "instanceId", ""), /**
   * @generated from field: string deliverable_definition_id = 2;
   */ _define_property(this, "deliverableDefinitionId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string clin_number = 4;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string deliverable_number = 5;
   */ _define_property(this, "deliverableNumber", ""), /**
   * @generated from field: string title = 6;
   */ _define_property(this, "title", ""), /**
   * @generated from field: google.protobuf.Timestamp due_at = 7;
   */ _define_property(this, "dueAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp submitted_at = 8;
   */ _define_property(this, "submittedAt", void 0), /**
   * @generated from field: bool on_time_flag = 9;
   */ _define_property(this, "onTimeFlag", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OnTimeReportRow, "runtime", proto3);
_define_property(OnTimeReportRow, "typeName", "mono.datagateway.v1.OnTimeReportRow");
_define_property(OnTimeReportRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "instance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "deliverable_definition_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "deliverable_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "due_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "submitted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "on_time_flag",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * GetOnTimeReportResponse is the windowed on-time report: rows is the full
 * drill-down, and numerator/denominator/pct are computed FROM rows (never a
 * separate aggregate), so a consumer that filters rows must recompute them
 * rather than trusting these fields for the filtered subset.
 *
 * @generated from message mono.datagateway.v1.GetOnTimeReportResponse
 */ export class GetOnTimeReportResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetOnTimeReportResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOnTimeReportResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOnTimeReportResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOnTimeReportResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.OnTimeReportRow rows = 1;
   */ _define_property(this, "rows", []), /**
   * @generated from field: int64 numerator = 2;
   */ _define_property(this, "numerator", protoInt64.zero), /**
   * @generated from field: int64 denominator = 3;
   */ _define_property(this, "denominator", protoInt64.zero), /**
   * @generated from field: double pct = 4;
   */ _define_property(this, "pct", 0), /**
   * window_from/window_to echo the half-open bounds the server actually
   * applied, whether they came from an OnTimeWindow or from explicit from/to,
   * so a caller can label the range it is looking at. Both unset when the
   * report was cumulative.
   *
   * @generated from field: google.protobuf.Timestamp window_from = 5;
   */ _define_property(this, "windowFrom", void 0), /**
   * @generated from field: google.protobuf.Timestamp window_to = 6;
   */ _define_property(this, "windowTo", void 0), /**
   * OPEN instances: past-due deliverable instances with no submission at all.
   * These are NEVER part of numerator/denominator/pct above — a consumer must
   * not fold them into the on-time rate. on_time_flag is always false on these
   * rows, meaning "not applicable" (there is no submission to be on time or
   * late), not "late"; submitted_at is unset.
   *
   * @generated from field: repeated mono.datagateway.v1.OnTimeReportRow outstanding_overdue = 7;
   */ _define_property(this, "outstandingOverdue", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOnTimeReportResponse, "runtime", proto3);
_define_property(GetOnTimeReportResponse, "typeName", "mono.datagateway.v1.GetOnTimeReportResponse");
_define_property(GetOnTimeReportResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rows",
            kind: "message",
            T: OnTimeReportRow,
            repeated: true
        },
        {
            no: 2,
            name: "numerator",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 3,
            name: "denominator",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 4,
            name: "pct",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "window_from",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "window_to",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "outstanding_overdue",
            kind: "message",
            T: OnTimeReportRow,
            repeated: true
        }
    ]));
/**
 * GetWeeklyRecapRequest scopes RPT-06's weekly recap. Unlike
 * GetOnTimeReportRequest, tenant_id AND program_id are both required — a
 * weekly recap is always a per-program artifact, never tenant-wide. There is
 * no explicit from/to field: window is the only way to name the range, and
 * it must not be UNSPECIFIED.
 *
 * @generated from message mono.datagateway.v1.GetWeeklyRecapRequest
 */ export class GetWeeklyRecapRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetWeeklyRecapRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetWeeklyRecapRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetWeeklyRecapRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetWeeklyRecapRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.OnTimeWindow window = 3;
   */ _define_property(this, "window", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetWeeklyRecapRequest, "runtime", proto3);
_define_property(GetWeeklyRecapRequest, "typeName", "mono.datagateway.v1.GetWeeklyRecapRequest");
_define_property(GetWeeklyRecapRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "window",
            kind: "enum",
            T: proto3.getEnumType(OnTimeWindow)
        }
    ]));
/**
 * WeeklyRecapRow is one on-time report row (embedded verbatim, so consumers
 * get the identical row shape as GetOnTimeReport) enriched with its linked
 * program task's id, waiver state, notes, and how many calendar days late
 * the submission was.
 *
 * @generated from message mono.datagateway.v1.WeeklyRecapRow
 */ export class WeeklyRecapRow extends Message {
    static fromBinary(bytes, options) {
        return new WeeklyRecapRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WeeklyRecapRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WeeklyRecapRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WeeklyRecapRow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OnTimeReportRow row = 1;
   */ _define_property(this, "row", void 0), /**
   * @generated from field: string program_task_id = 2;
   */ _define_property(this, "programTaskId", ""), /**
   * @generated from field: bool waived = 3;
   */ _define_property(this, "waived", false), /**
   * @generated from field: string task_notes = 4;
   */ _define_property(this, "taskNotes", ""), /**
   * @generated from field: int32 days_late = 5;
   */ _define_property(this, "daysLate", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WeeklyRecapRow, "runtime", proto3);
_define_property(WeeklyRecapRow, "typeName", "mono.datagateway.v1.WeeklyRecapRow");
_define_property(WeeklyRecapRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "row",
            kind: "message",
            T: OnTimeReportRow
        },
        {
            no: 2,
            name: "program_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "waived",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "task_notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "days_late",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * GetWeeklyRecapResponse is the windowed weekly recap: rows is the full
 * enriched drill-down, and numerator/denominator/pct are the underlying
 * on-time report's own numerator/denominator/pct (never a separate
 * aggregate) — same contract as GetOnTimeReportResponse.
 *
 * @generated from message mono.datagateway.v1.GetWeeklyRecapResponse
 */ export class GetWeeklyRecapResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetWeeklyRecapResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetWeeklyRecapResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetWeeklyRecapResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetWeeklyRecapResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.WeeklyRecapRow rows = 1;
   */ _define_property(this, "rows", []), /**
   * @generated from field: int64 numerator = 2;
   */ _define_property(this, "numerator", protoInt64.zero), /**
   * @generated from field: int64 denominator = 3;
   */ _define_property(this, "denominator", protoInt64.zero), /**
   * @generated from field: double pct = 4;
   */ _define_property(this, "pct", 0), /**
   * window_from/window_to echo the half-open bounds the server actually
   * applied for the resolved window.
   *
   * @generated from field: google.protobuf.Timestamp window_from = 5;
   */ _define_property(this, "windowFrom", void 0), /**
   * @generated from field: google.protobuf.Timestamp window_to = 6;
   */ _define_property(this, "windowTo", void 0), /**
   * OPEN instances: past-due deliverable instances with no submission at all
   * (the plain row type, not WeeklyRecapRow — these have no linked submission
   * to enrich with waiver/notes/days-late). NEVER part of numerator/
   * denominator/pct above. on_time_flag is always false on these rows,
   * meaning "not applicable", not "late"; submitted_at is unset.
   *
   * @generated from field: repeated mono.datagateway.v1.OnTimeReportRow outstanding_overdue = 7;
   */ _define_property(this, "outstandingOverdue", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetWeeklyRecapResponse, "runtime", proto3);
_define_property(GetWeeklyRecapResponse, "typeName", "mono.datagateway.v1.GetWeeklyRecapResponse");
_define_property(GetWeeklyRecapResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rows",
            kind: "message",
            T: WeeklyRecapRow,
            repeated: true
        },
        {
            no: 2,
            name: "numerator",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 3,
            name: "denominator",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 4,
            name: "pct",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 5,
            name: "window_from",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "window_to",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "outstanding_overdue",
            kind: "message",
            T: OnTimeReportRow,
            repeated: true
        }
    ]));
/**
 * AssignedAction is one row of the union: a single assignee-carrying record,
 * normalized to a common shape across the four source tables.
 *
 * @generated from message mono.datagateway.v1.AssignedAction
 */ export class AssignedAction extends Message {
    static fromBinary(bytes, options) {
        return new AssignedAction().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AssignedAction().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AssignedAction().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AssignedAction, a, b);
    }
    constructor(data){
        super(), /**
   * id is the source record's own id (program_task.id, issue.id, etc.).
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: mono.datagateway.v1.AssignedActionKind kind = 2;
   */ _define_property(this, "kind", 0), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string program_name = 4;
   */ _define_property(this, "programName", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * due_at is unset when the source record has no due date.
   *
   * @generated from field: google.protobuf.Timestamp due_at = 6;
   */ _define_property(this, "dueAt", void 0), /**
   * state is the source row's state/status column, verbatim (no normalization
   * across kinds — program_tasks/issues use "state", risks use "status").
   *
   * @generated from field: string state = 7;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string assignee_contact_id = 8;
   */ _define_property(this, "assigneeContactId", ""), /**
   * parent_id is the audit id for a CORRECTIVE_ACTION row (its program is
   * resolved through that audit); empty for every other kind.
   *
   * @generated from field: string parent_id = 9;
   */ _define_property(this, "parentId", ""), /**
   * Proposal-only canonical links. Delivery program fields remain empty.
   *
   * @generated from field: string project_id = 10;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string project_name = 11;
   */ _define_property(this, "projectName", ""), /**
   * @generated from field: string section_id = 12;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: string volume_id = 13;
   */ _define_property(this, "volumeId", ""), /**
   * @generated from field: string volume_name = 14;
   */ _define_property(this, "volumeName", ""), /**
   * @generated from field: string assignee_user_id = 15;
   */ _define_property(this, "assigneeUserId", ""), /**
   * Calendar date YYYY-MM-DD, not a timezone-dependent deadline.
   *
   * @generated from field: string internal_date = 16;
   */ _define_property(this, "internalDate", ""), /**
   * Proposal-only (17-22); zero/empty for Delivery kinds.
   * Requirements the section owns / how many are substantively addressed.
   *
   * @generated from field: int32 requirements_total = 17;
   */ _define_property(this, "requirementsTotal", 0), /**
   * @generated from field: int32 requirements_addressed = 18;
   */ _define_property(this, "requirementsAddressed", 0), /**
   * unknown, no_draft, drafting or ready_for_review (from PRP-31 body_chars).
   *
   * @generated from field: string drafting_state = 19;
   */ _define_property(this, "draftingState", ""), /**
   * "behind" or "on_track".
   *
   * @generated from field: string schedule_state = 20;
   */ _define_property(this, "scheduleState", ""), /**
   * Reserved for the PRP-05 review label; empty today.
   *
   * @generated from field: string next_review_label = 21;
   */ _define_property(this, "nextReviewLabel", ""), /**
   * Deep link to the section's volume; set by zou.
   *
   * @generated from field: string section_href = 22;
   */ _define_property(this, "sectionHref", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AssignedAction, "runtime", proto3);
_define_property(AssignedAction, "typeName", "mono.datagateway.v1.AssignedAction");
_define_property(AssignedAction, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "enum",
            T: proto3.getEnumType(AssignedActionKind)
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "program_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "due_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "assignee_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "parent_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "project_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "volume_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "volume_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "assignee_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "internal_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "requirements_total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 18,
            name: "requirements_addressed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 19,
            name: "drafting_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "schedule_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "next_review_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "section_href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ListAssignedActionsRequest resolves the caller's contact server-side by
 * joining delivery.contacts on (tenant_id, platform_user_id) — see the unique
 * index at 000013_foundation_schema.up.sql:174-176. program_id narrows to one
 * program when set; empty means tenant-wide.
 *
 * @generated from message mono.datagateway.v1.ListAssignedActionsRequest
 */ export class ListAssignedActionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListAssignedActionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAssignedActionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAssignedActionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAssignedActionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string platform_user_id = 2;
   */ _define_property(this, "platformUserId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * limit <= 0 defaults to 50; hard-capped at 200.
   *
   * @generated from field: int32 limit = 4;
   */ _define_property(this, "limit", 0), /**
   * Empty or DELIVERY keeps existing Delivery behavior. PROPOSAL selects
   * section writer/reviewer assignments only; never requires a contact.
   *
   * @generated from field: string source = 5;
   */ _define_property(this, "source", ""), /**
   * PROPOSAL only: optional project scope; membership is enforced in SQL.
   *
   * @generated from field: string project_id = 6;
   */ _define_property(this, "projectId", ""), /**
   * PROPOSAL only: offset after authorization; >= 0. No snapshot guarantee.
   *
   * @generated from field: int32 offset = 7;
   */ _define_property(this, "offset", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAssignedActionsRequest, "runtime", proto3);
_define_property(ListAssignedActionsRequest, "typeName", "mono.datagateway.v1.ListAssignedActionsRequest");
_define_property(ListAssignedActionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "platform_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListAssignedActionsResponse
 */ export class ListAssignedActionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListAssignedActionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListAssignedActionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListAssignedActionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListAssignedActionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.AssignedAction actions = 1;
   */ _define_property(this, "actions", []), /**
   * @generated from field: bool has_more = 2;
   */ _define_property(this, "hasMore", false), /**
   * resolved_contact_id is empty when platform_user_id matches no live
   * contact — this lets a caller distinguish "not linked to a contact" from
   * "linked, but nothing is assigned."
   *
   * @generated from field: string resolved_contact_id = 3;
   */ _define_property(this, "resolvedContactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListAssignedActionsResponse, "runtime", proto3);
_define_property(ListAssignedActionsResponse, "typeName", "mono.datagateway.v1.ListAssignedActionsResponse");
_define_property(ListAssignedActionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "actions",
            kind: "message",
            T: AssignedAction,
            repeated: true
        },
        {
            no: 2,
            name: "has_more",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "resolved_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CalendarEvent mirrors delivery.calendar_events. program_id / program_name are
 * enriched (resolved from the source object) for cross-project filtering + display.
 *
 * @generated from message mono.datagateway.v1.CalendarEvent
 */ export class CalendarEvent extends Message {
    static fromBinary(bytes, options) {
        return new CalendarEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CalendarEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CalendarEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CalendarEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * program_task | period_of_performance | protest_watch
   *
   * @generated from field: string source_object_type = 3;
   */ _define_property(this, "sourceObjectType", ""), /**
   * @generated from field: string source_object_id = 4;
   */ _define_property(this, "sourceObjectId", ""), /**
   * DELIVERABLE_DUE | POP_OPTION_EXPIRATION | PROTEST_DEBRIEF_WINDOW
   *
   * @generated from field: string event_type = 5;
   */ _define_property(this, "eventType", ""), /**
   * @generated from field: string title = 6;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 7;
   */ _define_property(this, "description", ""), /**
   * @generated from field: google.protobuf.Timestamp start_at = 8;
   */ _define_property(this, "startAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp end_at = 9;
   */ _define_property(this, "endAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp due_at = 10;
   */ _define_property(this, "dueAt", void 0), /**
   * ACTIVE | CANCELLED | SUPERSEDED
   *
   * @generated from field: string status = 11;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string program_id = 12;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string program_name = 13;
   */ _define_property(this, "programName", ""), /**
   * @generated from field: string sector_id = 14;
   */ _define_property(this, "sectorId", ""), /**
   * @generated from field: string business_unit_id = 15;
   */ _define_property(this, "businessUnitId", ""), /**
   * @generated from field: string portfolio_id = 16;
   */ _define_property(this, "portfolioId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CalendarEvent, "runtime", proto3);
_define_property(CalendarEvent, "typeName", "mono.datagateway.v1.CalendarEvent");
_define_property(CalendarEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "event_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "start_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "end_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "due_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "program_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "sector_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "portfolio_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CalendarEventFilter scopes a calendar read. tenant_id required; empty optional
 * fields apply no predicate. due_after/due_before bound the window (inclusive).
 *
 * @generated from message mono.datagateway.v1.CalendarEventFilter
 */ export class CalendarEventFilter extends Message {
    static fromBinary(bytes, options) {
        return new CalendarEventFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CalendarEventFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CalendarEventFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CalendarEventFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: google.protobuf.Timestamp due_after = 2;
   */ _define_property(this, "dueAfter", void 0), /**
   * @generated from field: google.protobuf.Timestamp due_before = 3;
   */ _define_property(this, "dueBefore", void 0), /**
   * @generated from field: string program_id = 4;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string sector_id = 5;
   */ _define_property(this, "sectorId", ""), /**
   * @generated from field: string business_unit_id = 6;
   */ _define_property(this, "businessUnitId", ""), /**
   * @generated from field: string portfolio_id = 7;
   */ _define_property(this, "portfolioId", ""), /**
   * @generated from field: string event_type = 8;
   */ _define_property(this, "eventType", ""), /**
   * defaults to ACTIVE when empty
   *
   * @generated from field: string status = 9;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CalendarEventFilter, "runtime", proto3);
_define_property(CalendarEventFilter, "typeName", "mono.datagateway.v1.CalendarEventFilter");
_define_property(CalendarEventFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "due_after",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "due_before",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "sector_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "portfolio_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "event_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Notification is a read-side join of a notification_event with one recipient
 * row + the linked calendar event's due_at.
 *
 * @generated from message mono.datagateway.v1.Notification
 */ export class Notification extends Message {
    static fromBinary(bytes, options) {
        return new Notification().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Notification().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Notification().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Notification, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string recipient_id = 1;
   */ _define_property(this, "recipientId", ""), /**
   * @generated from field: string notification_event_id = 2;
   */ _define_property(this, "notificationEventId", ""), /**
   * @generated from field: string tenant_id = 3;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string notification_type = 4;
   */ _define_property(this, "notificationType", ""), /**
   * @generated from field: string source_object_type = 5;
   */ _define_property(this, "sourceObjectType", ""), /**
   * @generated from field: string source_object_id = 6;
   */ _define_property(this, "sourceObjectId", ""), /**
   * @generated from field: string severity = 7;
   */ _define_property(this, "severity", ""), /**
   * @generated from field: string title = 8;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string body = 9;
   */ _define_property(this, "body", ""), /**
   * @generated from field: string calendar_event_id = 10;
   */ _define_property(this, "calendarEventId", ""), /**
   * @generated from field: google.protobuf.Timestamp due_at = 11;
   */ _define_property(this, "dueAt", void 0), /**
   * @generated from field: string contact_id = 12;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string platform_user_id = 13;
   */ _define_property(this, "platformUserId", ""), /**
   * PENDING | DELIVERED | FAILED
   *
   * @generated from field: string delivery_status = 14;
   */ _define_property(this, "deliveryStatus", ""), /**
   * @generated from field: google.protobuf.Timestamp acknowledged_at = 15;
   */ _define_property(this, "acknowledgedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 16;
   */ _define_property(this, "createdAt", void 0), /**
   * Program the notification's calendar event belongs to (empty when the
   * notification is not calendar-backed). Read-side viewer projection keys
   * per-row decisions on it (Phase 5d closure).
   *
   * @generated from field: string program_id = 17;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(Notification, "runtime", proto3);
_define_property(Notification, "typeName", "mono.datagateway.v1.Notification");
_define_property(Notification, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "recipient_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "notification_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "notification_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "severity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "calendar_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "due_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "platform_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "delivery_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "acknowledged_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.NotificationFilter
 */ export class NotificationFilter extends Message {
    static fromBinary(bytes, options) {
        return new NotificationFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NotificationFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NotificationFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NotificationFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string recipient_platform_user_id = 2;
   */ _define_property(this, "recipientPlatformUserId", ""), /**
   * @generated from field: string recipient_contact_id = 3;
   */ _define_property(this, "recipientContactId", ""), /**
   * @generated from field: string delivery_status = 4;
   */ _define_property(this, "deliveryStatus", ""), /**
   * @generated from field: bool unacknowledged_only = 5;
   */ _define_property(this, "unacknowledgedOnly", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(NotificationFilter, "runtime", proto3);
_define_property(NotificationFilter, "typeName", "mono.datagateway.v1.NotificationFilter");
_define_property(NotificationFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "recipient_platform_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "recipient_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "delivery_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "unacknowledged_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SyncDeliveryCalendarRequest
 */ export class SyncDeliveryCalendarRequest extends Message {
    static fromBinary(bytes, options) {
        return new SyncDeliveryCalendarRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncDeliveryCalendarRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncDeliveryCalendarRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncDeliveryCalendarRequest, a, b);
    }
    constructor(data){
        super(), /**
   * required
   *
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * notification look-ahead window; defaults to 14 when 0
   *
   * @generated from field: int32 horizon_days = 2;
   */ _define_property(this, "horizonDays", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SyncDeliveryCalendarRequest, "runtime", proto3);
_define_property(SyncDeliveryCalendarRequest, "typeName", "mono.datagateway.v1.SyncDeliveryCalendarRequest");
_define_property(SyncDeliveryCalendarRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "horizon_days",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SyncDeliveryCalendarResponse
 */ export class SyncDeliveryCalendarResponse extends Message {
    static fromBinary(bytes, options) {
        return new SyncDeliveryCalendarResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SyncDeliveryCalendarResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SyncDeliveryCalendarResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SyncDeliveryCalendarResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int64 calendar_events_upserted = 1;
   */ _define_property(this, "calendarEventsUpserted", protoInt64.zero), /**
   * @generated from field: int64 notifications_created = 2;
   */ _define_property(this, "notificationsCreated", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SyncDeliveryCalendarResponse, "runtime", proto3);
_define_property(SyncDeliveryCalendarResponse, "typeName", "mono.datagateway.v1.SyncDeliveryCalendarResponse");
_define_property(SyncDeliveryCalendarResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "calendar_events_upserted",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 2,
            name: "notifications_created",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCalendarEventsRequest
 */ export class ListCalendarEventsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCalendarEventsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCalendarEventsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCalendarEventsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCalendarEventsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CalendarEventFilter filter = 1;
   */ _define_property(this, "filter", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCalendarEventsRequest, "runtime", proto3);
_define_property(ListCalendarEventsRequest, "typeName", "mono.datagateway.v1.ListCalendarEventsRequest");
_define_property(ListCalendarEventsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: CalendarEventFilter
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCalendarEventsResponse
 */ export class ListCalendarEventsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCalendarEventsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCalendarEventsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCalendarEventsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCalendarEventsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CalendarEvent events = 1;
   */ _define_property(this, "events", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCalendarEventsResponse, "runtime", proto3);
_define_property(ListCalendarEventsResponse, "typeName", "mono.datagateway.v1.ListCalendarEventsResponse");
_define_property(ListCalendarEventsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "events",
            kind: "message",
            T: CalendarEvent,
            repeated: true
        }
    ]));
/**
 * DeliverableLookaheadItem is one deliverable-shaped occurrence due inside
 * the caller's window — a program_task with no recurring instances, or one
 * distinct deliverable_instance occurrence. occurrence_id is the source
 * row's own id (the task or the instance), not the materialized calendar
 * event's id, since the occurrence — not the calendar event — is what a
 * waiver, a submission, or a UI deep link actually refers to.
 *
 * @generated from message mono.datagateway.v1.DeliverableLookaheadItem
 */ export class DeliverableLookaheadItem extends Message {
    static fromBinary(bytes, options) {
        return new DeliverableLookaheadItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeliverableLookaheadItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeliverableLookaheadItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeliverableLookaheadItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string occurrence_id = 1;
   */ _define_property(this, "occurrenceId", ""), /**
   * program_task | deliverable_instance
   *
   * @generated from field: string source_object_type = 2;
   */ _define_property(this, "sourceObjectType", ""), /**
   * @generated from field: string deliverable_number = 3;
   */ _define_property(this, "deliverableNumber", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 5;
   */ _define_property(this, "description", ""), /**
   * @generated from field: google.protobuf.Timestamp due_at = 6;
   */ _define_property(this, "dueAt", void 0), /**
   * waived reflects an APPROVED WAIVER deviation resolved against THIS
   * occurrence specifically — a task-wide waiver (linked_deliverable_
   * instance_id NULL) applies to every occurrence of that task, but a
   * waiver naming one occurrence (SAD-165's linked_deliverable_instance_id)
   * never marks its siblings. Suppression-shaped, same as the calendar
   * sync's own WAIVER handling: a waived occurrence is still returned (it is
   * still due), just flagged, since this is a display read, not an alert.
   *
   * @generated from field: bool waived = 7;
   */ _define_property(this, "waived", false), /**
   * @generated from field: string program_id = 8;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string program_name = 9;
   */ _define_property(this, "programName", ""), /**
   * @generated from field: string sector_id = 10;
   */ _define_property(this, "sectorId", ""), /**
   * @generated from field: string business_unit_id = 11;
   */ _define_property(this, "businessUnitId", ""), /**
   * @generated from field: string portfolio_id = 12;
   */ _define_property(this, "portfolioId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeliverableLookaheadItem, "runtime", proto3);
_define_property(DeliverableLookaheadItem, "typeName", "mono.datagateway.v1.DeliverableLookaheadItem");
_define_property(DeliverableLookaheadItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "deliverable_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "due_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "waived",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "program_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "sector_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "business_unit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "portfolio_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ListDeliverableLookaheadRequest scopes SAD-105's 14-day deliverable-
 * occurrence lookahead. tenant_id and the due_after/due_before window are
 * required; program_id narrows to one program when set.
 *
 * @generated from message mono.datagateway.v1.ListDeliverableLookaheadRequest
 */ export class ListDeliverableLookaheadRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListDeliverableLookaheadRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDeliverableLookaheadRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDeliverableLookaheadRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDeliverableLookaheadRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: google.protobuf.Timestamp due_after = 2;
   */ _define_property(this, "dueAfter", void 0), /**
   * @generated from field: google.protobuf.Timestamp due_before = 3;
   */ _define_property(this, "dueBefore", void 0), /**
   * @generated from field: string program_id = 4;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDeliverableLookaheadRequest, "runtime", proto3);
_define_property(ListDeliverableLookaheadRequest, "typeName", "mono.datagateway.v1.ListDeliverableLookaheadRequest");
_define_property(ListDeliverableLookaheadRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "due_after",
            kind: "message",
            T: Timestamp
        },
        {
            no: 3,
            name: "due_before",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListDeliverableLookaheadResponse
 */ export class ListDeliverableLookaheadResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListDeliverableLookaheadResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDeliverableLookaheadResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDeliverableLookaheadResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDeliverableLookaheadResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.DeliverableLookaheadItem items = 1;
   */ _define_property(this, "items", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDeliverableLookaheadResponse, "runtime", proto3);
_define_property(ListDeliverableLookaheadResponse, "typeName", "mono.datagateway.v1.ListDeliverableLookaheadResponse");
_define_property(ListDeliverableLookaheadResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "items",
            kind: "message",
            T: DeliverableLookaheadItem,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListNotificationsRequest
 */ export class ListNotificationsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListNotificationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListNotificationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListNotificationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListNotificationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.NotificationFilter filter = 1;
   */ _define_property(this, "filter", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListNotificationsRequest, "runtime", proto3);
_define_property(ListNotificationsRequest, "typeName", "mono.datagateway.v1.ListNotificationsRequest");
_define_property(ListNotificationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: NotificationFilter
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListNotificationsResponse
 */ export class ListNotificationsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListNotificationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListNotificationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListNotificationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListNotificationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.Notification notifications = 1;
   */ _define_property(this, "notifications", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListNotificationsResponse, "runtime", proto3);
_define_property(ListNotificationsResponse, "typeName", "mono.datagateway.v1.ListNotificationsResponse");
_define_property(ListNotificationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notifications",
            kind: "message",
            T: Notification,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AcknowledgeNotificationRequest
 */ export class AcknowledgeNotificationRequest extends Message {
    static fromBinary(bytes, options) {
        return new AcknowledgeNotificationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AcknowledgeNotificationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AcknowledgeNotificationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AcknowledgeNotificationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string recipient_id = 2;
   */ _define_property(this, "recipientId", ""), /**
   * When set, the ack only lands if the recipient row belongs to this
   * platform user — callers fronting end users (ryugu) MUST set it so one
   * user can't ack another's notification by guessing recipient ids.
   *
   * @generated from field: string recipient_platform_user_id = 3;
   */ _define_property(this, "recipientPlatformUserId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AcknowledgeNotificationRequest, "runtime", proto3);
_define_property(AcknowledgeNotificationRequest, "typeName", "mono.datagateway.v1.AcknowledgeNotificationRequest");
_define_property(AcknowledgeNotificationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "recipient_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "recipient_platform_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AcknowledgeNotificationResponse
 */ export class AcknowledgeNotificationResponse extends Message {
    static fromBinary(bytes, options) {
        return new AcknowledgeNotificationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AcknowledgeNotificationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AcknowledgeNotificationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AcknowledgeNotificationResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(AcknowledgeNotificationResponse, "runtime", proto3);
_define_property(AcknowledgeNotificationResponse, "typeName", "mono.datagateway.v1.AcknowledgeNotificationResponse");
_define_property(AcknowledgeNotificationResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.AcknowledgeAllNotificationsRequest
 */ export class AcknowledgeAllNotificationsRequest extends Message {
    static fromBinary(bytes, options) {
        return new AcknowledgeAllNotificationsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AcknowledgeAllNotificationsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AcknowledgeAllNotificationsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AcknowledgeAllNotificationsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * Required. The bulk ack's ownership scope — resolved server-side from the
   * gateway principal by callers fronting end users (ryugu). Never
   * client-supplied; unlike AcknowledgeNotification's single-row guard this
   * is not optional, since an empty value here would ack an entire tenant's
   * notifications rather than one user's.
   *
   * @generated from field: string recipient_platform_user_id = 2;
   */ _define_property(this, "recipientPlatformUserId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AcknowledgeAllNotificationsRequest, "runtime", proto3);
_define_property(AcknowledgeAllNotificationsRequest, "typeName", "mono.datagateway.v1.AcknowledgeAllNotificationsRequest");
_define_property(AcknowledgeAllNotificationsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "recipient_platform_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AcknowledgeAllNotificationsResponse
 */ export class AcknowledgeAllNotificationsResponse extends Message {
    static fromBinary(bytes, options) {
        return new AcknowledgeAllNotificationsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AcknowledgeAllNotificationsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AcknowledgeAllNotificationsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AcknowledgeAllNotificationsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 acknowledged_count = 1;
   */ _define_property(this, "acknowledgedCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AcknowledgeAllNotificationsResponse, "runtime", proto3);
_define_property(AcknowledgeAllNotificationsResponse, "typeName", "mono.datagateway.v1.AcknowledgeAllNotificationsResponse");
_define_property(AcknowledgeAllNotificationsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "acknowledged_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateNotificationRequest
 */ export class CreateNotificationRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateNotificationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateNotificationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateNotificationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateNotificationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string notification_type = 2;
   */ _define_property(this, "notificationType", ""), /**
   * @generated from field: string source_object_type = 3;
   */ _define_property(this, "sourceObjectType", ""), /**
   * @generated from field: string source_object_id = 4;
   */ _define_property(this, "sourceObjectId", ""), /**
   * @generated from field: string severity = 5;
   */ _define_property(this, "severity", ""), /**
   * @generated from field: string title = 6;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string body = 7;
   */ _define_property(this, "body", ""), /**
   * The recipient — a delivery contact and/or a platform user. When both are
   * empty the notification is skipped (there is no one to route it to).
   *
   * @generated from field: string recipient_contact_id = 8;
   */ _define_property(this, "recipientContactId", ""), /**
   * @generated from field: string recipient_platform_user_id = 9;
   */ _define_property(this, "recipientPlatformUserId", ""), /**
   * Program the notification is about. There is no calendar event on this path
   * to derive it from, and read-side viewer projection keys per-row decisions on
   * it — an empty program_id fails closed, so the notification never reaches the
   * recipient's inbox.
   *
   * @generated from field: string program_id = 10;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateNotificationRequest, "runtime", proto3);
_define_property(CreateNotificationRequest, "typeName", "mono.datagateway.v1.CreateNotificationRequest");
_define_property(CreateNotificationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "notification_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "source_object_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_object_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "severity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "recipient_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "recipient_platform_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * notification_event_id is empty when the notification was skipped (no recipient).
 *
 * @generated from message mono.datagateway.v1.CreateNotificationResponse
 */ export class CreateNotificationResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateNotificationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateNotificationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateNotificationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateNotificationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string notification_event_id = 1;
   */ _define_property(this, "notificationEventId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateNotificationResponse, "runtime", proto3);
_define_property(CreateNotificationResponse, "typeName", "mono.datagateway.v1.CreateNotificationResponse");
_define_property(CreateNotificationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notification_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ResolveProgramPMRecipientRequest
 */ export class ResolveProgramPMRecipientRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolveProgramPMRecipientRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveProgramPMRecipientRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveProgramPMRecipientRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveProgramPMRecipientRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveProgramPMRecipientRequest, "runtime", proto3);
_define_property(ResolveProgramPMRecipientRequest, "typeName", "mono.datagateway.v1.ResolveProgramPMRecipientRequest");
_define_property(ResolveProgramPMRecipientRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * contact_id/platform_user_id are both empty when the program has no
 * resolvable PM - not an error; the caller's notification routes to nobody.
 *
 * @generated from message mono.datagateway.v1.ResolveProgramPMRecipientResponse
 */ export class ResolveProgramPMRecipientResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolveProgramPMRecipientResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveProgramPMRecipientResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveProgramPMRecipientResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveProgramPMRecipientResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contact_id = 1;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string platform_user_id = 2;
   */ _define_property(this, "platformUserId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveProgramPMRecipientResponse, "runtime", proto3);
_define_property(ResolveProgramPMRecipientResponse, "typeName", "mono.datagateway.v1.ResolveProgramPMRecipientResponse");
_define_property(ResolveProgramPMRecipientResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "platform_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ResolveProgramQualityRecipientsRequest
 */ export class ResolveProgramQualityRecipientsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolveProgramQualityRecipientsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveProgramQualityRecipientsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveProgramQualityRecipientsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveProgramQualityRecipientsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveProgramQualityRecipientsRequest, "runtime", proto3);
_define_property(ResolveProgramQualityRecipientsRequest, "typeName", "mono.datagateway.v1.ResolveProgramQualityRecipientsRequest");
_define_property(ResolveProgramQualityRecipientsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * One resolved recipient of a below-standard quality-score alert. contact_id
 * and platform_user_id are independently optional and may both be set, both
 * empty (never emitted; see the RPC comment), or just one — a person reached
 * only through a console/admin-access grant can carry a platform user id
 * with no linked delivery.contacts row at all.
 *
 * @generated from message mono.datagateway.v1.QualityRecipient
 */ export class QualityRecipient extends Message {
    static fromBinary(bytes, options) {
        return new QualityRecipient().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new QualityRecipient().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new QualityRecipient().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(QualityRecipient, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string contact_id = 1;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string platform_user_id = 2;
   */ _define_property(this, "platformUserId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(QualityRecipient, "runtime", proto3);
_define_property(QualityRecipient, "typeName", "mono.datagateway.v1.QualityRecipient");
_define_property(QualityRecipient, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "platform_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ResolveProgramQualityRecipientsResponse
 */ export class ResolveProgramQualityRecipientsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolveProgramQualityRecipientsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveProgramQualityRecipientsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveProgramQualityRecipientsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveProgramQualityRecipientsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.QualityRecipient recipients = 1;
   */ _define_property(this, "recipients", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveProgramQualityRecipientsResponse, "runtime", proto3);
_define_property(ResolveProgramQualityRecipientsResponse, "typeName", "mono.datagateway.v1.ResolveProgramQualityRecipientsResponse");
_define_property(ResolveProgramQualityRecipientsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "recipients",
            kind: "message",
            T: QualityRecipient,
            repeated: true
        }
    ]));
/**
 * ChannelDelivery is one row of delivery.notification_deliveries: a single
 * (recipient, channel) send attempt made by the dispatcher.
 *
 * @generated from message mono.datagateway.v1.ChannelDelivery
 */ export class ChannelDelivery extends Message {
    static fromBinary(bytes, options) {
        return new ChannelDelivery().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChannelDelivery().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChannelDelivery().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChannelDelivery, a, b);
    }
    constructor(data){
        super(), /**
   * EMAIL | TEAMS
   *
   * @generated from field: string channel = 1;
   */ _define_property(this, "channel", ""), /**
   * SENDING | SENT | FAILED
   *
   * @generated from field: string status = 2;
   */ _define_property(this, "status", ""), /**
   * @generated from field: google.protobuf.Timestamp attempted_at = 3;
   */ _define_property(this, "attemptedAt", void 0), /**
   * set on FAILED; empty otherwise
   *
   * @generated from field: string error = 4;
   */ _define_property(this, "error", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ChannelDelivery, "runtime", proto3);
_define_property(ChannelDelivery, "typeName", "mono.datagateway.v1.ChannelDelivery");
_define_property(ChannelDelivery, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "channel",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "attempted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "error",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * RecipientDeliveryStatus is one recipient of a notification event plus its
 * per-channel send attempts. channel_deliveries is empty when the dispatcher
 * has not attempted this recipient on any channel yet.
 *
 * @generated from message mono.datagateway.v1.RecipientDeliveryStatus
 */ export class RecipientDeliveryStatus extends Message {
    static fromBinary(bytes, options) {
        return new RecipientDeliveryStatus().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecipientDeliveryStatus().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecipientDeliveryStatus().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecipientDeliveryStatus, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string recipient_id = 1;
   */ _define_property(this, "recipientId", ""), /**
   * @generated from field: string contact_id = 2;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string platform_user_id = 3;
   */ _define_property(this, "platformUserId", ""), /**
   * in_app_status is notification_recipients.delivery_status — the in-app
   * read/ack state (PENDING | DELIVERED | FAILED), flipped to DELIVERED on
   * ack. It is NOT an external send outcome; those ride channel_deliveries.
   *
   * @generated from field: string in_app_status = 4;
   */ _define_property(this, "inAppStatus", ""), /**
   * @generated from field: google.protobuf.Timestamp acknowledged_at = 5;
   */ _define_property(this, "acknowledgedAt", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.ChannelDelivery channel_deliveries = 6;
   */ _define_property(this, "channelDeliveries", []), /**
   * recipient_display_name and recipient_email are best-effort display
   * decoration resolved tenant-safely from delivery.contacts / identity.users.
   * Both are empty when the contact/user is deleted or otherwise unresolvable —
   * the client must have a fallback (e.g. render recipient_id) rather than
   * assume either is populated.
   *
   * @generated from field: string recipient_display_name = 7;
   */ _define_property(this, "recipientDisplayName", ""), /**
   * @generated from field: string recipient_email = 8;
   */ _define_property(this, "recipientEmail", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecipientDeliveryStatus, "runtime", proto3);
_define_property(RecipientDeliveryStatus, "typeName", "mono.datagateway.v1.RecipientDeliveryStatus");
_define_property(RecipientDeliveryStatus, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "recipient_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "platform_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "in_app_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "acknowledged_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "channel_deliveries",
            kind: "message",
            T: ChannelDelivery,
            repeated: true
        },
        {
            no: 7,
            name: "recipient_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "recipient_email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * NotificationDeliveryStatus is one notification event with its recipients and
 * each recipient's per-channel delivery attempts.
 *
 * @generated from message mono.datagateway.v1.NotificationDeliveryStatus
 */ export class NotificationDeliveryStatus extends Message {
    static fromBinary(bytes, options) {
        return new NotificationDeliveryStatus().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NotificationDeliveryStatus().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NotificationDeliveryStatus().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NotificationDeliveryStatus, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string notification_event_id = 1;
   */ _define_property(this, "notificationEventId", ""), /**
   * @generated from field: string notification_type = 2;
   */ _define_property(this, "notificationType", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string severity = 4;
   */ _define_property(this, "severity", ""), /**
   * @generated from field: string program_id = 5;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.RecipientDeliveryStatus recipients = 7;
   */ _define_property(this, "recipients", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(NotificationDeliveryStatus, "runtime", proto3);
_define_property(NotificationDeliveryStatus, "typeName", "mono.datagateway.v1.NotificationDeliveryStatus");
_define_property(NotificationDeliveryStatus, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "notification_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "notification_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "severity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "recipients",
            kind: "message",
            T: RecipientDeliveryStatus,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListNotificationDeliveryStatusRequest
 */ export class ListNotificationDeliveryStatusRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListNotificationDeliveryStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListNotificationDeliveryStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListNotificationDeliveryStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListNotificationDeliveryStatusRequest, a, b);
    }
    constructor(data){
        super(), /**
   * required
   *
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * Optional drill-down: when set, only this event is returned. When empty,
   * the tenant's most recent events are returned, newest first.
   *
   * @generated from field: string notification_event_id = 2;
   */ _define_property(this, "notificationEventId", ""), /**
   * Caps the event count when notification_event_id is empty. <=0 → default.
   *
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListNotificationDeliveryStatusRequest, "runtime", proto3);
_define_property(ListNotificationDeliveryStatusRequest, "typeName", "mono.datagateway.v1.ListNotificationDeliveryStatusRequest");
_define_property(ListNotificationDeliveryStatusRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "notification_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListNotificationDeliveryStatusResponse
 */ export class ListNotificationDeliveryStatusResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListNotificationDeliveryStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListNotificationDeliveryStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListNotificationDeliveryStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListNotificationDeliveryStatusResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.NotificationDeliveryStatus statuses = 1;
   */ _define_property(this, "statuses", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListNotificationDeliveryStatusResponse, "runtime", proto3);
_define_property(ListNotificationDeliveryStatusResponse, "typeName", "mono.datagateway.v1.ListNotificationDeliveryStatusResponse");
_define_property(ListNotificationDeliveryStatusResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "statuses",
            kind: "message",
            T: NotificationDeliveryStatus,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetNotificationPreferencesRequest
 */ export class GetNotificationPreferencesRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetNotificationPreferencesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetNotificationPreferencesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetNotificationPreferencesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetNotificationPreferencesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: mono.datagateway.v1.NotificationPreferenceSubject subject = 2;
   */ _define_property(this, "subject", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetNotificationPreferencesRequest, "runtime", proto3);
_define_property(GetNotificationPreferencesRequest, "typeName", "mono.datagateway.v1.GetNotificationPreferencesRequest");
_define_property(GetNotificationPreferencesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "subject",
            kind: "message",
            T: NotificationPreferenceSubject
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetNotificationPreferencesRequest
 */ export class SetNotificationPreferencesRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetNotificationPreferencesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetNotificationPreferencesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetNotificationPreferencesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetNotificationPreferencesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: mono.datagateway.v1.NotificationPreferenceSubject subject = 2;
   */ _define_property(this, "subject", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.NotificationPreferenceChange changes = 3;
   */ _define_property(this, "changes", []), /**
   * Clears every stored choice for the subject before applying changes.
   *
   * @generated from field: bool reset_all = 4;
   */ _define_property(this, "resetAll", false), /**
   * Who made the change (platform user id), for the row's audit column.
   *
   * @generated from field: string updated_by = 5;
   */ _define_property(this, "updatedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetNotificationPreferencesRequest, "runtime", proto3);
_define_property(SetNotificationPreferencesRequest, "typeName", "mono.datagateway.v1.SetNotificationPreferencesRequest");
_define_property(SetNotificationPreferencesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "subject",
            kind: "message",
            T: NotificationPreferenceSubject
        },
        {
            no: 3,
            name: "changes",
            kind: "message",
            T: NotificationPreferenceChange,
            repeated: true
        },
        {
            no: 4,
            name: "reset_all",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "updated_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetNotificationPreferencesResponse
 */ export class GetNotificationPreferencesResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetNotificationPreferencesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetNotificationPreferencesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetNotificationPreferencesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetNotificationPreferencesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.NotificationKindPreference kinds = 1;
   */ _define_property(this, "kinds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetNotificationPreferencesResponse, "runtime", proto3);
_define_property(GetNotificationPreferencesResponse, "typeName", "mono.datagateway.v1.GetNotificationPreferencesResponse");
_define_property(GetNotificationPreferencesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kinds",
            kind: "message",
            T: NotificationKindPreference,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetNotificationPreferencesResponse
 */ export class SetNotificationPreferencesResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetNotificationPreferencesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetNotificationPreferencesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetNotificationPreferencesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetNotificationPreferencesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.NotificationKindPreference kinds = 1;
   */ _define_property(this, "kinds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetNotificationPreferencesResponse, "runtime", proto3);
_define_property(SetNotificationPreferencesResponse, "typeName", "mono.datagateway.v1.SetNotificationPreferencesResponse");
_define_property(SetNotificationPreferencesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kinds",
            kind: "message",
            T: NotificationKindPreference,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ApplyEmailPreferenceLinkRequest
 */ export class ApplyEmailPreferenceLinkRequest extends Message {
    static fromBinary(bytes, options) {
        return new ApplyEmailPreferenceLinkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApplyEmailPreferenceLinkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApplyEmailPreferenceLinkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApplyEmailPreferenceLinkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string token = 1;
   */ _define_property(this, "token", ""), /**
   * Turn the token's own kind's email off.
   *
   * @generated from field: bool stop = 2;
   */ _define_property(this, "stop", false), /**
   * Other EMAIL-channel changes for the token's subject (the page's manage
   * view). Non-EMAIL changes are refused.
   *
   * @generated from field: repeated mono.datagateway.v1.NotificationPreferenceChange changes = 3;
   */ _define_property(this, "changes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApplyEmailPreferenceLinkRequest, "runtime", proto3);
_define_property(ApplyEmailPreferenceLinkRequest, "typeName", "mono.datagateway.v1.ApplyEmailPreferenceLinkRequest");
_define_property(ApplyEmailPreferenceLinkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "stop",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "changes",
            kind: "message",
            T: NotificationPreferenceChange,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ApplyEmailPreferenceLinkResponse
 */ export class ApplyEmailPreferenceLinkResponse extends Message {
    static fromBinary(bytes, options) {
        return new ApplyEmailPreferenceLinkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApplyEmailPreferenceLinkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApplyEmailPreferenceLinkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApplyEmailPreferenceLinkResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Only kinds that ride email; in_app is not populated.
   *
   * @generated from field: repeated mono.datagateway.v1.NotificationKindPreference kinds = 1;
   */ _define_property(this, "kinds", []), /**
   * The kind the link's email was about.
   *
   * @generated from field: string link_kind = 2;
   */ _define_property(this, "linkKind", ""), /**
   * @generated from field: string link_kind_label = 3;
   */ _define_property(this, "linkKindLabel", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApplyEmailPreferenceLinkResponse, "runtime", proto3);
_define_property(ApplyEmailPreferenceLinkResponse, "typeName", "mono.datagateway.v1.ApplyEmailPreferenceLinkResponse");
_define_property(ApplyEmailPreferenceLinkResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kinds",
            kind: "message",
            T: NotificationKindPreference,
            repeated: true
        },
        {
            no: 2,
            name: "link_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "link_kind_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ResolveDeliveryResourceProgramRequest
 */ export class ResolveDeliveryResourceProgramRequest extends Message {
    static fromBinary(bytes, options) {
        return new ResolveDeliveryResourceProgramRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveDeliveryResourceProgramRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveDeliveryResourceProgramRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveDeliveryResourceProgramRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * The child entity's kind — a table-level name from the closed server-side
   * set (e.g. "risks", "task_attachments", "corrective_actions").
   *
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string id = 3;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveDeliveryResourceProgramRequest, "runtime", proto3);
_define_property(ResolveDeliveryResourceProgramRequest, "typeName", "mono.datagateway.v1.ResolveDeliveryResourceProgramRequest");
_define_property(ResolveDeliveryResourceProgramRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ResolveDeliveryResourceProgramResponse
 */ export class ResolveDeliveryResourceProgramResponse extends Message {
    static fromBinary(bytes, options) {
        return new ResolveDeliveryResourceProgramResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolveDeliveryResourceProgramResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolveDeliveryResourceProgramResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolveDeliveryResourceProgramResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * The program's scope node when one exists (may be empty for a program
   * whose node hasn't been seeded yet — callers resolve through the normal
   * scope-walk either way).
   *
   * @generated from field: string scope_node_id = 2;
   */ _define_property(this, "scopeNodeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolveDeliveryResourceProgramResponse, "runtime", proto3);
_define_property(ResolveDeliveryResourceProgramResponse, "typeName", "mono.datagateway.v1.ResolveDeliveryResourceProgramResponse");
_define_property(ResolveDeliveryResourceProgramResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scope_node_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * LaborCategoryEntry is one version of a labor category AS WRITTEN — title,
 * description, quals, clearance, certs are source-faithful and never
 * normalized (the Rosetta layer in Phase 2b maps between preserved
 * originals). company_profile_id and contract_vehicle_id are both optional:
 * a solicitation-as-written or vehicle-standard LCAT belongs to no
 * contractor. Entries are append-only versions: an edit mints a new row
 * (version+1) and stamps this row's superseded_by_id, so downstream facts
 * (rates in Phase 4, staffing lines) stay attached to the exact text they
 * referenced. "Current" rows have empty superseded_by_id.
 *
 * @generated from message mono.datagateway.v1.LaborCategoryEntry
 */ export class LaborCategoryEntry extends Message {
    static fromBinary(bytes, options) {
        return new LaborCategoryEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LaborCategoryEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LaborCategoryEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LaborCategoryEntry, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string company_profile_id = 3;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string contract_vehicle_id = 4;
   */ _define_property(this, "contractVehicleId", ""), /**
   * @generated from field: string zou_project_id = 5;
   */ _define_property(this, "zouProjectId", ""), /**
   * @generated from field: string solicitation_ref = 6;
   */ _define_property(this, "solicitationRef", ""), /**
   * @generated from field: string title = 7;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 8;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string qualifications = 9;
   */ _define_property(this, "qualifications", ""), /**
   * @generated from field: string clearance = 10;
   */ _define_property(this, "clearance", ""), /**
   * @generated from field: string certifications = 11;
   */ _define_property(this, "certifications", ""), /**
   * @generated from field: int32 version = 12;
   */ _define_property(this, "version", 0), /**
   * @generated from field: string superseded_by_id = 13;
   */ _define_property(this, "supersededById", ""), /**
   * MANUAL | CANDIDATE
   *
   * @generated from field: string source = 14;
   */ _define_property(this, "source", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 15;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 16;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 17;
   */ _define_property(this, "deletedAt", void 0), /**
   * ACTIVE | RETIRED. Retirement is a lifecycle stamp on the current version
   * row (no new version): the category leaves default lists and refuses NEW
   * selection, while every pin on any of its versions keeps resolving.
   *
   * @generated from field: string status = 18;
   */ _define_property(this, "status", ""), /**
   * @generated from field: google.protobuf.Timestamp retired_at = 19;
   */ _define_property(this, "retiredAt", void 0), /**
   * @generated from field: string retired_by = 20;
   */ _define_property(this, "retiredBy", ""), /**
   * COMPANY_LIST | VEHICLE_CATALOG | SOLICITATION
   *
   * @generated from field: string scope_kind = 21;
   */ _define_property(this, "scopeKind", ""), /**
   * @generated from field: string issuing_government_organization_id = 22;
   */ _define_property(this, "issuingGovernmentOrganizationId", ""), /**
   * @generated from field: string solicitation_notice_id = 23;
   */ _define_property(this, "solicitationNoticeId", ""), /**
   * computed at read time
   *
   * @generated from field: bool vehicle_mismatch = 24;
   */ _define_property(this, "vehicleMismatch", false), /**
   * @generated from field: string source_label = 25;
   */ _define_property(this, "sourceLabel", ""), /**
   * @generated from field: mono.datagateway.v1.LaborCategoryPrimaryMapping primary_mapping = 26;
   */ _define_property(this, "primaryMapping", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LaborCategoryEntry, "runtime", proto3);
_define_property(LaborCategoryEntry, "typeName", "mono.datagateway.v1.LaborCategoryEntry");
_define_property(LaborCategoryEntry, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "solicitation_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "qualifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "clearance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "certifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 13,
            name: "superseded_by_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 18,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "retired_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 20,
            name: "retired_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "scope_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "issuing_government_organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "solicitation_notice_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "vehicle_mismatch",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 25,
            name: "source_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 26,
            name: "primary_mapping",
            kind: "message",
            T: LaborCategoryPrimaryMapping
        }
    ]));
/**
 * LaborCategoryCandidate is an extraction-fed suggestion awaiting human
 * review (the IDP suggest→accept mirror). candidate_key is the feeder-owned
 * idempotency key (e.g. "zou:<project_id>:<code>") — re-filing the same
 * source row returns the existing candidate instead of duplicating.
 * evidence_json carries the extraction provenance until Phase 5 lands it in
 * source_references. Only AcceptLaborCategoryCandidate mints an entry.
 *
 * @generated from message mono.datagateway.v1.LaborCategoryCandidate
 */ export class LaborCategoryCandidate extends Message {
    static fromBinary(bytes, options) {
        return new LaborCategoryCandidate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LaborCategoryCandidate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LaborCategoryCandidate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LaborCategoryCandidate, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string candidate_key = 3;
   */ _define_property(this, "candidateKey", ""), /**
   * @generated from field: string company_profile_id = 4;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string contract_vehicle_id = 5;
   */ _define_property(this, "contractVehicleId", ""), /**
   * @generated from field: string zou_project_id = 6;
   */ _define_property(this, "zouProjectId", ""), /**
   * @generated from field: string solicitation_ref = 7;
   */ _define_property(this, "solicitationRef", ""), /**
   * @generated from field: string title = 8;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 9;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string qualifications = 10;
   */ _define_property(this, "qualifications", ""), /**
   * @generated from field: string clearance = 11;
   */ _define_property(this, "clearance", ""), /**
   * @generated from field: string certifications = 12;
   */ _define_property(this, "certifications", ""), /**
   * @generated from field: string evidence_json = 13;
   */ _define_property(this, "evidenceJson", ""), /**
   * PENDING | ACCEPTED | REJECTED
   *
   * @generated from field: string status = 14;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string accepted_entry_id = 15;
   */ _define_property(this, "acceptedEntryId", ""), /**
   * @generated from field: string decided_by = 16;
   */ _define_property(this, "decidedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp decided_at = 17;
   */ _define_property(this, "decidedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 18;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 19;
   */ _define_property(this, "updatedAt", void 0), /**
   * SAD-439: NEW | EXISTING | REJECTED, and the reviewer's field-level
   * changes as {field:{from,to}}. The fields above stay the original proposal.
   *
   * @generated from field: string resolution = 20;
   */ _define_property(this, "resolution", ""), /**
   * @generated from field: string correction_json = 21;
   */ _define_property(this, "correctionJson", ""), /**
   * @generated from field: bool conflict_acknowledged = 22;
   */ _define_property(this, "conflictAcknowledged", false), /**
   * @generated from field: bool vehicle_mismatch = 23;
   */ _define_property(this, "vehicleMismatch", false), /**
   * @generated from field: string mismatch_vehicle_name = 24;
   */ _define_property(this, "mismatchVehicleName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LaborCategoryCandidate, "runtime", proto3);
_define_property(LaborCategoryCandidate, "typeName", "mono.datagateway.v1.LaborCategoryCandidate");
_define_property(LaborCategoryCandidate, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "candidate_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "solicitation_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "qualifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "clearance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "certifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "evidence_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "accepted_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "decided_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "decided_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 18,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 19,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 20,
            name: "resolution",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "correction_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "conflict_acknowledged",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 23,
            name: "vehicle_mismatch",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 24,
            name: "mismatch_vehicle_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetLaborCategoryEntryRequest
 */ export class GetLaborCategoryEntryRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetLaborCategoryEntryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLaborCategoryEntryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLaborCategoryEntryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLaborCategoryEntryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: bool include_deleted = 2;
   */ _define_property(this, "includeDeleted", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLaborCategoryEntryRequest, "runtime", proto3);
_define_property(GetLaborCategoryEntryRequest, "typeName", "mono.datagateway.v1.GetLaborCategoryEntryRequest");
_define_property(GetLaborCategoryEntryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetLaborCategoryEntryResponse
 */ export class GetLaborCategoryEntryResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetLaborCategoryEntryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLaborCategoryEntryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLaborCategoryEntryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLaborCategoryEntryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LaborCategoryEntry labor_category_entry = 1;
   */ _define_property(this, "laborCategoryEntry", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLaborCategoryEntryResponse, "runtime", proto3);
_define_property(GetLaborCategoryEntryResponse, "typeName", "mono.datagateway.v1.GetLaborCategoryEntryResponse");
_define_property(GetLaborCategoryEntryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category_entry",
            kind: "message",
            T: LaborCategoryEntry
        }
    ]));
/**
 * Upsert: empty id creates version 1. A non-empty id whose text fields
 * changed mints a NEW version row (returned) and supersedes the old one; an
 * unchanged upsert returns the existing row untouched. Scope/provenance
 * fields (company, vehicle, refs) ride the new version verbatim.
 *
 * @generated from message mono.datagateway.v1.UpsertLaborCategoryEntryRequest
 */ export class UpsertLaborCategoryEntryRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertLaborCategoryEntryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertLaborCategoryEntryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertLaborCategoryEntryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertLaborCategoryEntryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LaborCategoryEntry labor_category_entry = 1;
   */ _define_property(this, "laborCategoryEntry", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertLaborCategoryEntryRequest, "runtime", proto3);
_define_property(UpsertLaborCategoryEntryRequest, "typeName", "mono.datagateway.v1.UpsertLaborCategoryEntryRequest");
_define_property(UpsertLaborCategoryEntryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category_entry",
            kind: "message",
            T: LaborCategoryEntry
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertLaborCategoryEntryResponse
 */ export class UpsertLaborCategoryEntryResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertLaborCategoryEntryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertLaborCategoryEntryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertLaborCategoryEntryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertLaborCategoryEntryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LaborCategoryEntry labor_category_entry = 1;
   */ _define_property(this, "laborCategoryEntry", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertLaborCategoryEntryResponse, "runtime", proto3);
_define_property(UpsertLaborCategoryEntryResponse, "typeName", "mono.datagateway.v1.UpsertLaborCategoryEntryResponse");
_define_property(UpsertLaborCategoryEntryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category_entry",
            kind: "message",
            T: LaborCategoryEntry
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LaborCategoryEntryFilter
 */ export class LaborCategoryEntryFilter extends Message {
    static fromBinary(bytes, options) {
        return new LaborCategoryEntryFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LaborCategoryEntryFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LaborCategoryEntryFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LaborCategoryEntryFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string company_profile_id = 2;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string contract_vehicle_id = 3;
   */ _define_property(this, "contractVehicleId", ""), /**
   * Case-insensitive substring over title.
   *
   * @generated from field: string search = 4;
   */ _define_property(this, "search", ""), /**
   * Superseded versions are hidden by default — the browse/picker surface
   * reads current rows; history views opt in.
   *
   * @generated from field: bool include_superseded = 5;
   */ _define_property(this, "includeSuperseded", false), /**
   * @generated from field: bool include_deleted = 6;
   */ _define_property(this, "includeDeleted", false), /**
   * Retired categories are hidden from the default browse/picker surface;
   * history and audit views opt in.
   *
   * @generated from field: bool include_retired = 7;
   */ _define_property(this, "includeRetired", false), /**
   * @generated from field: string scope_kind = 8;
   */ _define_property(this, "scopeKind", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LaborCategoryEntryFilter, "runtime", proto3);
_define_property(LaborCategoryEntryFilter, "typeName", "mono.datagateway.v1.LaborCategoryEntryFilter");
_define_property(LaborCategoryEntryFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "include_superseded",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "include_deleted",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "include_retired",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "scope_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListLaborCategoryEntriesRequest
 */ export class ListLaborCategoryEntriesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListLaborCategoryEntriesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLaborCategoryEntriesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLaborCategoryEntriesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLaborCategoryEntriesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LaborCategoryEntryFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLaborCategoryEntriesRequest, "runtime", proto3);
_define_property(ListLaborCategoryEntriesRequest, "typeName", "mono.datagateway.v1.ListLaborCategoryEntriesRequest");
_define_property(ListLaborCategoryEntriesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: LaborCategoryEntryFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListLaborCategoryEntriesResponse
 */ export class ListLaborCategoryEntriesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListLaborCategoryEntriesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLaborCategoryEntriesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLaborCategoryEntriesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLaborCategoryEntriesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.LaborCategoryEntry labor_category_entries = 1;
   */ _define_property(this, "laborCategoryEntries", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero), /**
   * Tenant-wide unretracted DAT-13 lcat_mismatch signals (not narrowed by the filter).
   *
   * @generated from field: int64 vehicle_mismatch_signal_count = 3;
   */ _define_property(this, "vehicleMismatchSignalCount", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLaborCategoryEntriesResponse, "runtime", proto3);
_define_property(ListLaborCategoryEntriesResponse, "typeName", "mono.datagateway.v1.ListLaborCategoryEntriesResponse");
_define_property(ListLaborCategoryEntriesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category_entries",
            kind: "message",
            T: LaborCategoryEntry,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 3,
            name: "vehicle_mismatch_signal_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteLaborCategoryEntryRequest
 */ export class DeleteLaborCategoryEntryRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteLaborCategoryEntryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteLaborCategoryEntryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteLaborCategoryEntryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteLaborCategoryEntryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteLaborCategoryEntryRequest, "runtime", proto3);
_define_property(DeleteLaborCategoryEntryRequest, "typeName", "mono.datagateway.v1.DeleteLaborCategoryEntryRequest");
_define_property(DeleteLaborCategoryEntryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteLaborCategoryEntryResponse
 */ export class DeleteLaborCategoryEntryResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteLaborCategoryEntryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteLaborCategoryEntryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteLaborCategoryEntryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteLaborCategoryEntryResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteLaborCategoryEntryResponse, "runtime", proto3);
_define_property(DeleteLaborCategoryEntryResponse, "typeName", "mono.datagateway.v1.DeleteLaborCategoryEntryResponse");
_define_property(DeleteLaborCategoryEntryResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * Retire the category containing id (any version — the stamp lands on the
 * current head). Mints no version and touches no rate, mapping or prior
 * version row. Idempotent: retiring a retired category returns it unchanged.
 *
 * @generated from message mono.datagateway.v1.RetireLaborCategoryEntryRequest
 */ export class RetireLaborCategoryEntryRequest extends Message {
    static fromBinary(bytes, options) {
        return new RetireLaborCategoryEntryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RetireLaborCategoryEntryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RetireLaborCategoryEntryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RetireLaborCategoryEntryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string retired_by = 2;
   */ _define_property(this, "retiredBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RetireLaborCategoryEntryRequest, "runtime", proto3);
_define_property(RetireLaborCategoryEntryRequest, "typeName", "mono.datagateway.v1.RetireLaborCategoryEntryRequest");
_define_property(RetireLaborCategoryEntryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "retired_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RetireLaborCategoryEntryResponse
 */ export class RetireLaborCategoryEntryResponse extends Message {
    static fromBinary(bytes, options) {
        return new RetireLaborCategoryEntryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RetireLaborCategoryEntryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RetireLaborCategoryEntryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RetireLaborCategoryEntryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LaborCategoryEntry labor_category_entry = 1;
   */ _define_property(this, "laborCategoryEntry", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RetireLaborCategoryEntryResponse, "runtime", proto3);
_define_property(RetireLaborCategoryEntryResponse, "typeName", "mono.datagateway.v1.RetireLaborCategoryEntryResponse");
_define_property(RetireLaborCategoryEntryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category_entry",
            kind: "message",
            T: LaborCategoryEntry
        }
    ]));
/**
 * The full version chain containing the given entry id, newest first. The id
 * may be any version in the chain — the walk finds the head, then descends.
 *
 * @generated from message mono.datagateway.v1.GetLaborCategoryEntryHistoryRequest
 */ export class GetLaborCategoryEntryHistoryRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetLaborCategoryEntryHistoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLaborCategoryEntryHistoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLaborCategoryEntryHistoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLaborCategoryEntryHistoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLaborCategoryEntryHistoryRequest, "runtime", proto3);
_define_property(GetLaborCategoryEntryHistoryRequest, "typeName", "mono.datagateway.v1.GetLaborCategoryEntryHistoryRequest");
_define_property(GetLaborCategoryEntryHistoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetLaborCategoryEntryHistoryResponse
 */ export class GetLaborCategoryEntryHistoryResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetLaborCategoryEntryHistoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLaborCategoryEntryHistoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLaborCategoryEntryHistoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLaborCategoryEntryHistoryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.LaborCategoryEntry labor_category_entries = 1;
   */ _define_property(this, "laborCategoryEntries", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLaborCategoryEntryHistoryResponse, "runtime", proto3);
_define_property(GetLaborCategoryEntryHistoryResponse, "typeName", "mono.datagateway.v1.GetLaborCategoryEntryHistoryResponse");
_define_property(GetLaborCategoryEntryHistoryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category_entries",
            kind: "message",
            T: LaborCategoryEntry,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateLaborCategoryCandidateRequest
 */ export class CreateLaborCategoryCandidateRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateLaborCategoryCandidateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateLaborCategoryCandidateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateLaborCategoryCandidateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateLaborCategoryCandidateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LaborCategoryCandidate labor_category_candidate = 1;
   */ _define_property(this, "laborCategoryCandidate", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateLaborCategoryCandidateRequest, "runtime", proto3);
_define_property(CreateLaborCategoryCandidateRequest, "typeName", "mono.datagateway.v1.CreateLaborCategoryCandidateRequest");
_define_property(CreateLaborCategoryCandidateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category_candidate",
            kind: "message",
            T: LaborCategoryCandidate
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateLaborCategoryCandidateResponse
 */ export class CreateLaborCategoryCandidateResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateLaborCategoryCandidateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateLaborCategoryCandidateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateLaborCategoryCandidateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateLaborCategoryCandidateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LaborCategoryCandidate labor_category_candidate = 1;
   */ _define_property(this, "laborCategoryCandidate", void 0), /**
   * False when the candidate_key already existed and the stored row was
   * returned instead — feeders treat either as success.
   *
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateLaborCategoryCandidateResponse, "runtime", proto3);
_define_property(CreateLaborCategoryCandidateResponse, "typeName", "mono.datagateway.v1.CreateLaborCategoryCandidateResponse");
_define_property(CreateLaborCategoryCandidateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category_candidate",
            kind: "message",
            T: LaborCategoryCandidate
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetLaborCategoryCandidateRequest
 */ export class GetLaborCategoryCandidateRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetLaborCategoryCandidateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLaborCategoryCandidateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLaborCategoryCandidateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLaborCategoryCandidateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLaborCategoryCandidateRequest, "runtime", proto3);
_define_property(GetLaborCategoryCandidateRequest, "typeName", "mono.datagateway.v1.GetLaborCategoryCandidateRequest");
_define_property(GetLaborCategoryCandidateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetLaborCategoryCandidateResponse
 */ export class GetLaborCategoryCandidateResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetLaborCategoryCandidateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLaborCategoryCandidateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLaborCategoryCandidateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLaborCategoryCandidateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LaborCategoryCandidate labor_category_candidate = 1;
   */ _define_property(this, "laborCategoryCandidate", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLaborCategoryCandidateResponse, "runtime", proto3);
_define_property(GetLaborCategoryCandidateResponse, "typeName", "mono.datagateway.v1.GetLaborCategoryCandidateResponse");
_define_property(GetLaborCategoryCandidateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category_candidate",
            kind: "message",
            T: LaborCategoryCandidate
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LaborCategoryCandidateFilter
 */ export class LaborCategoryCandidateFilter extends Message {
    static fromBinary(bytes, options) {
        return new LaborCategoryCandidateFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LaborCategoryCandidateFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LaborCategoryCandidateFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LaborCategoryCandidateFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * empty = all
   *
   * @generated from field: string status = 2;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LaborCategoryCandidateFilter, "runtime", proto3);
_define_property(LaborCategoryCandidateFilter, "typeName", "mono.datagateway.v1.LaborCategoryCandidateFilter");
_define_property(LaborCategoryCandidateFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListLaborCategoryCandidatesRequest
 */ export class ListLaborCategoryCandidatesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListLaborCategoryCandidatesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLaborCategoryCandidatesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLaborCategoryCandidatesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLaborCategoryCandidatesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LaborCategoryCandidateFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLaborCategoryCandidatesRequest, "runtime", proto3);
_define_property(ListLaborCategoryCandidatesRequest, "typeName", "mono.datagateway.v1.ListLaborCategoryCandidatesRequest");
_define_property(ListLaborCategoryCandidatesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: LaborCategoryCandidateFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListLaborCategoryCandidatesResponse
 */ export class ListLaborCategoryCandidatesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListLaborCategoryCandidatesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLaborCategoryCandidatesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLaborCategoryCandidatesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLaborCategoryCandidatesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.LaborCategoryCandidate labor_category_candidates = 1;
   */ _define_property(this, "laborCategoryCandidates", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLaborCategoryCandidatesResponse, "runtime", proto3);
_define_property(ListLaborCategoryCandidatesResponse, "typeName", "mono.datagateway.v1.ListLaborCategoryCandidatesResponse");
_define_property(ListLaborCategoryCandidatesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category_candidates",
            kind: "message",
            T: LaborCategoryCandidate,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * Accept promotes a PENDING candidate into an approved entry (source
 * CANDIDATE) in one transaction: entry created, candidate stamped
 * ACCEPTED + accepted_entry_id + decided_by/at. Non-PENDING candidates
 * fail with FAILED_PRECONDITION — decisions are not re-playable.
 * SAD-439: correction overlays the proposal before the entry is minted;
 * resolve_to_entry_id reuses that exact entry version instead of minting one
 * (held observations replay onto it either way). A qualifications conflict with
 * the chosen entry needs acknowledge_conflict.
 *
 * @generated from message mono.datagateway.v1.LaborCategoryCorrection
 */ export class LaborCategoryCorrection extends Message {
    static fromBinary(bytes, options) {
        return new LaborCategoryCorrection().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LaborCategoryCorrection().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LaborCategoryCorrection().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LaborCategoryCorrection, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: optional string title = 1;
   */ _define_property(this, "title", void 0), /**
   * @generated from field: optional string description = 2;
   */ _define_property(this, "description", void 0), /**
   * @generated from field: optional string qualifications = 3;
   */ _define_property(this, "qualifications", void 0), /**
   * @generated from field: optional string clearance = 4;
   */ _define_property(this, "clearance", void 0), /**
   * @generated from field: optional string certifications = 5;
   */ _define_property(this, "certifications", void 0), /**
   * @generated from field: optional string company_profile_id = 6;
   */ _define_property(this, "companyProfileId", void 0), /**
   * @generated from field: optional string contract_vehicle_id = 7;
   */ _define_property(this, "contractVehicleId", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LaborCategoryCorrection, "runtime", proto3);
_define_property(LaborCategoryCorrection, "typeName", "mono.datagateway.v1.LaborCategoryCorrection");
_define_property(LaborCategoryCorrection, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 2,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 3,
            name: "qualifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 4,
            name: "clearance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 5,
            name: "certifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 6,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 7,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AcceptLaborCategoryCandidateRequest
 */ export class AcceptLaborCategoryCandidateRequest extends Message {
    static fromBinary(bytes, options) {
        return new AcceptLaborCategoryCandidateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AcceptLaborCategoryCandidateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AcceptLaborCategoryCandidateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AcceptLaborCategoryCandidateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string decided_by = 2;
   */ _define_property(this, "decidedBy", ""), /**
   * @generated from field: mono.datagateway.v1.LaborCategoryCorrection correction = 3;
   */ _define_property(this, "correction", void 0), /**
   * @generated from field: string resolve_to_entry_id = 4;
   */ _define_property(this, "resolveToEntryId", ""), /**
   * @generated from field: bool acknowledge_conflict = 5;
   */ _define_property(this, "acknowledgeConflict", false), /**
   * SOLICITATION mints a solicitation-scoped entry
   *
   * @generated from field: string scope_kind = 6;
   */ _define_property(this, "scopeKind", ""), /**
   * else derived from the capture profile
   *
   * @generated from field: string issuing_government_organization_id = 7;
   */ _define_property(this, "issuingGovernmentOrganizationId", ""), /**
   * accept and propose a PENDING mapping in one transaction
   *
   * @generated from field: string propose_anchor_id = 8;
   */ _define_property(this, "proposeAnchorId", ""), /**
   * default BROADER
   *
   * @generated from field: string propose_relation = 9;
   */ _define_property(this, "proposeRelation", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AcceptLaborCategoryCandidateRequest, "runtime", proto3);
_define_property(AcceptLaborCategoryCandidateRequest, "typeName", "mono.datagateway.v1.AcceptLaborCategoryCandidateRequest");
_define_property(AcceptLaborCategoryCandidateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "decided_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "correction",
            kind: "message",
            T: LaborCategoryCorrection
        },
        {
            no: 4,
            name: "resolve_to_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "acknowledge_conflict",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "scope_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "issuing_government_organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "propose_anchor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "propose_relation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AcceptLaborCategoryCandidateResponse
 */ export class AcceptLaborCategoryCandidateResponse extends Message {
    static fromBinary(bytes, options) {
        return new AcceptLaborCategoryCandidateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AcceptLaborCategoryCandidateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AcceptLaborCategoryCandidateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AcceptLaborCategoryCandidateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LaborCategoryCandidate labor_category_candidate = 1;
   */ _define_property(this, "laborCategoryCandidate", void 0), /**
   * @generated from field: mono.datagateway.v1.LaborCategoryEntry labor_category_entry = 2;
   */ _define_property(this, "laborCategoryEntry", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AcceptLaborCategoryCandidateResponse, "runtime", proto3);
_define_property(AcceptLaborCategoryCandidateResponse, "typeName", "mono.datagateway.v1.AcceptLaborCategoryCandidateResponse");
_define_property(AcceptLaborCategoryCandidateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category_candidate",
            kind: "message",
            T: LaborCategoryCandidate
        },
        {
            no: 2,
            name: "labor_category_entry",
            kind: "message",
            T: LaborCategoryEntry
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RejectLaborCategoryCandidateRequest
 */ export class RejectLaborCategoryCandidateRequest extends Message {
    static fromBinary(bytes, options) {
        return new RejectLaborCategoryCandidateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectLaborCategoryCandidateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectLaborCategoryCandidateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectLaborCategoryCandidateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string decided_by = 2;
   */ _define_property(this, "decidedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectLaborCategoryCandidateRequest, "runtime", proto3);
_define_property(RejectLaborCategoryCandidateRequest, "typeName", "mono.datagateway.v1.RejectLaborCategoryCandidateRequest");
_define_property(RejectLaborCategoryCandidateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "decided_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RejectLaborCategoryCandidateResponse
 */ export class RejectLaborCategoryCandidateResponse extends Message {
    static fromBinary(bytes, options) {
        return new RejectLaborCategoryCandidateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectLaborCategoryCandidateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectLaborCategoryCandidateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectLaborCategoryCandidateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LaborCategoryCandidate labor_category_candidate = 1;
   */ _define_property(this, "laborCategoryCandidate", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectLaborCategoryCandidateResponse, "runtime", proto3);
_define_property(RejectLaborCategoryCandidateResponse, "typeName", "mono.datagateway.v1.RejectLaborCategoryCandidateResponse");
_define_property(RejectLaborCategoryCandidateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category_candidate",
            kind: "message",
            T: LaborCategoryCandidate
        }
    ]));
/**
 * LaborCategoryAnchor is a GLOBAL occupational reference row (SOC/O*NET) —
 * the hub cross-company comparison routes through. No tenant_id: every
 * tenant maps against the same code. Content is owned by pangaea's embedded
 * catalog (refdata) and, later, the Phase 5 BLS/O*NET importer.
 *
 * @generated from message mono.datagateway.v1.LaborCategoryAnchor
 */ export class LaborCategoryAnchor extends Message {
    static fromBinary(bytes, options) {
        return new LaborCategoryAnchor().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LaborCategoryAnchor().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LaborCategoryAnchor().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LaborCategoryAnchor, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string soc_code = 2;
   */ _define_property(this, "socCode", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 4;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string family = 5;
   */ _define_property(this, "family", ""), /**
   * @generated from field: string specialty = 6;
   */ _define_property(this, "specialty", ""), /**
   * @generated from field: string seniority = 7;
   */ _define_property(this, "seniority", ""), /**
   * @generated from field: string source = 8;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string source_version = 9;
   */ _define_property(this, "sourceVersion", ""), /**
   * Read from labor_category_anchor_reference_facts; the anchors row is unchanged.
   *
   * @generated from field: string onet_title = 10;
   */ _define_property(this, "onetTitle", ""), /**
   * @generated from field: string typical_education = 11;
   */ _define_property(this, "typicalEducation", ""), /**
   * -1 = not stated
   *
   * @generated from field: int32 typical_min_experience_years = 12;
   */ _define_property(this, "typicalMinExperienceYears", 0), /**
   * @generated from field: string facts_provenance = 13;
   */ _define_property(this, "factsProvenance", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LaborCategoryAnchor, "runtime", proto3);
_define_property(LaborCategoryAnchor, "typeName", "mono.datagateway.v1.LaborCategoryAnchor");
_define_property(LaborCategoryAnchor, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "soc_code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "family",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "specialty",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "seniority",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "source_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "onet_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "typical_education",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "typical_min_experience_years",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 13,
            name: "facts_provenance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * LaborCategoryMapping is a tenant-curated Rosetta edge from an entry to
 * EXACTLY ONE of another entry or an anchor. mapping_type is
 * EQUIVALENT | BROADER | NARROWER; status is PENDING | APPROVED | REJECTED
 * (terminal). Edges pin specific entry VERSIONS.
 *
 * @generated from message mono.datagateway.v1.LaborCategoryMapping
 */ export class LaborCategoryMapping extends Message {
    static fromBinary(bytes, options) {
        return new LaborCategoryMapping().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LaborCategoryMapping().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LaborCategoryMapping().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LaborCategoryMapping, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string from_entry_id = 3;
   */ _define_property(this, "fromEntryId", ""), /**
   * @generated from field: string to_entry_id = 4;
   */ _define_property(this, "toEntryId", ""), /**
   * @generated from field: string to_anchor_id = 5;
   */ _define_property(this, "toAnchorId", ""), /**
   * @generated from field: string mapping_type = 6;
   */ _define_property(this, "mappingType", ""), /**
   * Optional so an explicit 0.0 ("no confidence, evidence pending") is
   * distinguishable from an omitted field (proto3 double defaults to 0).
   *
   * @generated from field: optional double confidence = 7;
   */ _define_property(this, "confidence", void 0), /**
   * @generated from field: string evidence_json = 8;
   */ _define_property(this, "evidenceJson", ""), /**
   * @generated from field: string status = 9;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string proposed_by = 10;
   */ _define_property(this, "proposedBy", ""), /**
   * @generated from field: string decided_by = 11;
   */ _define_property(this, "decidedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp decided_at = 12;
   */ _define_property(this, "decidedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: string original_basis_json = 14;
   */ _define_property(this, "originalBasisJson", ""), /**
   * @generated from field: string reviewed_basis_json = 15;
   */ _define_property(this, "reviewedBasisJson", ""), /**
   * @generated from field: int64 review_revision = 16;
   */ _define_property(this, "reviewRevision", protoInt64.zero), /**
   * @generated from field: string correction_reason = 17;
   */ _define_property(this, "correctionReason", ""), /**
   * @generated from field: string corrected_by = 18;
   */ _define_property(this, "correctedBy", ""), /**
   * @generated from field: string withdrawal_reason = 19;
   */ _define_property(this, "withdrawalReason", ""), /**
   * @generated from field: string withdrawn_by = 20;
   */ _define_property(this, "withdrawnBy", ""), /**
   * @generated from field: google.protobuf.Timestamp withdrawn_at = 21;
   */ _define_property(this, "withdrawnAt", void 0), /**
   * @generated from field: string impact_notice_json = 22;
   */ _define_property(this, "impactNoticeJson", ""), /**
   * Read-only current definition heads; reviewed endpoint IDs above stay pinned.
   *
   * @generated from field: string current_from_entry_id = 23;
   */ _define_property(this, "currentFromEntryId", ""), /**
   * @generated from field: string current_to_entry_id = 24;
   */ _define_property(this, "currentToEntryId", ""), /**
   * @generated from field: string review_note = 25;
   */ _define_property(this, "reviewNote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LaborCategoryMapping, "runtime", proto3);
_define_property(LaborCategoryMapping, "typeName", "mono.datagateway.v1.LaborCategoryMapping");
_define_property(LaborCategoryMapping, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "from_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "to_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "to_anchor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "mapping_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 8,
            name: "evidence_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "proposed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "decided_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "decided_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "original_basis_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "reviewed_basis_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "review_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 17,
            name: "correction_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "corrected_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "withdrawal_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "withdrawn_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "withdrawn_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 22,
            name: "impact_notice_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "current_from_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "current_to_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 25,
            name: "review_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LaborCategoryAnchorFilter
 */ export class LaborCategoryAnchorFilter extends Message {
    static fromBinary(bytes, options) {
        return new LaborCategoryAnchorFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LaborCategoryAnchorFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LaborCategoryAnchorFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LaborCategoryAnchorFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string family = 1;
   */ _define_property(this, "family", ""), /**
   * Case-insensitive substring over soc_code + title.
   *
   * @generated from field: string search = 2;
   */ _define_property(this, "search", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LaborCategoryAnchorFilter, "runtime", proto3);
_define_property(LaborCategoryAnchorFilter, "typeName", "mono.datagateway.v1.LaborCategoryAnchorFilter");
_define_property(LaborCategoryAnchorFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "family",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListLaborCategoryAnchorsRequest
 */ export class ListLaborCategoryAnchorsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListLaborCategoryAnchorsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLaborCategoryAnchorsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLaborCategoryAnchorsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLaborCategoryAnchorsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LaborCategoryAnchorFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLaborCategoryAnchorsRequest, "runtime", proto3);
_define_property(ListLaborCategoryAnchorsRequest, "typeName", "mono.datagateway.v1.ListLaborCategoryAnchorsRequest");
_define_property(ListLaborCategoryAnchorsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: LaborCategoryAnchorFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListLaborCategoryAnchorsResponse
 */ export class ListLaborCategoryAnchorsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListLaborCategoryAnchorsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLaborCategoryAnchorsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLaborCategoryAnchorsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLaborCategoryAnchorsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.LaborCategoryAnchor labor_category_anchors = 1;
   */ _define_property(this, "laborCategoryAnchors", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLaborCategoryAnchorsResponse, "runtime", proto3);
_define_property(ListLaborCategoryAnchorsResponse, "typeName", "mono.datagateway.v1.ListLaborCategoryAnchorsResponse");
_define_property(ListLaborCategoryAnchorsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category_anchors",
            kind: "message",
            T: LaborCategoryAnchor,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * Propose: idempotent per (tenant, from, target) among live rows — a
 * re-proposed edge returns the stored row with created=false.
 *
 * @generated from message mono.datagateway.v1.ProposeLaborCategoryMappingRequest
 */ export class ProposeLaborCategoryMappingRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProposeLaborCategoryMappingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeLaborCategoryMappingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeLaborCategoryMappingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeLaborCategoryMappingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LaborCategoryMapping labor_category_mapping = 1;
   */ _define_property(this, "laborCategoryMapping", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeLaborCategoryMappingRequest, "runtime", proto3);
_define_property(ProposeLaborCategoryMappingRequest, "typeName", "mono.datagateway.v1.ProposeLaborCategoryMappingRequest");
_define_property(ProposeLaborCategoryMappingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category_mapping",
            kind: "message",
            T: LaborCategoryMapping
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposeLaborCategoryMappingResponse
 */ export class ProposeLaborCategoryMappingResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProposeLaborCategoryMappingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeLaborCategoryMappingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeLaborCategoryMappingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeLaborCategoryMappingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LaborCategoryMapping labor_category_mapping = 1;
   */ _define_property(this, "laborCategoryMapping", void 0), /**
   * @generated from field: bool created = 2;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeLaborCategoryMappingResponse, "runtime", proto3);
_define_property(ProposeLaborCategoryMappingResponse, "typeName", "mono.datagateway.v1.ProposeLaborCategoryMappingResponse");
_define_property(ProposeLaborCategoryMappingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category_mapping",
            kind: "message",
            T: LaborCategoryMapping
        },
        {
            no: 2,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetLaborCategoryMappingRequest
 */ export class GetLaborCategoryMappingRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetLaborCategoryMappingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLaborCategoryMappingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLaborCategoryMappingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLaborCategoryMappingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLaborCategoryMappingRequest, "runtime", proto3);
_define_property(GetLaborCategoryMappingRequest, "typeName", "mono.datagateway.v1.GetLaborCategoryMappingRequest");
_define_property(GetLaborCategoryMappingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetLaborCategoryMappingResponse
 */ export class GetLaborCategoryMappingResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetLaborCategoryMappingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLaborCategoryMappingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLaborCategoryMappingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLaborCategoryMappingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LaborCategoryMapping labor_category_mapping = 1;
   */ _define_property(this, "laborCategoryMapping", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLaborCategoryMappingResponse, "runtime", proto3);
_define_property(GetLaborCategoryMappingResponse, "typeName", "mono.datagateway.v1.GetLaborCategoryMappingResponse");
_define_property(GetLaborCategoryMappingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category_mapping",
            kind: "message",
            T: LaborCategoryMapping
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LaborCategoryMappingFilter
 */ export class LaborCategoryMappingFilter extends Message {
    static fromBinary(bytes, options) {
        return new LaborCategoryMappingFilter().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LaborCategoryMappingFilter().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LaborCategoryMappingFilter().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LaborCategoryMappingFilter, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string from_entry_id = 2;
   */ _define_property(this, "fromEntryId", ""), /**
   * @generated from field: string to_entry_id = 3;
   */ _define_property(this, "toEntryId", ""), /**
   * @generated from field: string to_anchor_id = 4;
   */ _define_property(this, "toAnchorId", ""), /**
   * empty = all
   *
   * @generated from field: string status = 5;
   */ _define_property(this, "status", ""), /**
   * Matches an edge touching this entry at EITHER endpoint (from_entry_id OR
   * to_entry_id). One stored decision is read from both sides; the reader
   * reverses BROADER/NARROWER for the to-side. Combines (AND) with the other
   * fields.
   *
   * @generated from field: string entry_id = 6;
   */ _define_property(this, "entryId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LaborCategoryMappingFilter, "runtime", proto3);
_define_property(LaborCategoryMappingFilter, "typeName", "mono.datagateway.v1.LaborCategoryMappingFilter");
_define_property(LaborCategoryMappingFilter, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "from_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "to_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "to_anchor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListLaborCategoryMappingsRequest
 */ export class ListLaborCategoryMappingsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListLaborCategoryMappingsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLaborCategoryMappingsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLaborCategoryMappingsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLaborCategoryMappingsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LaborCategoryMappingFilter filter = 1;
   */ _define_property(this, "filter", void 0), /**
   * @generated from field: int32 offset = 2;
   */ _define_property(this, "offset", 0), /**
   * @generated from field: int32 limit = 3;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLaborCategoryMappingsRequest, "runtime", proto3);
_define_property(ListLaborCategoryMappingsRequest, "typeName", "mono.datagateway.v1.ListLaborCategoryMappingsRequest");
_define_property(ListLaborCategoryMappingsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filter",
            kind: "message",
            T: LaborCategoryMappingFilter
        },
        {
            no: 2,
            name: "offset",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListLaborCategoryMappingsResponse
 */ export class ListLaborCategoryMappingsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListLaborCategoryMappingsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLaborCategoryMappingsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLaborCategoryMappingsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLaborCategoryMappingsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.LaborCategoryMapping labor_category_mappings = 1;
   */ _define_property(this, "laborCategoryMappings", []), /**
   * @generated from field: int64 total = 2;
   */ _define_property(this, "total", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLaborCategoryMappingsResponse, "runtime", proto3);
_define_property(ListLaborCategoryMappingsResponse, "typeName", "mono.datagateway.v1.ListLaborCategoryMappingsResponse");
_define_property(ListLaborCategoryMappingsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category_mappings",
            kind: "message",
            T: LaborCategoryMapping,
            repeated: true
        },
        {
            no: 2,
            name: "total",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * Decisions are terminal — FAILED_PRECONDITION on replay.
 *
 * @generated from message mono.datagateway.v1.ApproveLaborCategoryMappingRequest
 */ export class ApproveLaborCategoryMappingRequest extends Message {
    static fromBinary(bytes, options) {
        return new ApproveLaborCategoryMappingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApproveLaborCategoryMappingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApproveLaborCategoryMappingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApproveLaborCategoryMappingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string decided_by = 2;
   */ _define_property(this, "decidedBy", ""), /**
   * @generated from field: int64 review_revision = 3;
   */ _define_property(this, "reviewRevision", protoInt64.zero), /**
   * @generated from field: string review_note = 4;
   */ _define_property(this, "reviewNote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApproveLaborCategoryMappingRequest, "runtime", proto3);
_define_property(ApproveLaborCategoryMappingRequest, "typeName", "mono.datagateway.v1.ApproveLaborCategoryMappingRequest");
_define_property(ApproveLaborCategoryMappingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "decided_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "review_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 4,
            name: "review_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ApproveLaborCategoryMappingResponse
 */ export class ApproveLaborCategoryMappingResponse extends Message {
    static fromBinary(bytes, options) {
        return new ApproveLaborCategoryMappingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApproveLaborCategoryMappingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApproveLaborCategoryMappingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApproveLaborCategoryMappingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LaborCategoryMapping labor_category_mapping = 1;
   */ _define_property(this, "laborCategoryMapping", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApproveLaborCategoryMappingResponse, "runtime", proto3);
_define_property(ApproveLaborCategoryMappingResponse, "typeName", "mono.datagateway.v1.ApproveLaborCategoryMappingResponse");
_define_property(ApproveLaborCategoryMappingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category_mapping",
            kind: "message",
            T: LaborCategoryMapping
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RejectLaborCategoryMappingRequest
 */ export class RejectLaborCategoryMappingRequest extends Message {
    static fromBinary(bytes, options) {
        return new RejectLaborCategoryMappingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectLaborCategoryMappingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectLaborCategoryMappingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectLaborCategoryMappingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string decided_by = 2;
   */ _define_property(this, "decidedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectLaborCategoryMappingRequest, "runtime", proto3);
_define_property(RejectLaborCategoryMappingRequest, "typeName", "mono.datagateway.v1.RejectLaborCategoryMappingRequest");
_define_property(RejectLaborCategoryMappingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "decided_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RejectLaborCategoryMappingResponse
 */ export class RejectLaborCategoryMappingResponse extends Message {
    static fromBinary(bytes, options) {
        return new RejectLaborCategoryMappingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectLaborCategoryMappingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectLaborCategoryMappingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectLaborCategoryMappingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LaborCategoryMapping labor_category_mapping = 1;
   */ _define_property(this, "laborCategoryMapping", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectLaborCategoryMappingResponse, "runtime", proto3);
_define_property(RejectLaborCategoryMappingResponse, "typeName", "mono.datagateway.v1.RejectLaborCategoryMappingResponse");
_define_property(RejectLaborCategoryMappingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category_mapping",
            kind: "message",
            T: LaborCategoryMapping
        }
    ]));
/**
 * CloseoutChecklistTemplate is the per-tenant (or "_system" default) set of
 * checklist items a program's closeout checklist is instantiated from.
 *
 * @generated from message mono.datagateway.v1.CloseoutChecklistTemplate
 */ export class CloseoutChecklistTemplate extends Message {
    static fromBinary(bytes, options) {
        return new CloseoutChecklistTemplate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseoutChecklistTemplate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseoutChecklistTemplate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseoutChecklistTemplate, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string key = 3;
   */ _define_property(this, "key", ""), /**
   * @generated from field: string name = 4;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string description = 5;
   */ _define_property(this, "description", ""), /**
   * @generated from field: bool is_system = 6;
   */ _define_property(this, "isSystem", false), /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 9;
   */ _define_property(this, "deletedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseoutChecklistTemplate, "runtime", proto3);
_define_property(CloseoutChecklistTemplate, "typeName", "mono.datagateway.v1.CloseoutChecklistTemplate");
_define_property(CloseoutChecklistTemplate, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "is_system",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * CloseoutChecklistTemplateItem is one line of template prose.
 *
 * @generated from message mono.datagateway.v1.CloseoutChecklistTemplateItem
 */ export class CloseoutChecklistTemplateItem extends Message {
    static fromBinary(bytes, options) {
        return new CloseoutChecklistTemplateItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseoutChecklistTemplateItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseoutChecklistTemplateItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseoutChecklistTemplateItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string template_id = 3;
   */ _define_property(this, "templateId", ""), /**
   * @generated from field: int32 ordinal = 4;
   */ _define_property(this, "ordinal", 0), /**
   * @generated from field: string text = 5;
   */ _define_property(this, "text", ""), /**
   * @generated from field: string comments_guidance = 6;
   */ _define_property(this, "commentsGuidance", ""), /**
   * @generated from field: string sds_section = 7;
   */ _define_property(this, "sdsSection", ""), /**
   * @generated from field: string review_instruction = 8;
   */ _define_property(this, "reviewInstruction", ""), /**
   * @generated from field: string accountable_party = 9;
   */ _define_property(this, "accountableParty", ""), /**
   * @generated from field: bool specra_specific = 10;
   */ _define_property(this, "specraSpecific", false), /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 13;
   */ _define_property(this, "deletedAt", void 0), /**
   * final|period|both
   *
   * @generated from field: string applies_to = 14;
   */ _define_property(this, "appliesTo", ""), /**
   * The prefill rule this item carries on a contract-period checklist; set by
   * the seeded default and kept through edits.
   *
   * @generated from field: string prefill_rule = 15;
   */ _define_property(this, "prefillRule", ""), /**
   * exclude|include. Only the sub_reviews_in_period prefill reads it.
   * Default exclude: subs with no review due are not counted toward a No.
   *
   * @generated from field: string count_subs_with_no_review_due = 16;
   */ _define_property(this, "countSubsWithNoReviewDue", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseoutChecklistTemplateItem, "runtime", proto3);
_define_property(CloseoutChecklistTemplateItem, "typeName", "mono.datagateway.v1.CloseoutChecklistTemplateItem");
_define_property(CloseoutChecklistTemplateItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "ordinal",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "comments_guidance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "sds_section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "review_instruction",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "accountable_party",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "specra_specific",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "applies_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "prefill_rule",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "count_subs_with_no_review_due",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CloseoutChecklistTemplateView pairs a resolved template with its items —
 * the shape ListCloseoutChecklistTemplates returns per template.
 *
 * @generated from message mono.datagateway.v1.CloseoutChecklistTemplateView
 */ export class CloseoutChecklistTemplateView extends Message {
    static fromBinary(bytes, options) {
        return new CloseoutChecklistTemplateView().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseoutChecklistTemplateView().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseoutChecklistTemplateView().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseoutChecklistTemplateView, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CloseoutChecklistTemplate template = 1;
   */ _define_property(this, "template", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.CloseoutChecklistTemplateItem items = 2;
   */ _define_property(this, "items", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseoutChecklistTemplateView, "runtime", proto3);
_define_property(CloseoutChecklistTemplateView, "typeName", "mono.datagateway.v1.CloseoutChecklistTemplateView");
_define_property(CloseoutChecklistTemplateView, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "template",
            kind: "message",
            T: CloseoutChecklistTemplate
        },
        {
            no: 2,
            name: "items",
            kind: "message",
            T: CloseoutChecklistTemplateItem,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCloseoutChecklistTemplatesRequest
 */ export class ListCloseoutChecklistTemplatesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCloseoutChecklistTemplatesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCloseoutChecklistTemplatesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCloseoutChecklistTemplatesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCloseoutChecklistTemplatesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * When false, "_system" defaults the tenant has not overridden are omitted.
   *
   * @generated from field: bool include_system = 2;
   */ _define_property(this, "includeSystem", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCloseoutChecklistTemplatesRequest, "runtime", proto3);
_define_property(ListCloseoutChecklistTemplatesRequest, "typeName", "mono.datagateway.v1.ListCloseoutChecklistTemplatesRequest");
_define_property(ListCloseoutChecklistTemplatesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_system",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListCloseoutChecklistTemplatesResponse
 */ export class ListCloseoutChecklistTemplatesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCloseoutChecklistTemplatesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCloseoutChecklistTemplatesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCloseoutChecklistTemplatesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCloseoutChecklistTemplatesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CloseoutChecklistTemplateView templates = 1;
   */ _define_property(this, "templates", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCloseoutChecklistTemplatesResponse, "runtime", proto3);
_define_property(ListCloseoutChecklistTemplatesResponse, "typeName", "mono.datagateway.v1.ListCloseoutChecklistTemplatesResponse");
_define_property(ListCloseoutChecklistTemplatesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "templates",
            kind: "message",
            T: CloseoutChecklistTemplateView,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCloseoutChecklistTemplateItemRequest
 */ export class UpsertCloseoutChecklistTemplateItemRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCloseoutChecklistTemplateItemRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCloseoutChecklistTemplateItemRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCloseoutChecklistTemplateItemRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCloseoutChecklistTemplateItemRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string template_key = 2;
   */ _define_property(this, "templateKey", ""), /**
   * @generated from field: int32 ordinal = 3;
   */ _define_property(this, "ordinal", 0), /**
   * @generated from field: string text = 4;
   */ _define_property(this, "text", ""), /**
   * @generated from field: string comments_guidance = 5;
   */ _define_property(this, "commentsGuidance", ""), /**
   * @generated from field: string sds_section = 6;
   */ _define_property(this, "sdsSection", ""), /**
   * @generated from field: string review_instruction = 7;
   */ _define_property(this, "reviewInstruction", ""), /**
   * @generated from field: string accountable_party = 8;
   */ _define_property(this, "accountableParty", ""), /**
   * @generated from field: bool specra_specific = 9;
   */ _define_property(this, "specraSpecific", false), /**
   * final|period|both. Empty keeps an existing item's value; a new item
   * defaults to final.
   *
   * @generated from field: string applies_to = 10;
   */ _define_property(this, "appliesTo", ""), /**
   * exclude|include. Empty keeps an existing item's value; a new item
   * defaults to exclude.
   *
   * @generated from field: string count_subs_with_no_review_due = 11;
   */ _define_property(this, "countSubsWithNoReviewDue", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCloseoutChecklistTemplateItemRequest, "runtime", proto3);
_define_property(UpsertCloseoutChecklistTemplateItemRequest, "typeName", "mono.datagateway.v1.UpsertCloseoutChecklistTemplateItemRequest");
_define_property(UpsertCloseoutChecklistTemplateItemRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "template_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "ordinal",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "comments_guidance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "sds_section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "review_instruction",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "accountable_party",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "specra_specific",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "applies_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "count_subs_with_no_review_due",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCloseoutChecklistTemplateItemResponse
 */ export class UpsertCloseoutChecklistTemplateItemResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCloseoutChecklistTemplateItemResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCloseoutChecklistTemplateItemResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCloseoutChecklistTemplateItemResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCloseoutChecklistTemplateItemResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CloseoutChecklistTemplateItem item = 1;
   */ _define_property(this, "item", void 0), /**
   * The tenant-owned template's id. Differs from the "_system" template
   * resolved by template_key when this call triggered a copy-on-write clone.
   *
   * @generated from field: string template_id = 2;
   */ _define_property(this, "templateId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCloseoutChecklistTemplateItemResponse, "runtime", proto3);
_define_property(UpsertCloseoutChecklistTemplateItemResponse, "typeName", "mono.datagateway.v1.UpsertCloseoutChecklistTemplateItemResponse");
_define_property(UpsertCloseoutChecklistTemplateItemResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: CloseoutChecklistTemplateItem
        },
        {
            no: 2,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCloseoutChecklistTemplateItemRequest
 */ export class DeleteCloseoutChecklistTemplateItemRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCloseoutChecklistTemplateItemRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCloseoutChecklistTemplateItemRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCloseoutChecklistTemplateItemRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCloseoutChecklistTemplateItemRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string template_key = 2;
   */ _define_property(this, "templateKey", ""), /**
   * @generated from field: int32 ordinal = 3;
   */ _define_property(this, "ordinal", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCloseoutChecklistTemplateItemRequest, "runtime", proto3);
_define_property(DeleteCloseoutChecklistTemplateItemRequest, "typeName", "mono.datagateway.v1.DeleteCloseoutChecklistTemplateItemRequest");
_define_property(DeleteCloseoutChecklistTemplateItemRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "template_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "ordinal",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCloseoutChecklistTemplateItemResponse
 */ export class DeleteCloseoutChecklistTemplateItemResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCloseoutChecklistTemplateItemResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCloseoutChecklistTemplateItemResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCloseoutChecklistTemplateItemResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCloseoutChecklistTemplateItemResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCloseoutChecklistTemplateItemResponse, "runtime", proto3);
_define_property(DeleteCloseoutChecklistTemplateItemResponse, "typeName", "mono.datagateway.v1.DeleteCloseoutChecklistTemplateItemResponse");
_define_property(DeleteCloseoutChecklistTemplateItemResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * CloseoutChecklist is one per Program (scope "program") plus one per period
 * (scope "period"), instantiated from a template.
 *
 * @generated from message mono.datagateway.v1.CloseoutChecklist
 */ export class CloseoutChecklist extends Message {
    static fromBinary(bytes, options) {
        return new CloseoutChecklist().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseoutChecklist().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseoutChecklist().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseoutChecklist, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 3;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string template_id = 4;
   */ _define_property(this, "templateId", ""), /**
   * Pending|Completed
   *
   * @generated from field: string state = 5;
   */ _define_property(this, "state", ""), /**
   * @generated from field: google.protobuf.Timestamp closeout_date = 6;
   */ _define_property(this, "closeoutDate", void 0), /**
   * @generated from field: google.protobuf.Timestamp completed_at = 7;
   */ _define_property(this, "completedAt", void 0), /**
   * @generated from field: string completed_by = 8;
   */ _define_property(this, "completedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 11;
   */ _define_property(this, "deletedAt", void 0), /**
   * program|period
   *
   * @generated from field: string scope = 12;
   */ _define_property(this, "scope", ""), /**
   * contract|team_cycle; empty at scope program
   *
   * @generated from field: string period_kind = 13;
   */ _define_property(this, "periodKind", ""), /**
   * A periods_of_performance id (contract) or optional_task_exercises id
   * (team_cycle); empty at scope program.
   *
   * @generated from field: string period_id = 14;
   */ _define_property(this, "periodId", ""), /**
   * Set when the period is closed; never set at scope program.
   *
   * @generated from field: google.protobuf.Timestamp closed_at = 15;
   */ _define_property(this, "closedAt", void 0), /**
   * @generated from field: string closed_by = 16;
   */ _define_property(this, "closedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseoutChecklist, "runtime", proto3);
_define_property(CloseoutChecklist, "typeName", "mono.datagateway.v1.CloseoutChecklist");
_define_property(CloseoutChecklist, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "closeout_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 7,
            name: "completed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 8,
            name: "completed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "period_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "period_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "closed_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "closed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CloseoutChecklistItem is a per-checklist instance row. The prose fields are
 * a SNAPSHOT copied from the template item at instantiation.
 *
 * @generated from message mono.datagateway.v1.CloseoutChecklistItem
 */ export class CloseoutChecklistItem extends Message {
    static fromBinary(bytes, options) {
        return new CloseoutChecklistItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseoutChecklistItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseoutChecklistItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseoutChecklistItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string checklist_id = 3;
   */ _define_property(this, "checklistId", ""), /**
   * @generated from field: string template_item_id = 4;
   */ _define_property(this, "templateItemId", ""), /**
   * @generated from field: int32 ordinal = 5;
   */ _define_property(this, "ordinal", 0), /**
   * @generated from field: string text = 6;
   */ _define_property(this, "text", ""), /**
   * @generated from field: string comments_guidance = 7;
   */ _define_property(this, "commentsGuidance", ""), /**
   * @generated from field: string sds_section = 8;
   */ _define_property(this, "sdsSection", ""), /**
   * @generated from field: string review_instruction = 9;
   */ _define_property(this, "reviewInstruction", ""), /**
   * @generated from field: string accountable_party = 10;
   */ _define_property(this, "accountableParty", ""), /**
   * @generated from field: bool specra_specific = 11;
   */ _define_property(this, "specraSpecific", false), /**
   * YES|N_A|NO
   *
   * @generated from field: string answer = 12;
   */ _define_property(this, "answer", ""), /**
   * @generated from field: string comments = 13;
   */ _define_property(this, "comments", ""), /**
   * @generated from field: string answered_by = 14;
   */ _define_property(this, "answeredBy", ""), /**
   * @generated from field: google.protobuf.Timestamp answered_at = 15;
   */ _define_property(this, "answeredAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 16;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 17;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: string prefill_rule = 18;
   */ _define_property(this, "prefillRule", ""), /**
   * @generated from field: string count_subs_with_no_review_due = 19;
   */ _define_property(this, "countSubsWithNoReviewDue", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseoutChecklistItem, "runtime", proto3);
_define_property(CloseoutChecklistItem, "typeName", "mono.datagateway.v1.CloseoutChecklistItem");
_define_property(CloseoutChecklistItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "checklist_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "template_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "ordinal",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "comments_guidance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "sds_section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "review_instruction",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "accountable_party",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "specra_specific",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "answer",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "comments",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "answered_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "answered_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 16,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 17,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 18,
            name: "prefill_rule",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "count_subs_with_no_review_due",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CloseoutOutstandingItem is a free row in the checklist's Outstanding Items
 * sub-list — anything not closed at sign-off.
 *
 * @generated from message mono.datagateway.v1.CloseoutOutstandingItem
 */ export class CloseoutOutstandingItem extends Message {
    static fromBinary(bytes, options) {
        return new CloseoutOutstandingItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseoutOutstandingItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseoutOutstandingItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseoutOutstandingItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string checklist_id = 3;
   */ _define_property(this, "checklistId", ""), /**
   * @generated from field: string item = 4;
   */ _define_property(this, "item", ""), /**
   * @generated from field: google.protobuf.Timestamp planned_completion_date = 5;
   */ _define_property(this, "plannedCompletionDate", void 0), /**
   * @generated from field: string comments = 6;
   */ _define_property(this, "comments", ""), /**
   * @generated from field: string sds_section = 7;
   */ _define_property(this, "sdsSection", ""), /**
   * @generated from field: string responsible_party = 8;
   */ _define_property(this, "responsibleParty", ""), /**
   * @generated from field: int32 sort_order = 9;
   */ _define_property(this, "sortOrder", 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */ _define_property(this, "updatedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp deleted_at = 12;
   */ _define_property(this, "deletedAt", void 0), /**
   * Marked true once the item is resolved; purely informational — the
   * Outstanding Items list is not part of the completion gate.
   *
   * @generated from field: bool resolved = 13;
   */ _define_property(this, "resolved", false), /**
   * The previous period's unresolved item this row was carried forward from.
   * Set only by the carry-forward; ignored on upsert.
   *
   * @generated from field: string carried_from_id = 14;
   */ _define_property(this, "carriedFromId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseoutOutstandingItem, "runtime", proto3);
_define_property(CloseoutOutstandingItem, "typeName", "mono.datagateway.v1.CloseoutOutstandingItem");
_define_property(CloseoutOutstandingItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "checklist_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "item",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "planned_completion_date",
            kind: "message",
            T: Timestamp
        },
        {
            no: 6,
            name: "comments",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "sds_section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "responsible_party",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "sort_order",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "updated_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "deleted_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "resolved",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 14,
            name: "carried_from_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CloseoutPrefillSource is one record a prefill read.
 *
 * @generated from message mono.datagateway.v1.CloseoutPrefillSource
 */ export class CloseoutPrefillSource extends Message {
    static fromBinary(bytes, options) {
        return new CloseoutPrefillSource().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseoutPrefillSource().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseoutPrefillSource().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseoutPrefillSource, a, b);
    }
    constructor(data){
        super(), /**
   * occurrence|cpars|qasp|subcontractor_review|company_assignment|financial_month|period|modification|sow|risk|issue|corrective_action
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string label = 3;
   */ _define_property(this, "label", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseoutPrefillSource, "runtime", proto3);
_define_property(CloseoutPrefillSource, "typeName", "mono.datagateway.v1.CloseoutPrefillSource");
_define_property(CloseoutPrefillSource, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * CloseoutPrefill is a deterministic proposed answer for one checklist item
 * on a contract-period checklist, with the records it read. answer is
 * YES|N_A|NO, or empty when the records cannot settle it (summary says why).
 *
 * @generated from message mono.datagateway.v1.CloseoutPrefill
 */ export class CloseoutPrefill extends Message {
    static fromBinary(bytes, options) {
        return new CloseoutPrefill().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseoutPrefill().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseoutPrefill().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseoutPrefill, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 ordinal = 1;
   */ _define_property(this, "ordinal", 0), /**
   * @generated from field: string rule = 2;
   */ _define_property(this, "rule", ""), /**
   * @generated from field: string answer = 3;
   */ _define_property(this, "answer", ""), /**
   * @generated from field: string summary = 4;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: repeated mono.datagateway.v1.CloseoutPrefillSource sources = 5;
   */ _define_property(this, "sources", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseoutPrefill, "runtime", proto3);
_define_property(CloseoutPrefill, "typeName", "mono.datagateway.v1.CloseoutPrefill");
_define_property(CloseoutPrefill, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "ordinal",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "rule",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "answer",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "sources",
            kind: "message",
            T: CloseoutPrefillSource,
            repeated: true
        }
    ]));
/**
 * CloseoutChecklistItemCorrection is one answer-log row: kind "correction"
 * is an answer changed after its period closed, kind "override" an answer
 * that departs from the item's prefill. Both keep the value they replaced.
 *
 * @generated from message mono.datagateway.v1.CloseoutChecklistItemCorrection
 */ export class CloseoutChecklistItemCorrection extends Message {
    static fromBinary(bytes, options) {
        return new CloseoutChecklistItemCorrection().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseoutChecklistItemCorrection().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseoutChecklistItemCorrection().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseoutChecklistItemCorrection, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string checklist_id = 3;
   */ _define_property(this, "checklistId", ""), /**
   * @generated from field: int32 ordinal = 4;
   */ _define_property(this, "ordinal", 0), /**
   * @generated from field: string prior_answer = 5;
   */ _define_property(this, "priorAnswer", ""), /**
   * @generated from field: string prior_comments = 6;
   */ _define_property(this, "priorComments", ""), /**
   * @generated from field: string prior_answered_by = 7;
   */ _define_property(this, "priorAnsweredBy", ""), /**
   * @generated from field: google.protobuf.Timestamp prior_answered_at = 8;
   */ _define_property(this, "priorAnsweredAt", void 0), /**
   * @generated from field: string answer = 9;
   */ _define_property(this, "answer", ""), /**
   * @generated from field: string comments = 10;
   */ _define_property(this, "comments", ""), /**
   * @generated from field: string corrected_by = 11;
   */ _define_property(this, "correctedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */ _define_property(this, "createdAt", void 0), /**
   * correction|override
   *
   * @generated from field: string kind = 13;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string prefill_answer = 14;
   */ _define_property(this, "prefillAnswer", ""), /**
   * @generated from field: repeated mono.datagateway.v1.CloseoutPrefillSource prefill_sources = 15;
   */ _define_property(this, "prefillSources", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseoutChecklistItemCorrection, "runtime", proto3);
_define_property(CloseoutChecklistItemCorrection, "typeName", "mono.datagateway.v1.CloseoutChecklistItemCorrection");
_define_property(CloseoutChecklistItemCorrection, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "checklist_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "ordinal",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "prior_answer",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "prior_comments",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "prior_answered_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "prior_answered_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "answer",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "comments",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "corrected_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 13,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "prefill_answer",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "prefill_sources",
            kind: "message",
            T: CloseoutPrefillSource,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateCloseoutChecklistRequest
 */ export class CreateCloseoutChecklistRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateCloseoutChecklistRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCloseoutChecklistRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCloseoutChecklistRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCloseoutChecklistRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string template_key = 3;
   */ _define_property(this, "templateKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCloseoutChecklistRequest, "runtime", proto3);
_define_property(CreateCloseoutChecklistRequest, "typeName", "mono.datagateway.v1.CreateCloseoutChecklistRequest");
_define_property(CreateCloseoutChecklistRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "template_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateCloseoutChecklistResponse
 */ export class CreateCloseoutChecklistResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateCloseoutChecklistResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateCloseoutChecklistResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateCloseoutChecklistResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateCloseoutChecklistResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CloseoutChecklist checklist = 1;
   */ _define_property(this, "checklist", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.CloseoutChecklistItem items = 2;
   */ _define_property(this, "items", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateCloseoutChecklistResponse, "runtime", proto3);
_define_property(CreateCloseoutChecklistResponse, "typeName", "mono.datagateway.v1.CreateCloseoutChecklistResponse");
_define_property(CreateCloseoutChecklistResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "checklist",
            kind: "message",
            T: CloseoutChecklist
        },
        {
            no: 2,
            name: "items",
            kind: "message",
            T: CloseoutChecklistItem,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCloseoutChecklistRequest
 */ export class GetCloseoutChecklistRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetCloseoutChecklistRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCloseoutChecklistRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCloseoutChecklistRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCloseoutChecklistRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCloseoutChecklistRequest, "runtime", proto3);
_define_property(GetCloseoutChecklistRequest, "typeName", "mono.datagateway.v1.GetCloseoutChecklistRequest");
_define_property(GetCloseoutChecklistRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetCloseoutChecklistResponse
 */ export class GetCloseoutChecklistResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetCloseoutChecklistResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetCloseoutChecklistResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetCloseoutChecklistResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetCloseoutChecklistResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CloseoutChecklist checklist = 1;
   */ _define_property(this, "checklist", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.CloseoutChecklistItem items = 2;
   */ _define_property(this, "items", []), /**
   * @generated from field: repeated mono.datagateway.v1.CloseoutOutstandingItem outstanding_items = 3;
   */ _define_property(this, "outstandingItems", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetCloseoutChecklistResponse, "runtime", proto3);
_define_property(GetCloseoutChecklistResponse, "typeName", "mono.datagateway.v1.GetCloseoutChecklistResponse");
_define_property(GetCloseoutChecklistResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "checklist",
            kind: "message",
            T: CloseoutChecklist
        },
        {
            no: 2,
            name: "items",
            kind: "message",
            T: CloseoutChecklistItem,
            repeated: true
        },
        {
            no: 3,
            name: "outstanding_items",
            kind: "message",
            T: CloseoutOutstandingItem,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCloseoutChecklistItemAnswerRequest
 */ export class UpsertCloseoutChecklistItemAnswerRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCloseoutChecklistItemAnswerRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCloseoutChecklistItemAnswerRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCloseoutChecklistItemAnswerRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCloseoutChecklistItemAnswerRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string checklist_id = 2;
   */ _define_property(this, "checklistId", ""), /**
   * @generated from field: int32 ordinal = 3;
   */ _define_property(this, "ordinal", 0), /**
   * YES|N_A|NO
   *
   * @generated from field: string answer = 4;
   */ _define_property(this, "answer", ""), /**
   * @generated from field: string comments = 5;
   */ _define_property(this, "comments", ""), /**
   * @generated from field: string answered_by = 6;
   */ _define_property(this, "answeredBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCloseoutChecklistItemAnswerRequest, "runtime", proto3);
_define_property(UpsertCloseoutChecklistItemAnswerRequest, "typeName", "mono.datagateway.v1.UpsertCloseoutChecklistItemAnswerRequest");
_define_property(UpsertCloseoutChecklistItemAnswerRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "checklist_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "ordinal",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "answer",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "comments",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "answered_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCloseoutChecklistItemAnswerResponse
 */ export class UpsertCloseoutChecklistItemAnswerResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCloseoutChecklistItemAnswerResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCloseoutChecklistItemAnswerResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCloseoutChecklistItemAnswerResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCloseoutChecklistItemAnswerResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CloseoutChecklistItem item = 1;
   */ _define_property(this, "item", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCloseoutChecklistItemAnswerResponse, "runtime", proto3);
_define_property(UpsertCloseoutChecklistItemAnswerResponse, "typeName", "mono.datagateway.v1.UpsertCloseoutChecklistItemAnswerResponse");
_define_property(UpsertCloseoutChecklistItemAnswerResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item",
            kind: "message",
            T: CloseoutChecklistItem
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCloseoutOutstandingItemRequest
 */ export class UpsertCloseoutOutstandingItemRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCloseoutOutstandingItemRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCloseoutOutstandingItemRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCloseoutOutstandingItemRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCloseoutOutstandingItemRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CloseoutOutstandingItem outstanding_item = 1;
   */ _define_property(this, "outstandingItem", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCloseoutOutstandingItemRequest, "runtime", proto3);
_define_property(UpsertCloseoutOutstandingItemRequest, "typeName", "mono.datagateway.v1.UpsertCloseoutOutstandingItemRequest");
_define_property(UpsertCloseoutOutstandingItemRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "outstanding_item",
            kind: "message",
            T: CloseoutOutstandingItem
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertCloseoutOutstandingItemResponse
 */ export class UpsertCloseoutOutstandingItemResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertCloseoutOutstandingItemResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertCloseoutOutstandingItemResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertCloseoutOutstandingItemResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertCloseoutOutstandingItemResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CloseoutOutstandingItem outstanding_item = 1;
   */ _define_property(this, "outstandingItem", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertCloseoutOutstandingItemResponse, "runtime", proto3);
_define_property(UpsertCloseoutOutstandingItemResponse, "typeName", "mono.datagateway.v1.UpsertCloseoutOutstandingItemResponse");
_define_property(UpsertCloseoutOutstandingItemResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "outstanding_item",
            kind: "message",
            T: CloseoutOutstandingItem
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCloseoutOutstandingItemRequest
 */ export class DeleteCloseoutOutstandingItemRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCloseoutOutstandingItemRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCloseoutOutstandingItemRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCloseoutOutstandingItemRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCloseoutOutstandingItemRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCloseoutOutstandingItemRequest, "runtime", proto3);
_define_property(DeleteCloseoutOutstandingItemRequest, "typeName", "mono.datagateway.v1.DeleteCloseoutOutstandingItemRequest");
_define_property(DeleteCloseoutOutstandingItemRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteCloseoutOutstandingItemResponse
 */ export class DeleteCloseoutOutstandingItemResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteCloseoutOutstandingItemResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteCloseoutOutstandingItemResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteCloseoutOutstandingItemResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteCloseoutOutstandingItemResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteCloseoutOutstandingItemResponse, "runtime", proto3);
_define_property(DeleteCloseoutOutstandingItemResponse, "typeName", "mono.datagateway.v1.DeleteCloseoutOutstandingItemResponse");
_define_property(DeleteCloseoutOutstandingItemResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.CompleteCloseoutChecklistRequest
 */ export class CompleteCloseoutChecklistRequest extends Message {
    static fromBinary(bytes, options) {
        return new CompleteCloseoutChecklistRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompleteCloseoutChecklistRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompleteCloseoutChecklistRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompleteCloseoutChecklistRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string completed_by = 3;
   */ _define_property(this, "completedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompleteCloseoutChecklistRequest, "runtime", proto3);
_define_property(CompleteCloseoutChecklistRequest, "typeName", "mono.datagateway.v1.CompleteCloseoutChecklistRequest");
_define_property(CompleteCloseoutChecklistRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "completed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CompleteCloseoutChecklistResponse
 */ export class CompleteCloseoutChecklistResponse extends Message {
    static fromBinary(bytes, options) {
        return new CompleteCloseoutChecklistResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompleteCloseoutChecklistResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompleteCloseoutChecklistResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompleteCloseoutChecklistResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Populated regardless of outcome.
   *
   * @generated from field: mono.datagateway.v1.CloseoutChecklist checklist = 1;
   */ _define_property(this, "checklist", void 0), /**
   * Ordinals of items violating the completion invariant (unanswered, or a
   * non-YES answer with no comments). Non-empty means the checklist was NOT
   * completed — mirrors ActivateContractResponse.violations
   * (projectdata.proto): the caller renders exactly what's missing rather
   * than getting a failed RPC.
   *
   * @generated from field: repeated int32 violations = 2;
   */ _define_property(this, "violations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CompleteCloseoutChecklistResponse, "runtime", proto3);
_define_property(CompleteCloseoutChecklistResponse, "typeName", "mono.datagateway.v1.CompleteCloseoutChecklistResponse");
_define_property(CompleteCloseoutChecklistResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "checklist",
            kind: "message",
            T: CloseoutChecklist
        },
        {
            no: 2,
            name: "violations",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CloseProgramRequest
 */ export class CloseProgramRequest extends Message {
    static fromBinary(bytes, options) {
        return new CloseProgramRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseProgramRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseProgramRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseProgramRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string closed_by = 3;
   */ _define_property(this, "closedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseProgramRequest, "runtime", proto3);
_define_property(CloseProgramRequest, "typeName", "mono.datagateway.v1.CloseProgramRequest");
_define_property(CloseProgramRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "closed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CloseProgramResponse
 */ export class CloseProgramResponse extends Message {
    static fromBinary(bytes, options) {
        return new CloseProgramResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CloseProgramResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CloseProgramResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CloseProgramResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(CloseProgramResponse, "runtime", proto3);
_define_property(CloseProgramResponse, "typeName", "mono.datagateway.v1.CloseProgramResponse");
_define_property(CloseProgramResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * SAD-451 RATE-07. A selection freezes the observation id, its correction-chain
 * version and applicability; the amount and assumptions are the consumer's own.
 * It never writes back to the Rate Book.
 *
 * @generated from message mono.datagateway.v1.RateSelection
 */ export class RateSelection extends Message {
    static fromBinary(bytes, options) {
        return new RateSelection().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RateSelection().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RateSelection().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RateSelection, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string tenant_id = 2;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string consumer_kind = 3;
   */ _define_property(this, "consumerKind", ""), /**
   * @generated from field: string consumer_id = 4;
   */ _define_property(this, "consumerId", ""), /**
   * @generated from field: string consumer_ref = 5;
   */ _define_property(this, "consumerRef", ""), /**
   * @generated from field: string observation_id = 6;
   */ _define_property(this, "observationId", ""), /**
   * @generated from field: int32 observation_version = 7;
   */ _define_property(this, "observationVersion", 0), /**
   * @generated from field: double observation_amount = 8;
   */ _define_property(this, "observationAmount", 0), /**
   * @generated from field: double selected_amount = 9;
   */ _define_property(this, "selectedAmount", 0), /**
   * @generated from field: string applicability_json = 10;
   */ _define_property(this, "applicabilityJson", ""), /**
   * @generated from field: string assumptions_json = 11;
   */ _define_property(this, "assumptionsJson", ""), /**
   * @generated from field: string selected_by = 12;
   */ _define_property(this, "selectedBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */ _define_property(this, "createdAt", void 0), /**
   * Computed on read: "" | CORRECTED | INVALIDATED | NEWER_EVIDENCE. A review is
   * an offer; the selected amount never changes unless the consumer selects again.
   *
   * @generated from field: string review_status = 14;
   */ _define_property(this, "reviewStatus", ""), /**
   * @generated from field: string review_candidate_id = 15;
   */ _define_property(this, "reviewCandidateId", ""), /**
   * @generated from field: double review_candidate_amount = 16;
   */ _define_property(this, "reviewCandidateAmount", 0), /**
   * @generated from field: int32 review_candidate_version = 17;
   */ _define_property(this, "reviewCandidateVersion", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RateSelection, "runtime", proto3);
_define_property(RateSelection, "typeName", "mono.datagateway.v1.RateSelection");
_define_property(RateSelection, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "consumer_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "consumer_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "consumer_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "observation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "observation_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "observation_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 9,
            name: "selected_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 10,
            name: "applicability_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "assumptions_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "selected_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 14,
            name: "review_status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "review_candidate_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "review_candidate_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 17,
            name: "review_candidate_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SelectRateObservationRequest
 */ export class SelectRateObservationRequest extends Message {
    static fromBinary(bytes, options) {
        return new SelectRateObservationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SelectRateObservationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SelectRateObservationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SelectRateObservationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string consumer_kind = 2;
   */ _define_property(this, "consumerKind", ""), /**
   * @generated from field: string consumer_id = 3;
   */ _define_property(this, "consumerId", ""), /**
   * @generated from field: string consumer_ref = 4;
   */ _define_property(this, "consumerRef", ""), /**
   * @generated from field: string observation_id = 5;
   */ _define_property(this, "observationId", ""), /**
   * 0 adopts the observation's amount as-is.
   *
   * @generated from field: double selected_amount = 6;
   */ _define_property(this, "selectedAmount", 0), /**
   * @generated from field: string assumptions_json = 7;
   */ _define_property(this, "assumptionsJson", ""), /**
   * Optional applicability context; selection works without any registry contract.
   *
   * @generated from field: string registry_contract_id = 8;
   */ _define_property(this, "registryContractId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SelectRateObservationRequest, "runtime", proto3);
_define_property(SelectRateObservationRequest, "typeName", "mono.datagateway.v1.SelectRateObservationRequest");
_define_property(SelectRateObservationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "consumer_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "consumer_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "consumer_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "observation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "selected_amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 7,
            name: "assumptions_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "registry_contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SelectRateObservationResponse
 */ export class SelectRateObservationResponse extends Message {
    static fromBinary(bytes, options) {
        return new SelectRateObservationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SelectRateObservationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SelectRateObservationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SelectRateObservationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RateSelection selection = 1;
   */ _define_property(this, "selection", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SelectRateObservationResponse, "runtime", proto3);
_define_property(SelectRateObservationResponse, "typeName", "mono.datagateway.v1.SelectRateObservationResponse");
_define_property(SelectRateObservationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "selection",
            kind: "message",
            T: RateSelection
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRateSelectionsRequest
 */ export class ListRateSelectionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRateSelectionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRateSelectionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRateSelectionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRateSelectionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string consumer_kind = 2;
   */ _define_property(this, "consumerKind", ""), /**
   * @generated from field: string consumer_id = 3;
   */ _define_property(this, "consumerId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRateSelectionsRequest, "runtime", proto3);
_define_property(ListRateSelectionsRequest, "typeName", "mono.datagateway.v1.ListRateSelectionsRequest");
_define_property(ListRateSelectionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "consumer_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "consumer_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRateSelectionsResponse
 */ export class ListRateSelectionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRateSelectionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRateSelectionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRateSelectionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRateSelectionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.RateSelection selections = 1;
   */ _define_property(this, "selections", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRateSelectionsResponse, "runtime", proto3);
_define_property(ListRateSelectionsResponse, "typeName", "mono.datagateway.v1.ListRateSelectionsResponse");
_define_property(ListRateSelectionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "selections",
            kind: "message",
            T: RateSelection,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AcknowledgeRateSelectionReviewRequest
 */ export class AcknowledgeRateSelectionReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new AcknowledgeRateSelectionReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AcknowledgeRateSelectionReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AcknowledgeRateSelectionReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AcknowledgeRateSelectionReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string selection_id = 2;
   */ _define_property(this, "selectionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AcknowledgeRateSelectionReviewRequest, "runtime", proto3);
_define_property(AcknowledgeRateSelectionReviewRequest, "typeName", "mono.datagateway.v1.AcknowledgeRateSelectionReviewRequest");
_define_property(AcknowledgeRateSelectionReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "selection_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AcknowledgeRateSelectionReviewResponse
 */ export class AcknowledgeRateSelectionReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new AcknowledgeRateSelectionReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AcknowledgeRateSelectionReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AcknowledgeRateSelectionReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AcknowledgeRateSelectionReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RateSelection selection = 1;
   */ _define_property(this, "selection", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AcknowledgeRateSelectionReviewResponse, "runtime", proto3);
_define_property(AcknowledgeRateSelectionReviewResponse, "typeName", "mono.datagateway.v1.AcknowledgeRateSelectionReviewResponse");
_define_property(AcknowledgeRateSelectionReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "selection",
            kind: "message",
            T: RateSelection
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPeriodCloseoutChecklistsRequest
 */ export class ListPeriodCloseoutChecklistsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPeriodCloseoutChecklistsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPeriodCloseoutChecklistsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPeriodCloseoutChecklistsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPeriodCloseoutChecklistsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * contract|team_cycle
   *
   * @generated from field: string period_kind = 3;
   */ _define_property(this, "periodKind", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPeriodCloseoutChecklistsRequest, "runtime", proto3);
_define_property(ListPeriodCloseoutChecklistsRequest, "typeName", "mono.datagateway.v1.ListPeriodCloseoutChecklistsRequest");
_define_property(ListPeriodCloseoutChecklistsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "period_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListPeriodCloseoutChecklistsResponse
 */ export class ListPeriodCloseoutChecklistsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPeriodCloseoutChecklistsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPeriodCloseoutChecklistsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPeriodCloseoutChecklistsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPeriodCloseoutChecklistsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CloseoutChecklist checklists = 1;
   */ _define_property(this, "checklists", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPeriodCloseoutChecklistsResponse, "runtime", proto3);
_define_property(ListPeriodCloseoutChecklistsResponse, "typeName", "mono.datagateway.v1.ListPeriodCloseoutChecklistsResponse");
_define_property(ListPeriodCloseoutChecklistsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "checklists",
            kind: "message",
            T: CloseoutChecklist,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreatePeriodCloseoutChecklistRequest
 */ export class CreatePeriodCloseoutChecklistRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreatePeriodCloseoutChecklistRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreatePeriodCloseoutChecklistRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreatePeriodCloseoutChecklistRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreatePeriodCloseoutChecklistRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * contract|team_cycle
   *
   * @generated from field: string period_kind = 3;
   */ _define_property(this, "periodKind", ""), /**
   * @generated from field: string period_id = 4;
   */ _define_property(this, "periodId", ""), /**
   * @generated from field: string template_key = 5;
   */ _define_property(this, "templateKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreatePeriodCloseoutChecklistRequest, "runtime", proto3);
_define_property(CreatePeriodCloseoutChecklistRequest, "typeName", "mono.datagateway.v1.CreatePeriodCloseoutChecklistRequest");
_define_property(CreatePeriodCloseoutChecklistRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "period_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "period_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "template_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreatePeriodCloseoutChecklistResponse
 */ export class CreatePeriodCloseoutChecklistResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreatePeriodCloseoutChecklistResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreatePeriodCloseoutChecklistResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreatePeriodCloseoutChecklistResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreatePeriodCloseoutChecklistResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CloseoutChecklist checklist = 1;
   */ _define_property(this, "checklist", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.CloseoutChecklistItem items = 2;
   */ _define_property(this, "items", []), /**
   * Any items carried forward from the previous closed period.
   *
   * @generated from field: repeated mono.datagateway.v1.CloseoutOutstandingItem outstanding_items = 3;
   */ _define_property(this, "outstandingItems", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreatePeriodCloseoutChecklistResponse, "runtime", proto3);
_define_property(CreatePeriodCloseoutChecklistResponse, "typeName", "mono.datagateway.v1.CreatePeriodCloseoutChecklistResponse");
_define_property(CreatePeriodCloseoutChecklistResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "checklist",
            kind: "message",
            T: CloseoutChecklist
        },
        {
            no: 2,
            name: "items",
            kind: "message",
            T: CloseoutChecklistItem,
            repeated: true
        },
        {
            no: 3,
            name: "outstanding_items",
            kind: "message",
            T: CloseoutOutstandingItem,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetPeriodCloseoutChecklistRequest
 */ export class GetPeriodCloseoutChecklistRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPeriodCloseoutChecklistRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPeriodCloseoutChecklistRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPeriodCloseoutChecklistRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPeriodCloseoutChecklistRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * contract|team_cycle
   *
   * @generated from field: string period_kind = 3;
   */ _define_property(this, "periodKind", ""), /**
   * @generated from field: string period_id = 4;
   */ _define_property(this, "periodId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPeriodCloseoutChecklistRequest, "runtime", proto3);
_define_property(GetPeriodCloseoutChecklistRequest, "typeName", "mono.datagateway.v1.GetPeriodCloseoutChecklistRequest");
_define_property(GetPeriodCloseoutChecklistRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "period_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "period_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * NotFound when the period has no checklist yet.
 *
 * @generated from message mono.datagateway.v1.GetPeriodCloseoutChecklistResponse
 */ export class GetPeriodCloseoutChecklistResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPeriodCloseoutChecklistResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPeriodCloseoutChecklistResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPeriodCloseoutChecklistResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPeriodCloseoutChecklistResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CloseoutChecklist checklist = 1;
   */ _define_property(this, "checklist", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.CloseoutChecklistItem items = 2;
   */ _define_property(this, "items", []), /**
   * @generated from field: repeated mono.datagateway.v1.CloseoutOutstandingItem outstanding_items = 3;
   */ _define_property(this, "outstandingItems", []), /**
   * @generated from field: repeated mono.datagateway.v1.CloseoutChecklistItemCorrection corrections = 4;
   */ _define_property(this, "corrections", []), /**
   * Computed on read for a contract period that is not closed; empty
   * otherwise.
   *
   * @generated from field: repeated mono.datagateway.v1.CloseoutPrefill prefills = 5;
   */ _define_property(this, "prefills", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPeriodCloseoutChecklistResponse, "runtime", proto3);
_define_property(GetPeriodCloseoutChecklistResponse, "typeName", "mono.datagateway.v1.GetPeriodCloseoutChecklistResponse");
_define_property(GetPeriodCloseoutChecklistResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "checklist",
            kind: "message",
            T: CloseoutChecklist
        },
        {
            no: 2,
            name: "items",
            kind: "message",
            T: CloseoutChecklistItem,
            repeated: true
        },
        {
            no: 3,
            name: "outstanding_items",
            kind: "message",
            T: CloseoutOutstandingItem,
            repeated: true
        },
        {
            no: 4,
            name: "corrections",
            kind: "message",
            T: CloseoutChecklistItemCorrection,
            repeated: true
        },
        {
            no: 5,
            name: "prefills",
            kind: "message",
            T: CloseoutPrefill,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ClosePeriodRequest
 */ export class ClosePeriodRequest extends Message {
    static fromBinary(bytes, options) {
        return new ClosePeriodRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClosePeriodRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClosePeriodRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClosePeriodRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * contract|team_cycle
   *
   * @generated from field: string period_kind = 3;
   */ _define_property(this, "periodKind", ""), /**
   * @generated from field: string period_id = 4;
   */ _define_property(this, "periodId", ""), /**
   * @generated from field: string closed_by = 5;
   */ _define_property(this, "closedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ClosePeriodRequest, "runtime", proto3);
_define_property(ClosePeriodRequest, "typeName", "mono.datagateway.v1.ClosePeriodRequest");
_define_property(ClosePeriodRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "period_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "period_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "closed_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ClosePeriodResponse
 */ export class ClosePeriodResponse extends Message {
    static fromBinary(bytes, options) {
        return new ClosePeriodResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClosePeriodResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClosePeriodResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClosePeriodResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CloseoutChecklist checklist = 1;
   */ _define_property(this, "checklist", void 0), /**
   * Non-empty means the period was NOT closed; same rule as
   * CompleteCloseoutChecklistResponse.violations.
   *
   * @generated from field: repeated int32 violations = 2;
   */ _define_property(this, "violations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ClosePeriodResponse, "runtime", proto3);
_define_property(ClosePeriodResponse, "typeName", "mono.datagateway.v1.ClosePeriodResponse");
_define_property(ClosePeriodResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "checklist",
            kind: "message",
            T: CloseoutChecklist
        },
        {
            no: 2,
            name: "violations",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ ,
            repeated: true
        }
    ]));
/**
 * Correct only a still-pending proposal at the revision inspected by the reviewer.
 *
 * @generated from message mono.datagateway.v1.CorrectLaborCategoryMappingRequest
 */ export class CorrectLaborCategoryMappingRequest extends Message {
    static fromBinary(bytes, options) {
        return new CorrectLaborCategoryMappingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CorrectLaborCategoryMappingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CorrectLaborCategoryMappingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CorrectLaborCategoryMappingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string to_entry_id = 2;
   */ _define_property(this, "toEntryId", ""), /**
   * @generated from field: string to_anchor_id = 3;
   */ _define_property(this, "toAnchorId", ""), /**
   * @generated from field: string mapping_type = 4;
   */ _define_property(this, "mappingType", ""), /**
   * @generated from field: string reason = 5;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: int64 expected_revision = 6;
   */ _define_property(this, "expectedRevision", protoInt64.zero), /**
   * @generated from field: string corrected_by = 7;
   */ _define_property(this, "correctedBy", ""), /**
   * @generated from field: string review_note = 8;
   */ _define_property(this, "reviewNote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CorrectLaborCategoryMappingRequest, "runtime", proto3);
_define_property(CorrectLaborCategoryMappingRequest, "typeName", "mono.datagateway.v1.CorrectLaborCategoryMappingRequest");
_define_property(CorrectLaborCategoryMappingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "to_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "to_anchor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "mapping_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "expected_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 7,
            name: "corrected_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "review_note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CorrectLaborCategoryMappingResponse
 */ export class CorrectLaborCategoryMappingResponse extends Message {
    static fromBinary(bytes, options) {
        return new CorrectLaborCategoryMappingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CorrectLaborCategoryMappingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CorrectLaborCategoryMappingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CorrectLaborCategoryMappingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LaborCategoryMapping labor_category_mapping = 1;
   */ _define_property(this, "laborCategoryMapping", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CorrectLaborCategoryMappingResponse, "runtime", proto3);
_define_property(CorrectLaborCategoryMappingResponse, "typeName", "mono.datagateway.v1.CorrectLaborCategoryMappingResponse");
_define_property(CorrectLaborCategoryMappingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category_mapping",
            kind: "message",
            T: LaborCategoryMapping
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.WithdrawLaborCategoryMappingRequest
 */ export class WithdrawLaborCategoryMappingRequest extends Message {
    static fromBinary(bytes, options) {
        return new WithdrawLaborCategoryMappingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WithdrawLaborCategoryMappingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WithdrawLaborCategoryMappingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WithdrawLaborCategoryMappingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string reason = 2;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string withdrawn_by = 3;
   */ _define_property(this, "withdrawnBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(WithdrawLaborCategoryMappingRequest, "runtime", proto3);
_define_property(WithdrawLaborCategoryMappingRequest, "typeName", "mono.datagateway.v1.WithdrawLaborCategoryMappingRequest");
_define_property(WithdrawLaborCategoryMappingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "withdrawn_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.WithdrawLaborCategoryMappingResponse
 */ export class WithdrawLaborCategoryMappingResponse extends Message {
    static fromBinary(bytes, options) {
        return new WithdrawLaborCategoryMappingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WithdrawLaborCategoryMappingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WithdrawLaborCategoryMappingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WithdrawLaborCategoryMappingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.LaborCategoryMapping labor_category_mapping = 1;
   */ _define_property(this, "laborCategoryMapping", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WithdrawLaborCategoryMappingResponse, "runtime", proto3);
_define_property(WithdrawLaborCategoryMappingResponse, "typeName", "mono.datagateway.v1.WithdrawLaborCategoryMappingResponse");
_define_property(WithdrawLaborCategoryMappingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "labor_category_mapping",
            kind: "message",
            T: LaborCategoryMapping
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MatchLaborCategoriesItem
 */ export class MatchLaborCategoriesItem extends Message {
    static fromBinary(bytes, options) {
        return new MatchLaborCategoriesItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MatchLaborCategoriesItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MatchLaborCategoriesItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MatchLaborCategoriesItem, a, b);
    }
    constructor(data){
        super(), /**
   * caller key (zou LaborCategory.logical_key)
   *
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string description = 3;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string qualifications = 4;
   */ _define_property(this, "qualifications", ""), /**
   * labor_category_candidates.candidate_key when known
   *
   * @generated from field: string candidate_key = 5;
   */ _define_property(this, "candidateKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MatchLaborCategoriesItem, "runtime", proto3);
_define_property(MatchLaborCategoriesItem, "typeName", "mono.datagateway.v1.MatchLaborCategoriesItem");
_define_property(MatchLaborCategoriesItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "qualifications",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "candidate_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MatchLaborCategoriesResult
 */ export class MatchLaborCategoriesResult extends Message {
    static fromBinary(bytes, options) {
        return new MatchLaborCategoriesResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MatchLaborCategoriesResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MatchLaborCategoriesResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MatchLaborCategoriesResult, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * ACCEPTED_CANDIDATE | SAME_VEHICLE_EXACT | SAME_VEHICLE_ROSETTA | AMBIGUOUS | VEHICLE_MISMATCH | UNKNOWN_VEHICLE | UNMATCHED (UNKNOWN_VEHICLE: the request's or the entry's vehicle has no family — never reported as a mismatch)
   *
   * @generated from field: string status = 2;
   */ _define_property(this, "status", ""), /**
   * @generated from field: string entry_id = 3;
   */ _define_property(this, "entryId", ""), /**
   * @generated from field: string entry_vehicle_id = 4;
   */ _define_property(this, "entryVehicleId", ""), /**
   * @generated from field: string entry_vehicle_name = 5;
   */ _define_property(this, "entryVehicleName", ""), /**
   * @generated from field: string anchor_id = 6;
   */ _define_property(this, "anchorId", ""), /**
   * @generated from field: repeated string ambiguous_entry_ids = 7;
   */ _define_property(this, "ambiguousEntryIds", []), /**
   * human-readable reasons
   *
   * @generated from field: repeated string evidence = 8;
   */ _define_property(this, "evidence", []), /**
   * @generated from field: string normalized_title = 9;
   */ _define_property(this, "normalizedTitle", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MatchLaborCategoriesResult, "runtime", proto3);
_define_property(MatchLaborCategoriesResult, "typeName", "mono.datagateway.v1.MatchLaborCategoriesResult");
_define_property(MatchLaborCategoriesResult, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "entry_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "entry_vehicle_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "anchor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "ambiguous_entry_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "evidence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "normalized_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MatchLaborCategoriesRequest
 */ export class MatchLaborCategoriesRequest extends Message {
    static fromBinary(bytes, options) {
        return new MatchLaborCategoriesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MatchLaborCategoriesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MatchLaborCategoriesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MatchLaborCategoriesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * the solicitation's vehicle
   *
   * @generated from field: string contract_vehicle_id = 2;
   */ _define_property(this, "contractVehicleId", ""), /**
   * "" = any company (default: own company first)
   *
   * @generated from field: string company_profile_id = 3;
   */ _define_property(this, "companyProfileId", ""), /**
   * ≤ 500
   *
   * @generated from field: repeated mono.datagateway.v1.MatchLaborCategoriesItem items = 4;
   */ _define_property(this, "items", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MatchLaborCategoriesRequest, "runtime", proto3);
_define_property(MatchLaborCategoriesRequest, "typeName", "mono.datagateway.v1.MatchLaborCategoriesRequest");
_define_property(MatchLaborCategoriesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "items",
            kind: "message",
            T: MatchLaborCategoriesItem,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MatchLaborCategoriesResponse
 */ export class MatchLaborCategoriesResponse extends Message {
    static fromBinary(bytes, options) {
        return new MatchLaborCategoriesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MatchLaborCategoriesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MatchLaborCategoriesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MatchLaborCategoriesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.MatchLaborCategoriesResult results = 1;
   */ _define_property(this, "results", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MatchLaborCategoriesResponse, "runtime", proto3);
_define_property(MatchLaborCategoriesResponse, "typeName", "mono.datagateway.v1.MatchLaborCategoriesResponse");
_define_property(MatchLaborCategoriesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "results",
            kind: "message",
            T: MatchLaborCategoriesResult,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RateSuggestionTarget
 */ export class RateSuggestionTarget extends Message {
    static fromBinary(bytes, options) {
        return new RateSuggestionTarget().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RateSuggestionTarget().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RateSuggestionTarget().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RateSuggestionTarget, a, b);
    }
    constructor(data){
        super(), /**
   * caller row key, echoed
   *
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * one of entry or anchor
   *
   * @generated from field: string lcat_entry_id = 2;
   */ _define_property(this, "lcatEntryId", ""), /**
   * @generated from field: string anchor_id = 3;
   */ _define_property(this, "anchorId", ""), /**
   * required with anchor_id to pick a lane; optional with entry
   *
   * @generated from field: string company_profile_id = 4;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string contract_vehicle_id = 5;
   */ _define_property(this, "contractVehicleId", ""), /**
   * "FY2027" | "CY2027" | "2026-10-01/2027-09-30" (sheet DATE_RANGE key) | "ORDINAL:2"
   *
   * @generated from field: string target_period_key = 6;
   */ _define_property(this, "targetPeriodKey", ""), /**
   * @generated from field: string target_period_label = 7;
   */ _define_property(this, "targetPeriodLabel", ""), /**
   * @generated from field: google.protobuf.Timestamp target_period_start = 8;
   */ _define_property(this, "targetPeriodStart", void 0), /**
   * @generated from field: google.protobuf.Timestamp target_period_end = 9;
   */ _define_property(this, "targetPeriodEnd", void 0), /**
   * default HOURLY
   *
   * @generated from field: string rate_unit = 10;
   */ _define_property(this, "rateUnit", ""), /**
   * default FULLY_BURDENED
   *
   * @generated from field: string burden_basis = 11;
   */ _define_property(this, "burdenBasis", ""), /**
   * default USD
   *
   * @generated from field: string currency = 12;
   */ _define_property(this, "currency", ""), /**
   * "" = any
   *
   * @generated from field: string worksite = 13;
   */ _define_property(this, "worksite", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RateSuggestionTarget, "runtime", proto3);
_define_property(RateSuggestionTarget, "typeName", "mono.datagateway.v1.RateSuggestionTarget");
_define_property(RateSuggestionTarget, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "lcat_entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "anchor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "contract_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "target_period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "target_period_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "target_period_start",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "target_period_end",
            kind: "message",
            T: Timestamp
        },
        {
            no: 10,
            name: "rate_unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "burden_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "currency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "worksite",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RateSuggestionInput
 */ export class RateSuggestionInput extends Message {
    static fromBinary(bytes, options) {
        return new RateSuggestionInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RateSuggestionInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RateSuggestionInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RateSuggestionInput, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string observation_id = 1;
   */ _define_property(this, "observationId", ""), /**
   * @generated from field: string observation_type = 2;
   */ _define_property(this, "observationType", ""), /**
   * @generated from field: double amount = 3;
   */ _define_property(this, "amount", 0), /**
   * USED | CONSIDERED | EXCLUDED
   *
   * @generated from field: string role = 4;
   */ _define_property(this, "role", ""), /**
   * PERSON_SCOPED | VAULT | SUPERSEDED | NOT_A_PRICE | RELATION_NOT_EQUIVALENT | MAPPING_NOT_APPROVED | NOT_COMPARABLE | BURDEN_NOT_STATED | WORKSITE_MISMATCH | PERIOD_MISMATCH | OUTSIDE_WINDOW (BURDEN_NOT_STATED rows have role CONSIDERED, never USED)
   *
   * @generated from field: string exclude_reason = 5;
   */ _define_property(this, "excludeReason", ""), /**
   * @generated from field: string period_label = 6;
   */ _define_property(this, "periodLabel", ""), /**
   * @generated from field: string normalized_period_key = 7;
   */ _define_property(this, "normalizedPeriodKey", ""), /**
   * @generated from field: int32 lcat_entry_version = 8;
   */ _define_property(this, "lcatEntryVersion", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RateSuggestionInput, "runtime", proto3);
_define_property(RateSuggestionInput, "typeName", "mono.datagateway.v1.RateSuggestionInput");
_define_property(RateSuggestionInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "observation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "observation_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 4,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "exclude_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "period_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "normalized_period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "lcat_entry_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RateSuggestion
 */ export class RateSuggestion extends Message {
    static fromBinary(bytes, options) {
        return new RateSuggestion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RateSuggestion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RateSuggestion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RateSuggestion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * R1_PAST_24M_LOWEST_EXECUTED | R1_NO_EXECUTED_USE_CEILING | R2_FUTURE_CEILING | NONE
   *
   * @generated from field: string rule_id = 2;
   */ _define_property(this, "ruleId", ""), /**
   * @generated from field: string rule_label = 3;
   */ _define_property(this, "ruleLabel", ""), /**
   * @generated from field: bool has_amount = 4;
   */ _define_property(this, "hasAmount", false), /**
   * @generated from field: double amount = 5;
   */ _define_property(this, "amount", 0), /**
   * only INFERRED available, or period unknown
   *
   * @generated from field: bool requires_choice = 6;
   */ _define_property(this, "requiresChoice", false), /**
   * @generated from field: repeated mono.datagateway.v1.RateSuggestionInput inputs = 7;
   */ _define_property(this, "inputs", []), /**
   * PERIOD_UNKNOWN | MULTIPLE_CEILING_GENERATIONS | INFERRED_ONLY | OUTSIDE_LOOKBACK | BURDEN_NOT_STATED
   *
   * @generated from field: repeated string warnings = 8;
   */ _define_property(this, "warnings", []), /**
   * SAME_KEY | SAME_LABEL | DATE_OVERLAP | ""
   *
   * @generated from field: string match_basis = 9;
   */ _define_property(this, "matchBasis", ""), /**
   * @generated from field: bool has_range = 10;
   */ _define_property(this, "hasRange", false), /**
   * @generated from field: double low = 11;
   */ _define_property(this, "low", 0), /**
   * @generated from field: double high = 12;
   */ _define_property(this, "high", 0), /**
   * @generated from field: string explanation = 13;
   */ _define_property(this, "explanation", ""), /**
   * ratebook.HelperVersion
   *
   * @generated from field: string helper_version = 14;
   */ _define_property(this, "helperVersion", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RateSuggestion, "runtime", proto3);
_define_property(RateSuggestion, "typeName", "mono.datagateway.v1.RateSuggestion");
_define_property(RateSuggestion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rule_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "rule_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "has_amount",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "amount",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 6,
            name: "requires_choice",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "inputs",
            kind: "message",
            T: RateSuggestionInput,
            repeated: true
        },
        {
            no: 8,
            name: "warnings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "match_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "has_range",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "low",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 12,
            name: "high",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 13,
            name: "explanation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "helper_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetRateSuggestionsRequest
 */ export class GetRateSuggestionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetRateSuggestionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRateSuggestionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRateSuggestionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRateSuggestionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * ≤ 500
   *
   * @generated from field: repeated mono.datagateway.v1.RateSuggestionTarget targets = 2;
   */ _define_property(this, "targets", []), /**
   * unset = now
   *
   * @generated from field: google.protobuf.Timestamp as_of = 3;
   */ _define_property(this, "asOf", void 0), /**
   * default 24
   *
   * @generated from field: int32 lookback_months = 4;
   */ _define_property(this, "lookbackMonths", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRateSuggestionsRequest, "runtime", proto3);
_define_property(GetRateSuggestionsRequest, "typeName", "mono.datagateway.v1.GetRateSuggestionsRequest");
_define_property(GetRateSuggestionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "targets",
            kind: "message",
            T: RateSuggestionTarget,
            repeated: true
        },
        {
            no: 3,
            name: "as_of",
            kind: "message",
            T: Timestamp
        },
        {
            no: 4,
            name: "lookback_months",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetRateSuggestionsResponse
 */ export class GetRateSuggestionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetRateSuggestionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRateSuggestionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRateSuggestionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRateSuggestionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.RateSuggestion suggestions = 1;
   */ _define_property(this, "suggestions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRateSuggestionsResponse, "runtime", proto3);
_define_property(GetRateSuggestionsResponse, "typeName", "mono.datagateway.v1.GetRateSuggestionsResponse");
_define_property(GetRateSuggestionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "suggestions",
            kind: "message",
            T: RateSuggestion,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LaborCategoryPrimaryMapping
 */ export class LaborCategoryPrimaryMapping extends Message {
    static fromBinary(bytes, options) {
        return new LaborCategoryPrimaryMapping().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LaborCategoryPrimaryMapping().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LaborCategoryPrimaryMapping().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LaborCategoryPrimaryMapping, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string anchor_id = 1;
   */ _define_property(this, "anchorId", ""), /**
   * @generated from field: string anchor_title = 2;
   */ _define_property(this, "anchorTitle", ""), /**
   * @generated from field: string relation = 3;
   */ _define_property(this, "relation", ""), /**
   * @generated from field: string status = 4;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LaborCategoryPrimaryMapping, "runtime", proto3);
_define_property(LaborCategoryPrimaryMapping, "typeName", "mono.datagateway.v1.LaborCategoryPrimaryMapping");
_define_property(LaborCategoryPrimaryMapping, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "anchor_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "anchor_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "relation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ReportVehicleFamiliesRequest scopes ops diagnostics to one tenant.
 *
 * @generated from message mono.datagateway.v1.ReportVehicleFamiliesRequest
 */ export class ReportVehicleFamiliesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReportVehicleFamiliesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReportVehicleFamiliesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReportVehicleFamiliesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReportVehicleFamiliesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReportVehicleFamiliesRequest, "runtime", proto3);
_define_property(ReportVehicleFamiliesRequest, "typeName", "mono.datagateway.v1.ReportVehicleFamiliesRequest");
_define_property(ReportVehicleFamiliesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * VehicleFamilyDuplicate lists canonical vehicles sharing a normalized name.
 *
 * @generated from message mono.datagateway.v1.VehicleFamilyDuplicate
 */ export class VehicleFamilyDuplicate extends Message {
    static fromBinary(bytes, options) {
        return new VehicleFamilyDuplicate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VehicleFamilyDuplicate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VehicleFamilyDuplicate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VehicleFamilyDuplicate, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string name = 1;
   */ _define_property(this, "name", ""), /**
   * @generated from field: repeated string vehicle_ids = 2;
   */ _define_property(this, "vehicleIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(VehicleFamilyDuplicate, "runtime", proto3);
_define_property(VehicleFamilyDuplicate, "typeName", "mono.datagateway.v1.VehicleFamilyDuplicate");
_define_property(VehicleFamilyDuplicate, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "vehicle_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * VehicleFamilyUnresolved is a contract-number-shaped vehicle without a parent.
 *
 * @generated from message mono.datagateway.v1.VehicleFamilyUnresolved
 */ export class VehicleFamilyUnresolved extends Message {
    static fromBinary(bytes, options) {
        return new VehicleFamilyUnresolved().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new VehicleFamilyUnresolved().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new VehicleFamilyUnresolved().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(VehicleFamilyUnresolved, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(VehicleFamilyUnresolved, "runtime", proto3);
_define_property(VehicleFamilyUnresolved, "typeName", "mono.datagateway.v1.VehicleFamilyUnresolved");
_define_property(VehicleFamilyUnresolved, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ReportVehicleFamiliesResponse reports data issues without modifying data.
 *
 * @generated from message mono.datagateway.v1.ReportVehicleFamiliesResponse
 */ export class ReportVehicleFamiliesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReportVehicleFamiliesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReportVehicleFamiliesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReportVehicleFamiliesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReportVehicleFamiliesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.VehicleFamilyDuplicate duplicate_names = 1;
   */ _define_property(this, "duplicateNames", []), /**
   * @generated from field: repeated mono.datagateway.v1.VehicleFamilyUnresolved unresolved_contract_vehicles = 2;
   */ _define_property(this, "unresolvedContractVehicles", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReportVehicleFamiliesResponse, "runtime", proto3);
_define_property(ReportVehicleFamiliesResponse, "typeName", "mono.datagateway.v1.ReportVehicleFamiliesResponse");
_define_property(ReportVehicleFamiliesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "duplicate_names",
            kind: "message",
            T: VehicleFamilyDuplicate,
            repeated: true
        },
        {
            no: 2,
            name: "unresolved_contract_vehicles",
            kind: "message",
            T: VehicleFamilyUnresolved,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SuggestLaborCategoryMappingsRequest
 */ export class SuggestLaborCategoryMappingsRequest extends Message {
    static fromBinary(bytes, options) {
        return new SuggestLaborCategoryMappingsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SuggestLaborCategoryMappingsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SuggestLaborCategoryMappingsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SuggestLaborCategoryMappingsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * empty = all eligible entries
   *
   * @generated from field: repeated string entry_ids = 2;
   */ _define_property(this, "entryIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SuggestLaborCategoryMappingsRequest, "runtime", proto3);
_define_property(SuggestLaborCategoryMappingsRequest, "typeName", "mono.datagateway.v1.SuggestLaborCategoryMappingsRequest");
_define_property(SuggestLaborCategoryMappingsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "entry_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SuggestLaborCategoryMappingsResponse
 */ export class SuggestLaborCategoryMappingsResponse extends Message {
    static fromBinary(bytes, options) {
        return new SuggestLaborCategoryMappingsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SuggestLaborCategoryMappingsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SuggestLaborCategoryMappingsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SuggestLaborCategoryMappingsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * the pending run the request was merged into
   *
   * @generated from field: string run_id = 1;
   */ _define_property(this, "runId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SuggestLaborCategoryMappingsResponse, "runtime", proto3);
_define_property(SuggestLaborCategoryMappingsResponse, "typeName", "mono.datagateway.v1.SuggestLaborCategoryMappingsResponse");
_define_property(SuggestLaborCategoryMappingsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "run_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Only fully fetched contract sets may be submitted. A missing contract is untouched;
 * an explicit empty set clears its live rows. Vendor queries must be resolved and
 * completed by the importer, then grouped by contract; partial/vendor-only subsets
 * MUST NOT replace a contract. No vendor fragment is accepted here.
 *
 * @generated from message mono.datagateway.v1.RecordCalcPlusBenchmarksRequest
 */ export class RecordCalcPlusBenchmarksRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordCalcPlusBenchmarksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordCalcPlusBenchmarksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordCalcPlusBenchmarksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordCalcPlusBenchmarksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * triggering tenant, audit only; benchmark rows are global
   *
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: repeated mono.datagateway.v1.CalcPlusContractReplacement contracts = 2;
   */ _define_property(this, "contracts", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordCalcPlusBenchmarksRequest, "runtime", proto3);
_define_property(RecordCalcPlusBenchmarksRequest, "typeName", "mono.datagateway.v1.RecordCalcPlusBenchmarksRequest");
_define_property(RecordCalcPlusBenchmarksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contracts",
            kind: "message",
            T: CalcPlusContractReplacement,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CalcPlusContractReplacement
 */ export class CalcPlusContractReplacement extends Message {
    static fromBinary(bytes, options) {
        return new CalcPlusContractReplacement().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CalcPlusContractReplacement().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CalcPlusContractReplacement().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CalcPlusContractReplacement, a, b);
    }
    constructor(data){
        super(), /**
   * canonicalized to uppercase without hyphens/whitespace
   *
   * @generated from field: string idv_piid = 1;
   */ _define_property(this, "idvPiid", ""), /**
   * complete set, including empty
   *
   * @generated from field: repeated mono.datagateway.v1.CalcPlusBenchmarkInput rows = 2;
   */ _define_property(this, "rows", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CalcPlusContractReplacement, "runtime", proto3);
_define_property(CalcPlusContractReplacement, "typeName", "mono.datagateway.v1.CalcPlusContractReplacement");
_define_property(CalcPlusContractReplacement, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "idv_piid",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rows",
            kind: "message",
            T: CalcPlusBenchmarkInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CalcPlusBenchmarkInput
 */ export class CalcPlusBenchmarkInput extends Message {
    static fromBinary(bytes, options) {
        return new CalcPlusBenchmarkInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CalcPlusBenchmarkInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CalcPlusBenchmarkInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CalcPlusBenchmarkInput, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string vendor_name = 1;
   */ _define_property(this, "vendorName", ""), /**
   * @generated from field: string labor_category = 2;
   */ _define_property(this, "laborCategory", ""), /**
   * @generated from field: string education_level = 3;
   */ _define_property(this, "educationLevel", ""), /**
   * @generated from field: optional int32 min_years_experience = 4;
   */ _define_property(this, "minYearsExperience", void 0), /**
   * @generated from field: string security_clearance = 5;
   */ _define_property(this, "securityClearance", ""), /**
   * @generated from field: string worksite = 6;
   */ _define_property(this, "worksite", ""), /**
   * @generated from field: string sin = 7;
   */ _define_property(this, "sin", ""), /**
   * @generated from field: string business_size = 8;
   */ _define_property(this, "businessSize", ""), /**
   * @generated from field: optional double current_price = 9;
   */ _define_property(this, "currentPrice", void 0), /**
   * @generated from field: optional double next_year_price = 10;
   */ _define_property(this, "nextYearPrice", void 0), /**
   * @generated from field: optional double second_year_price = 11;
   */ _define_property(this, "secondYearPrice", void 0), /**
   * YYYY-MM-DD or empty
   *
   * @generated from field: string contract_start = 12;
   */ _define_property(this, "contractStart", ""), /**
   * YYYY-MM-DD or empty
   *
   * @generated from field: string contract_end = 13;
   */ _define_property(this, "contractEnd", ""), /**
   * exact CALC+ query/page URL; never reconstructed
   *
   * @generated from field: string source_url = 14;
   */ _define_property(this, "sourceUrl", ""), /**
   * SHA-256 hex of raw response body for this row's page
   *
   * @generated from field: string source_sha256 = 15;
   */ _define_property(this, "sourceSha256", ""), /**
   * @generated from field: google.protobuf.Timestamp retrieved_at = 16;
   */ _define_property(this, "retrievedAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CalcPlusBenchmarkInput, "runtime", proto3);
_define_property(CalcPlusBenchmarkInput, "typeName", "mono.datagateway.v1.CalcPlusBenchmarkInput");
_define_property(CalcPlusBenchmarkInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "vendor_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "labor_category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "education_level",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "min_years_experience",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ ,
            opt: true
        },
        {
            no: 5,
            name: "security_clearance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "worksite",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "sin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "business_size",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "current_price",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 10,
            name: "next_year_price",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 11,
            name: "second_year_price",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ ,
            opt: true
        },
        {
            no: 12,
            name: "contract_start",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "contract_end",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "source_url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "source_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "retrieved_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordCalcPlusBenchmarksResponse
 */ export class RecordCalcPlusBenchmarksResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordCalcPlusBenchmarksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordCalcPlusBenchmarksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordCalcPlusBenchmarksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordCalcPlusBenchmarksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 rows = 1;
   */ _define_property(this, "rows", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordCalcPlusBenchmarksResponse, "runtime", proto3);
_define_property(RecordCalcPlusBenchmarksResponse, "typeName", "mono.datagateway.v1.RecordCalcPlusBenchmarksResponse");
_define_property(RecordCalcPlusBenchmarksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rows",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * FileContactEmploymentCandidateRequest mirrors repository.FileInput. Dates are YYYY-MM-DD.
 *
 * @generated from message mono.datagateway.v1.FileContactEmploymentCandidateRequest
 */ export class FileContactEmploymentCandidateRequest extends Message {
    static fromBinary(bytes, options) {
        return new FileContactEmploymentCandidateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FileContactEmploymentCandidateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FileContactEmploymentCandidateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FileContactEmploymentCandidateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * the known contact; "" when the person is not in the registry yet
   *
   * @generated from field: string contact_id = 2;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string proposed_contact_name = 3;
   */ _define_property(this, "proposedContactName", ""), /**
   * @generated from field: string proposed_contact_email = 4;
   */ _define_property(this, "proposedContactEmail", ""), /**
   * @generated from field: string proposed_contact_government_email = 5;
   */ _define_property(this, "proposedContactGovernmentEmail", ""), /**
   * @generated from field: string proposed_contact_phone = 6;
   */ _define_property(this, "proposedContactPhone", ""), /**
   * exactly one of company_profile_id / government_organization_id
   *
   * @generated from field: string company_profile_id = 7;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string government_organization_id = 8;
   */ _define_property(this, "governmentOrganizationId", ""), /**
   * @generated from field: string title = 9;
   */ _define_property(this, "title", ""), /**
   * EMPLOYEE | CONTRACTOR | ADVISOR | GOV_CIVILIAN | MILITARY | UNKNOWN
   *
   * @generated from field: string employment_type = 10;
   */ _define_property(this, "employmentType", ""), /**
   * @generated from field: string start_date = 11;
   */ _define_property(this, "startDate", ""), /**
   * @generated from field: string end_date = 12;
   */ _define_property(this, "endDate", ""), /**
   * @generated from field: string end_previous_employment_id = 13;
   */ _define_property(this, "endPreviousEmploymentId", ""), /**
   * DOCUMENT | NOTICE | IMPORT | ANALYST | USER | ASSIST | PUBLIC
   *
   * @generated from field: string source_kind = 14;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string source_label = 15;
   */ _define_property(this, "sourceLabel", ""), /**
   * @generated from field: string source_artifact_id = 16;
   */ _define_property(this, "sourceArtifactId", ""), /**
   * only callers who see the program see the candidate
   *
   * @generated from field: string source_program_id = 17;
   */ _define_property(this, "sourceProgramId", ""), /**
   * JSON object or empty
   *
   * @generated from field: string evidence_json = 18;
   */ _define_property(this, "evidenceJson", ""), /**
   * 0 = unknown
   *
   * @generated from field: double confidence = 19;
   */ _define_property(this, "confidence", 0), /**
   * required; the same key on a PENDING row refreshes it
   *
   * @generated from field: string candidate_key = 20;
   */ _define_property(this, "candidateKey", ""), /**
   * stored as evidence.uploaded_by
   *
   * @generated from field: string source_uploader_user_id = 21;
   */ _define_property(this, "sourceUploaderUserId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FileContactEmploymentCandidateRequest, "runtime", proto3);
_define_property(FileContactEmploymentCandidateRequest, "typeName", "mono.datagateway.v1.FileContactEmploymentCandidateRequest");
_define_property(FileContactEmploymentCandidateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "proposed_contact_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "proposed_contact_email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "proposed_contact_government_email",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "proposed_contact_phone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "government_organization_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "employment_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "start_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "end_date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "end_previous_employment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "source_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "source_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "source_program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "evidence_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "confidence",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        },
        {
            no: 20,
            name: "candidate_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "source_uploader_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.FileContactEmploymentCandidateResponse
 */ export class FileContactEmploymentCandidateResponse extends Message {
    static fromBinary(bytes, options) {
        return new FileContactEmploymentCandidateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FileContactEmploymentCandidateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FileContactEmploymentCandidateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FileContactEmploymentCandidateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * an existing PENDING row with the same key was updated
   *
   * @generated from field: bool refreshed = 2;
   */ _define_property(this, "refreshed", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(FileContactEmploymentCandidateResponse, "runtime", proto3);
_define_property(FileContactEmploymentCandidateResponse, "typeName", "mono.datagateway.v1.FileContactEmploymentCandidateResponse");
_define_property(FileContactEmploymentCandidateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "refreshed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
